webpackJsonp([114276838955818,60335399758886],{

/***/ 255:
/***/ (function(module, exports) {

	module.exports = {"data":{"posts":{"edges":[{"node":{"excerpt":"SkyView® Lite The winning spot belongs to SkyView® Lite. The developer Terminal Eleven LLC says the following about the app.  SkyView® Lite…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in September 2021","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in September 2021.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-da46393af9f99eea3358c66196bb3a02-6d4e8.png","srcSet":"/static/main-da46393af9f99eea3358c66196bb3a02-6d4e8.png 1x","srcWebp":"/static/main-da46393af9f99eea3358c66196bb3a02-9a16c.webp","srcSetWebp":"/static/main-da46393af9f99eea3358c66196bb3a02-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ZOOM Cloud Meetings The winner of the battle is ZOOM Cloud Meetings. The developer Zoom says the following about the app.  Zoom is #1 in…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in September 2021","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in September 2021.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-017bb1881a46045f5e93f802d6814f88-6d4e8.png","srcSet":"/static/main-017bb1881a46045f5e93f802d6814f88-6d4e8.png 1x","srcWebp":"/static/main-017bb1881a46045f5e93f802d6814f88-9a16c.webp","srcSetWebp":"/static/main-017bb1881a46045f5e93f802d6814f88-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps The winning spot belongs to Google Maps. The developer Google LLC says the following about the app.  Navigate your world faster…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in September 2021","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in September 2021.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-25d2a0c8006b9a61a065dbb6f31f8b17-6d4e8.png","srcSet":"/static/main-25d2a0c8006b9a61a065dbb6f31f8b17-6d4e8.png 1x","srcWebp":"/static/main-25d2a0c8006b9a61a065dbb6f31f8b17-9a16c.webp","srcSetWebp":"/static/main-25d2a0c8006b9a61a065dbb6f31f8b17-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Pinterest The first place is taken by Pinterest. The developer Pinterest says the following about the app.  Pinterest is the place to…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in September 2021","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in September 2021.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-64a7d1de0abf52fdaca15d639e5bc8f9-6d4e8.png","srcSet":"/static/main-64a7d1de0abf52fdaca15d639e5bc8f9-6d4e8.png 1x","srcWebp":"/static/main-64a7d1de0abf52fdaca15d639e5bc8f9-9a16c.webp","srcSetWebp":"/static/main-64a7d1de0abf52fdaca15d639e5bc8f9-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The first place belongs to YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-free-ios-apps-in-photo-and-video-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in September 2021","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in September 2021.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-02c973240a80bb5b5b8bbb68a0f14d3b-6d4e8.png","srcSet":"/static/main-02c973240a80bb5b5b8bbb68a0f14d3b-6d4e8.png 1x","srcWebp":"/static/main-02c973240a80bb5b5b8bbb68a0f14d3b-9a16c.webp","srcSetWebp":"/static/main-02c973240a80bb5b5b8bbb68a0f14d3b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The winning spot belongs to Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in September 2021","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in September 2021.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-f18d7e94dc9f91fff642f31f74c1e524-6d4e8.png","srcSet":"/static/main-f18d7e94dc9f91fff642f31f74c1e524-6d4e8.png 1x","srcWebp":"/static/main-f18d7e94dc9f91fff642f31f74c1e524-9a16c.webp","srcSetWebp":"/static/main-f18d7e94dc9f91fff642f31f74c1e524-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber - Request a ride The winning spot belongs to Uber - Request a ride. The developer Uber Technologies, Inc. says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in September 2021","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in September 2021.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6cc60fef542314f25119ad4ce8b30d85-6d4e8.png","srcSet":"/static/main-6cc60fef542314f25119ad4ce8b30d85-6d4e8.png 1x","srcWebp":"/static/main-6cc60fef542314f25119ad4ce8b30d85-9a16c.webp","srcSetWebp":"/static/main-6cc60fef542314f25119ad4ce8b30d85-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facebook The winner of the battle is Facebook. The developer Facebook, Inc. says the following about the app.  Connect with friends, family…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in September 2021","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in September 2021.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-af20ee407eff81369305d3030474809e-6d4e8.png","srcSet":"/static/main-af20ee407eff81369305d3030474809e-6d4e8.png 1x","srcWebp":"/static/main-af20ee407eff81369305d3030474809e-9a16c.webp","srcSetWebp":"/static/main-af20ee407eff81369305d3030474809e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Toca Life World: Build stories The first place belongs to Toca Life World: Build stories. The developer Toca Boca AB says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in September 2021","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in September 2021.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-7656d00b075d257c8decbc95cf77c626-6d4e8.png","srcSet":"/static/main-7656d00b075d257c8decbc95cf77c626-6d4e8.png 1x","srcWebp":"/static/main-7656d00b075d257c8decbc95cf77c626-9a16c.webp","srcSetWebp":"/static/main-7656d00b075d257c8decbc95cf77c626-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google The winner of the battle is Google. The developer Google LLC says the following about the app.  Get fast access to Google Search with…","fields":{"slug":"/top-5-free-ios-apps-in-utilities-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in September 2021","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in September 2021.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9749047e007e8869fde36ee7bd977185-6d4e8.png","srcSet":"/static/main-9749047e007e8869fde36ee7bd977185-6d4e8.png 1x","srcWebp":"/static/main-9749047e007e8869fde36ee7bd977185-9a16c.webp","srcSetWebp":"/static/main-9749047e007e8869fde36ee7bd977185-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The first place belongs to LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in September 2021","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in September 2021.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b2ba08ce957b31b80d315d2c9b91d50a-6d4e8.png","srcSet":"/static/main-b2ba08ce957b31b80d315d2c9b91d50a-6d4e8.png 1x","srcWebp":"/static/main-b2ba08ce957b31b80d315d2c9b91d50a-9a16c.webp","srcSetWebp":"/static/main-b2ba08ce957b31b80d315d2c9b91d50a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder - Dating & New Friends The winner of the battle is Tinder - Dating & New Friends. The developer Tinder Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in September 2021","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in September 2021.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-8a8ef83befeb724856002dc9254517fd-6d4e8.png","srcSet":"/static/main-8a8ef83befeb724856002dc9254517fd-6d4e8.png 1x","srcWebp":"/static/main-8a8ef83befeb724856002dc9254517fd-9a16c.webp","srcSetWebp":"/static/main-8a8ef83befeb724856002dc9254517fd-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The first place is taken by onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in September 2021","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in September 2021.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-fee234fa1afb1a2b6772ceb3c91cf422-6d4e8.png","srcSet":"/static/main-fee234fa1afb1a2b6772ceb3c91cf422-6d4e8.png 1x","srcWebp":"/static/main-fee234fa1afb1a2b6772ceb3c91cf422-9a16c.webp","srcSetWebp":"/static/main-fee234fa1afb1a2b6772ceb3c91cf422-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"BIGO LIVE-Live Stream, Go Live The first place is taken by BIGO LIVE-Live Stream, Go Live. The developer BIGO TECHNOLOGY PTE. LTD. says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in September 2021","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in September 2021.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6a96e1c15cb40b2573b38c3523199473-6d4e8.png","srcSet":"/static/main-6a96e1c15cb40b2573b38c3523199473-6d4e8.png 1x","srcWebp":"/static/main-6a96e1c15cb40b2573b38c3523199473-9a16c.webp","srcSetWebp":"/static/main-6a96e1c15cb40b2573b38c3523199473-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The winner of the battle is RoboKiller: Block Spam Calls. The developer TelTech Systems says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in September 2021","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in September 2021.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-495e0ed134e688b9c1b4267086d8825d-6d4e8.png","srcSet":"/static/main-495e0ed134e688b9c1b4267086d8825d-6d4e8.png 1x","srcWebp":"/static/main-495e0ed134e688b9c1b4267086d8825d-9a16c.webp","srcSetWebp":"/static/main-495e0ed134e688b9c1b4267086d8825d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The first place is taken by YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Photo and Video in September 2021","subTitle":"Top 5 Grossing iOS Apps in Photo and Video and Reviews from the AppStore in September 2021.","category":"top 5 grossing ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-02c973240a80bb5b5b8bbb68a0f14d3b-6d4e8.png","srcSet":"/static/main-02c973240a80bb5b5b8bbb68a0f14d3b-6d4e8.png 1x","srcWebp":"/static/main-02c973240a80bb5b5b8bbb68a0f14d3b-9a16c.webp","srcSetWebp":"/static/main-02c973240a80bb5b5b8bbb68a0f14d3b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"My Disney Experience The winner of the battle is My Disney Experience. The developer Disney says the following about the app.  The official…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Travel in September 2021","subTitle":"Top 5 Grossing iOS Apps in Travel and Reviews from the AppStore in September 2021.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-1e1316e0214ca73533bba271efccd6f2-6d4e8.png","srcSet":"/static/main-1e1316e0214ca73533bba271efccd6f2-6d4e8.png 1x","srcWebp":"/static/main-1e1316e0214ca73533bba271efccd6f2-9a16c.webp","srcSetWebp":"/static/main-1e1316e0214ca73533bba271efccd6f2-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The first place belongs to HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in September 2021","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in September 2021.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e4fbf2316c01ba8423d71bb3458bd364-6d4e8.png","srcSet":"/static/main-e4fbf2316c01ba8423d71bb3458bd364-6d4e8.png 1x","srcWebp":"/static/main-e4fbf2316c01ba8423d71bb3458bd364-9a16c.webp","srcSetWebp":"/static/main-e4fbf2316c01ba8423d71bb3458bd364-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"SkyView® The winning spot belongs to SkyView®. The developer Terminal Eleven LLC says the following about the app.  SkyView® brings…","fields":{"slug":"/top-5-paid-ios-apps-in-education-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in September 2021","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in September 2021.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0829c236212b904092fe757b109b6e14-6d4e8.png","srcSet":"/static/main-0829c236212b904092fe757b109b6e14-6d4e8.png 1x","srcWebp":"/static/main-0829c236212b904092fe757b109b6e14-9a16c.webp","srcSetWebp":"/static/main-0829c236212b904092fe757b109b6e14-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"iNavX: Marine Navigation The winning spot belongs to iNavX: Marine Navigation. The developer NavX Studios LLC says the following about the…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in September 2021","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in September 2021.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c443ae54401b5c217e72ff1523e83c4d-6d4e8.png","srcSet":"/static/main-c443ae54401b5c217e72ff1523e83c4d-6d4e8.png 1x","srcWebp":"/static/main-c443ae54401b5c217e72ff1523e83c4d-9a16c.webp","srcSetWebp":"/static/main-c443ae54401b5c217e72ff1523e83c4d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Stylebook The first place belongs to Stylebook. The developer left brain / right brain, LLC says the following about the app.  Get the most…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in September 2021","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in September 2021.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5904a98a1f06769e4be067e39b53a2d8-6d4e8.png","srcSet":"/static/main-5904a98a1f06769e4be067e39b53a2d8-6d4e8.png 1x","srcWebp":"/static/main-5904a98a1f06769e4be067e39b53a2d8-9a16c.webp","srcSetWebp":"/static/main-5904a98a1f06769e4be067e39b53a2d8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Screen Mirroring + for Roku The first place belongs to Screen Mirroring + for Roku. The developer Kraus und Karnath GbR 2Kit Consulting says…","fields":{"slug":"/top-5-paid-ios-apps-in-productivity-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in September 2021","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in September 2021.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-bf7d42a594bd6a091bb8e77601d1716a-6d4e8.png","srcSet":"/static/main-bf7d42a594bd6a091bb8e77601d1716a-6d4e8.png 1x","srcWebp":"/static/main-bf7d42a594bd6a091bb8e77601d1716a-9a16c.webp","srcSetWebp":"/static/main-bf7d42a594bd6a091bb8e77601d1716a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Free Tone - Calling & Texting The first place is taken by Free Tone - Calling & Texting. The developer TextMe, Inc. says the following about…","fields":{"slug":"/top-5-paid-ios-apps-in-social-networking-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Social Networking in September 2021","subTitle":"Top 5 Paid iOS Apps in Social Networking and Reviews from the AppStore in September 2021.","category":"top 5 paid ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-3ded001001ae3b8b0fe377517d7bc961-6d4e8.png","srcSet":"/static/main-3ded001001ae3b8b0fe377517d7bc961-6d4e8.png 1x","srcWebp":"/static/main-3ded001001ae3b8b0fe377517d7bc961-9a16c.webp","srcSetWebp":"/static/main-3ded001001ae3b8b0fe377517d7bc961-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"PeakFinder The winning spot belongs to PeakFinder. The developer PeakFinder GmbH says the following about the app.  The mountains are…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in September 2021","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in September 2021.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a0926e339e5fe46908e8945c17f8fea6-6d4e8.png","srcSet":"/static/main-a0926e339e5fe46908e8945c17f8fea6-6d4e8.png 1x","srcWebp":"/static/main-a0926e339e5fe46908e8945c17f8fea6-9a16c.webp","srcSetWebp":"/static/main-a0926e339e5fe46908e8945c17f8fea6-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facetune The winner of the battle is Facetune. The developer Lightricks Ltd. says the following about the app.  Facetune 2 is now available…","fields":{"slug":"/top-5-paid-ios-apps-in-photo-and-video-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in September 2021","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in September 2021.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-d25974a5907bda791eb5e5686603868f-6d4e8.png","srcSet":"/static/main-d25974a5907bda791eb5e5686603868f-6d4e8.png 1x","srcWebp":"/static/main-d25974a5907bda791eb5e5686603868f-9a16c.webp","srcSetWebp":"/static/main-d25974a5907bda791eb5e5686603868f-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Shadowrocket The winner of the battle is Shadowrocket. The developer Shadow Launch Technology Limited says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-september-2021/","prefix":"2021-09-06"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in September 2021","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in September 2021.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-29b4f1c0101adea51aa85cac982bfc06-6d4e8.png","srcSet":"/static/main-29b4f1c0101adea51aa85cac982bfc06-6d4e8.png 1x","srcWebp":"/static/main-29b4f1c0101adea51aa85cac982bfc06-9a16c.webp","srcSetWebp":"/static/main-29b4f1c0101adea51aa85cac982bfc06-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Duolingo - Language Lessons The winning spot belongs to Duolingo - Language Lessons. The developer Duolingo says the following about the app…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in July 2021","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in July 2021.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-49bf1e3375fdb8e90dabe30c4e689dc3-6d4e8.png","srcSet":"/static/main-49bf1e3375fdb8e90dabe30c4e689dc3-6d4e8.png 1x","srcWebp":"/static/main-49bf1e3375fdb8e90dabe30c4e689dc3-9a16c.webp","srcSetWebp":"/static/main-49bf1e3375fdb8e90dabe30c4e689dc3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ZOOM Cloud Meetings The winning spot belongs to ZOOM Cloud Meetings. The developer Zoom says the following about the app.  Zoom is #1 in…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in July 2021","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in July 2021.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-645b326a19c0944a32b38f6fabbad70d-6d4e8.png","srcSet":"/static/main-645b326a19c0944a32b38f6fabbad70d-6d4e8.png 1x","srcWebp":"/static/main-645b326a19c0944a32b38f6fabbad70d-9a16c.webp","srcSetWebp":"/static/main-645b326a19c0944a32b38f6fabbad70d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps The winning spot belongs to Google Maps. The developer Google LLC says the following about the app.  Navigate your world faster…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in July 2021","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in July 2021.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-8f32cd2f315bb8327d23325d6481ed5e-6d4e8.png","srcSet":"/static/main-8f32cd2f315bb8327d23325d6481ed5e-6d4e8.png 1x","srcWebp":"/static/main-8f32cd2f315bb8327d23325d6481ed5e-9a16c.webp","srcSetWebp":"/static/main-8f32cd2f315bb8327d23325d6481ed5e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Pinterest The winning spot belongs to Pinterest. The developer Pinterest says the following about the app.  Pinterest is the place to…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in July 2021","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in July 2021.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-4a45b98ec7a83e9a13dc81224cf58b26-6d4e8.png","srcSet":"/static/main-4a45b98ec7a83e9a13dc81224cf58b26-6d4e8.png 1x","srcWebp":"/static/main-4a45b98ec7a83e9a13dc81224cf58b26-9a16c.webp","srcSetWebp":"/static/main-4a45b98ec7a83e9a13dc81224cf58b26-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winning spot belongs to YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-free-ios-apps-in-photo-and-video-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in July 2021","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in July 2021.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-dd5484179a7b9a33be3b0db6972d82d7-6d4e8.png","srcSet":"/static/main-dd5484179a7b9a33be3b0db6972d82d7-6d4e8.png 1x","srcWebp":"/static/main-dd5484179a7b9a33be3b0db6972d82d7-9a16c.webp","srcSetWebp":"/static/main-dd5484179a7b9a33be3b0db6972d82d7-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The winner of the battle is Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in July 2021","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in July 2021.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ff1990aabd48992328d2cb7f69b1a12a-6d4e8.png","srcSet":"/static/main-ff1990aabd48992328d2cb7f69b1a12a-6d4e8.png 1x","srcWebp":"/static/main-ff1990aabd48992328d2cb7f69b1a12a-9a16c.webp","srcSetWebp":"/static/main-ff1990aabd48992328d2cb7f69b1a12a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facebook The winner of the battle is Facebook. The developer Facebook, Inc. says the following about the app.  Connect with friends, family…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in July 2021","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in July 2021.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-04624b81e465c3f959438425e5a40ea6-6d4e8.png","srcSet":"/static/main-04624b81e465c3f959438425e5a40ea6-6d4e8.png 1x","srcWebp":"/static/main-04624b81e465c3f959438425e5a40ea6-9a16c.webp","srcSetWebp":"/static/main-04624b81e465c3f959438425e5a40ea6-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber - Request a ride The first place belongs to Uber - Request a ride. The developer Uber Technologies, Inc. says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in July 2021","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in July 2021.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b89f4599204a574b1dc6523eccd821e2-6d4e8.png","srcSet":"/static/main-b89f4599204a574b1dc6523eccd821e2-6d4e8.png 1x","srcWebp":"/static/main-b89f4599204a574b1dc6523eccd821e2-9a16c.webp","srcSetWebp":"/static/main-b89f4599204a574b1dc6523eccd821e2-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google The winner of the battle is Google. The developer Google LLC says the following about the app.  Get fast access to Google Search with…","fields":{"slug":"/top-5-free-ios-apps-in-utilities-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in July 2021","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in July 2021.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c6f2c1980386994594814a192e9d5249-6d4e8.png","srcSet":"/static/main-c6f2c1980386994594814a192e9d5249-6d4e8.png 1x","srcWebp":"/static/main-c6f2c1980386994594814a192e9d5249-9a16c.webp","srcSetWebp":"/static/main-c6f2c1980386994594814a192e9d5249-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The first place is taken by LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in July 2021","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in July 2021.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-8237a0744ac8c9fdafaaa65a198a44c2-6d4e8.png","srcSet":"/static/main-8237a0744ac8c9fdafaaa65a198a44c2-6d4e8.png 1x","srcWebp":"/static/main-8237a0744ac8c9fdafaaa65a198a44c2-9a16c.webp","srcSetWebp":"/static/main-8237a0744ac8c9fdafaaa65a198a44c2-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Duolingo - Language Lessons The first place belongs to Duolingo - Language Lessons. The developer Duolingo says the following about the app…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in July 2021","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in July 2021.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-49bf1e3375fdb8e90dabe30c4e689dc3-6d4e8.png","srcSet":"/static/main-49bf1e3375fdb8e90dabe30c4e689dc3-6d4e8.png 1x","srcWebp":"/static/main-49bf1e3375fdb8e90dabe30c4e689dc3-9a16c.webp","srcSetWebp":"/static/main-49bf1e3375fdb8e90dabe30c4e689dc3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The winner of the battle is onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in July 2021","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in July 2021.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e27480a13966830a688515b952b4cf95-6d4e8.png","srcSet":"/static/main-e27480a13966830a688515b952b4cf95-6d4e8.png 1x","srcWebp":"/static/main-e27480a13966830a688515b952b4cf95-9a16c.webp","srcSetWebp":"/static/main-e27480a13966830a688515b952b4cf95-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder - Dating & New Friends The first place belongs to Tinder - Dating & New Friends. The developer Tinder Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in July 2021","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in July 2021.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b9040e30bf007db6ac339bc135fa30da-6d4e8.png","srcSet":"/static/main-b9040e30bf007db6ac339bc135fa30da-6d4e8.png 1x","srcWebp":"/static/main-b9040e30bf007db6ac339bc135fa30da-9a16c.webp","srcSetWebp":"/static/main-b9040e30bf007db6ac339bc135fa30da-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winner of the battle is YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Photo and Video in July 2021","subTitle":"Top 5 Grossing iOS Apps in Photo and Video and Reviews from the AppStore in July 2021.","category":"top 5 grossing ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-dd5484179a7b9a33be3b0db6972d82d7-6d4e8.png","srcSet":"/static/main-dd5484179a7b9a33be3b0db6972d82d7-6d4e8.png 1x","srcWebp":"/static/main-dd5484179a7b9a33be3b0db6972d82d7-9a16c.webp","srcSetWebp":"/static/main-dd5484179a7b9a33be3b0db6972d82d7-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"BIGO LIVE-Live Stream, Go Live The first place is taken by BIGO LIVE-Live Stream, Go Live. The developer BIGO TECHNOLOGY PTE. LTD. says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in July 2021","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in July 2021.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-17e715794b8330ec6534e156dfcc295b-6d4e8.png","srcSet":"/static/main-17e715794b8330ec6534e156dfcc295b-6d4e8.png 1x","srcWebp":"/static/main-17e715794b8330ec6534e156dfcc295b-9a16c.webp","srcSetWebp":"/static/main-17e715794b8330ec6534e156dfcc295b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The first place belongs to RoboKiller: Block Spam Calls. The developer TelTech Systems says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in July 2021","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in July 2021.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-83e42277b65c5f245f3d33931f47c17d-6d4e8.png","srcSet":"/static/main-83e42277b65c5f245f3d33931f47c17d-6d4e8.png 1x","srcWebp":"/static/main-83e42277b65c5f245f3d33931f47c17d-9a16c.webp","srcSetWebp":"/static/main-83e42277b65c5f245f3d33931f47c17d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"My Disney Experience The first place belongs to My Disney Experience. The developer Disney says the following about the app.  The official…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Travel in July 2021","subTitle":"Top 5 Grossing iOS Apps in Travel and Reviews from the AppStore in July 2021.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-462db44d86e6a5aad287a39088902269-6d4e8.png","srcSet":"/static/main-462db44d86e6a5aad287a39088902269-6d4e8.png 1x","srcWebp":"/static/main-462db44d86e6a5aad287a39088902269-9a16c.webp","srcSetWebp":"/static/main-462db44d86e6a5aad287a39088902269-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The winning spot belongs to HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in July 2021","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in July 2021.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-82caf734835aa4c544b1e3191a5744bf-6d4e8.png","srcSet":"/static/main-82caf734835aa4c544b1e3191a5744bf-6d4e8.png 1x","srcWebp":"/static/main-82caf734835aa4c544b1e3191a5744bf-9a16c.webp","srcSetWebp":"/static/main-82caf734835aa4c544b1e3191a5744bf-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Toca Kitchen 2 The first place belongs to Toca Kitchen 2. The developer Toca Boca AB says the following about the app.  The wildly popular…","fields":{"slug":"/top-5-paid-ios-apps-in-education-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in July 2021","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in July 2021.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e1b9de14628ff292d9b3320cbf93167a-6d4e8.png","srcSet":"/static/main-e1b9de14628ff292d9b3320cbf93167a-6d4e8.png 1x","srcWebp":"/static/main-e1b9de14628ff292d9b3320cbf93167a-9a16c.webp","srcSetWebp":"/static/main-e1b9de14628ff292d9b3320cbf93167a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"INKHUNTER PRO Tattoos try on The winning spot belongs to INKHUNTER PRO Tattoos try on. The developer INKHUNTER, Inc. says the following…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in July 2021","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in July 2021.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c4a1b36dde71de918a4624b51341c756-6d4e8.png","srcSet":"/static/main-c4a1b36dde71de918a4624b51341c756-6d4e8.png 1x","srcWebp":"/static/main-c4a1b36dde71de918a4624b51341c756-9a16c.webp","srcSetWebp":"/static/main-c4a1b36dde71de918a4624b51341c756-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Land Nav Assistant The winner of the battle is Land Nav Assistant. The developer Gammon Applications says the following about the app.  Land…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in July 2021","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in July 2021.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-93715674f31b5a2740c75d0abefa8910-6d4e8.png","srcSet":"/static/main-93715674f31b5a2740c75d0abefa8910-6d4e8.png 1x","srcWebp":"/static/main-93715674f31b5a2740c75d0abefa8910-9a16c.webp","srcSetWebp":"/static/main-93715674f31b5a2740c75d0abefa8910-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facetune The first place belongs to Facetune. The developer Lightricks Ltd. says the following about the app.  Facetune 2 is now available…","fields":{"slug":"/top-5-paid-ios-apps-in-photo-and-video-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in July 2021","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in July 2021.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-d25974a5907bda791eb5e5686603868f-6d4e8.png","srcSet":"/static/main-d25974a5907bda791eb5e5686603868f-6d4e8.png 1x","srcWebp":"/static/main-d25974a5907bda791eb5e5686603868f-9a16c.webp","srcSetWebp":"/static/main-d25974a5907bda791eb5e5686603868f-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Screen Mirroring+ for Roku The first place is taken by Screen Mirroring+ for Roku. The developer Kraus und Karnath GbR 2Kit Consulting says…","fields":{"slug":"/top-5-paid-ios-apps-in-productivity-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in July 2021","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in July 2021.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-858f4a3608ed2ea0e802614a0102a574-6d4e8.png","srcSet":"/static/main-858f4a3608ed2ea0e802614a0102a574-6d4e8.png 1x","srcWebp":"/static/main-858f4a3608ed2ea0e802614a0102a574-9a16c.webp","srcSetWebp":"/static/main-858f4a3608ed2ea0e802614a0102a574-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Threema. The Secure Messenger The first place is taken by Threema. The Secure Messenger. The developer Threema GmbH says the following about…","fields":{"slug":"/top-5-paid-ios-apps-in-social-networking-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Social Networking in July 2021","subTitle":"Top 5 Paid iOS Apps in Social Networking and Reviews from the AppStore in July 2021.","category":"top 5 paid ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-98d08141a86c1d45845f1ddad60ea451-6d4e8.png","srcSet":"/static/main-98d08141a86c1d45845f1ddad60ea451-6d4e8.png 1x","srcWebp":"/static/main-98d08141a86c1d45845f1ddad60ea451-9a16c.webp","srcSetWebp":"/static/main-98d08141a86c1d45845f1ddad60ea451-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LiveATC Air Radio The first place is taken by LiveATC Air Radio. The developer Dave Pascoe says the following about the app.  LiveATC Air…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in July 2021","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in July 2021.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-95749e35385e20917273f22891a25301-6d4e8.png","srcSet":"/static/main-95749e35385e20917273f22891a25301-6d4e8.png 1x","srcWebp":"/static/main-95749e35385e20917273f22891a25301-9a16c.webp","srcSetWebp":"/static/main-95749e35385e20917273f22891a25301-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Shadowrocket The first place is taken by Shadowrocket. The developer Shadow Launch Technology Limited says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-july-2021/","prefix":"2021-07-21"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in July 2021","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in July 2021.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a3365806900f13333d7386257c061fdd-6d4e8.png","srcSet":"/static/main-a3365806900f13333d7386257c061fdd-6d4e8.png 1x","srcWebp":"/static/main-a3365806900f13333d7386257c061fdd-9a16c.webp","srcSetWebp":"/static/main-a3365806900f13333d7386257c061fdd-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ZOOM Cloud Meetings The first place is taken by ZOOM Cloud Meetings. The developer Zoom says the following about the app.  Zoom is #1 in…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in July 2021","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in July 2021.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-645b326a19c0944a32b38f6fabbad70d-6d4e8.png","srcSet":"/static/main-645b326a19c0944a32b38f6fabbad70d-6d4e8.png 1x","srcWebp":"/static/main-645b326a19c0944a32b38f6fabbad70d-9a16c.webp","srcSetWebp":"/static/main-645b326a19c0944a32b38f6fabbad70d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Impulse - Brain Training The first place is taken by Impulse - Brain Training. The developer GMRD Apps Limited says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in July 2021","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in July 2021.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-8cab03b5fa7bfef781d01c4308877449-6d4e8.png","srcSet":"/static/main-8cab03b5fa7bfef781d01c4308877449-6d4e8.png 1x","srcWebp":"/static/main-8cab03b5fa7bfef781d01c4308877449-9a16c.webp","srcSetWebp":"/static/main-8cab03b5fa7bfef781d01c4308877449-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Pinterest The first place is taken by Pinterest. The developer Pinterest says the following about the app.  Pinterest is the place to…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in July 2021","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in July 2021.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-810446da05e26ee6a809b14ba895a0f7-6d4e8.png","srcSet":"/static/main-810446da05e26ee6a809b14ba895a0f7-6d4e8.png 1x","srcWebp":"/static/main-810446da05e26ee6a809b14ba895a0f7-9a16c.webp","srcSetWebp":"/static/main-810446da05e26ee6a809b14ba895a0f7-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps The first place is taken by Google Maps. The developer Google LLC says the following about the app.  Navigate your world faster…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in July 2021","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in July 2021.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-eb681651386ecbf4d56bfaaa8e344cb8-6d4e8.png","srcSet":"/static/main-eb681651386ecbf4d56bfaaa8e344cb8-6d4e8.png 1x","srcWebp":"/static/main-eb681651386ecbf4d56bfaaa8e344cb8-9a16c.webp","srcSetWebp":"/static/main-eb681651386ecbf4d56bfaaa8e344cb8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winner of the battle is YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-free-ios-apps-in-photo-and-video-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in July 2021","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in July 2021.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-3fa0cfc39e8e9deadf7fd2d7e43ecf82-6d4e8.png","srcSet":"/static/main-3fa0cfc39e8e9deadf7fd2d7e43ecf82-6d4e8.png 1x","srcWebp":"/static/main-3fa0cfc39e8e9deadf7fd2d7e43ecf82-9a16c.webp","srcSetWebp":"/static/main-3fa0cfc39e8e9deadf7fd2d7e43ecf82-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The first place is taken by Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in July 2021","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in July 2021.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-f6a532ea685f4c98898b5da2c69cc4c4-6d4e8.png","srcSet":"/static/main-f6a532ea685f4c98898b5da2c69cc4c4-6d4e8.png 1x","srcWebp":"/static/main-f6a532ea685f4c98898b5da2c69cc4c4-9a16c.webp","srcSetWebp":"/static/main-f6a532ea685f4c98898b5da2c69cc4c4-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber - Request a ride The first place belongs to Uber - Request a ride. The developer Uber Technologies, Inc. says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in July 2021","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in July 2021.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-8014a807e35ab34bbdce627bbba8fd01-6d4e8.png","srcSet":"/static/main-8014a807e35ab34bbdce627bbba8fd01-6d4e8.png 1x","srcWebp":"/static/main-8014a807e35ab34bbdce627bbba8fd01-9a16c.webp","srcSetWebp":"/static/main-8014a807e35ab34bbdce627bbba8fd01-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google The winning spot belongs to Google. The developer Google LLC says the following about the app.  Get fast access to Google Search with…","fields":{"slug":"/top-5-free-ios-apps-in-utilities-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in July 2021","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in July 2021.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-20753a00ae492ca13d2cb464bf9d82f3-6d4e8.png","srcSet":"/static/main-20753a00ae492ca13d2cb464bf9d82f3-6d4e8.png 1x","srcWebp":"/static/main-20753a00ae492ca13d2cb464bf9d82f3-9a16c.webp","srcSetWebp":"/static/main-20753a00ae492ca13d2cb464bf9d82f3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facebook The first place is taken by Facebook. The developer Facebook, Inc. says the following about the app.  Connect with friends, family…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in July 2021","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in July 2021.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-94c3edcafc60f5126f07a37edebfd6f0-6d4e8.png","srcSet":"/static/main-94c3edcafc60f5126f07a37edebfd6f0-6d4e8.png 1x","srcWebp":"/static/main-94c3edcafc60f5126f07a37edebfd6f0-9a16c.webp","srcSetWebp":"/static/main-94c3edcafc60f5126f07a37edebfd6f0-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The first place is taken by LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in July 2021","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in July 2021.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-057f80706a8e6e4beebce18313d35d61-6d4e8.png","srcSet":"/static/main-057f80706a8e6e4beebce18313d35d61-6d4e8.png 1x","srcWebp":"/static/main-057f80706a8e6e4beebce18313d35d61-9a16c.webp","srcSetWebp":"/static/main-057f80706a8e6e4beebce18313d35d61-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The first place is taken by onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in July 2021","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in July 2021.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e27480a13966830a688515b952b4cf95-6d4e8.png","srcSet":"/static/main-e27480a13966830a688515b952b4cf95-6d4e8.png 1x","srcWebp":"/static/main-e27480a13966830a688515b952b4cf95-9a16c.webp","srcSetWebp":"/static/main-e27480a13966830a688515b952b4cf95-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder - Dating & New Friends The first place is taken by Tinder - Dating & New Friends. The developer Tinder Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in July 2021","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in July 2021.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-74f365a20e6ca7958625d2e1105abcb7-6d4e8.png","srcSet":"/static/main-74f365a20e6ca7958625d2e1105abcb7-6d4e8.png 1x","srcWebp":"/static/main-74f365a20e6ca7958625d2e1105abcb7-9a16c.webp","srcSetWebp":"/static/main-74f365a20e6ca7958625d2e1105abcb7-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"PictureThis - Plant Identifier The winner of the battle is PictureThis - Plant Identifier. The developer Glority Global Group Ltd. says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in July 2021","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in July 2021.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-07d4bdffadc011c6c837400a3ab31bba-6d4e8.png","srcSet":"/static/main-07d4bdffadc011c6c837400a3ab31bba-6d4e8.png 1x","srcWebp":"/static/main-07d4bdffadc011c6c837400a3ab31bba-9a16c.webp","srcSetWebp":"/static/main-07d4bdffadc011c6c837400a3ab31bba-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The first place is taken by YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Photo and Video in July 2021","subTitle":"Top 5 Grossing iOS Apps in Photo and Video and Reviews from the AppStore in July 2021.","category":"top 5 grossing ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-3fa0cfc39e8e9deadf7fd2d7e43ecf82-6d4e8.png","srcSet":"/static/main-3fa0cfc39e8e9deadf7fd2d7e43ecf82-6d4e8.png 1x","srcWebp":"/static/main-3fa0cfc39e8e9deadf7fd2d7e43ecf82-9a16c.webp","srcSetWebp":"/static/main-3fa0cfc39e8e9deadf7fd2d7e43ecf82-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"BIGO LIVE-Live Stream, Go Live The first place belongs to BIGO LIVE-Live Stream, Go Live. The developer BIGO TECHNOLOGY PTE. LTD. says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in July 2021","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in July 2021.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e9465ac30db0d2e8639cef4e3c85cb8f-6d4e8.png","srcSet":"/static/main-e9465ac30db0d2e8639cef4e3c85cb8f-6d4e8.png 1x","srcWebp":"/static/main-e9465ac30db0d2e8639cef4e3c85cb8f-9a16c.webp","srcSetWebp":"/static/main-e9465ac30db0d2e8639cef4e3c85cb8f-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"My Disney Experience The first place belongs to My Disney Experience. The developer Disney says the following about the app.  The official…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Travel in July 2021","subTitle":"Top 5 Grossing iOS Apps in Travel and Reviews from the AppStore in July 2021.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a5f8f48dfadf6d9b8d7b3f50f9acf169-6d4e8.png","srcSet":"/static/main-a5f8f48dfadf6d9b8d7b3f50f9acf169-6d4e8.png 1x","srcWebp":"/static/main-a5f8f48dfadf6d9b8d7b3f50f9acf169-9a16c.webp","srcSetWebp":"/static/main-a5f8f48dfadf6d9b8d7b3f50f9acf169-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"SkyView® The winning spot belongs to SkyView®. The developer Terminal Eleven LLC says the following about the app.  SkyView® brings…","fields":{"slug":"/top-5-paid-ios-apps-in-education-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in July 2021","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in July 2021.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0829c236212b904092fe757b109b6e14-6d4e8.png","srcSet":"/static/main-0829c236212b904092fe757b109b6e14-6d4e8.png 1x","srcWebp":"/static/main-0829c236212b904092fe757b109b6e14-9a16c.webp","srcSetWebp":"/static/main-0829c236212b904092fe757b109b6e14-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The first place belongs to RoboKiller: Block Spam Calls. The developer TelTech Systems says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in July 2021","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in July 2021.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-83e42277b65c5f245f3d33931f47c17d-6d4e8.png","srcSet":"/static/main-83e42277b65c5f245f3d33931f47c17d-6d4e8.png 1x","srcWebp":"/static/main-83e42277b65c5f245f3d33931f47c17d-9a16c.webp","srcSetWebp":"/static/main-83e42277b65c5f245f3d33931f47c17d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Cloud Baby Monitor The winner of the battle is Cloud Baby Monitor. The developer VIGI Limited says the following about the app.  High…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in July 2021","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in July 2021.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-f54d3ad95f7b36a6a460c672913dc21b-6d4e8.png","srcSet":"/static/main-f54d3ad95f7b36a6a460c672913dc21b-6d4e8.png 1x","srcWebp":"/static/main-f54d3ad95f7b36a6a460c672913dc21b-9a16c.webp","srcSetWebp":"/static/main-f54d3ad95f7b36a6a460c672913dc21b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The winner of the battle is HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in July 2021","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in July 2021.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-fd644749ac985aa13dbf8e35d380734f-6d4e8.png","srcSet":"/static/main-fd644749ac985aa13dbf8e35d380734f-6d4e8.png 1x","srcWebp":"/static/main-fd644749ac985aa13dbf8e35d380734f-9a16c.webp","srcSetWebp":"/static/main-fd644749ac985aa13dbf8e35d380734f-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"iNavX: Marine Navigation The winner of the battle is iNavX: Marine Navigation. The developer NavX Studios LLC says the following about the…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in July 2021","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in July 2021.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-427a1f81209ce9215e01719ede0d06a3-6d4e8.png","srcSet":"/static/main-427a1f81209ce9215e01719ede0d06a3-6d4e8.png 1x","srcWebp":"/static/main-427a1f81209ce9215e01719ede0d06a3-9a16c.webp","srcSetWebp":"/static/main-427a1f81209ce9215e01719ede0d06a3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"kirakira+ The first place belongs to kirakira+. The developer bytes inc. says the following about the app.  With this app, you can add…","fields":{"slug":"/top-5-paid-ios-apps-in-photo-and-video-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in July 2021","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in July 2021.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-2846e198a89990291f20fe2ed9921e5e-6d4e8.png","srcSet":"/static/main-2846e198a89990291f20fe2ed9921e5e-6d4e8.png 1x","srcWebp":"/static/main-2846e198a89990291f20fe2ed9921e5e-9a16c.webp","srcSetWebp":"/static/main-2846e198a89990291f20fe2ed9921e5e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Screen Mirroring+ for Roku The winner of the battle is Screen Mirroring+ for Roku. The developer Kraus und Karnath GbR 2Kit Consulting says…","fields":{"slug":"/top-5-paid-ios-apps-in-productivity-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in July 2021","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in July 2021.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-858f4a3608ed2ea0e802614a0102a574-6d4e8.png","srcSet":"/static/main-858f4a3608ed2ea0e802614a0102a574-6d4e8.png 1x","srcWebp":"/static/main-858f4a3608ed2ea0e802614a0102a574-9a16c.webp","srcSetWebp":"/static/main-858f4a3608ed2ea0e802614a0102a574-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Vegan Food Near You - HappyCow The first place is taken by Vegan Food Near You - HappyCow. The developer HappyCow says the following about…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in July 2021","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in July 2021.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-f96839b479114f55eb24a995f5570d1d-6d4e8.png","srcSet":"/static/main-f96839b479114f55eb24a995f5570d1d-6d4e8.png 1x","srcWebp":"/static/main-f96839b479114f55eb24a995f5570d1d-9a16c.webp","srcSetWebp":"/static/main-f96839b479114f55eb24a995f5570d1d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Shadowrocket The first place belongs to Shadowrocket. The developer Shadow Launch Technology Limited says the following about the app.  Rule…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in July 2021","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in July 2021.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a3365806900f13333d7386257c061fdd-6d4e8.png","srcSet":"/static/main-a3365806900f13333d7386257c061fdd-6d4e8.png 1x","srcWebp":"/static/main-a3365806900f13333d7386257c061fdd-9a16c.webp","srcSetWebp":"/static/main-a3365806900f13333d7386257c061fdd-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Threema. The Secure Messenger The winning spot belongs to Threema. The Secure Messenger. The developer Threema GmbH says the following about…","fields":{"slug":"/top-5-paid-ios-apps-in-social-networking-in-july-2021/","prefix":"2021-07-04"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Social Networking in July 2021","subTitle":"Top 5 Paid iOS Apps in Social Networking and Reviews from the AppStore in July 2021.","category":"top 5 paid ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-da7ca3595eb3ad42f3f259f2b1ba41a9-6d4e8.png","srcSet":"/static/main-da7ca3595eb3ad42f3f259f2b1ba41a9-6d4e8.png 1x","srcWebp":"/static/main-da7ca3595eb3ad42f3f259f2b1ba41a9-9a16c.webp","srcSetWebp":"/static/main-da7ca3595eb3ad42f3f259f2b1ba41a9-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ZOOM Cloud Meetings The first place is taken by ZOOM Cloud Meetings. The developer Zoom says the following about the app.  Zoom is #1 in…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in May 2021","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in May 2021.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-eb11d2e7632e0984897344d4b613a862-6d4e8.png","srcSet":"/static/main-eb11d2e7632e0984897344d4b613a862-6d4e8.png 1x","srcWebp":"/static/main-eb11d2e7632e0984897344d4b613a862-9a16c.webp","srcSetWebp":"/static/main-eb11d2e7632e0984897344d4b613a862-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"PictureThis - Plant Identifier The winner of the battle is PictureThis - Plant Identifier. The developer Glority Global Group Ltd. says the…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in May 2021","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in May 2021.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-3117ba599d996b39d56c7c9ef12b990c-6d4e8.png","srcSet":"/static/main-3117ba599d996b39d56c7c9ef12b990c-6d4e8.png 1x","srcWebp":"/static/main-3117ba599d996b39d56c7c9ef12b990c-9a16c.webp","srcSetWebp":"/static/main-3117ba599d996b39d56c7c9ef12b990c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps The winning spot belongs to Google Maps. The developer Google LLC says the following about the app.  Navigate your world faster…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in May 2021","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in May 2021.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-322aaed159e8c270496aab396247eb15-6d4e8.png","srcSet":"/static/main-322aaed159e8c270496aab396247eb15-6d4e8.png 1x","srcWebp":"/static/main-322aaed159e8c270496aab396247eb15-9a16c.webp","srcSetWebp":"/static/main-322aaed159e8c270496aab396247eb15-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Pinterest The winning spot belongs to Pinterest. The developer Pinterest says the following about the app.  Looking for inspiration? Whether…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in May 2021","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in May 2021.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-2e52af373f7ffb152aa542d2d831cd8c-6d4e8.png","srcSet":"/static/main-2e52af373f7ffb152aa542d2d831cd8c-6d4e8.png 1x","srcWebp":"/static/main-2e52af373f7ffb152aa542d2d831cd8c-9a16c.webp","srcSetWebp":"/static/main-2e52af373f7ffb152aa542d2d831cd8c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winner of the battle is YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-free-ios-apps-in-photo-and-video-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in May 2021","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in May 2021.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9d73ab253cd90ebfaf702badb2c3d73c-6d4e8.png","srcSet":"/static/main-9d73ab253cd90ebfaf702badb2c3d73c-6d4e8.png 1x","srcWebp":"/static/main-9d73ab253cd90ebfaf702badb2c3d73c-9a16c.webp","srcSetWebp":"/static/main-9d73ab253cd90ebfaf702badb2c3d73c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The winner of the battle is Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in May 2021","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in May 2021.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a0b848a80c3f2c4b97223cd3b1188318-6d4e8.png","srcSet":"/static/main-a0b848a80c3f2c4b97223cd3b1188318-6d4e8.png 1x","srcWebp":"/static/main-a0b848a80c3f2c4b97223cd3b1188318-9a16c.webp","srcSetWebp":"/static/main-a0b848a80c3f2c4b97223cd3b1188318-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facebook The first place is taken by Facebook. The developer Facebook, Inc. says the following about the app.  Connect with friends, family…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in May 2021","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in May 2021.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e4f4f148c397bad5e6955613c0685559-6d4e8.png","srcSet":"/static/main-e4f4f148c397bad5e6955613c0685559-6d4e8.png 1x","srcWebp":"/static/main-e4f4f148c397bad5e6955613c0685559-9a16c.webp","srcSetWebp":"/static/main-e4f4f148c397bad5e6955613c0685559-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"GasBuddy: Find & Pay for Gas The winner of the battle is GasBuddy: Find & Pay for Gas. The developer GasBuddy Organization Inc says the…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in May 2021","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in May 2021.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c6638012dd7a6ae7096088e178dc80ed-6d4e8.png","srcSet":"/static/main-c6638012dd7a6ae7096088e178dc80ed-6d4e8.png 1x","srcWebp":"/static/main-c6638012dd7a6ae7096088e178dc80ed-9a16c.webp","srcSetWebp":"/static/main-c6638012dd7a6ae7096088e178dc80ed-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google The first place is taken by Google. The developer Google LLC says the following about the app.  Get fast access to Google Search with…","fields":{"slug":"/top-5-free-ios-apps-in-utilities-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in May 2021","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in May 2021.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-2cff9c9aa50552caf688fa9b7b63e04e-6d4e8.png","srcSet":"/static/main-2cff9c9aa50552caf688fa9b7b63e04e-6d4e8.png 1x","srcWebp":"/static/main-2cff9c9aa50552caf688fa9b7b63e04e-9a16c.webp","srcSetWebp":"/static/main-2cff9c9aa50552caf688fa9b7b63e04e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The winner of the battle is LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in May 2021","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in May 2021.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a5fc00b3627309185548b0d849728fd5-6d4e8.png","srcSet":"/static/main-a5fc00b3627309185548b0d849728fd5-6d4e8.png 1x","srcWebp":"/static/main-a5fc00b3627309185548b0d849728fd5-9a16c.webp","srcSetWebp":"/static/main-a5fc00b3627309185548b0d849728fd5-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"PictureThis - Plant Identifier The winner of the battle is PictureThis - Plant Identifier. The developer Glority Global Group Ltd. says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in May 2021","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in May 2021.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-3117ba599d996b39d56c7c9ef12b990c-6d4e8.png","srcSet":"/static/main-3117ba599d996b39d56c7c9ef12b990c-6d4e8.png 1x","srcWebp":"/static/main-3117ba599d996b39d56c7c9ef12b990c-9a16c.webp","srcSetWebp":"/static/main-3117ba599d996b39d56c7c9ef12b990c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder - Dating New People The first place belongs to Tinder - Dating New People. The developer Tinder Inc. says the following about the app…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in May 2021","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in May 2021.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5e355ddd27c16377b5d8eede332becfa-6d4e8.png","srcSet":"/static/main-5e355ddd27c16377b5d8eede332becfa-6d4e8.png 1x","srcWebp":"/static/main-5e355ddd27c16377b5d8eede332becfa-9a16c.webp","srcSetWebp":"/static/main-5e355ddd27c16377b5d8eede332becfa-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The winner of the battle is onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in May 2021","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in May 2021.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5e930619d4a4ae4182644ae49fd91114-6d4e8.png","srcSet":"/static/main-5e930619d4a4ae4182644ae49fd91114-6d4e8.png 1x","srcWebp":"/static/main-5e930619d4a4ae4182644ae49fd91114-9a16c.webp","srcSetWebp":"/static/main-5e930619d4a4ae4182644ae49fd91114-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"BIGO LIVE-Live Stream, Go Live The first place is taken by BIGO LIVE-Live Stream, Go Live. The developer BIGO TECHNOLOGY PTE. LTD. says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in May 2021","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in May 2021.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-81d4c99a5aae7e76c1338e977913dcfd-6d4e8.png","srcSet":"/static/main-81d4c99a5aae7e76c1338e977913dcfd-6d4e8.png 1x","srcWebp":"/static/main-81d4c99a5aae7e76c1338e977913dcfd-9a16c.webp","srcSetWebp":"/static/main-81d4c99a5aae7e76c1338e977913dcfd-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winner of the battle is YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Photo and Video in May 2021","subTitle":"Top 5 Grossing iOS Apps in Photo and Video and Reviews from the AppStore in May 2021.","category":"top 5 grossing ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9d73ab253cd90ebfaf702badb2c3d73c-6d4e8.png","srcSet":"/static/main-9d73ab253cd90ebfaf702badb2c3d73c-6d4e8.png 1x","srcWebp":"/static/main-9d73ab253cd90ebfaf702badb2c3d73c-9a16c.webp","srcSetWebp":"/static/main-9d73ab253cd90ebfaf702badb2c3d73c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"My Disney Experience The first place belongs to My Disney Experience. The developer Disney says the following about the app.  The official…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Travel in May 2021","subTitle":"Top 5 Grossing iOS Apps in Travel and Reviews from the AppStore in May 2021.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a866aeab8dc4f2445beb35763a5ae7a0-6d4e8.png","srcSet":"/static/main-a866aeab8dc4f2445beb35763a5ae7a0-6d4e8.png 1x","srcWebp":"/static/main-a866aeab8dc4f2445beb35763a5ae7a0-9a16c.webp","srcSetWebp":"/static/main-a866aeab8dc4f2445beb35763a5ae7a0-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The winner of the battle is RoboKiller: Block Spam Calls. The developer TelTech Systems says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in May 2021","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in May 2021.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-bae0b026a4c698017adb1052ab00f8ca-6d4e8.png","srcSet":"/static/main-bae0b026a4c698017adb1052ab00f8ca-6d4e8.png 1x","srcWebp":"/static/main-bae0b026a4c698017adb1052ab00f8ca-9a16c.webp","srcSetWebp":"/static/main-bae0b026a4c698017adb1052ab00f8ca-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The first place is taken by HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in May 2021","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in May 2021.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-7e7354df1fd3211afdbc687d8d41eb81-6d4e8.png","srcSet":"/static/main-7e7354df1fd3211afdbc687d8d41eb81-6d4e8.png 1x","srcWebp":"/static/main-7e7354df1fd3211afdbc687d8d41eb81-9a16c.webp","srcSetWebp":"/static/main-7e7354df1fd3211afdbc687d8d41eb81-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"AnkiMobile Flashcards The winner of the battle is AnkiMobile Flashcards. The developer Ankitects Pty Ltd says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-education-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in May 2021","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in May 2021.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-52ead264b2c757a330b35e4f8f29dfd7-6d4e8.png","srcSet":"/static/main-52ead264b2c757a330b35e4f8f29dfd7-6d4e8.png 1x","srcWebp":"/static/main-52ead264b2c757a330b35e4f8f29dfd7-9a16c.webp","srcSetWebp":"/static/main-52ead264b2c757a330b35e4f8f29dfd7-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Land Nav Assistant The winning spot belongs to Land Nav Assistant. The developer Gammon Applications says the following about the app.  Land…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in May 2021","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in May 2021.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-065d0f9b33ce69d52b0863ced7d35267-6d4e8.png","srcSet":"/static/main-065d0f9b33ce69d52b0863ced7d35267-6d4e8.png 1x","srcWebp":"/static/main-065d0f9b33ce69d52b0863ced7d35267-9a16c.webp","srcSetWebp":"/static/main-065d0f9b33ce69d52b0863ced7d35267-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facetune The winning spot belongs to Facetune. The developer Lightricks Ltd. says the following about the app.  Facetune 2 is now available…","fields":{"slug":"/top-5-paid-ios-apps-in-photo-and-video-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in May 2021","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in May 2021.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ebe9a3f062c7601a39db2b2afa605a03-6d4e8.png","srcSet":"/static/main-ebe9a3f062c7601a39db2b2afa605a03-6d4e8.png 1x","srcWebp":"/static/main-ebe9a3f062c7601a39db2b2afa605a03-9a16c.webp","srcSetWebp":"/static/main-ebe9a3f062c7601a39db2b2afa605a03-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"INKHUNTER PRO Tattoos try on The winner of the battle is INKHUNTER PRO Tattoos try on. The developer INKHUNTER, Inc. says the following…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in May 2021","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in May 2021.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-12af33fe86a742a0eb80696242ec6859-6d4e8.png","srcSet":"/static/main-12af33fe86a742a0eb80696242ec6859-6d4e8.png 1x","srcWebp":"/static/main-12af33fe86a742a0eb80696242ec6859-9a16c.webp","srcSetWebp":"/static/main-12af33fe86a742a0eb80696242ec6859-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Forest - Stay focused The winner of the battle is Forest - Stay focused. The developer SEEKRTECH CO., LTD. says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-productivity-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in May 2021","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in May 2021.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b75d01a05024716eb83731aa195329df-6d4e8.png","srcSet":"/static/main-b75d01a05024716eb83731aa195329df-6d4e8.png 1x","srcWebp":"/static/main-b75d01a05024716eb83731aa195329df-9a16c.webp","srcSetWebp":"/static/main-b75d01a05024716eb83731aa195329df-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Threema. The Secure Messenger The winning spot belongs to Threema. The Secure Messenger. The developer Threema GmbH says the following about…","fields":{"slug":"/top-5-paid-ios-apps-in-social-networking-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Social Networking in May 2021","subTitle":"Top 5 Paid iOS Apps in Social Networking and Reviews from the AppStore in May 2021.","category":"top 5 paid ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-94ec3dc91b13db13cc6fb0255f0587a7-6d4e8.png","srcSet":"/static/main-94ec3dc91b13db13cc6fb0255f0587a7-6d4e8.png 1x","srcWebp":"/static/main-94ec3dc91b13db13cc6fb0255f0587a7-9a16c.webp","srcSetWebp":"/static/main-94ec3dc91b13db13cc6fb0255f0587a7-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Shadowrocket The winner of the battle is Shadowrocket. The developer Shadow Launch Technology Limited says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in May 2021","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in May 2021.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5ac4119b0c1fa1ea16decee09d81d74e-6d4e8.png","srcSet":"/static/main-5ac4119b0c1fa1ea16decee09d81d74e-6d4e8.png 1x","srcWebp":"/static/main-5ac4119b0c1fa1ea16decee09d81d74e-9a16c.webp","srcSetWebp":"/static/main-5ac4119b0c1fa1ea16decee09d81d74e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Camp & RV - Tents to RV Parks The winner of the battle is Camp & RV - Tents to RV Parks. The developer Allstays LLC says the following about…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-may-2021/","prefix":"2021-05-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in May 2021","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in May 2021.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-93da7df7d8bad54a3c94b8271dbf5027-6d4e8.png","srcSet":"/static/main-93da7df7d8bad54a3c94b8271dbf5027-6d4e8.png 1x","srcWebp":"/static/main-93da7df7d8bad54a3c94b8271dbf5027-9a16c.webp","srcSetWebp":"/static/main-93da7df7d8bad54a3c94b8271dbf5027-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ZOOM Cloud Meetings The first place is taken by ZOOM Cloud Meetings. The developer Zoom says the following about the app.  Zoom is #1 in…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in April 2021","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in April 2021.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-30db852f52d2e95933770d6b42d38e74-6d4e8.png","srcSet":"/static/main-30db852f52d2e95933770d6b42d38e74-6d4e8.png 1x","srcWebp":"/static/main-30db852f52d2e95933770d6b42d38e74-9a16c.webp","srcSetWebp":"/static/main-30db852f52d2e95933770d6b42d38e74-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"PictureThis - Plant Identifier The winning spot belongs to PictureThis - Plant Identifier. The developer Glority Global Group Ltd. says the…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in April 2021","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in April 2021.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-eaf14fdfad0a9475cfa81c1bb18c0aad-6d4e8.png","srcSet":"/static/main-eaf14fdfad0a9475cfa81c1bb18c0aad-6d4e8.png 1x","srcWebp":"/static/main-eaf14fdfad0a9475cfa81c1bb18c0aad-9a16c.webp","srcSetWebp":"/static/main-eaf14fdfad0a9475cfa81c1bb18c0aad-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Pinterest The first place is taken by Pinterest. The developer Pinterest says the following about the app.  Looking for inspiration? Whether…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in April 2021","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in April 2021.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-2e52af373f7ffb152aa542d2d831cd8c-6d4e8.png","srcSet":"/static/main-2e52af373f7ffb152aa542d2d831cd8c-6d4e8.png 1x","srcWebp":"/static/main-2e52af373f7ffb152aa542d2d831cd8c-9a16c.webp","srcSetWebp":"/static/main-2e52af373f7ffb152aa542d2d831cd8c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The winner of the battle is Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in April 2021","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in April 2021.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-aa10ee1e3cac97d13e694bd28479118f-6d4e8.png","srcSet":"/static/main-aa10ee1e3cac97d13e694bd28479118f-6d4e8.png 1x","srcWebp":"/static/main-aa10ee1e3cac97d13e694bd28479118f-9a16c.webp","srcSetWebp":"/static/main-aa10ee1e3cac97d13e694bd28479118f-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps - Transit & Food The first place belongs to Google Maps - Transit & Food. The developer Google LLC says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in April 2021","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in April 2021.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-322aaed159e8c270496aab396247eb15-6d4e8.png","srcSet":"/static/main-322aaed159e8c270496aab396247eb15-6d4e8.png 1x","srcWebp":"/static/main-322aaed159e8c270496aab396247eb15-9a16c.webp","srcSetWebp":"/static/main-322aaed159e8c270496aab396247eb15-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winning spot belongs to YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-free-ios-apps-in-photo-and-video-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in April 2021","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in April 2021.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-1532ba9c1c5946d58e63d5c858f24eb6-6d4e8.png","srcSet":"/static/main-1532ba9c1c5946d58e63d5c858f24eb6-6d4e8.png 1x","srcWebp":"/static/main-1532ba9c1c5946d58e63d5c858f24eb6-9a16c.webp","srcSetWebp":"/static/main-1532ba9c1c5946d58e63d5c858f24eb6-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facebook The winner of the battle is Facebook. The developer Facebook, Inc. says the following about the app.  Connect with friends, family…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in April 2021","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in April 2021.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-4b95fe776965022d02c48cc5d0679261-6d4e8.png","srcSet":"/static/main-4b95fe776965022d02c48cc5d0679261-6d4e8.png 1x","srcWebp":"/static/main-4b95fe776965022d02c48cc5d0679261-9a16c.webp","srcSetWebp":"/static/main-4b95fe776965022d02c48cc5d0679261-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber - Request a ride The winning spot belongs to Uber - Request a ride. The developer Uber Technologies, Inc. says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in April 2021","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in April 2021.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b192663f219de9a9a877d7c992bf0e85-6d4e8.png","srcSet":"/static/main-b192663f219de9a9a877d7c992bf0e85-6d4e8.png 1x","srcWebp":"/static/main-b192663f219de9a9a877d7c992bf0e85-9a16c.webp","srcSetWebp":"/static/main-b192663f219de9a9a877d7c992bf0e85-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The winner of the battle is LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in April 2021","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in April 2021.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9d1f101e42efefc71bc8e06622326a3a-6d4e8.png","srcSet":"/static/main-9d1f101e42efefc71bc8e06622326a3a-6d4e8.png 1x","srcWebp":"/static/main-9d1f101e42efefc71bc8e06622326a3a-9a16c.webp","srcSetWebp":"/static/main-9d1f101e42efefc71bc8e06622326a3a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google The winner of the battle is Google. The developer Google LLC says the following about the app.  Get fast access to Google Search with…","fields":{"slug":"/top-5-free-ios-apps-in-utilities-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in April 2021","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in April 2021.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-090bbfe62516c758ad4bee869f31c99e-6d4e8.png","srcSet":"/static/main-090bbfe62516c758ad4bee869f31c99e-6d4e8.png 1x","srcWebp":"/static/main-090bbfe62516c758ad4bee869f31c99e-9a16c.webp","srcSetWebp":"/static/main-090bbfe62516c758ad4bee869f31c99e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"PictureThis - Plant Identifier The first place is taken by PictureThis - Plant Identifier. The developer Glority Global Group Ltd. says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in April 2021","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in April 2021.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-eaf14fdfad0a9475cfa81c1bb18c0aad-6d4e8.png","srcSet":"/static/main-eaf14fdfad0a9475cfa81c1bb18c0aad-6d4e8.png 1x","srcWebp":"/static/main-eaf14fdfad0a9475cfa81c1bb18c0aad-9a16c.webp","srcSetWebp":"/static/main-eaf14fdfad0a9475cfa81c1bb18c0aad-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder - Dating New People The winner of the battle is Tinder - Dating New People. The developer Tinder Inc. says the following about the…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in April 2021","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in April 2021.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5e355ddd27c16377b5d8eede332becfa-6d4e8.png","srcSet":"/static/main-5e355ddd27c16377b5d8eede332becfa-6d4e8.png 1x","srcWebp":"/static/main-5e355ddd27c16377b5d8eede332becfa-9a16c.webp","srcSetWebp":"/static/main-5e355ddd27c16377b5d8eede332becfa-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The first place belongs to YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Photo and Video in April 2021","subTitle":"Top 5 Grossing iOS Apps in Photo and Video and Reviews from the AppStore in April 2021.","category":"top 5 grossing ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-1532ba9c1c5946d58e63d5c858f24eb6-6d4e8.png","srcSet":"/static/main-1532ba9c1c5946d58e63d5c858f24eb6-6d4e8.png 1x","srcWebp":"/static/main-1532ba9c1c5946d58e63d5c858f24eb6-9a16c.webp","srcSetWebp":"/static/main-1532ba9c1c5946d58e63d5c858f24eb6-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"BIGO LIVE-Live Stream, Go Live The first place is taken by BIGO LIVE-Live Stream, Go Live. The developer BIGO TECHNOLOGY PTE. LTD. says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in April 2021","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in April 2021.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e7c108e66a4c32299aa84d2a860a3f9d-6d4e8.png","srcSet":"/static/main-e7c108e66a4c32299aa84d2a860a3f9d-6d4e8.png 1x","srcWebp":"/static/main-e7c108e66a4c32299aa84d2a860a3f9d-9a16c.webp","srcSetWebp":"/static/main-e7c108e66a4c32299aa84d2a860a3f9d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The first place is taken by onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in April 2021","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in April 2021.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5b7f3f143ac0cfceae0e0383586d5286-6d4e8.png","srcSet":"/static/main-5b7f3f143ac0cfceae0e0383586d5286-6d4e8.png 1x","srcWebp":"/static/main-5b7f3f143ac0cfceae0e0383586d5286-9a16c.webp","srcSetWebp":"/static/main-5b7f3f143ac0cfceae0e0383586d5286-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"My Disney Experience The winner of the battle is My Disney Experience. The developer Disney says the following about the app.  The official…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Travel in April 2021","subTitle":"Top 5 Grossing iOS Apps in Travel and Reviews from the AppStore in April 2021.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-8f629f27fd9ccd34a34e994c888e3030-6d4e8.png","srcSet":"/static/main-8f629f27fd9ccd34a34e994c888e3030-6d4e8.png 1x","srcWebp":"/static/main-8f629f27fd9ccd34a34e994c888e3030-9a16c.webp","srcSetWebp":"/static/main-8f629f27fd9ccd34a34e994c888e3030-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The first place is taken by RoboKiller: Block Spam Calls. The developer TelTech Systems says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in April 2021","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in April 2021.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-fb0f5b62fe7857bd923ec01e493b01b9-6d4e8.png","srcSet":"/static/main-fb0f5b62fe7857bd923ec01e493b01b9-6d4e8.png 1x","srcWebp":"/static/main-fb0f5b62fe7857bd923ec01e493b01b9-9a16c.webp","srcSetWebp":"/static/main-fb0f5b62fe7857bd923ec01e493b01b9-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"INKHUNTER PRO Tattoos try on The winner of the battle is INKHUNTER PRO Tattoos try on. The developer INKHUNTER, Inc. says the following…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in April 2021","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in April 2021.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-40ea6834b2982debb0131810e9f1d492-6d4e8.png","srcSet":"/static/main-40ea6834b2982debb0131810e9f1d492-6d4e8.png 1x","srcWebp":"/static/main-40ea6834b2982debb0131810e9f1d492-9a16c.webp","srcSetWebp":"/static/main-40ea6834b2982debb0131810e9f1d492-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"SkyView® The winner of the battle is SkyView®. The developer Terminal Eleven LLC says the following about the app.  SkyView® brings…","fields":{"slug":"/top-5-paid-ios-apps-in-education-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in April 2021","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in April 2021.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0d5a380d33c27e04670560a433e3ccb3-6d4e8.png","srcSet":"/static/main-0d5a380d33c27e04670560a433e3ccb3-6d4e8.png 1x","srcWebp":"/static/main-0d5a380d33c27e04670560a433e3ccb3-9a16c.webp","srcSetWebp":"/static/main-0d5a380d33c27e04670560a433e3ccb3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The first place belongs to HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in April 2021","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in April 2021.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0c0ffd65ee07f1fb28b49579cf68a307-6d4e8.png","srcSet":"/static/main-0c0ffd65ee07f1fb28b49579cf68a307-6d4e8.png 1x","srcWebp":"/static/main-0c0ffd65ee07f1fb28b49579cf68a307-9a16c.webp","srcSetWebp":"/static/main-0c0ffd65ee07f1fb28b49579cf68a307-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"iNavX: Marine Navigation The winner of the battle is iNavX: Marine Navigation. The developer NavX Studios LLC says the following about the…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in April 2021","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in April 2021.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5cb27b355765a253374641f44fd2899e-6d4e8.png","srcSet":"/static/main-5cb27b355765a253374641f44fd2899e-6d4e8.png 1x","srcWebp":"/static/main-5cb27b355765a253374641f44fd2899e-9a16c.webp","srcSetWebp":"/static/main-5cb27b355765a253374641f44fd2899e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facetune The first place belongs to Facetune. The developer Lightricks Ltd. says the following about the app.  Facetune 2 is now available…","fields":{"slug":"/top-5-paid-ios-apps-in-photo-and-video-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in April 2021","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in April 2021.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-77d1a97b8ff2cf3efad7df6b9e14ee06-6d4e8.png","srcSet":"/static/main-77d1a97b8ff2cf3efad7df6b9e14ee06-6d4e8.png 1x","srcWebp":"/static/main-77d1a97b8ff2cf3efad7df6b9e14ee06-9a16c.webp","srcSetWebp":"/static/main-77d1a97b8ff2cf3efad7df6b9e14ee06-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Screen Mirroring+ for Roku The first place belongs to Screen Mirroring+ for Roku. The developer Kraus und Karnath GbR 2Kit Consulting says…","fields":{"slug":"/top-5-paid-ios-apps-in-productivity-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in April 2021","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in April 2021.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-4922948eedd131ca857d55dacc99a89e-6d4e8.png","srcSet":"/static/main-4922948eedd131ca857d55dacc99a89e-6d4e8.png 1x","srcWebp":"/static/main-4922948eedd131ca857d55dacc99a89e-9a16c.webp","srcSetWebp":"/static/main-4922948eedd131ca857d55dacc99a89e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Camp & RV - Tents to RV Parks The winning spot belongs to Camp & RV - Tents to RV Parks. The developer Allstays LLC says the following about…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in April 2021","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in April 2021.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-93da7df7d8bad54a3c94b8271dbf5027-6d4e8.png","srcSet":"/static/main-93da7df7d8bad54a3c94b8271dbf5027-6d4e8.png 1x","srcWebp":"/static/main-93da7df7d8bad54a3c94b8271dbf5027-9a16c.webp","srcSetWebp":"/static/main-93da7df7d8bad54a3c94b8271dbf5027-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Threema. The Secure Messenger The winner of the battle is Threema. The Secure Messenger. The developer Threema GmbH says the following about…","fields":{"slug":"/top-5-paid-ios-apps-in-social-networking-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Social Networking in April 2021","subTitle":"Top 5 Paid iOS Apps in Social Networking and Reviews from the AppStore in April 2021.","category":"top 5 paid ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-53144cf358760af54112d32b9a27a4c4-6d4e8.png","srcSet":"/static/main-53144cf358760af54112d32b9a27a4c4-6d4e8.png 1x","srcWebp":"/static/main-53144cf358760af54112d32b9a27a4c4-9a16c.webp","srcSetWebp":"/static/main-53144cf358760af54112d32b9a27a4c4-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Shadowrocket The winning spot belongs to Shadowrocket. The developer Shadow Launch Technology Limited says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-april-2021/","prefix":"2021-04-18"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in April 2021","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in April 2021.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-8e459e490b5d73a30cc8d2fa446c0f79-6d4e8.png","srcSet":"/static/main-8e459e490b5d73a30cc8d2fa446c0f79-6d4e8.png 1x","srcWebp":"/static/main-8e459e490b5d73a30cc8d2fa446c0f79-9a16c.webp","srcSetWebp":"/static/main-8e459e490b5d73a30cc8d2fa446c0f79-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ZOOM Cloud Meetings The winning spot belongs to ZOOM Cloud Meetings. The developer Zoom says the following about the app.  Zoom is #1 in…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in March 2021","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in March 2021.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-cd3693eaff676a3852db5dd0550966ca-6d4e8.png","srcSet":"/static/main-cd3693eaff676a3852db5dd0550966ca-6d4e8.png 1x","srcWebp":"/static/main-cd3693eaff676a3852db5dd0550966ca-9a16c.webp","srcSetWebp":"/static/main-cd3693eaff676a3852db5dd0550966ca-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Classroom The first place belongs to Google Classroom. The developer Google LLC says the following about the app.  Classroom is a…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in March 2021","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in March 2021.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-7c67d301835ef178fd342a427367330c-6d4e8.png","srcSet":"/static/main-7c67d301835ef178fd342a427367330c-6d4e8.png 1x","srcWebp":"/static/main-7c67d301835ef178fd342a427367330c-9a16c.webp","srcSetWebp":"/static/main-7c67d301835ef178fd342a427367330c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Pinterest The winner of the battle is Pinterest. The developer Pinterest says the following about the app.  Looking for inspiration? Whether…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in March 2021","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in March 2021.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b93f86bf2e3e27bab081f81538ad07ea-6d4e8.png","srcSet":"/static/main-b93f86bf2e3e27bab081f81538ad07ea-6d4e8.png 1x","srcWebp":"/static/main-b93f86bf2e3e27bab081f81538ad07ea-9a16c.webp","srcSetWebp":"/static/main-b93f86bf2e3e27bab081f81538ad07ea-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps - Transit & Food The winning spot belongs to Google Maps - Transit & Food. The developer Google LLC says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in March 2021","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in March 2021.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-19fed70364496fb25b86b1f3ccc6dcf8-6d4e8.png","srcSet":"/static/main-19fed70364496fb25b86b1f3ccc6dcf8-6d4e8.png 1x","srcWebp":"/static/main-19fed70364496fb25b86b1f3ccc6dcf8-9a16c.webp","srcSetWebp":"/static/main-19fed70364496fb25b86b1f3ccc6dcf8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winning spot belongs to YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-free-ios-apps-in-photo-and-video-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in March 2021","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in March 2021.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-98ccf41cc3f3d5ad06e081d6c54564b9-6d4e8.png","srcSet":"/static/main-98ccf41cc3f3d5ad06e081d6c54564b9-6d4e8.png 1x","srcWebp":"/static/main-98ccf41cc3f3d5ad06e081d6c54564b9-9a16c.webp","srcSetWebp":"/static/main-98ccf41cc3f3d5ad06e081d6c54564b9-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The first place is taken by Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in March 2021","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in March 2021.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-87647cd905627e907047e7627da32482-6d4e8.png","srcSet":"/static/main-87647cd905627e907047e7627da32482-6d4e8.png 1x","srcWebp":"/static/main-87647cd905627e907047e7627da32482-9a16c.webp","srcSetWebp":"/static/main-87647cd905627e907047e7627da32482-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facebook The first place belongs to Facebook. The developer Facebook, Inc. says the following about the app.  Connect with friends, family…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in March 2021","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in March 2021.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-377a3c877804a540b048198924f3239d-6d4e8.png","srcSet":"/static/main-377a3c877804a540b048198924f3239d-6d4e8.png 1x","srcWebp":"/static/main-377a3c877804a540b048198924f3239d-9a16c.webp","srcSetWebp":"/static/main-377a3c877804a540b048198924f3239d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google The winner of the battle is Google. The developer Google LLC says the following about the app.  Get fast access to Google Search with…","fields":{"slug":"/top-5-free-ios-apps-in-utilities-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in March 2021","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in March 2021.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-8070610e11a41dcfc16769f23301048e-6d4e8.png","srcSet":"/static/main-8070610e11a41dcfc16769f23301048e-6d4e8.png 1x","srcWebp":"/static/main-8070610e11a41dcfc16769f23301048e-9a16c.webp","srcSetWebp":"/static/main-8070610e11a41dcfc16769f23301048e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber - Request a ride The winner of the battle is Uber - Request a ride. The developer Uber Technologies, Inc. says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in March 2021","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in March 2021.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-7bd00a1195ec2b77c4387d22c7596506-6d4e8.png","srcSet":"/static/main-7bd00a1195ec2b77c4387d22c7596506-6d4e8.png 1x","srcWebp":"/static/main-7bd00a1195ec2b77c4387d22c7596506-9a16c.webp","srcSetWebp":"/static/main-7bd00a1195ec2b77c4387d22c7596506-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder - Dating & Meet People The first place belongs to Tinder - Dating & Meet People. The developer Tinder Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in March 2021","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in March 2021.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-2c0b02c26234d03215de83bf428fc69a-6d4e8.png","srcSet":"/static/main-2c0b02c26234d03215de83bf428fc69a-6d4e8.png 1x","srcWebp":"/static/main-2c0b02c26234d03215de83bf428fc69a-9a16c.webp","srcSetWebp":"/static/main-2c0b02c26234d03215de83bf428fc69a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The first place is taken by LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in March 2021","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in March 2021.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-03a5a90cba46dff5be357bdc6b512adc-6d4e8.png","srcSet":"/static/main-03a5a90cba46dff5be357bdc6b512adc-6d4e8.png 1x","srcWebp":"/static/main-03a5a90cba46dff5be357bdc6b512adc-9a16c.webp","srcSetWebp":"/static/main-03a5a90cba46dff5be357bdc6b512adc-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Duolingo - Language Lessons The winner of the battle is Duolingo - Language Lessons. The developer Duolingo says the following about the app…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in March 2021","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in March 2021.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b8e5da78fe53e6ef2ceff9719235ce79-6d4e8.png","srcSet":"/static/main-b8e5da78fe53e6ef2ceff9719235ce79-6d4e8.png 1x","srcWebp":"/static/main-b8e5da78fe53e6ef2ceff9719235ce79-9a16c.webp","srcSetWebp":"/static/main-b8e5da78fe53e6ef2ceff9719235ce79-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The first place is taken by onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in March 2021","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in March 2021.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-8fbe18c4f83518c9bd372a587ebecdc1-6d4e8.png","srcSet":"/static/main-8fbe18c4f83518c9bd372a587ebecdc1-6d4e8.png 1x","srcWebp":"/static/main-8fbe18c4f83518c9bd372a587ebecdc1-9a16c.webp","srcSetWebp":"/static/main-8fbe18c4f83518c9bd372a587ebecdc1-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The first place is taken by YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Photo and Video in March 2021","subTitle":"Top 5 Grossing iOS Apps in Photo and Video and Reviews from the AppStore in March 2021.","category":"top 5 grossing ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-98ccf41cc3f3d5ad06e081d6c54564b9-6d4e8.png","srcSet":"/static/main-98ccf41cc3f3d5ad06e081d6c54564b9-6d4e8.png 1x","srcWebp":"/static/main-98ccf41cc3f3d5ad06e081d6c54564b9-9a16c.webp","srcSetWebp":"/static/main-98ccf41cc3f3d5ad06e081d6c54564b9-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"BIGO LIVE-Live Stream, Go Live The winning spot belongs to BIGO LIVE-Live Stream, Go Live. The developer BIGO TECHNOLOGY PTE. LTD. says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in March 2021","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in March 2021.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b97e8212dc68fbbe7acb4d26758dc30c-6d4e8.png","srcSet":"/static/main-b97e8212dc68fbbe7acb4d26758dc30c-6d4e8.png 1x","srcWebp":"/static/main-b97e8212dc68fbbe7acb4d26758dc30c-9a16c.webp","srcSetWebp":"/static/main-b97e8212dc68fbbe7acb4d26758dc30c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"My Disney Experience The winning spot belongs to My Disney Experience. The developer Disney says the following about the app.  The official…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Travel in March 2021","subTitle":"Top 5 Grossing iOS Apps in Travel and Reviews from the AppStore in March 2021.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-394e04918feeb830240c7dbad01deb18-6d4e8.png","srcSet":"/static/main-394e04918feeb830240c7dbad01deb18-6d4e8.png 1x","srcWebp":"/static/main-394e04918feeb830240c7dbad01deb18-9a16c.webp","srcSetWebp":"/static/main-394e04918feeb830240c7dbad01deb18-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The winner of the battle is RoboKiller: Block Spam Calls. The developer TelTech Systems says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in March 2021","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in March 2021.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-3698468188f821b6e95b3078cafa070d-6d4e8.png","srcSet":"/static/main-3698468188f821b6e95b3078cafa070d-6d4e8.png 1x","srcWebp":"/static/main-3698468188f821b6e95b3078cafa070d-9a16c.webp","srcSetWebp":"/static/main-3698468188f821b6e95b3078cafa070d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The winner of the battle is HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in March 2021","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in March 2021.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0b4d904b4247eae751531637be13e8f8-6d4e8.png","srcSet":"/static/main-0b4d904b4247eae751531637be13e8f8-6d4e8.png 1x","srcWebp":"/static/main-0b4d904b4247eae751531637be13e8f8-9a16c.webp","srcSetWebp":"/static/main-0b4d904b4247eae751531637be13e8f8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"SkyView® The winner of the battle is SkyView®. The developer Terminal Eleven LLC says the following about the app.  SkyView® brings…","fields":{"slug":"/top-5-paid-ios-apps-in-education-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in March 2021","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in March 2021.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9c01d0d99d2da1631cbb00ae75d65d3a-6d4e8.png","srcSet":"/static/main-9c01d0d99d2da1631cbb00ae75d65d3a-6d4e8.png 1x","srcWebp":"/static/main-9c01d0d99d2da1631cbb00ae75d65d3a-9a16c.webp","srcSetWebp":"/static/main-9c01d0d99d2da1631cbb00ae75d65d3a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"CDOT Colorado Road Conditions The winner of the battle is CDOT Colorado Road Conditions. The developer LW Brands, LLC says the following…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in March 2021","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in March 2021.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-02e635dcf5e2d4da0048943e5dae0b5f-6d4e8.png","srcSet":"/static/main-02e635dcf5e2d4da0048943e5dae0b5f-6d4e8.png 1x","srcWebp":"/static/main-02e635dcf5e2d4da0048943e5dae0b5f-9a16c.webp","srcSetWebp":"/static/main-02e635dcf5e2d4da0048943e5dae0b5f-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"INKHUNTER PRO Tattoos try on The winning spot belongs to INKHUNTER PRO Tattoos try on. The developer INKHUNTER, Inc. says the following…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in March 2021","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in March 2021.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-40ea6834b2982debb0131810e9f1d492-6d4e8.png","srcSet":"/static/main-40ea6834b2982debb0131810e9f1d492-6d4e8.png 1x","srcWebp":"/static/main-40ea6834b2982debb0131810e9f1d492-9a16c.webp","srcSetWebp":"/static/main-40ea6834b2982debb0131810e9f1d492-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Forest - Stay focused The winner of the battle is Forest - Stay focused. The developer SEEKRTECH CO., LTD. says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-productivity-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in March 2021","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in March 2021.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-192c3c5ef19ce0d31be575ad508a03f9-6d4e8.png","srcSet":"/static/main-192c3c5ef19ce0d31be575ad508a03f9-6d4e8.png 1x","srcWebp":"/static/main-192c3c5ef19ce0d31be575ad508a03f9-9a16c.webp","srcSetWebp":"/static/main-192c3c5ef19ce0d31be575ad508a03f9-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facetune The winner of the battle is Facetune. The developer Lightricks Ltd. says the following about the app.  Facetune 2 is now available…","fields":{"slug":"/top-5-paid-ios-apps-in-photo-and-video-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in March 2021","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in March 2021.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-77d1a97b8ff2cf3efad7df6b9e14ee06-6d4e8.png","srcSet":"/static/main-77d1a97b8ff2cf3efad7df6b9e14ee06-6d4e8.png 1x","srcWebp":"/static/main-77d1a97b8ff2cf3efad7df6b9e14ee06-9a16c.webp","srcSetWebp":"/static/main-77d1a97b8ff2cf3efad7df6b9e14ee06-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Threema. The Secure Messenger The winning spot belongs to Threema. The Secure Messenger. The developer Threema GmbH says the following about…","fields":{"slug":"/top-5-paid-ios-apps-in-social-networking-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Social Networking in March 2021","subTitle":"Top 5 Paid iOS Apps in Social Networking and Reviews from the AppStore in March 2021.","category":"top 5 paid ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-53144cf358760af54112d32b9a27a4c4-6d4e8.png","srcSet":"/static/main-53144cf358760af54112d32b9a27a4c4-6d4e8.png 1x","srcWebp":"/static/main-53144cf358760af54112d32b9a27a4c4-9a16c.webp","srcSetWebp":"/static/main-53144cf358760af54112d32b9a27a4c4-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Camp & RV - Tents to RV Parks The winning spot belongs to Camp & RV - Tents to RV Parks. The developer Allstays LLC says the following about…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in March 2021","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in March 2021.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-23dcb0b5493209011419efcb230d1e9a-6d4e8.png","srcSet":"/static/main-23dcb0b5493209011419efcb230d1e9a-6d4e8.png 1x","srcWebp":"/static/main-23dcb0b5493209011419efcb230d1e9a-9a16c.webp","srcSetWebp":"/static/main-23dcb0b5493209011419efcb230d1e9a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Shadowrocket The first place is taken by Shadowrocket. The developer Shadow Launch Technology Limited says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-march-2021/","prefix":"2021-03-15"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in March 2021","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in March 2021.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6c3ee3bbddb7c4fe57dee5d9b187afcd-6d4e8.png","srcSet":"/static/main-6c3ee3bbddb7c4fe57dee5d9b187afcd-6d4e8.png 1x","srcWebp":"/static/main-6c3ee3bbddb7c4fe57dee5d9b187afcd-9a16c.webp","srcSetWebp":"/static/main-6c3ee3bbddb7c4fe57dee5d9b187afcd-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ZOOM Cloud Meetings The first place is taken by ZOOM Cloud Meetings. The developer Zoom says the following about the app.  Zoom is #1 in…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in November 2020","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in November 2020.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-1886c916742ec64a0320f934c4f33860-6d4e8.png","srcSet":"/static/main-1886c916742ec64a0320f934c4f33860-6d4e8.png 1x","srcWebp":"/static/main-1886c916742ec64a0320f934c4f33860-9a16c.webp","srcSetWebp":"/static/main-1886c916742ec64a0320f934c4f33860-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Photomath The first place belongs to Photomath. The developer Photomath, Inc. says the following about the app.  Learn math, check homework…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in November 2020","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in November 2020.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-7aa9b87e59d4698ed706be90719c7f73-6d4e8.png","srcSet":"/static/main-7aa9b87e59d4698ed706be90719c7f73-6d4e8.png 1x","srcWebp":"/static/main-7aa9b87e59d4698ed706be90719c7f73-9a16c.webp","srcSetWebp":"/static/main-7aa9b87e59d4698ed706be90719c7f73-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Pinterest The winner of the battle is Pinterest. The developer Pinterest says the following about the app.  Looking for inspiration? Whether…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in November 2020","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in November 2020.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0de081c65e789aec9d8a89ce54dcb00a-6d4e8.png","srcSet":"/static/main-0de081c65e789aec9d8a89ce54dcb00a-6d4e8.png 1x","srcWebp":"/static/main-0de081c65e789aec9d8a89ce54dcb00a-9a16c.webp","srcSetWebp":"/static/main-0de081c65e789aec9d8a89ce54dcb00a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps - Transit & Food The first place is taken by Google Maps - Transit & Food. The developer Google LLC says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in November 2020","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in November 2020.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b66ce7fffb28783a42609dd850fa507f-6d4e8.png","srcSet":"/static/main-b66ce7fffb28783a42609dd850fa507f-6d4e8.png 1x","srcWebp":"/static/main-b66ce7fffb28783a42609dd850fa507f-9a16c.webp","srcSetWebp":"/static/main-b66ce7fffb28783a42609dd850fa507f-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winner of the battle is YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-free-ios-apps-in-photo-and-video-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in November 2020","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in November 2020.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-6d4e8.png","srcSet":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-6d4e8.png 1x","srcWebp":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-9a16c.webp","srcSetWebp":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facebook The winner of the battle is Facebook. The developer Facebook, Inc. says the following about the app.  Connect with friends, family…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in November 2020","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in November 2020.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ea86d7227a2727b012559b872207dc97-6d4e8.png","srcSet":"/static/main-ea86d7227a2727b012559b872207dc97-6d4e8.png 1x","srcWebp":"/static/main-ea86d7227a2727b012559b872207dc97-9a16c.webp","srcSetWebp":"/static/main-ea86d7227a2727b012559b872207dc97-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google The winning spot belongs to Google. The developer Google LLC says the following about the app.  Get fast access to Google Search with…","fields":{"slug":"/top-5-free-ios-apps-in-utilities-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in November 2020","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in November 2020.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e7ae26c1fade3d861fd883c8c729a171-6d4e8.png","srcSet":"/static/main-e7ae26c1fade3d861fd883c8c729a171-6d4e8.png 1x","srcWebp":"/static/main-e7ae26c1fade3d861fd883c8c729a171-9a16c.webp","srcSetWebp":"/static/main-e7ae26c1fade3d861fd883c8c729a171-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The winning spot belongs to Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in November 2020","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in November 2020.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-7874c308bc38765abceddde349e1c1ff-6d4e8.png","srcSet":"/static/main-7874c308bc38765abceddde349e1c1ff-6d4e8.png 1x","srcWebp":"/static/main-7874c308bc38765abceddde349e1c1ff-9a16c.webp","srcSetWebp":"/static/main-7874c308bc38765abceddde349e1c1ff-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The first place is taken by LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in November 2020","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in November 2020.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-be3ed2b1de835ff50bdf1008fec41f5d-6d4e8.png","srcSet":"/static/main-be3ed2b1de835ff50bdf1008fec41f5d-6d4e8.png 1x","srcWebp":"/static/main-be3ed2b1de835ff50bdf1008fec41f5d-9a16c.webp","srcSetWebp":"/static/main-be3ed2b1de835ff50bdf1008fec41f5d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber - Request a ride The first place is taken by Uber - Request a ride. The developer Uber Technologies, Inc. says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in November 2020","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in November 2020.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-7e942d554ffe41ad14ee1be52cfbad23-6d4e8.png","srcSet":"/static/main-7e942d554ffe41ad14ee1be52cfbad23-6d4e8.png 1x","srcWebp":"/static/main-7e942d554ffe41ad14ee1be52cfbad23-9a16c.webp","srcSetWebp":"/static/main-7e942d554ffe41ad14ee1be52cfbad23-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder - Dating & Make Friends The winning spot belongs to Tinder - Dating & Make Friends. The developer Tinder Inc. says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in November 2020","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in November 2020.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-f1547896238e1bc8673f7a08923f20ad-6d4e8.png","srcSet":"/static/main-f1547896238e1bc8673f7a08923f20ad-6d4e8.png 1x","srcWebp":"/static/main-f1547896238e1bc8673f7a08923f20ad-9a16c.webp","srcSetWebp":"/static/main-f1547896238e1bc8673f7a08923f20ad-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The first place is taken by onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in November 2020","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in November 2020.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-27d5848fca48c020885371aab40c8010-6d4e8.png","srcSet":"/static/main-27d5848fca48c020885371aab40c8010-6d4e8.png 1x","srcWebp":"/static/main-27d5848fca48c020885371aab40c8010-9a16c.webp","srcSetWebp":"/static/main-27d5848fca48c020885371aab40c8010-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Duolingo - Language Lessons The winner of the battle is Duolingo - Language Lessons. The developer Duolingo says the following about the app…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in November 2020","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in November 2020.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-f577b84a07c008d8f2a76eabc3a2d0f1-6d4e8.png","srcSet":"/static/main-f577b84a07c008d8f2a76eabc3a2d0f1-6d4e8.png 1x","srcWebp":"/static/main-f577b84a07c008d8f2a76eabc3a2d0f1-9a16c.webp","srcSetWebp":"/static/main-f577b84a07c008d8f2a76eabc3a2d0f1-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"BIGO LIVE-Live Stream, Go Live The first place belongs to BIGO LIVE-Live Stream, Go Live. The developer BIGO TECHNOLOGY PTE. LTD. says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in November 2020","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in November 2020.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5af1a0fad803d47f9ef34b0c63f5b4ad-6d4e8.png","srcSet":"/static/main-5af1a0fad803d47f9ef34b0c63f5b4ad-6d4e8.png 1x","srcWebp":"/static/main-5af1a0fad803d47f9ef34b0c63f5b4ad-9a16c.webp","srcSetWebp":"/static/main-5af1a0fad803d47f9ef34b0c63f5b4ad-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The winning spot belongs to RoboKiller: Block Spam Calls. The developer TelTech Systems says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in November 2020","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in November 2020.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-d59989a300a7bc326c43eedb78a0eb11-6d4e8.png","srcSet":"/static/main-d59989a300a7bc326c43eedb78a0eb11-6d4e8.png 1x","srcWebp":"/static/main-d59989a300a7bc326c43eedb78a0eb11-9a16c.webp","srcSetWebp":"/static/main-d59989a300a7bc326c43eedb78a0eb11-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Planes Live - Flight Tracker The winner of the battle is Planes Live - Flight Tracker. The developer Weather or Not Apps, LLC says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Travel in November 2020","subTitle":"Top 5 Grossing iOS Apps in Travel and Reviews from the AppStore in November 2020.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-d246533627e4793187609ac17aea23b0-6d4e8.png","srcSet":"/static/main-d246533627e4793187609ac17aea23b0-6d4e8.png 1x","srcWebp":"/static/main-d246533627e4793187609ac17aea23b0-9a16c.webp","srcSetWebp":"/static/main-d246533627e4793187609ac17aea23b0-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The first place is taken by HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in November 2020","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in November 2020.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c699350cb6e75e03625e1b9ef53cfc3c-6d4e8.png","srcSet":"/static/main-c699350cb6e75e03625e1b9ef53cfc3c-6d4e8.png 1x","srcWebp":"/static/main-c699350cb6e75e03625e1b9ef53cfc3c-9a16c.webp","srcSetWebp":"/static/main-c699350cb6e75e03625e1b9ef53cfc3c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"SkyView® The first place is taken by SkyView®. The developer Terminal Eleven LLC says the following about the app.  SkyView® brings…","fields":{"slug":"/top-5-paid-ios-apps-in-education-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in November 2020","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in November 2020.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-550ba15f1c9653f7febb55df7934f43b-6d4e8.png","srcSet":"/static/main-550ba15f1c9653f7febb55df7934f43b-6d4e8.png 1x","srcWebp":"/static/main-550ba15f1c9653f7febb55df7934f43b-9a16c.webp","srcSetWebp":"/static/main-550ba15f1c9653f7febb55df7934f43b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Jacquie Lawson Advent Calendar The first place is taken by Jacquie Lawson Advent Calendar. The developer Jacquielawson.com says the…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in November 2020","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in November 2020.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-160a34961c6ff6f687d7ecd568414dc4-6d4e8.png","srcSet":"/static/main-160a34961c6ff6f687d7ecd568414dc4-6d4e8.png 1x","srcWebp":"/static/main-160a34961c6ff6f687d7ecd568414dc4-9a16c.webp","srcSetWebp":"/static/main-160a34961c6ff6f687d7ecd568414dc4-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The first place is taken by YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Photo and Video in November 2020","subTitle":"Top 5 Grossing iOS Apps in Photo and Video and Reviews from the AppStore in November 2020.","category":"top 5 grossing ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-6d4e8.png","srcSet":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-6d4e8.png 1x","srcWebp":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-9a16c.webp","srcSetWebp":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Land Nav Assistant The winner of the battle is Land Nav Assistant. The developer Gammon Applications says the following about the app.  Land…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in November 2020","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in November 2020.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-8598ef0400e9c187f0a96b17a005ad30-6d4e8.png","srcSet":"/static/main-8598ef0400e9c187f0a96b17a005ad30-6d4e8.png 1x","srcWebp":"/static/main-8598ef0400e9c187f0a96b17a005ad30-9a16c.webp","srcSetWebp":"/static/main-8598ef0400e9c187f0a96b17a005ad30-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facetune The winner of the battle is Facetune. The developer Lightricks Ltd. says the following about the app.  Facetune 2 is now available…","fields":{"slug":"/top-5-paid-ios-apps-in-photo-and-video-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in November 2020","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in November 2020.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-223f996c229da4b1ee14e96abdc64c53-6d4e8.png","srcSet":"/static/main-223f996c229da4b1ee14e96abdc64c53-6d4e8.png 1x","srcWebp":"/static/main-223f996c229da4b1ee14e96abdc64c53-9a16c.webp","srcSetWebp":"/static/main-223f996c229da4b1ee14e96abdc64c53-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Forest - Stay focused The first place is taken by Forest - Stay focused. The developer SEEKRTECH CO., LTD. says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-productivity-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in November 2020","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in November 2020.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-2be219fe3ea2c28c0dd4db65441c149d-6d4e8.png","srcSet":"/static/main-2be219fe3ea2c28c0dd4db65441c149d-6d4e8.png 1x","srcWebp":"/static/main-2be219fe3ea2c28c0dd4db65441c149d-9a16c.webp","srcSetWebp":"/static/main-2be219fe3ea2c28c0dd4db65441c149d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LiveATC Air Radio The winner of the battle is LiveATC Air Radio. The developer Dave Pascoe says the following about the app.  LiveATC Air…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in November 2020","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in November 2020.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-89b19f8e2844c2ac9f4a6357f6e6e721-6d4e8.png","srcSet":"/static/main-89b19f8e2844c2ac9f4a6357f6e6e721-6d4e8.png 1x","srcWebp":"/static/main-89b19f8e2844c2ac9f4a6357f6e6e721-9a16c.webp","srcSetWebp":"/static/main-89b19f8e2844c2ac9f4a6357f6e6e721-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Shadowrocket The winner of the battle is Shadowrocket. The developer Shadow Launch Technology Limited says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-november-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in November 2020","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in November 2020.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-7a28c9110ddbd61facced9c24857b809-6d4e8.png","srcSet":"/static/main-7a28c9110ddbd61facced9c24857b809-6d4e8.png 1x","srcWebp":"/static/main-7a28c9110ddbd61facced9c24857b809-9a16c.webp","srcSetWebp":"/static/main-7a28c9110ddbd61facced9c24857b809-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Pinterest The first place belongs to Pinterest. The developer Pinterest says the following about the app.  Looking for inspiration? Whether…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-free-ios-apps-in-lifestyle-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in December 2020","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in December 2020.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0de081c65e789aec9d8a89ce54dcb00a-6d4e8.png","srcSet":"/static/main-0de081c65e789aec9d8a89ce54dcb00a-6d4e8.png 1x","srcWebp":"/static/main-0de081c65e789aec9d8a89ce54dcb00a-9a16c.webp","srcSetWebp":"/static/main-0de081c65e789aec9d8a89ce54dcb00a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ZOOM Cloud Meetings The first place belongs to ZOOM Cloud Meetings. The developer Zoom says the following about the app.  Zoom is #1 in…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-free-ios-apps-in-business-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in December 2020","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in December 2020.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6993a7142cbfed5a3bae6bf2068471d1-6d4e8.png","srcSet":"/static/main-6993a7142cbfed5a3bae6bf2068471d1-6d4e8.png 1x","srcWebp":"/static/main-6993a7142cbfed5a3bae6bf2068471d1-9a16c.webp","srcSetWebp":"/static/main-6993a7142cbfed5a3bae6bf2068471d1-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Kahoot! Play & Create Quizzes The first place belongs to Kahoot! Play & Create Quizzes. The developer Kahoot! AS says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-free-ios-apps-in-education-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in December 2020","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in December 2020.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-72e6a8b0e33d466d4f125fa8c8c4cb38-6d4e8.png","srcSet":"/static/main-72e6a8b0e33d466d4f125fa8c8c4cb38-6d4e8.png 1x","srcWebp":"/static/main-72e6a8b0e33d466d4f125fa8c8c4cb38-9a16c.webp","srcSetWebp":"/static/main-72e6a8b0e33d466d4f125fa8c8c4cb38-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winning spot belongs to YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-free-ios-apps-in-photo-and-video-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in December 2020","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in December 2020.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-6d4e8.png","srcSet":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-6d4e8.png 1x","srcWebp":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-9a16c.webp","srcSetWebp":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facebook The winner of the battle is Facebook. The developer Facebook, Inc. says the following about the app.  Connect with friends, family…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-free-ios-apps-in-social-networking-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in December 2020","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in December 2020.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-3d8e79bb57b9db234110d6a1c264a9e1-6d4e8.png","srcSet":"/static/main-3d8e79bb57b9db234110d6a1c264a9e1-6d4e8.png 1x","srcWebp":"/static/main-3d8e79bb57b9db234110d6a1c264a9e1-9a16c.webp","srcSetWebp":"/static/main-3d8e79bb57b9db234110d6a1c264a9e1-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The winner of the battle is Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-free-ios-apps-in-productivity-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in December 2020","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in December 2020.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-7874c308bc38765abceddde349e1c1ff-6d4e8.png","srcSet":"/static/main-7874c308bc38765abceddde349e1c1ff-6d4e8.png 1x","srcWebp":"/static/main-7874c308bc38765abceddde349e1c1ff-9a16c.webp","srcSetWebp":"/static/main-7874c308bc38765abceddde349e1c1ff-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps - Transit & Food The first place is taken by Google Maps - Transit & Food. The developer Google LLC says the following about the…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-free-ios-apps-in-navigation-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in December 2020","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in December 2020.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b66ce7fffb28783a42609dd850fa507f-6d4e8.png","srcSet":"/static/main-b66ce7fffb28783a42609dd850fa507f-6d4e8.png 1x","srcWebp":"/static/main-b66ce7fffb28783a42609dd850fa507f-9a16c.webp","srcSetWebp":"/static/main-b66ce7fffb28783a42609dd850fa507f-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber - Request a ride The winning spot belongs to Uber - Request a ride. The developer Uber Technologies, Inc. says the following about the…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-free-ios-apps-in-travel-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in December 2020","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in December 2020.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-7e942d554ffe41ad14ee1be52cfbad23-6d4e8.png","srcSet":"/static/main-7e942d554ffe41ad14ee1be52cfbad23-6d4e8.png 1x","srcWebp":"/static/main-7e942d554ffe41ad14ee1be52cfbad23-9a16c.webp","srcSetWebp":"/static/main-7e942d554ffe41ad14ee1be52cfbad23-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google The winner of the battle is Google. The developer Google LLC says the following about the app.  Get fast access to Google Search with…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-free-ios-apps-in-utilities-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in December 2020","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in December 2020.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e7ae26c1fade3d861fd883c8c729a171-6d4e8.png","srcSet":"/static/main-e7ae26c1fade3d861fd883c8c729a171-6d4e8.png 1x","srcWebp":"/static/main-e7ae26c1fade3d861fd883c8c729a171-9a16c.webp","srcSetWebp":"/static/main-e7ae26c1fade3d861fd883c8c729a171-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Duolingo - Language Lessons The winning spot belongs to Duolingo - Language Lessons. The developer Duolingo says the following about the app…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-grossing-ios-apps-in-education-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in December 2020","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in December 2020.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9a7166033e337152f0601871b7f5ba83-6d4e8.png","srcSet":"/static/main-9a7166033e337152f0601871b7f5ba83-6d4e8.png 1x","srcWebp":"/static/main-9a7166033e337152f0601871b7f5ba83-9a16c.webp","srcSetWebp":"/static/main-9a7166033e337152f0601871b7f5ba83-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The first place belongs to onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-grossing-ios-apps-in-navigation-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in December 2020","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in December 2020.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b0a99cf31a2bc1c3ea540532fe2be2a0-6d4e8.png","srcSet":"/static/main-b0a99cf31a2bc1c3ea540532fe2be2a0-6d4e8.png 1x","srcWebp":"/static/main-b0a99cf31a2bc1c3ea540532fe2be2a0-9a16c.webp","srcSetWebp":"/static/main-b0a99cf31a2bc1c3ea540532fe2be2a0-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The first place is taken by LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-grossing-ios-apps-in-business-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in December 2020","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in December 2020.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9a3a61430d6bb33f00c8dc4b0cb174b4-6d4e8.png","srcSet":"/static/main-9a3a61430d6bb33f00c8dc4b0cb174b4-6d4e8.png 1x","srcWebp":"/static/main-9a3a61430d6bb33f00c8dc4b0cb174b4-9a16c.webp","srcSetWebp":"/static/main-9a3a61430d6bb33f00c8dc4b0cb174b4-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder - Dating New People The first place is taken by Tinder - Dating New People. The developer Tinder Inc. says the following about the…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-grossing-ios-apps-in-lifestyle-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in December 2020","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in December 2020.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-91217ce956a678801948c2b94771c3ec-6d4e8.png","srcSet":"/static/main-91217ce956a678801948c2b94771c3ec-6d4e8.png 1x","srcWebp":"/static/main-91217ce956a678801948c2b94771c3ec-9a16c.webp","srcSetWebp":"/static/main-91217ce956a678801948c2b94771c3ec-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winner of the battle is YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-grossing-ios-apps-in-photo-and-video-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Photo and Video in December 2020","subTitle":"Top 5 Grossing iOS Apps in Photo and Video and Reviews from the AppStore in December 2020.","category":"top 5 grossing ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-6d4e8.png","srcSet":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-6d4e8.png 1x","srcWebp":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-9a16c.webp","srcSetWebp":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"BIGO LIVE-Live Stream, Go Live The winning spot belongs to BIGO LIVE-Live Stream, Go Live. The developer BIGO TECHNOLOGY PTE. LTD. says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-grossing-ios-apps-in-social-networking-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in December 2020","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in December 2020.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-1a49915b7f2a5486f4141c13f9d4a340-6d4e8.png","srcSet":"/static/main-1a49915b7f2a5486f4141c13f9d4a340-6d4e8.png 1x","srcWebp":"/static/main-1a49915b7f2a5486f4141c13f9d4a340-9a16c.webp","srcSetWebp":"/static/main-1a49915b7f2a5486f4141c13f9d4a340-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The winner of the battle is RoboKiller: Block Spam Calls. The developer TelTech Systems says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-grossing-ios-apps-in-utilities-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in December 2020","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in December 2020.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-cb60bb8fe5cd8feda46cdeb2418eb4ea-6d4e8.png","srcSet":"/static/main-cb60bb8fe5cd8feda46cdeb2418eb4ea-6d4e8.png 1x","srcWebp":"/static/main-cb60bb8fe5cd8feda46cdeb2418eb4ea-9a16c.webp","srcSetWebp":"/static/main-cb60bb8fe5cd8feda46cdeb2418eb4ea-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The first place is taken by HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-paid-ios-apps-in-business-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in December 2020","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in December 2020.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-bfa2a24e49eb93cf1ef217cdd36c6376-6d4e8.png","srcSet":"/static/main-bfa2a24e49eb93cf1ef217cdd36c6376-6d4e8.png 1x","srcWebp":"/static/main-bfa2a24e49eb93cf1ef217cdd36c6376-9a16c.webp","srcSetWebp":"/static/main-bfa2a24e49eb93cf1ef217cdd36c6376-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Screen Mirroring+ for Fire TV The winning spot belongs to Screen Mirroring+ for Fire TV. The developer Kraus und Karnath GbR 2Kit Consulting…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-paid-ios-apps-in-lifestyle-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in December 2020","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in December 2020.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-803da49eeee8f788c9525a18411b0854-6d4e8.png","srcSet":"/static/main-803da49eeee8f788c9525a18411b0854-6d4e8.png 1x","srcWebp":"/static/main-803da49eeee8f788c9525a18411b0854-9a16c.webp","srcSetWebp":"/static/main-803da49eeee8f788c9525a18411b0854-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"SkyView® The first place is taken by SkyView®. The developer Terminal Eleven LLC says the following about the app.  SkyView® brings…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-paid-ios-apps-in-education-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in December 2020","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in December 2020.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-550ba15f1c9653f7febb55df7934f43b-6d4e8.png","srcSet":"/static/main-550ba15f1c9653f7febb55df7934f43b-6d4e8.png 1x","srcWebp":"/static/main-550ba15f1c9653f7febb55df7934f43b-9a16c.webp","srcSetWebp":"/static/main-550ba15f1c9653f7febb55df7934f43b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Ski Tracks The winning spot belongs to Ski Tracks. The developer Core Coders Ltd says the following about the app.  The world’s favourite…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-paid-ios-apps-in-navigation-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in December 2020","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in December 2020.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-2b376746052c2d9da6852fb68091dc4e-6d4e8.png","srcSet":"/static/main-2b376746052c2d9da6852fb68091dc4e-6d4e8.png 1x","srcWebp":"/static/main-2b376746052c2d9da6852fb68091dc4e-9a16c.webp","srcSetWebp":"/static/main-2b376746052c2d9da6852fb68091dc4e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facetune The winner of the battle is Facetune. The developer Lightricks Ltd. says the following about the app.  Facetune 2 is now available…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-paid-ios-apps-in-photo-and-video-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in December 2020","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in December 2020.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-223f996c229da4b1ee14e96abdc64c53-6d4e8.png","srcSet":"/static/main-223f996c229da4b1ee14e96abdc64c53-6d4e8.png 1x","srcWebp":"/static/main-223f996c229da4b1ee14e96abdc64c53-9a16c.webp","srcSetWebp":"/static/main-223f996c229da4b1ee14e96abdc64c53-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Screen Mirroring+ for Roku The winning spot belongs to Screen Mirroring+ for Roku. The developer Kraus und Karnath GbR 2Kit Consulting says…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-paid-ios-apps-in-productivity-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in December 2020","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in December 2020.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-d8bef33206c9dff32fb6e20c456ff542-6d4e8.png","srcSet":"/static/main-d8bef33206c9dff32fb6e20c456ff542-6d4e8.png 1x","srcWebp":"/static/main-d8bef33206c9dff32fb6e20c456ff542-9a16c.webp","srcSetWebp":"/static/main-d8bef33206c9dff32fb6e20c456ff542-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LiveATC Air Radio The winner of the battle is LiveATC Air Radio. The developer Dave Pascoe says the following about the app.  LiveATC Air…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-paid-ios-apps-in-travel-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in December 2020","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in December 2020.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-7a7c2a30bbe03e538ea3477631fdb938-6d4e8.png","srcSet":"/static/main-7a7c2a30bbe03e538ea3477631fdb938-6d4e8.png 1x","srcWebp":"/static/main-7a7c2a30bbe03e538ea3477631fdb938-9a16c.webp","srcSetWebp":"/static/main-7a7c2a30bbe03e538ea3477631fdb938-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Puffin Cloud Browser The winning spot belongs to Puffin Cloud Browser. The developer CloudMosa, Inc. says the following about the app…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2020-12-19--top-5-paid-ios-apps-in-utilities-in-december-2020/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in December 2020","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in December 2020.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ba640522a916f31b6228e72331caf920-6d4e8.png","srcSet":"/static/main-ba640522a916f31b6228e72331caf920-6d4e8.png 1x","srcWebp":"/static/main-ba640522a916f31b6228e72331caf920-9a16c.webp","srcSetWebp":"/static/main-ba640522a916f31b6228e72331caf920-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ZOOM Cloud Meetings The winning spot belongs to ZOOM Cloud Meetings. The developer Zoom says the following about the app.  Zoom is #1 in…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-free-ios-apps-in-business-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in February 2021","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in February 2021.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-cd3693eaff676a3852db5dd0550966ca-6d4e8.png","srcSet":"/static/main-cd3693eaff676a3852db5dd0550966ca-6d4e8.png 1x","srcWebp":"/static/main-cd3693eaff676a3852db5dd0550966ca-9a16c.webp","srcSetWebp":"/static/main-cd3693eaff676a3852db5dd0550966ca-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Pinterest The first place is taken by Pinterest. The developer Pinterest says the following about the app.  Looking for inspiration? Whether…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-free-ios-apps-in-lifestyle-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in February 2021","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in February 2021.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-00687e10cf4cd0671cc04533db96cba8-6d4e8.png","srcSet":"/static/main-00687e10cf4cd0671cc04533db96cba8-6d4e8.png 1x","srcWebp":"/static/main-00687e10cf4cd0671cc04533db96cba8-9a16c.webp","srcSetWebp":"/static/main-00687e10cf4cd0671cc04533db96cba8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Brainly – Homework Help App The first place is taken by Brainly – Homework Help App. The developer Brainly sp. z o o says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-free-ios-apps-in-education-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in February 2021","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in February 2021.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-dbf1e8ec12bc531dfd39d588e6131a9d-6d4e8.png","srcSet":"/static/main-dbf1e8ec12bc531dfd39d588e6131a9d-6d4e8.png 1x","srcWebp":"/static/main-dbf1e8ec12bc531dfd39d588e6131a9d-9a16c.webp","srcSetWebp":"/static/main-dbf1e8ec12bc531dfd39d588e6131a9d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps - Transit & Food The winner of the battle is Google Maps - Transit & Food. The developer Google LLC says the following about the…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-free-ios-apps-in-navigation-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in February 2021","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in February 2021.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-19fed70364496fb25b86b1f3ccc6dcf8-6d4e8.png","srcSet":"/static/main-19fed70364496fb25b86b1f3ccc6dcf8-6d4e8.png 1x","srcWebp":"/static/main-19fed70364496fb25b86b1f3ccc6dcf8-9a16c.webp","srcSetWebp":"/static/main-19fed70364496fb25b86b1f3ccc6dcf8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winning spot belongs to YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-free-ios-apps-in-photo-and-video-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in February 2021","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in February 2021.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-6d4e8.png","srcSet":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-6d4e8.png 1x","srcWebp":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-9a16c.webp","srcSetWebp":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The first place belongs to Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-free-ios-apps-in-productivity-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in February 2021","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in February 2021.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-771d5277e3a5694e120492adcb3c09cf-6d4e8.png","srcSet":"/static/main-771d5277e3a5694e120492adcb3c09cf-6d4e8.png 1x","srcWebp":"/static/main-771d5277e3a5694e120492adcb3c09cf-9a16c.webp","srcSetWebp":"/static/main-771d5277e3a5694e120492adcb3c09cf-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facebook The first place belongs to Facebook. The developer Facebook, Inc. says the following about the app.  Connect with friends, family…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-free-ios-apps-in-social-networking-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in February 2021","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in February 2021.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-772372cd2a8781c67f3f6ae5cb183139-6d4e8.png","srcSet":"/static/main-772372cd2a8781c67f3f6ae5cb183139-6d4e8.png 1x","srcWebp":"/static/main-772372cd2a8781c67f3f6ae5cb183139-9a16c.webp","srcSetWebp":"/static/main-772372cd2a8781c67f3f6ae5cb183139-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google The first place belongs to Google. The developer Google LLC says the following about the app.  Get fast access to Google Search with…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-free-ios-apps-in-utilities-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in February 2021","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in February 2021.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e7ae26c1fade3d861fd883c8c729a171-6d4e8.png","srcSet":"/static/main-e7ae26c1fade3d861fd883c8c729a171-6d4e8.png 1x","srcWebp":"/static/main-e7ae26c1fade3d861fd883c8c729a171-9a16c.webp","srcSetWebp":"/static/main-e7ae26c1fade3d861fd883c8c729a171-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber - Request a ride The first place belongs to Uber - Request a ride. The developer Uber Technologies, Inc. says the following about the…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-free-ios-apps-in-travel-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in February 2021","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in February 2021.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-448c40a9f8e59fcca34da79792ceeffc-6d4e8.png","srcSet":"/static/main-448c40a9f8e59fcca34da79792ceeffc-6d4e8.png 1x","srcWebp":"/static/main-448c40a9f8e59fcca34da79792ceeffc-9a16c.webp","srcSetWebp":"/static/main-448c40a9f8e59fcca34da79792ceeffc-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The first place is taken by LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-grossing-ios-apps-in-business-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in February 2021","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in February 2021.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-20ee97212c5418946020299401bb0448-6d4e8.png","srcSet":"/static/main-20ee97212c5418946020299401bb0448-6d4e8.png 1x","srcWebp":"/static/main-20ee97212c5418946020299401bb0448-9a16c.webp","srcSetWebp":"/static/main-20ee97212c5418946020299401bb0448-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Duolingo - Language Lessons The winner of the battle is Duolingo - Language Lessons. The developer Duolingo says the following about the app…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-grossing-ios-apps-in-education-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in February 2021","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in February 2021.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b8e5da78fe53e6ef2ceff9719235ce79-6d4e8.png","srcSet":"/static/main-b8e5da78fe53e6ef2ceff9719235ce79-6d4e8.png 1x","srcWebp":"/static/main-b8e5da78fe53e6ef2ceff9719235ce79-9a16c.webp","srcSetWebp":"/static/main-b8e5da78fe53e6ef2ceff9719235ce79-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The first place is taken by onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-grossing-ios-apps-in-navigation-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in February 2021","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in February 2021.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-91cee73c3bc61d5f2b671fda03278762-6d4e8.png","srcSet":"/static/main-91cee73c3bc61d5f2b671fda03278762-6d4e8.png 1x","srcWebp":"/static/main-91cee73c3bc61d5f2b671fda03278762-9a16c.webp","srcSetWebp":"/static/main-91cee73c3bc61d5f2b671fda03278762-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder - Dating New People The first place belongs to Tinder - Dating New People. The developer Tinder Inc. says the following about the app…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-grossing-ios-apps-in-lifestyle-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in February 2021","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in February 2021.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-2c0b02c26234d03215de83bf428fc69a-6d4e8.png","srcSet":"/static/main-2c0b02c26234d03215de83bf428fc69a-6d4e8.png 1x","srcWebp":"/static/main-2c0b02c26234d03215de83bf428fc69a-9a16c.webp","srcSetWebp":"/static/main-2c0b02c26234d03215de83bf428fc69a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The first place belongs to YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-grossing-ios-apps-in-photo-and-video-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Photo and Video in February 2021","subTitle":"Top 5 Grossing iOS Apps in Photo and Video and Reviews from the AppStore in February 2021.","category":"top 5 grossing ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-6d4e8.png","srcSet":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-6d4e8.png 1x","srcWebp":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-9a16c.webp","srcSetWebp":"/static/main-50a7b7f38416312fb4c589fa0ae490e3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"BIGO LIVE-Live Stream, Go Live The winner of the battle is BIGO LIVE-Live Stream, Go Live. The developer BIGO TECHNOLOGY PTE. LTD. says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-grossing-ios-apps-in-social-networking-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in February 2021","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in February 2021.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c06aa387c434dd9608c78e50b25e9348-6d4e8.png","srcSet":"/static/main-c06aa387c434dd9608c78e50b25e9348-6d4e8.png 1x","srcWebp":"/static/main-c06aa387c434dd9608c78e50b25e9348-9a16c.webp","srcSetWebp":"/static/main-c06aa387c434dd9608c78e50b25e9348-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The first place is taken by RoboKiller: Block Spam Calls. The developer TelTech Systems says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-grossing-ios-apps-in-utilities-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in February 2021","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in February 2021.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-3698468188f821b6e95b3078cafa070d-6d4e8.png","srcSet":"/static/main-3698468188f821b6e95b3078cafa070d-6d4e8.png 1x","srcWebp":"/static/main-3698468188f821b6e95b3078cafa070d-9a16c.webp","srcSetWebp":"/static/main-3698468188f821b6e95b3078cafa070d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"My Disney Experience The winner of the battle is My Disney Experience. The developer Disney says the following about the app.  The official…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-grossing-ios-apps-in-travel-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Travel in February 2021","subTitle":"Top 5 Grossing iOS Apps in Travel and Reviews from the AppStore in February 2021.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-efb2cd1184ba16651fce487737d8803f-6d4e8.png","srcSet":"/static/main-efb2cd1184ba16651fce487737d8803f-6d4e8.png 1x","srcWebp":"/static/main-efb2cd1184ba16651fce487737d8803f-9a16c.webp","srcSetWebp":"/static/main-efb2cd1184ba16651fce487737d8803f-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The winning spot belongs to HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-paid-ios-apps-in-business-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in February 2021","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in February 2021.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-922e04bd8ed39419e24e7a618231a260-6d4e8.png","srcSet":"/static/main-922e04bd8ed39419e24e7a618231a260-6d4e8.png 1x","srcWebp":"/static/main-922e04bd8ed39419e24e7a618231a260-9a16c.webp","srcSetWebp":"/static/main-922e04bd8ed39419e24e7a618231a260-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"SkyView® The winning spot belongs to SkyView®. The developer Terminal Eleven LLC says the following about the app.  SkyView® brings…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-paid-ios-apps-in-education-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in February 2021","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in February 2021.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6ce0e88994cc8c33c987ea1e55a043eb-6d4e8.png","srcSet":"/static/main-6ce0e88994cc8c33c987ea1e55a043eb-6d4e8.png 1x","srcWebp":"/static/main-6ce0e88994cc8c33c987ea1e55a043eb-9a16c.webp","srcSetWebp":"/static/main-6ce0e88994cc8c33c987ea1e55a043eb-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"INKHUNTER PRO Tattoos try on The winner of the battle is INKHUNTER PRO Tattoos try on. The developer INKHUNTER, Inc. says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-paid-ios-apps-in-lifestyle-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in February 2021","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in February 2021.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-d500c26765d54ca8aaa32f9c92f30b6e-6d4e8.png","srcSet":"/static/main-d500c26765d54ca8aaa32f9c92f30b6e-6d4e8.png 1x","srcWebp":"/static/main-d500c26765d54ca8aaa32f9c92f30b6e-9a16c.webp","srcSetWebp":"/static/main-d500c26765d54ca8aaa32f9c92f30b6e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Ski Tracks The winner of the battle is Ski Tracks. The developer Core Coders Ltd says the following about the app.  The world’s favourite…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-paid-ios-apps-in-navigation-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in February 2021","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in February 2021.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-4294da294da8d8ec5eaf4e278718119e-6d4e8.png","srcSet":"/static/main-4294da294da8d8ec5eaf4e278718119e-6d4e8.png 1x","srcWebp":"/static/main-4294da294da8d8ec5eaf4e278718119e-9a16c.webp","srcSetWebp":"/static/main-4294da294da8d8ec5eaf4e278718119e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Screen Mirroring+ for Roku The winner of the battle is Screen Mirroring+ for Roku. The developer Kraus und Karnath GbR 2Kit Consulting says…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-paid-ios-apps-in-productivity-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in February 2021","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in February 2021.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9585f352809689d048259aaa357bf1bd-6d4e8.png","srcSet":"/static/main-9585f352809689d048259aaa357bf1bd-6d4e8.png 1x","srcWebp":"/static/main-9585f352809689d048259aaa357bf1bd-9a16c.webp","srcSetWebp":"/static/main-9585f352809689d048259aaa357bf1bd-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facetune The winner of the battle is Facetune. The developer Lightricks Ltd. says the following about the app.  Facetune 2 is now available…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-paid-ios-apps-in-photo-and-video-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in February 2021","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in February 2021.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-77d1a97b8ff2cf3efad7df6b9e14ee06-6d4e8.png","srcSet":"/static/main-77d1a97b8ff2cf3efad7df6b9e14ee06-6d4e8.png 1x","srcWebp":"/static/main-77d1a97b8ff2cf3efad7df6b9e14ee06-9a16c.webp","srcSetWebp":"/static/main-77d1a97b8ff2cf3efad7df6b9e14ee06-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Threema. The Secure Messenger The first place is taken by Threema. The Secure Messenger. The developer Threema GmbH says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-paid-ios-apps-in-social-networking-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Social Networking in February 2021","subTitle":"Top 5 Paid iOS Apps in Social Networking and Reviews from the AppStore in February 2021.","category":"top 5 paid ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a16bc5a22ef8945cfb2a51731c084151-6d4e8.png","srcSet":"/static/main-a16bc5a22ef8945cfb2a51731c084151-6d4e8.png 1x","srcWebp":"/static/main-a16bc5a22ef8945cfb2a51731c084151-9a16c.webp","srcSetWebp":"/static/main-a16bc5a22ef8945cfb2a51731c084151-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"MarineTraffic - Ship Tracking The winner of the battle is MarineTraffic - Ship Tracking. The developer MarineTraffic.com says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-paid-ios-apps-in-travel-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in February 2021","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in February 2021.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e0107cd7984a693a9f58a57d80862196-6d4e8.png","srcSet":"/static/main-e0107cd7984a693a9f58a57d80862196-6d4e8.png 1x","srcWebp":"/static/main-e0107cd7984a693a9f58a57d80862196-9a16c.webp","srcSetWebp":"/static/main-e0107cd7984a693a9f58a57d80862196-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Shadowrocket The first place is taken by Shadowrocket. The developer Shadow Launch Technology Limited says the following about the app…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2020/2021-02-08--top-5-paid-ios-apps-in-utilities-in-february-2021/","prefix":"2020-11-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in February 2021","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in February 2021.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-bdf83d74284dedf79227a95129bec0ca-6d4e8.png","srcSet":"/static/main-bdf83d74284dedf79227a95129bec0ca-6d4e8.png 1x","srcWebp":"/static/main-bdf83d74284dedf79227a95129bec0ca-9a16c.webp","srcSetWebp":"/static/main-bdf83d74284dedf79227a95129bec0ca-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Photomath The winning spot belongs to Photomath. The developer Photomath, Inc. says the following about the app.  Learn math, check homework…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in October 2020","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in October 2020.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-bbd7ae89c085b20ae83550d8db8b97f1-6d4e8.png","srcSet":"/static/main-bbd7ae89c085b20ae83550d8db8b97f1-6d4e8.png 1x","srcWebp":"/static/main-bbd7ae89c085b20ae83550d8db8b97f1-9a16c.webp","srcSetWebp":"/static/main-bbd7ae89c085b20ae83550d8db8b97f1-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ZOOM Cloud Meetings The winning spot belongs to ZOOM Cloud Meetings. The developer Zoom says the following about the app.  Zoom is #1 in…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in October 2020","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in October 2020.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-d3612097a32a87c749c7d8ee5cdfc289-6d4e8.png","srcSet":"/static/main-d3612097a32a87c749c7d8ee5cdfc289-6d4e8.png 1x","srcWebp":"/static/main-d3612097a32a87c749c7d8ee5cdfc289-9a16c.webp","srcSetWebp":"/static/main-d3612097a32a87c749c7d8ee5cdfc289-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps - Transit & Food The first place is taken by Google Maps - Transit & Food. The developer Google LLC says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in October 2020","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in October 2020.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6a2794e20d468e70e8f9d6afd1aa5f0a-6d4e8.png","srcSet":"/static/main-6a2794e20d468e70e8f9d6afd1aa5f0a-6d4e8.png 1x","srcWebp":"/static/main-6a2794e20d468e70e8f9d6afd1aa5f0a-9a16c.webp","srcSetWebp":"/static/main-6a2794e20d468e70e8f9d6afd1aa5f0a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The first place belongs to YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-free-ios-apps-in-photo-and-video-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in October 2020","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in October 2020.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-75f16678ef060cac90e66c6a8154ba0e-6d4e8.png","srcSet":"/static/main-75f16678ef060cac90e66c6a8154ba0e-6d4e8.png 1x","srcWebp":"/static/main-75f16678ef060cac90e66c6a8154ba0e-9a16c.webp","srcSetWebp":"/static/main-75f16678ef060cac90e66c6a8154ba0e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Pinterest The winner of the battle is Pinterest. The developer Pinterest says the following about the app.  Looking for inspiration? Whether…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in October 2020","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in October 2020.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5fcd3fa332a5ed8de77dc99baac6deb7-6d4e8.png","srcSet":"/static/main-5fcd3fa332a5ed8de77dc99baac6deb7-6d4e8.png 1x","srcWebp":"/static/main-5fcd3fa332a5ed8de77dc99baac6deb7-9a16c.webp","srcSetWebp":"/static/main-5fcd3fa332a5ed8de77dc99baac6deb7-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Widgetsmith The winning spot belongs to Widgetsmith. The developer Cross Forward Consulting, LLC says the following about the app…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in October 2020","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in October 2020.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-637df1055452a54c53379c6ea1d1c5eb-6d4e8.png","srcSet":"/static/main-637df1055452a54c53379c6ea1d1c5eb-6d4e8.png 1x","srcWebp":"/static/main-637df1055452a54c53379c6ea1d1c5eb-9a16c.webp","srcSetWebp":"/static/main-637df1055452a54c53379c6ea1d1c5eb-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber - Request a ride The winner of the battle is Uber - Request a ride. The developer Uber Technologies, Inc. says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in October 2020","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in October 2020.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e9552d2c456c8e7ad5ae42b4641c38ac-6d4e8.png","srcSet":"/static/main-e9552d2c456c8e7ad5ae42b4641c38ac-6d4e8.png 1x","srcWebp":"/static/main-e9552d2c456c8e7ad5ae42b4641c38ac-9a16c.webp","srcSetWebp":"/static/main-e9552d2c456c8e7ad5ae42b4641c38ac-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facebook The winner of the battle is Facebook. The developer Facebook, Inc. says the following about the app.  Connect with friends, family…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in October 2020","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in October 2020.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-20ee943ea151893e4da750261a304fd6-6d4e8.png","srcSet":"/static/main-20ee943ea151893e4da750261a304fd6-6d4e8.png 1x","srcWebp":"/static/main-20ee943ea151893e4da750261a304fd6-9a16c.webp","srcSetWebp":"/static/main-20ee943ea151893e4da750261a304fd6-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google The winner of the battle is Google. The developer Google LLC says the following about the app.  The Google app keeps you in the know…","fields":{"slug":"/top-5-free-ios-apps-in-utilities-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in October 2020","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in October 2020.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-3bdc595ac20b185447c3810d5acab90c-6d4e8.png","srcSet":"/static/main-3bdc595ac20b185447c3810d5acab90c-6d4e8.png 1x","srcWebp":"/static/main-3bdc595ac20b185447c3810d5acab90c-9a16c.webp","srcSetWebp":"/static/main-3bdc595ac20b185447c3810d5acab90c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Duolingo - Language Lessons The first place is taken by Duolingo - Language Lessons. The developer Duolingo says the following about the app…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in October 2020","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in October 2020.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5a1b101d67ba88f05d7fcddee53ad24c-6d4e8.png","srcSet":"/static/main-5a1b101d67ba88f05d7fcddee53ad24c-6d4e8.png 1x","srcWebp":"/static/main-5a1b101d67ba88f05d7fcddee53ad24c-9a16c.webp","srcSetWebp":"/static/main-5a1b101d67ba88f05d7fcddee53ad24c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The first place belongs to LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in October 2020","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in October 2020.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b37b426920356cf6ceaac86843f99f2e-6d4e8.png","srcSet":"/static/main-b37b426920356cf6ceaac86843f99f2e-6d4e8.png 1x","srcWebp":"/static/main-b37b426920356cf6ceaac86843f99f2e-9a16c.webp","srcSetWebp":"/static/main-b37b426920356cf6ceaac86843f99f2e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder - Dating & Make Friends The first place belongs to Tinder - Dating & Make Friends. The developer Tinder Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in October 2020","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in October 2020.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-1840ae06d8068512ac392b7d90a46a6a-6d4e8.png","srcSet":"/static/main-1840ae06d8068512ac392b7d90a46a6a-6d4e8.png 1x","srcWebp":"/static/main-1840ae06d8068512ac392b7d90a46a6a-9a16c.webp","srcSetWebp":"/static/main-1840ae06d8068512ac392b7d90a46a6a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The winning spot belongs to onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in October 2020","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in October 2020.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-d825d8b4ae3a18f8c4cd730e9d654ec1-6d4e8.png","srcSet":"/static/main-d825d8b4ae3a18f8c4cd730e9d654ec1-6d4e8.png 1x","srcWebp":"/static/main-d825d8b4ae3a18f8c4cd730e9d654ec1-9a16c.webp","srcSetWebp":"/static/main-d825d8b4ae3a18f8c4cd730e9d654ec1-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The first place belongs to YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Photo and Video in October 2020","subTitle":"Top 5 Grossing iOS Apps in Photo and Video and Reviews from the AppStore in October 2020.","category":"top 5 grossing ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-75f16678ef060cac90e66c6a8154ba0e-6d4e8.png","srcSet":"/static/main-75f16678ef060cac90e66c6a8154ba0e-6d4e8.png 1x","srcWebp":"/static/main-75f16678ef060cac90e66c6a8154ba0e-9a16c.webp","srcSetWebp":"/static/main-75f16678ef060cac90e66c6a8154ba0e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"BIGO LIVE-Live Stream, Go Live The winner of the battle is BIGO LIVE-Live Stream, Go Live. The developer BIGO TECHNOLOGY PTE. LTD. says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in October 2020","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in October 2020.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-d28ba042bf2051ad76030c101fc6ca11-6d4e8.png","srcSet":"/static/main-d28ba042bf2051ad76030c101fc6ca11-6d4e8.png 1x","srcWebp":"/static/main-d28ba042bf2051ad76030c101fc6ca11-9a16c.webp","srcSetWebp":"/static/main-d28ba042bf2051ad76030c101fc6ca11-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"My Disney Experience The first place belongs to My Disney Experience. The developer Disney says the following about the app.  The official…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Travel in October 2020","subTitle":"Top 5 Grossing iOS Apps in Travel and Reviews from the AppStore in October 2020.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5833e17cbcc3e7490b6f83c9af0c09ed-6d4e8.png","srcSet":"/static/main-5833e17cbcc3e7490b6f83c9af0c09ed-6d4e8.png 1x","srcWebp":"/static/main-5833e17cbcc3e7490b6f83c9af0c09ed-9a16c.webp","srcSetWebp":"/static/main-5833e17cbcc3e7490b6f83c9af0c09ed-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The winning spot belongs to RoboKiller: Block Spam Calls. The developer TelTech Systems says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in October 2020","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in October 2020.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-7aa71bcab065f448faca5a0766b03809-6d4e8.png","srcSet":"/static/main-7aa71bcab065f448faca5a0766b03809-6d4e8.png 1x","srcWebp":"/static/main-7aa71bcab065f448faca5a0766b03809-9a16c.webp","srcSetWebp":"/static/main-7aa71bcab065f448faca5a0766b03809-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"SkyView® The winner of the battle is SkyView®. The developer Terminal Eleven LLC says the following about the app.  SkyView® brings…","fields":{"slug":"/top-5-paid-ios-apps-in-education-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in October 2020","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in October 2020.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-479d227885f9a388d0ea4d7bd6580412-6d4e8.png","srcSet":"/static/main-479d227885f9a388d0ea4d7bd6580412-6d4e8.png 1x","srcWebp":"/static/main-479d227885f9a388d0ea4d7bd6580412-9a16c.webp","srcSetWebp":"/static/main-479d227885f9a388d0ea4d7bd6580412-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The winning spot belongs to HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in October 2020","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in October 2020.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0a22af6e7e3879ea026dcb01ce493d81-6d4e8.png","srcSet":"/static/main-0a22af6e7e3879ea026dcb01ce493d81-6d4e8.png 1x","srcWebp":"/static/main-0a22af6e7e3879ea026dcb01ce493d81-9a16c.webp","srcSetWebp":"/static/main-0a22af6e7e3879ea026dcb01ce493d81-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Screen Mirroring+ for Fire TV The first place belongs to Screen Mirroring+ for Fire TV. The developer Kraus und Karnath GbR 2Kit Consulting…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in October 2020","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in October 2020.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6a6caa61b7f2d149df82059402c4ca7a-6d4e8.png","srcSet":"/static/main-6a6caa61b7f2d149df82059402c4ca7a-6d4e8.png 1x","srcWebp":"/static/main-6a6caa61b7f2d149df82059402c4ca7a-9a16c.webp","srcSetWebp":"/static/main-6a6caa61b7f2d149df82059402c4ca7a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Land Nav Assistant The first place is taken by Land Nav Assistant. The developer Gammon Applications says the following about the app.  Land…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in October 2020","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in October 2020.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-8598ef0400e9c187f0a96b17a005ad30-6d4e8.png","srcSet":"/static/main-8598ef0400e9c187f0a96b17a005ad30-6d4e8.png 1x","srcWebp":"/static/main-8598ef0400e9c187f0a96b17a005ad30-9a16c.webp","srcSetWebp":"/static/main-8598ef0400e9c187f0a96b17a005ad30-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facetune The winner of the battle is Facetune. The developer Lightricks Ltd. says the following about the app.  Facetune 2 is now available…","fields":{"slug":"/top-5-paid-ios-apps-in-photo-and-video-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in October 2020","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in October 2020.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-67f42230e1c2d1122598a91d3c36a930-6d4e8.png","srcSet":"/static/main-67f42230e1c2d1122598a91d3c36a930-6d4e8.png 1x","srcWebp":"/static/main-67f42230e1c2d1122598a91d3c36a930-9a16c.webp","srcSetWebp":"/static/main-67f42230e1c2d1122598a91d3c36a930-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Screen Mirroring+ for Roku The first place is taken by Screen Mirroring+ for Roku. The developer Kraus und Karnath GbR 2Kit Consulting says…","fields":{"slug":"/top-5-paid-ios-apps-in-productivity-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in October 2020","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in October 2020.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b1a24b41fd620a5353690d82b61eaad8-6d4e8.png","srcSet":"/static/main-b1a24b41fd620a5353690d82b61eaad8-6d4e8.png 1x","srcWebp":"/static/main-b1a24b41fd620a5353690d82b61eaad8-9a16c.webp","srcSetWebp":"/static/main-b1a24b41fd620a5353690d82b61eaad8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Vegan Food Near You - HappyCow The first place is taken by Vegan Food Near You - HappyCow. The developer HappyCow says the following about…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in October 2020","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in October 2020.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ef55da3edad2face74c7694c7916bb58-6d4e8.png","srcSet":"/static/main-ef55da3edad2face74c7694c7916bb58-6d4e8.png 1x","srcWebp":"/static/main-ef55da3edad2face74c7694c7916bb58-9a16c.webp","srcSetWebp":"/static/main-ef55da3edad2face74c7694c7916bb58-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Shadowrocket The winner of the battle is Shadowrocket. The developer Shadow Launch Technology Limited says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-october-2020/","prefix":"2020-10-18"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in October 2020","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in October 2020.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ddbd9f9ca93cbb0d94bfd92dc7ed004b-6d4e8.png","srcSet":"/static/main-ddbd9f9ca93cbb0d94bfd92dc7ed004b-6d4e8.png 1x","srcWebp":"/static/main-ddbd9f9ca93cbb0d94bfd92dc7ed004b-9a16c.webp","srcSetWebp":"/static/main-ddbd9f9ca93cbb0d94bfd92dc7ed004b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ZOOM Cloud Meetings The winner of the battle is ZOOM Cloud Meetings. The developer Zoom says the following about the app.  Zoom is #1 in…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in September 2020","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in September 2020.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-df562a1ccd982f797e9753d340e7f06c-6d4e8.png","srcSet":"/static/main-df562a1ccd982f797e9753d340e7f06c-6d4e8.png 1x","srcWebp":"/static/main-df562a1ccd982f797e9753d340e7f06c-9a16c.webp","srcSetWebp":"/static/main-df562a1ccd982f797e9753d340e7f06c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Pinterest The winner of the battle is Pinterest. The developer Pinterest says the following about the app.  Looking for inspiration? Whether…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in September 2020","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in September 2020.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-733dd778fa545336a082c58cc3ea608b-6d4e8.png","srcSet":"/static/main-733dd778fa545336a082c58cc3ea608b-6d4e8.png 1x","srcWebp":"/static/main-733dd778fa545336a082c58cc3ea608b-9a16c.webp","srcSetWebp":"/static/main-733dd778fa545336a082c58cc3ea608b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winning spot belongs to YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-free-ios-apps-in-photo-and-video-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in September 2020","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in September 2020.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6fef1421be3d8cc0136b2a6cac319e99-6d4e8.png","srcSet":"/static/main-6fef1421be3d8cc0136b2a6cac319e99-6d4e8.png 1x","srcWebp":"/static/main-6fef1421be3d8cc0136b2a6cac319e99-9a16c.webp","srcSetWebp":"/static/main-6fef1421be3d8cc0136b2a6cac319e99-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Photomath The first place is taken by Photomath. The developer Photomath, Inc. says the following about the app.  Learn math, check homework…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in September 2020","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in September 2020.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c547bb4cf83cc12ad8dad77455d45564-6d4e8.png","srcSet":"/static/main-c547bb4cf83cc12ad8dad77455d45564-6d4e8.png 1x","srcWebp":"/static/main-c547bb4cf83cc12ad8dad77455d45564-9a16c.webp","srcSetWebp":"/static/main-c547bb4cf83cc12ad8dad77455d45564-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Widgetsmith The winner of the battle is Widgetsmith. The developer Cross Forward Consulting, LLC says the following about the app…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in September 2020","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in September 2020.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-be7ebc81ebe78058431381652c8f5337-6d4e8.png","srcSet":"/static/main-be7ebc81ebe78058431381652c8f5337-6d4e8.png 1x","srcWebp":"/static/main-be7ebc81ebe78058431381652c8f5337-9a16c.webp","srcSetWebp":"/static/main-be7ebc81ebe78058431381652c8f5337-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps - Transit & Food The winning spot belongs to Google Maps - Transit & Food. The developer Google LLC says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in September 2020","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in September 2020.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-584ee07641fbaced97ff7d7113bb3bb5-6d4e8.png","srcSet":"/static/main-584ee07641fbaced97ff7d7113bb3bb5-6d4e8.png 1x","srcWebp":"/static/main-584ee07641fbaced97ff7d7113bb3bb5-9a16c.webp","srcSetWebp":"/static/main-584ee07641fbaced97ff7d7113bb3bb5-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Discord - Talk, Chat, Hang Out The first place belongs to Discord - Talk, Chat, Hang Out. The developer Discord, Inc. says the following…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in September 2020","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in September 2020.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-fdab9728699b2fef25763117793578c6-6d4e8.png","srcSet":"/static/main-fdab9728699b2fef25763117793578c6-6d4e8.png 1x","srcWebp":"/static/main-fdab9728699b2fef25763117793578c6-9a16c.webp","srcSetWebp":"/static/main-fdab9728699b2fef25763117793578c6-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber - Request a ride The first place belongs to Uber - Request a ride. The developer Uber Technologies, Inc. says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in September 2020","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in September 2020.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-4b7bdaa4e2e548dbbb5ff7196afc0cca-6d4e8.png","srcSet":"/static/main-4b7bdaa4e2e548dbbb5ff7196afc0cca-6d4e8.png 1x","srcWebp":"/static/main-4b7bdaa4e2e548dbbb5ff7196afc0cca-9a16c.webp","srcSetWebp":"/static/main-4b7bdaa4e2e548dbbb5ff7196afc0cca-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The first place is taken by LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in September 2020","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in September 2020.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-2e120016f526e9db0ebf547ac13617e4-6d4e8.png","srcSet":"/static/main-2e120016f526e9db0ebf547ac13617e4-6d4e8.png 1x","srcWebp":"/static/main-2e120016f526e9db0ebf547ac13617e4-9a16c.webp","srcSetWebp":"/static/main-2e120016f526e9db0ebf547ac13617e4-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Color Widgets The winning spot belongs to Color Widgets. The developer MM Apps, Inc. says the following about the app.  Color Widgets lets…","fields":{"slug":"/top-5-free-ios-apps-in-utilities-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in September 2020","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in September 2020.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-92ebb17d8e0f5e23b5091aaf76811b18-6d4e8.png","srcSet":"/static/main-92ebb17d8e0f5e23b5091aaf76811b18-6d4e8.png 1x","srcWebp":"/static/main-92ebb17d8e0f5e23b5091aaf76811b18-9a16c.webp","srcSetWebp":"/static/main-92ebb17d8e0f5e23b5091aaf76811b18-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder - Dating & Make Friends The winning spot belongs to Tinder - Dating & Make Friends. The developer Tinder Inc. says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in September 2020","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in September 2020.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0c6ec6cc1b616173e9754ac3ae1dd4b8-6d4e8.png","srcSet":"/static/main-0c6ec6cc1b616173e9754ac3ae1dd4b8-6d4e8.png 1x","srcWebp":"/static/main-0c6ec6cc1b616173e9754ac3ae1dd4b8-9a16c.webp","srcSetWebp":"/static/main-0c6ec6cc1b616173e9754ac3ae1dd4b8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The winning spot belongs to onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in September 2020","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in September 2020.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e89b3cba1f741907d2789aec1324eb73-6d4e8.png","srcSet":"/static/main-e89b3cba1f741907d2789aec1324eb73-6d4e8.png 1x","srcWebp":"/static/main-e89b3cba1f741907d2789aec1324eb73-9a16c.webp","srcSetWebp":"/static/main-e89b3cba1f741907d2789aec1324eb73-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Toca Life World: Build stories The winner of the battle is Toca Life World: Build stories. The developer Toca Boca AB says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in September 2020","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in September 2020.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-65b6737f425d04844dc8636e6d92ce43-6d4e8.png","srcSet":"/static/main-65b6737f425d04844dc8636e6d92ce43-6d4e8.png 1x","srcWebp":"/static/main-65b6737f425d04844dc8636e6d92ce43-9a16c.webp","srcSetWebp":"/static/main-65b6737f425d04844dc8636e6d92ce43-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"BIGO LIVE-Live Stream, Go Live The winner of the battle is BIGO LIVE-Live Stream, Go Live. The developer BIGO TECHNOLOGY PTE. LTD. says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in September 2020","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in September 2020.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-d28ba042bf2051ad76030c101fc6ca11-6d4e8.png","srcSet":"/static/main-d28ba042bf2051ad76030c101fc6ca11-6d4e8.png 1x","srcWebp":"/static/main-d28ba042bf2051ad76030c101fc6ca11-9a16c.webp","srcSetWebp":"/static/main-d28ba042bf2051ad76030c101fc6ca11-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The first place belongs to RoboKiller: Block Spam Calls. The developer TelTech Systems says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in September 2020","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in September 2020.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-029d18800eace3fd783d8357983f120c-6d4e8.png","srcSet":"/static/main-029d18800eace3fd783d8357983f120c-6d4e8.png 1x","srcWebp":"/static/main-029d18800eace3fd783d8357983f120c-9a16c.webp","srcSetWebp":"/static/main-029d18800eace3fd783d8357983f120c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"My Disney Experience The winner of the battle is My Disney Experience. The developer Disney says the following about the app.  The official…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Travel in September 2020","subTitle":"Top 5 Grossing iOS Apps in Travel and Reviews from the AppStore in September 2020.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5833e17cbcc3e7490b6f83c9af0c09ed-6d4e8.png","srcSet":"/static/main-5833e17cbcc3e7490b6f83c9af0c09ed-6d4e8.png 1x","srcWebp":"/static/main-5833e17cbcc3e7490b6f83c9af0c09ed-9a16c.webp","srcSetWebp":"/static/main-5833e17cbcc3e7490b6f83c9af0c09ed-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The winning spot belongs to HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in September 2020","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in September 2020.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-4da71bb44af2043271ecf41f5079be64-6d4e8.png","srcSet":"/static/main-4da71bb44af2043271ecf41f5079be64-6d4e8.png 1x","srcWebp":"/static/main-4da71bb44af2043271ecf41f5079be64-9a16c.webp","srcSetWebp":"/static/main-4da71bb44af2043271ecf41f5079be64-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Universe in a Nutshell The first place is taken by Universe in a Nutshell. The developer in a nutshell - kurzgesagt GmbH says the following…","fields":{"slug":"/top-5-paid-ios-apps-in-education-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in September 2020","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in September 2020.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-38bf2d6a3c749d681e0105d933fa68e4-6d4e8.png","srcSet":"/static/main-38bf2d6a3c749d681e0105d933fa68e4-6d4e8.png 1x","srcWebp":"/static/main-38bf2d6a3c749d681e0105d933fa68e4-9a16c.webp","srcSetWebp":"/static/main-38bf2d6a3c749d681e0105d933fa68e4-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Land Nav Assistant The winning spot belongs to Land Nav Assistant. The developer Gammon Applications says the following about the app.  Land…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in September 2020","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in September 2020.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9f4895c7d1cee54cee47cb898e2832eb-6d4e8.png","srcSet":"/static/main-9f4895c7d1cee54cee47cb898e2832eb-6d4e8.png 1x","srcWebp":"/static/main-9f4895c7d1cee54cee47cb898e2832eb-9a16c.webp","srcSetWebp":"/static/main-9f4895c7d1cee54cee47cb898e2832eb-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Screen Mirroring+ for Fire TV The first place belongs to Screen Mirroring+ for Fire TV. The developer 2kit consulting says the following…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in September 2020","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in September 2020.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6a6caa61b7f2d149df82059402c4ca7a-6d4e8.png","srcSet":"/static/main-6a6caa61b7f2d149df82059402c4ca7a-6d4e8.png 1x","srcWebp":"/static/main-6a6caa61b7f2d149df82059402c4ca7a-9a16c.webp","srcSetWebp":"/static/main-6a6caa61b7f2d149df82059402c4ca7a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facetune The first place is taken by Facetune. The developer Lightricks Ltd. says the following about the app.  Facetune 2 is now available…","fields":{"slug":"/top-5-paid-ios-apps-in-photo-and-video-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in September 2020","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in September 2020.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-67f42230e1c2d1122598a91d3c36a930-6d4e8.png","srcSet":"/static/main-67f42230e1c2d1122598a91d3c36a930-6d4e8.png 1x","srcWebp":"/static/main-67f42230e1c2d1122598a91d3c36a930-9a16c.webp","srcSetWebp":"/static/main-67f42230e1c2d1122598a91d3c36a930-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Forest - Stay focused The first place belongs to Forest - Stay focused. The developer SEEKRTECH CO., LTD. says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-productivity-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in September 2020","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in September 2020.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-afc06057f2dbc4dcbd7587f628de87f3-6d4e8.png","srcSet":"/static/main-afc06057f2dbc4dcbd7587f628de87f3-6d4e8.png 1x","srcWebp":"/static/main-afc06057f2dbc4dcbd7587f628de87f3-9a16c.webp","srcSetWebp":"/static/main-afc06057f2dbc4dcbd7587f628de87f3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Threema. The Secure Messenger The first place is taken by Threema. The Secure Messenger. The developer Threema GmbH says the following about…","fields":{"slug":"/top-5-paid-ios-apps-in-social-networking-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Social Networking in September 2020","subTitle":"Top 5 Paid iOS Apps in Social Networking and Reviews from the AppStore in September 2020.","category":"top 5 paid ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-d21fd422a107cbd26481bb70b9e05981-6d4e8.png","srcSet":"/static/main-d21fd422a107cbd26481bb70b9e05981-6d4e8.png 1x","srcWebp":"/static/main-d21fd422a107cbd26481bb70b9e05981-9a16c.webp","srcSetWebp":"/static/main-d21fd422a107cbd26481bb70b9e05981-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"MarineTraffic - Ship Tracking The first place is taken by MarineTraffic - Ship Tracking. The developer MarineTraffic.com says the following…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in September 2020","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in September 2020.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9ef1e031f40ecd06eebe03eb07d79312-6d4e8.png","srcSet":"/static/main-9ef1e031f40ecd06eebe03eb07d79312-6d4e8.png 1x","srcWebp":"/static/main-9ef1e031f40ecd06eebe03eb07d79312-9a16c.webp","srcSetWebp":"/static/main-9ef1e031f40ecd06eebe03eb07d79312-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Shadowrocket The winning spot belongs to Shadowrocket. The developer Shadow Launch Technology Limited says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-september-2020/","prefix":"2020-09-26"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in September 2020","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in September 2020.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-dfea3202456b5aaa03aecc424f51e7d8-6d4e8.png","srcSet":"/static/main-dfea3202456b5aaa03aecc424f51e7d8-6d4e8.png 1x","srcWebp":"/static/main-dfea3202456b5aaa03aecc424f51e7d8-9a16c.webp","srcSetWebp":"/static/main-dfea3202456b5aaa03aecc424f51e7d8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ZOOM Cloud Meetings The first place belongs to ZOOM Cloud Meetings. The developer Zoom says the following about the app.  Zoom is #1 in…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in August 2020","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in August 2020.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a739978e377ce7c903abcc3c88ab4f05-6d4e8.png","srcSet":"/static/main-a739978e377ce7c903abcc3c88ab4f05-6d4e8.png 1x","srcWebp":"/static/main-a739978e377ce7c903abcc3c88ab4f05-9a16c.webp","srcSetWebp":"/static/main-a739978e377ce7c903abcc3c88ab4f05-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Classroom The first place is taken by Google Classroom. The developer Google LLC says the following about the app.  Classroom is a…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in August 2020","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in August 2020.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-d0a21947e4d159d9fd2723d48e686856-6d4e8.png","srcSet":"/static/main-d0a21947e4d159d9fd2723d48e686856-6d4e8.png 1x","srcWebp":"/static/main-d0a21947e4d159d9fd2723d48e686856-9a16c.webp","srcSetWebp":"/static/main-d0a21947e4d159d9fd2723d48e686856-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Pinterest The first place is taken by Pinterest. The developer Pinterest says the following about the app.  Looking for inspiration? Whether…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in August 2020","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in August 2020.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-8ff4a75ca0bf3bb02decde10303f5710-6d4e8.png","srcSet":"/static/main-8ff4a75ca0bf3bb02decde10303f5710-6d4e8.png 1x","srcWebp":"/static/main-8ff4a75ca0bf3bb02decde10303f5710-9a16c.webp","srcSetWebp":"/static/main-8ff4a75ca0bf3bb02decde10303f5710-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps - Transit & Food The first place belongs to Google Maps - Transit & Food. The developer Google LLC says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in August 2020","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in August 2020.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-f768de6cef68435e62ab6352414dfcea-6d4e8.png","srcSet":"/static/main-f768de6cef68435e62ab6352414dfcea-6d4e8.png 1x","srcWebp":"/static/main-f768de6cef68435e62ab6352414dfcea-9a16c.webp","srcSetWebp":"/static/main-f768de6cef68435e62ab6352414dfcea-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Messenger The first place is taken by Messenger. The developer Facebook, Inc. says the following about the app.  Be together whenever, with…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in August 2020","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in August 2020.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-2b33c1086d0db04e748158178ebfe189-6d4e8.png","srcSet":"/static/main-2b33c1086d0db04e748158178ebfe189-6d4e8.png 1x","srcWebp":"/static/main-2b33c1086d0db04e748158178ebfe189-9a16c.webp","srcSetWebp":"/static/main-2b33c1086d0db04e748158178ebfe189-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber - Request a ride The winner of the battle is Uber - Request a ride. The developer Uber Technologies, Inc. says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in August 2020","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in August 2020.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-cb3ed02872ead1aea8a9e34bf099dfc3-6d4e8.png","srcSet":"/static/main-cb3ed02872ead1aea8a9e34bf099dfc3-6d4e8.png 1x","srcWebp":"/static/main-cb3ed02872ead1aea8a9e34bf099dfc3-9a16c.webp","srcSetWebp":"/static/main-cb3ed02872ead1aea8a9e34bf099dfc3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The first place is taken by LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in August 2020","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in August 2020.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6e76885b61624ee8ae2ad9b6a06c3ba6-6d4e8.png","srcSet":"/static/main-6e76885b61624ee8ae2ad9b6a06c3ba6-6d4e8.png 1x","srcWebp":"/static/main-6e76885b61624ee8ae2ad9b6a06c3ba6-9a16c.webp","srcSetWebp":"/static/main-6e76885b61624ee8ae2ad9b6a06c3ba6-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Toca Life World: Build stories The winning spot belongs to Toca Life World: Build stories. The developer Toca Boca AB says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in August 2020","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in August 2020.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6174dbe981650ecd524fbf069b344748-6d4e8.png","srcSet":"/static/main-6174dbe981650ecd524fbf069b344748-6d4e8.png 1x","srcWebp":"/static/main-6174dbe981650ecd524fbf069b344748-9a16c.webp","srcSetWebp":"/static/main-6174dbe981650ecd524fbf069b344748-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The winning spot belongs to Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in August 2020","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in August 2020.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-98ee67a616d4b40d7209421765071b10-6d4e8.png","srcSet":"/static/main-98ee67a616d4b40d7209421765071b10-6d4e8.png 1x","srcWebp":"/static/main-98ee67a616d4b40d7209421765071b10-9a16c.webp","srcSetWebp":"/static/main-98ee67a616d4b40d7209421765071b10-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder - Dating & New Friends The winning spot belongs to Tinder - Dating & New Friends. The developer Tinder Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in August 2020","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in August 2020.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-8faa15639a6a8e12a39f12eb0b9da240-6d4e8.png","srcSet":"/static/main-8faa15639a6a8e12a39f12eb0b9da240-6d4e8.png 1x","srcWebp":"/static/main-8faa15639a6a8e12a39f12eb0b9da240-9a16c.webp","srcSetWebp":"/static/main-8faa15639a6a8e12a39f12eb0b9da240-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The first place is taken by onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in August 2020","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in August 2020.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b4140e5f74ab2ad97b932dc3d513ad58-6d4e8.png","srcSet":"/static/main-b4140e5f74ab2ad97b932dc3d513ad58-6d4e8.png 1x","srcWebp":"/static/main-b4140e5f74ab2ad97b932dc3d513ad58-9a16c.webp","srcSetWebp":"/static/main-b4140e5f74ab2ad97b932dc3d513ad58-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The winner of the battle is RoboKiller: Block Spam Calls. The developer TelTech Systems says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in August 2020","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in August 2020.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-3b611d5dc7c67013ce142698387f7369-6d4e8.png","srcSet":"/static/main-3b611d5dc7c67013ce142698387f7369-6d4e8.png 1x","srcWebp":"/static/main-3b611d5dc7c67013ce142698387f7369-9a16c.webp","srcSetWebp":"/static/main-3b611d5dc7c67013ce142698387f7369-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"BIGO LIVE-Live Stream, Go Live The winning spot belongs to BIGO LIVE-Live Stream, Go Live. The developer BIGO TECHNOLOGY PTE. LTD. says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in August 2020","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in August 2020.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-670077accb20836630c2a214ba25b69b-6d4e8.png","srcSet":"/static/main-670077accb20836630c2a214ba25b69b-6d4e8.png 1x","srcWebp":"/static/main-670077accb20836630c2a214ba25b69b-9a16c.webp","srcSetWebp":"/static/main-670077accb20836630c2a214ba25b69b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winning spot belongs to YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Photo and Video in August 2020","subTitle":"Top 5 Grossing iOS Apps in Photo and Video and Reviews from the AppStore in August 2020.","category":"top 5 grossing ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-158f3287d75e4efbb864496a66d78e69-6d4e8.png","srcSet":"/static/main-158f3287d75e4efbb864496a66d78e69-6d4e8.png 1x","srcWebp":"/static/main-158f3287d75e4efbb864496a66d78e69-9a16c.webp","srcSetWebp":"/static/main-158f3287d75e4efbb864496a66d78e69-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The winning spot belongs to HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in August 2020","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in August 2020.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c13d1bd837856d1b42bfd49b83b54572-6d4e8.png","srcSet":"/static/main-c13d1bd837856d1b42bfd49b83b54572-6d4e8.png 1x","srcWebp":"/static/main-c13d1bd837856d1b42bfd49b83b54572-9a16c.webp","srcSetWebp":"/static/main-c13d1bd837856d1b42bfd49b83b54572-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Land Nav Assistant The first place is taken by Land Nav Assistant. The developer Gammon Applications says the following about the app.  Land…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in August 2020","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in August 2020.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9a4fee321c8ae01ae0a9fc6d1fa2da93-6d4e8.png","srcSet":"/static/main-9a4fee321c8ae01ae0a9fc6d1fa2da93-6d4e8.png 1x","srcWebp":"/static/main-9a4fee321c8ae01ae0a9fc6d1fa2da93-9a16c.webp","srcSetWebp":"/static/main-9a4fee321c8ae01ae0a9fc6d1fa2da93-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Screen Mirroring+ for Fire TV The winning spot belongs to Screen Mirroring+ for Fire TV. The developer 2kit consulting says the following…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in August 2020","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in August 2020.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-f5d248b780ed907109749fd1afb3611b-6d4e8.png","srcSet":"/static/main-f5d248b780ed907109749fd1afb3611b-6d4e8.png 1x","srcWebp":"/static/main-f5d248b780ed907109749fd1afb3611b-9a16c.webp","srcSetWebp":"/static/main-f5d248b780ed907109749fd1afb3611b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"MarineTraffic - Ship Tracking The first place belongs to MarineTraffic - Ship Tracking. The developer MarineTraffic.com says the following…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in August 2020","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in August 2020.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-03313ad36e368ed633c5c6e8553303eb-6d4e8.png","srcSet":"/static/main-03313ad36e368ed633c5c6e8553303eb-6d4e8.png 1x","srcWebp":"/static/main-03313ad36e368ed633c5c6e8553303eb-9a16c.webp","srcSetWebp":"/static/main-03313ad36e368ed633c5c6e8553303eb-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Shadowrocket The first place is taken by Shadowrocket. The developer Shadow Launch Technology Limited says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-august-2020/","prefix":"2020-08-28"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in August 2020","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in August 2020.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-dfea3202456b5aaa03aecc424f51e7d8-6d4e8.png","srcSet":"/static/main-dfea3202456b5aaa03aecc424f51e7d8-6d4e8.png 1x","srcWebp":"/static/main-dfea3202456b5aaa03aecc424f51e7d8-9a16c.webp","srcSetWebp":"/static/main-dfea3202456b5aaa03aecc424f51e7d8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ZOOM Cloud Meetings The winner of the battle is ZOOM Cloud Meetings. The developer Zoom says the following about the app. _Stay connected…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in July 2020","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in July 2020.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-dd1a548d5c3d55f8ddc45a303d360328-6d4e8.png","srcSet":"/static/main-dd1a548d5c3d55f8ddc45a303d360328-6d4e8.png 1x","srcWebp":"/static/main-dd1a548d5c3d55f8ddc45a303d360328-9a16c.webp","srcSetWebp":"/static/main-dd1a548d5c3d55f8ddc45a303d360328-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Pinterest The winner of the battle is Pinterest. The developer Pinterest says the following about the app.  Looking for inspiration? Whether…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in July 2020","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in July 2020.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b00255b119d8c9e90e1d8130367b8716-6d4e8.png","srcSet":"/static/main-b00255b119d8c9e90e1d8130367b8716-6d4e8.png 1x","srcWebp":"/static/main-b00255b119d8c9e90e1d8130367b8716-9a16c.webp","srcSetWebp":"/static/main-b00255b119d8c9e90e1d8130367b8716-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"SignSchool The first place belongs to SignSchool. The developer SignSchool Technologies LLC says the following about the app.  Learn…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in July 2020","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in July 2020.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6a02e3323f74db345ca6f699f6abd470-6d4e8.png","srcSet":"/static/main-6a02e3323f74db345ca6f699f6abd470-6d4e8.png 1x","srcWebp":"/static/main-6a02e3323f74db345ca6f699f6abd470-9a16c.webp","srcSetWebp":"/static/main-6a02e3323f74db345ca6f699f6abd470-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps - Transit & Food The winner of the battle is Google Maps - Transit & Food. The developer Google LLC says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in July 2020","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in July 2020.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-913f6b63e072acc00989ef155472930b-6d4e8.png","srcSet":"/static/main-913f6b63e072acc00989ef155472930b-6d4e8.png 1x","srcWebp":"/static/main-913f6b63e072acc00989ef155472930b-9a16c.webp","srcSetWebp":"/static/main-913f6b63e072acc00989ef155472930b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Messenger The first place belongs to Messenger. The developer Facebook, Inc. says the following about the app.  Be together whenever, with…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in July 2020","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in July 2020.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-cf286985f57485c755d1b1416a4de4ec-6d4e8.png","srcSet":"/static/main-cf286985f57485c755d1b1416a4de4ec-6d4e8.png 1x","srcWebp":"/static/main-cf286985f57485c755d1b1416a4de4ec-9a16c.webp","srcSetWebp":"/static/main-cf286985f57485c755d1b1416a4de4ec-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The winning spot belongs to Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in July 2020","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in July 2020.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0299868114663afe8386d202be2b75ed-6d4e8.png","srcSet":"/static/main-0299868114663afe8386d202be2b75ed-6d4e8.png 1x","srcWebp":"/static/main-0299868114663afe8386d202be2b75ed-9a16c.webp","srcSetWebp":"/static/main-0299868114663afe8386d202be2b75ed-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google The first place is taken by Google. The developer Google LLC says the following about the app.  The Google app keeps you in the know…","fields":{"slug":"/top-5-free-ios-apps-in-utilities-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in July 2020","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in July 2020.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-86144296661bf9e6f1787ffc346a25d4-6d4e8.png","srcSet":"/static/main-86144296661bf9e6f1787ffc346a25d4-6d4e8.png 1x","srcWebp":"/static/main-86144296661bf9e6f1787ffc346a25d4-9a16c.webp","srcSetWebp":"/static/main-86144296661bf9e6f1787ffc346a25d4-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber - Request a ride The winner of the battle is Uber - Request a ride. The developer Uber Technologies, Inc. says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in July 2020","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in July 2020.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6873ee23f87edcfde157979ebd3d7cc9-6d4e8.png","srcSet":"/static/main-6873ee23f87edcfde157979ebd3d7cc9-6d4e8.png 1x","srcWebp":"/static/main-6873ee23f87edcfde157979ebd3d7cc9-9a16c.webp","srcSetWebp":"/static/main-6873ee23f87edcfde157979ebd3d7cc9-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The first place belongs to LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in July 2020","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in July 2020.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-1ebac1b5485dc9955a4afb67415c6e13-6d4e8.png","srcSet":"/static/main-1ebac1b5485dc9955a4afb67415c6e13-6d4e8.png 1x","srcWebp":"/static/main-1ebac1b5485dc9955a4afb67415c6e13-9a16c.webp","srcSetWebp":"/static/main-1ebac1b5485dc9955a4afb67415c6e13-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder The winner of the battle is Tinder. The developer Tinder Inc. says the following about the app.  With 30 billion matches to date…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in July 2020","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in July 2020.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-dd1fe3d4effd963f129675d16ec1f490-6d4e8.png","srcSet":"/static/main-dd1fe3d4effd963f129675d16ec1f490-6d4e8.png 1x","srcWebp":"/static/main-dd1fe3d4effd963f129675d16ec1f490-9a16c.webp","srcSetWebp":"/static/main-dd1fe3d4effd963f129675d16ec1f490-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ABCmouse.com The first place is taken by ABCmouse.com. The developer Age of Learning, Inc. says the following about the app.  Start your 3…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in July 2020","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in July 2020.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-4c9ae5ebb18defb2404d8ac91e6b407d-6d4e8.png","srcSet":"/static/main-4c9ae5ebb18defb2404d8ac91e6b407d-6d4e8.png 1x","srcWebp":"/static/main-4c9ae5ebb18defb2404d8ac91e6b407d-9a16c.webp","srcSetWebp":"/static/main-4c9ae5ebb18defb2404d8ac91e6b407d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The winning spot belongs to onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in July 2020","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in July 2020.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c681b18ded4c86aa0ab29c628a1b0abc-6d4e8.png","srcSet":"/static/main-c681b18ded4c86aa0ab29c628a1b0abc-6d4e8.png 1x","srcWebp":"/static/main-c681b18ded4c86aa0ab29c628a1b0abc-9a16c.webp","srcSetWebp":"/static/main-c681b18ded4c86aa0ab29c628a1b0abc-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Planes Live - Flight Tracker The winner of the battle is Planes Live - Flight Tracker. The developer Weather or Not Apps, LLC says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Travel in July 2020","subTitle":"Top 5 Grossing iOS Apps in Travel and Reviews from the AppStore in July 2020.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-3eff16aa1e3635043eb01862dbbafa05-6d4e8.png","srcSet":"/static/main-3eff16aa1e3635043eb01862dbbafa05-6d4e8.png 1x","srcWebp":"/static/main-3eff16aa1e3635043eb01862dbbafa05-9a16c.webp","srcSetWebp":"/static/main-3eff16aa1e3635043eb01862dbbafa05-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"BIGO LIVE-Live Stream, Go Live The winning spot belongs to BIGO LIVE-Live Stream, Go Live. The developer BIGO TECHNOLOGY PTE. LTD. says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in July 2020","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in July 2020.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-fe63f71978fcc467caa85afeee6aaabe-6d4e8.png","srcSet":"/static/main-fe63f71978fcc467caa85afeee6aaabe-6d4e8.png 1x","srcWebp":"/static/main-fe63f71978fcc467caa85afeee6aaabe-9a16c.webp","srcSetWebp":"/static/main-fe63f71978fcc467caa85afeee6aaabe-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The first place is taken by RoboKiller: Block Spam Calls. The developer TelTech Systems says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in July 2020","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in July 2020.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-4be8d5c18b0585c8bcd89aec14f24062-6d4e8.png","srcSet":"/static/main-4be8d5c18b0585c8bcd89aec14f24062-6d4e8.png 1x","srcWebp":"/static/main-4be8d5c18b0585c8bcd89aec14f24062-9a16c.webp","srcSetWebp":"/static/main-4be8d5c18b0585c8bcd89aec14f24062-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The winner of the battle is HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in July 2020","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in July 2020.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a9fc648307a742dc42676757d56aaeb9-6d4e8.png","srcSet":"/static/main-a9fc648307a742dc42676757d56aaeb9-6d4e8.png 1x","srcWebp":"/static/main-a9fc648307a742dc42676757d56aaeb9-9a16c.webp","srcSetWebp":"/static/main-a9fc648307a742dc42676757d56aaeb9-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Toca Hair Salon 3 The winner of the battle is Toca Hair Salon 3. The developer Toca Boca AB says the following about the app.  Welcome to…","fields":{"slug":"/top-5-paid-ios-apps-in-education-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in July 2020","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in July 2020.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-dd6d61b18bc08af2f0bba4a29fe68370-6d4e8.png","srcSet":"/static/main-dd6d61b18bc08af2f0bba4a29fe68370-6d4e8.png 1x","srcWebp":"/static/main-dd6d61b18bc08af2f0bba4a29fe68370-9a16c.webp","srcSetWebp":"/static/main-dd6d61b18bc08af2f0bba4a29fe68370-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Screen Mirroring+ for Fire TV The first place belongs to Screen Mirroring+ for Fire TV. The developer 2kit consulting says the following…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in July 2020","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in July 2020.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ae80417766b357dbdca110a4739f790c-6d4e8.png","srcSet":"/static/main-ae80417766b357dbdca110a4739f790c-6d4e8.png 1x","srcWebp":"/static/main-ae80417766b357dbdca110a4739f790c-9a16c.webp","srcSetWebp":"/static/main-ae80417766b357dbdca110a4739f790c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"GoSkyWatch Planetarium The winning spot belongs to GoSkyWatch Planetarium. The developer GoSoftWorks says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in July 2020","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in July 2020.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-80555597055e35c925b43311ba050bf2-6d4e8.png","srcSet":"/static/main-80555597055e35c925b43311ba050bf2-6d4e8.png 1x","srcWebp":"/static/main-80555597055e35c925b43311ba050bf2-9a16c.webp","srcSetWebp":"/static/main-80555597055e35c925b43311ba050bf2-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facetune The winner of the battle is Facetune. The developer Lightricks Ltd. says the following about the app.  Facetune 2 is now available…","fields":{"slug":"/top-5-paid-ios-apps-in-photo-and-video-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in July 2020","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in July 2020.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c400c8023dfe672e1b11598379350a75-6d4e8.png","srcSet":"/static/main-c400c8023dfe672e1b11598379350a75-6d4e8.png 1x","srcWebp":"/static/main-c400c8023dfe672e1b11598379350a75-9a16c.webp","srcSetWebp":"/static/main-c400c8023dfe672e1b11598379350a75-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"FlickType Keyboard The first place belongs to FlickType Keyboard. The developer Kpaw, LLC says the following about the app.  FlickType is a…","fields":{"slug":"/top-5-paid-ios-apps-in-productivity-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in July 2020","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in July 2020.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-bffa285b0dfa603faa49ad6f5e01c151-6d4e8.png","srcSet":"/static/main-bffa285b0dfa603faa49ad6f5e01c151-6d4e8.png 1x","srcWebp":"/static/main-bffa285b0dfa603faa49ad6f5e01c151-9a16c.webp","srcSetWebp":"/static/main-bffa285b0dfa603faa49ad6f5e01c151-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Hi Monkey - Quick Chat The first place belongs to Hi Monkey - Quick Chat. The developer Mohammed Essabbar says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-social-networking-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Social Networking in July 2020","subTitle":"Top 5 Paid iOS Apps in Social Networking and Reviews from the AppStore in July 2020.","category":"top 5 paid ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e905b1a08030a09b46e3b279e4d0fccb-6d4e8.png","srcSet":"/static/main-e905b1a08030a09b46e3b279e4d0fccb-6d4e8.png 1x","srcWebp":"/static/main-e905b1a08030a09b46e3b279e4d0fccb-9a16c.webp","srcSetWebp":"/static/main-e905b1a08030a09b46e3b279e4d0fccb-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Shadowrocket The first place belongs to Shadowrocket. The developer Shadow Launch Technology Limited says the following about the app.  Rule…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in July 2020","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in July 2020.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5f1849d1b293847634bcc9f3b591cc28-6d4e8.png","srcSet":"/static/main-5f1849d1b293847634bcc9f3b591cc28-6d4e8.png 1x","srcWebp":"/static/main-5f1849d1b293847634bcc9f3b591cc28-9a16c.webp","srcSetWebp":"/static/main-5f1849d1b293847634bcc9f3b591cc28-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Camp & RV - Tents to RV Parks The first place is taken by Camp & RV - Tents to RV Parks. The developer Allstays LLC says the following about…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-july-2020/","prefix":"2020-07-16"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in July 2020","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in July 2020.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-cb6b2535b46add4e674a755e428fbb6d-6d4e8.png","srcSet":"/static/main-cb6b2535b46add4e674a755e428fbb6d-6d4e8.png 1x","srcWebp":"/static/main-cb6b2535b46add4e674a755e428fbb6d-9a16c.webp","srcSetWebp":"/static/main-cb6b2535b46add4e674a755e428fbb6d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ZOOM Cloud Meetings The first place is taken by ZOOM Cloud Meetings. The developer Zoom says the following about the app.  Stay connected…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in June 2020","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in June 2020.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-21cc390005660e6ae44e4ff8f1b7deb9-6d4e8.png","srcSet":"/static/main-21cc390005660e6ae44e4ff8f1b7deb9-6d4e8.png 1x","srcWebp":"/static/main-21cc390005660e6ae44e4ff8f1b7deb9-9a16c.webp","srcSetWebp":"/static/main-21cc390005660e6ae44e4ff8f1b7deb9-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"PictureThis - Plant Identifier The first place is taken by PictureThis - Plant Identifier. The developer Glority Global Group Ltd. says the…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in June 2020","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in June 2020.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-d555749b162e2a5133f6862d079bb1ef-6d4e8.png","srcSet":"/static/main-d555749b162e2a5133f6862d079bb1ef-6d4e8.png 1x","srcWebp":"/static/main-d555749b162e2a5133f6862d079bb1ef-9a16c.webp","srcSetWebp":"/static/main-d555749b162e2a5133f6862d079bb1ef-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps - Transit & Food The winner of the battle is Google Maps - Transit & Food. The developer Google LLC says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in June 2020","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in June 2020.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-bbdd983da036f6a7b9905db893146871-6d4e8.png","srcSet":"/static/main-bbdd983da036f6a7b9905db893146871-6d4e8.png 1x","srcWebp":"/static/main-bbdd983da036f6a7b9905db893146871-9a16c.webp","srcSetWebp":"/static/main-bbdd983da036f6a7b9905db893146871-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Pinterest The first place is taken by Pinterest. The developer Pinterest says the following about the app.  Looking for inspiration? Whether…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in June 2020","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in June 2020.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-21b221659f48dab7e6b72e837e663582-6d4e8.png","srcSet":"/static/main-21b221659f48dab7e6b72e837e663582-6d4e8.png 1x","srcWebp":"/static/main-21b221659f48dab7e6b72e837e663582-9a16c.webp","srcSetWebp":"/static/main-21b221659f48dab7e6b72e837e663582-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"FaceApp - AI Face Editor The first place belongs to FaceApp - AI Face Editor. The developer FaceApp Inc says the following about the app…","fields":{"slug":"/top-5-free-ios-apps-in-photo-and-video-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in June 2020","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in June 2020.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ec5fd4dd348ab4ffa40e5e6fa24441bd-6d4e8.png","srcSet":"/static/main-ec5fd4dd348ab4ffa40e5e6fa24441bd-6d4e8.png 1x","srcWebp":"/static/main-ec5fd4dd348ab4ffa40e5e6fa24441bd-9a16c.webp","srcSetWebp":"/static/main-ec5fd4dd348ab4ffa40e5e6fa24441bd-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facebook The first place belongs to Facebook. The developer Facebook, Inc. says the following about the app.  Connect with friends, family…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in June 2020","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in June 2020.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c0db03d8ac1b8cc95b3ad75e93d59654-6d4e8.png","srcSet":"/static/main-c0db03d8ac1b8cc95b3ad75e93d59654-6d4e8.png 1x","srcWebp":"/static/main-c0db03d8ac1b8cc95b3ad75e93d59654-9a16c.webp","srcSetWebp":"/static/main-c0db03d8ac1b8cc95b3ad75e93d59654-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The first place is taken by Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in June 2020","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in June 2020.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0299868114663afe8386d202be2b75ed-6d4e8.png","srcSet":"/static/main-0299868114663afe8386d202be2b75ed-6d4e8.png 1x","srcWebp":"/static/main-0299868114663afe8386d202be2b75ed-9a16c.webp","srcSetWebp":"/static/main-0299868114663afe8386d202be2b75ed-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber - Request a ride The winning spot belongs to Uber - Request a ride. The developer Uber Technologies, Inc. says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in June 2020","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in June 2020.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-786c058a598c8019ea7f9cd1fbe1385f-6d4e8.png","srcSet":"/static/main-786c058a598c8019ea7f9cd1fbe1385f-6d4e8.png 1x","srcWebp":"/static/main-786c058a598c8019ea7f9cd1fbe1385f-9a16c.webp","srcSetWebp":"/static/main-786c058a598c8019ea7f9cd1fbe1385f-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The first place belongs to LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in June 2020","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in June 2020.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-1ebac1b5485dc9955a4afb67415c6e13-6d4e8.png","srcSet":"/static/main-1ebac1b5485dc9955a4afb67415c6e13-6d4e8.png 1x","srcWebp":"/static/main-1ebac1b5485dc9955a4afb67415c6e13-9a16c.webp","srcSetWebp":"/static/main-1ebac1b5485dc9955a4afb67415c6e13-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ABCmouse.com The first place belongs to ABCmouse.com. The developer Age of Learning, Inc. says the following about the app.  Start your 3…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in June 2020","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in June 2020.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-4c9ae5ebb18defb2404d8ac91e6b407d-6d4e8.png","srcSet":"/static/main-4c9ae5ebb18defb2404d8ac91e6b407d-6d4e8.png 1x","srcWebp":"/static/main-4c9ae5ebb18defb2404d8ac91e6b407d-9a16c.webp","srcSetWebp":"/static/main-4c9ae5ebb18defb2404d8ac91e6b407d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder The winner of the battle is Tinder. The developer Tinder Inc. says the following about the app.  With 30 billion matches to date…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in June 2020","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in June 2020.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-551afa6d41274844a2f53a0841262e8a-6d4e8.png","srcSet":"/static/main-551afa6d41274844a2f53a0841262e8a-6d4e8.png 1x","srcWebp":"/static/main-551afa6d41274844a2f53a0841262e8a-9a16c.webp","srcSetWebp":"/static/main-551afa6d41274844a2f53a0841262e8a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Chrome The first place is taken by Google Chrome. The developer Google LLC says the following about the app.  Get more done with the…","fields":{"slug":"/top-5-free-ios-apps-in-utilities-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in June 2020","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in June 2020.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-dd47008ce9c1885d29ca7b0138983033-6d4e8.png","srcSet":"/static/main-dd47008ce9c1885d29ca7b0138983033-6d4e8.png 1x","srcWebp":"/static/main-dd47008ce9c1885d29ca7b0138983033-9a16c.webp","srcSetWebp":"/static/main-dd47008ce9c1885d29ca7b0138983033-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The first place is taken by onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in June 2020","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in June 2020.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c681b18ded4c86aa0ab29c628a1b0abc-6d4e8.png","srcSet":"/static/main-c681b18ded4c86aa0ab29c628a1b0abc-6d4e8.png 1x","srcWebp":"/static/main-c681b18ded4c86aa0ab29c628a1b0abc-9a16c.webp","srcSetWebp":"/static/main-c681b18ded4c86aa0ab29c628a1b0abc-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The first place belongs to YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Photo and Video in June 2020","subTitle":"Top 5 Grossing iOS Apps in Photo and Video and Reviews from the AppStore in June 2020.","category":"top 5 grossing ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0e185351bf2ccc4fd02998d557ceac4e-6d4e8.png","srcSet":"/static/main-0e185351bf2ccc4fd02998d557ceac4e-6d4e8.png 1x","srcWebp":"/static/main-0e185351bf2ccc4fd02998d557ceac4e-9a16c.webp","srcSetWebp":"/static/main-0e185351bf2ccc4fd02998d557ceac4e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Planes Live - Flight Tracker The first place belongs to Planes Live - Flight Tracker. The developer Weather or Not Apps, LLC says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Travel in June 2020","subTitle":"Top 5 Grossing iOS Apps in Travel and Reviews from the AppStore in June 2020.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-48476f082bc65c425f0b67bde4eb9724-6d4e8.png","srcSet":"/static/main-48476f082bc65c425f0b67bde4eb9724-6d4e8.png 1x","srcWebp":"/static/main-48476f082bc65c425f0b67bde4eb9724-9a16c.webp","srcSetWebp":"/static/main-48476f082bc65c425f0b67bde4eb9724-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"SkyView® The winner of the battle is SkyView®. The developer Terminal Eleven LLC says the following about the app.  SkyView® brings…","fields":{"slug":"/top-5-paid-ios-apps-in-education-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in June 2020","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in June 2020.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0a0c89aa1fd793b8f517731fd2b5a613-6d4e8.png","srcSet":"/static/main-0a0c89aa1fd793b8f517731fd2b5a613-6d4e8.png 1x","srcWebp":"/static/main-0a0c89aa1fd793b8f517731fd2b5a613-9a16c.webp","srcSetWebp":"/static/main-0a0c89aa1fd793b8f517731fd2b5a613-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"BIGO LIVE-Live Stream, Go Live The first place belongs to BIGO LIVE-Live Stream, Go Live. The developer BIGO TECHNOLOGY PTE. LTD. says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in June 2020","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in June 2020.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-4c40a45328a922da9c87704877eebce5-6d4e8.png","srcSet":"/static/main-4c40a45328a922da9c87704877eebce5-6d4e8.png 1x","srcWebp":"/static/main-4c40a45328a922da9c87704877eebce5-9a16c.webp","srcSetWebp":"/static/main-4c40a45328a922da9c87704877eebce5-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The first place is taken by RoboKiller: Block Spam Calls. The developer TelTech Systems says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in June 2020","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in June 2020.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-4be8d5c18b0585c8bcd89aec14f24062-6d4e8.png","srcSet":"/static/main-4be8d5c18b0585c8bcd89aec14f24062-6d4e8.png 1x","srcWebp":"/static/main-4be8d5c18b0585c8bcd89aec14f24062-9a16c.webp","srcSetWebp":"/static/main-4be8d5c18b0585c8bcd89aec14f24062-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The first place belongs to HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in June 2020","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in June 2020.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-50a7c8cc88a7719dfb34d4231cb7d9eb-6d4e8.png","srcSet":"/static/main-50a7c8cc88a7719dfb34d4231cb7d9eb-6d4e8.png 1x","srcWebp":"/static/main-50a7c8cc88a7719dfb34d4231cb7d9eb-9a16c.webp","srcSetWebp":"/static/main-50a7c8cc88a7719dfb34d4231cb7d9eb-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Screen Mirroring+ for Fire TV The winner of the battle is Screen Mirroring+ for Fire TV. The developer 2kit consulting says the following…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in June 2020","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in June 2020.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ae80417766b357dbdca110a4739f790c-6d4e8.png","srcSet":"/static/main-ae80417766b357dbdca110a4739f790c-6d4e8.png 1x","srcWebp":"/static/main-ae80417766b357dbdca110a4739f790c-9a16c.webp","srcSetWebp":"/static/main-ae80417766b357dbdca110a4739f790c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facetune The winner of the battle is Facetune. The developer Lightricks Ltd. says the following about the app.  Facetune 2 is now available…","fields":{"slug":"/top-5-paid-ios-apps-in-photo-and-video-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in June 2020","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in June 2020.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c400c8023dfe672e1b11598379350a75-6d4e8.png","srcSet":"/static/main-c400c8023dfe672e1b11598379350a75-6d4e8.png 1x","srcWebp":"/static/main-c400c8023dfe672e1b11598379350a75-9a16c.webp","srcSetWebp":"/static/main-c400c8023dfe672e1b11598379350a75-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"iNavX: Marine Navigation The first place belongs to iNavX: Marine Navigation. The developer NavX Studios LLC says the following about the…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in June 2020","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in June 2020.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-2f737f649f203198e56728b05b18fd0e-6d4e8.png","srcSet":"/static/main-2f737f649f203198e56728b05b18fd0e-6d4e8.png 1x","srcWebp":"/static/main-2f737f649f203198e56728b05b18fd0e-9a16c.webp","srcSetWebp":"/static/main-2f737f649f203198e56728b05b18fd0e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"OBD Fusion The winning spot belongs to OBD Fusion. The developer OCTech, LLC says the following about the app.  OBD Fusion is an app for…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in June 2020","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in June 2020.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-4813ec072adf760cb64d53746ec3b3c4-6d4e8.png","srcSet":"/static/main-4813ec072adf760cb64d53746ec3b3c4-6d4e8.png 1x","srcWebp":"/static/main-4813ec072adf760cb64d53746ec3b3c4-9a16c.webp","srcSetWebp":"/static/main-4813ec072adf760cb64d53746ec3b3c4-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"FlickType Keyboard The first place is taken by FlickType Keyboard. The developer Kpaw, LLC says the following about the app.  FlickType is a…","fields":{"slug":"/top-5-paid-ios-apps-in-productivity-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in June 2020","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in June 2020.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-35951e72befc17eefbb103ad675ee238-6d4e8.png","srcSet":"/static/main-35951e72befc17eefbb103ad675ee238-6d4e8.png 1x","srcWebp":"/static/main-35951e72befc17eefbb103ad675ee238-9a16c.webp","srcSetWebp":"/static/main-35951e72befc17eefbb103ad675ee238-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Cora — Organization tool The winning spot belongs to Cora — Organization tool. The developer Refinery Apps, LLC says the following about the…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-june-2020/","prefix":"2020-06-19"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in June 2020","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in June 2020.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0cfbd33828a1c127a82197351d5e3795-6d4e8.png","srcSet":"/static/main-0cfbd33828a1c127a82197351d5e3795-6d4e8.png 1x","srcWebp":"/static/main-0cfbd33828a1c127a82197351d5e3795-9a16c.webp","srcSetWebp":"/static/main-0cfbd33828a1c127a82197351d5e3795-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ZOOM Cloud Meetings The winning spot belongs to ZOOM Cloud Meetings. The developer Zoom says the following about the app. _Stay connected…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in May 2020","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in May 2020.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ec1fc791c4e524963350834a664e8920-6d4e8.png","srcSet":"/static/main-ec1fc791c4e524963350834a664e8920-6d4e8.png 1x","srcWebp":"/static/main-ec1fc791c4e524963350834a664e8920-9a16c.webp","srcSetWebp":"/static/main-ec1fc791c4e524963350834a664e8920-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Classroom The winning spot belongs to Google Classroom. The developer Google LLC says the following about the app.  Classroom is a…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in May 2020","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in May 2020.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-10f1b986c651d6feece0060a726faf4d-6d4e8.png","srcSet":"/static/main-10f1b986c651d6feece0060a726faf4d-6d4e8.png 1x","srcWebp":"/static/main-10f1b986c651d6feece0060a726faf4d-9a16c.webp","srcSetWebp":"/static/main-10f1b986c651d6feece0060a726faf4d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps - Transit & Food The winning spot belongs to Google Maps - Transit & Food. The developer Google LLC says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in May 2020","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in May 2020.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-8e5f6e65664b5f5a04430f7bec70e9b5-6d4e8.png","srcSet":"/static/main-8e5f6e65664b5f5a04430f7bec70e9b5-6d4e8.png 1x","srcWebp":"/static/main-8e5f6e65664b5f5a04430f7bec70e9b5-9a16c.webp","srcSetWebp":"/static/main-8e5f6e65664b5f5a04430f7bec70e9b5-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Pinterest The winner of the battle is Pinterest. The developer Pinterest says the following about the app.  Looking for inspiration? Whether…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in May 2020","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in May 2020.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-bb7c7ec402bae38f826848d6272260e1-6d4e8.png","srcSet":"/static/main-bb7c7ec402bae38f826848d6272260e1-6d4e8.png 1x","srcWebp":"/static/main-bb7c7ec402bae38f826848d6272260e1-9a16c.webp","srcSetWebp":"/static/main-bb7c7ec402bae38f826848d6272260e1-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The first place belongs to YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-free-ios-apps-in-photo-and-video-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in May 2020","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in May 2020.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-2f6b4b7f6c263f7484c84db21b4940c4-6d4e8.png","srcSet":"/static/main-2f6b4b7f6c263f7484c84db21b4940c4-6d4e8.png 1x","srcWebp":"/static/main-2f6b4b7f6c263f7484c84db21b4940c4-9a16c.webp","srcSetWebp":"/static/main-2f6b4b7f6c263f7484c84db21b4940c4-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The winning spot belongs to Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in May 2020","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in May 2020.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9b6395a38c2b3b202a461b18f6bca7cf-6d4e8.png","srcSet":"/static/main-9b6395a38c2b3b202a461b18f6bca7cf-6d4e8.png 1x","srcWebp":"/static/main-9b6395a38c2b3b202a461b18f6bca7cf-9a16c.webp","srcSetWebp":"/static/main-9b6395a38c2b3b202a461b18f6bca7cf-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facebook The first place belongs to Facebook. The developer Facebook, Inc. says the following about the app.  Connect with friends, family…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in May 2020","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in May 2020.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5da2daca135fcdd41a1bb99582d77fb0-6d4e8.png","srcSet":"/static/main-5da2daca135fcdd41a1bb99582d77fb0-6d4e8.png 1x","srcWebp":"/static/main-5da2daca135fcdd41a1bb99582d77fb0-9a16c.webp","srcSetWebp":"/static/main-5da2daca135fcdd41a1bb99582d77fb0-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Randonautica The winner of the battle is Randonautica. The developer FUNX says the following about the app.  The Randonautica app puts the…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in May 2020","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in May 2020.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-cdece20345fa1b4912f7fb76d9356a2c-6d4e8.png","srcSet":"/static/main-cdece20345fa1b4912f7fb76d9356a2c-6d4e8.png 1x","srcWebp":"/static/main-cdece20345fa1b4912f7fb76d9356a2c-9a16c.webp","srcSetWebp":"/static/main-cdece20345fa1b4912f7fb76d9356a2c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Chrome The winning spot belongs to Google Chrome. The developer Google LLC says the following about the app.  Get more done with the…","fields":{"slug":"/top-5-free-ios-apps-in-utilities-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in May 2020","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in May 2020.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-06837ed510b7f46928def8a5b3c8da38-6d4e8.png","srcSet":"/static/main-06837ed510b7f46928def8a5b3c8da38-6d4e8.png 1x","srcWebp":"/static/main-06837ed510b7f46928def8a5b3c8da38-9a16c.webp","srcSetWebp":"/static/main-06837ed510b7f46928def8a5b3c8da38-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The first place is taken by LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in May 2020","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in May 2020.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-201fd8a3cecb4d91841e3f450d5db410-6d4e8.png","srcSet":"/static/main-201fd8a3cecb4d91841e3f450d5db410-6d4e8.png 1x","srcWebp":"/static/main-201fd8a3cecb4d91841e3f450d5db410-9a16c.webp","srcSetWebp":"/static/main-201fd8a3cecb4d91841e3f450d5db410-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Duolingo - Language Lessons The first place belongs to Duolingo - Language Lessons. The developer Duolingo says the following about the app…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in May 2020","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in May 2020.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-4672706d869e990d07d2f863fc1ea927-6d4e8.png","srcSet":"/static/main-4672706d869e990d07d2f863fc1ea927-6d4e8.png 1x","srcWebp":"/static/main-4672706d869e990d07d2f863fc1ea927-9a16c.webp","srcSetWebp":"/static/main-4672706d869e990d07d2f863fc1ea927-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder The first place belongs to Tinder. The developer Tinder Inc. says the following about the app.  With 30 billion matches to date…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in May 2020","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in May 2020.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e20ac7cfdafe12ecd08d78216166d6cf-6d4e8.png","srcSet":"/static/main-e20ac7cfdafe12ecd08d78216166d6cf-6d4e8.png 1x","srcWebp":"/static/main-e20ac7cfdafe12ecd08d78216166d6cf-9a16c.webp","srcSetWebp":"/static/main-e20ac7cfdafe12ecd08d78216166d6cf-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The first place belongs to onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in May 2020","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in May 2020.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-3ca7cd99b1f5f062ec330d8935ed976f-6d4e8.png","srcSet":"/static/main-3ca7cd99b1f5f062ec330d8935ed976f-6d4e8.png 1x","srcWebp":"/static/main-3ca7cd99b1f5f062ec330d8935ed976f-9a16c.webp","srcSetWebp":"/static/main-3ca7cd99b1f5f062ec330d8935ed976f-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"BIGO LIVE - Live Stream The first place belongs to BIGO LIVE - Live Stream. The developer BIGO TECHNOLOGY PTE. LTD. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in May 2020","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in May 2020.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-15e4f1f0292f5d87a4d7dd8e6e21884a-6d4e8.png","srcSet":"/static/main-15e4f1f0292f5d87a4d7dd8e6e21884a-6d4e8.png 1x","srcWebp":"/static/main-15e4f1f0292f5d87a4d7dd8e6e21884a-9a16c.webp","srcSetWebp":"/static/main-15e4f1f0292f5d87a4d7dd8e6e21884a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Mobile Passport The winner of the battle is Mobile Passport. The developer Airside Mobile LLC says the following about the app.  Mobile…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Travel in May 2020","subTitle":"Top 5 Grossing iOS Apps in Travel and Reviews from the AppStore in May 2020.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a91fa2e38e44e40ce5921f4088cf73ba-6d4e8.png","srcSet":"/static/main-a91fa2e38e44e40ce5921f4088cf73ba-6d4e8.png 1x","srcWebp":"/static/main-a91fa2e38e44e40ce5921f4088cf73ba-9a16c.webp","srcSetWebp":"/static/main-a91fa2e38e44e40ce5921f4088cf73ba-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The winning spot belongs to RoboKiller: Block Spam Calls. The developer TelTech Systems says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in May 2020","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in May 2020.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-587cb76f3b8dccbeeb0d356a2a741d64-6d4e8.png","srcSet":"/static/main-587cb76f3b8dccbeeb0d356a2a741d64-6d4e8.png 1x","srcWebp":"/static/main-587cb76f3b8dccbeeb0d356a2a741d64-9a16c.webp","srcSetWebp":"/static/main-587cb76f3b8dccbeeb0d356a2a741d64-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The first place is taken by HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in May 2020","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in May 2020.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b1d7a06f20da4376a85a0014ca1e7ae9-6d4e8.png","srcSet":"/static/main-b1d7a06f20da4376a85a0014ca1e7ae9-6d4e8.png 1x","srcWebp":"/static/main-b1d7a06f20da4376a85a0014ca1e7ae9-9a16c.webp","srcSetWebp":"/static/main-b1d7a06f20da4376a85a0014ca1e7ae9-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"MyBabysBeat - Fetal heartbeat The winner of the battle is MyBabysBeat - Fetal heartbeat. The developer MATIS O.M.G LTD says the following…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in May 2020","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in May 2020.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b19388e7fb0e467aa11ad6b8f4dcc6c3-6d4e8.png","srcSet":"/static/main-b19388e7fb0e467aa11ad6b8f4dcc6c3-6d4e8.png 1x","srcWebp":"/static/main-b19388e7fb0e467aa11ad6b8f4dcc6c3-9a16c.webp","srcSetWebp":"/static/main-b19388e7fb0e467aa11ad6b8f4dcc6c3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Romulus Euro The first place is taken by Romulus Euro. The developer Romulus Education, LLC says the following about the app.  Romulus…","fields":{"slug":"/top-5-paid-ios-apps-in-education-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in May 2020","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in May 2020.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-f148782e13d07e478be0d53f02f0848e-6d4e8.png","srcSet":"/static/main-f148782e13d07e478be0d53f02f0848e-6d4e8.png 1x","srcWebp":"/static/main-f148782e13d07e478be0d53f02f0848e-9a16c.webp","srcSetWebp":"/static/main-f148782e13d07e478be0d53f02f0848e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"iNavX: Marine Navigation The first place belongs to iNavX: Marine Navigation. The developer NavX Studios LLC says the following about the…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in May 2020","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in May 2020.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-2f737f649f203198e56728b05b18fd0e-6d4e8.png","srcSet":"/static/main-2f737f649f203198e56728b05b18fd0e-6d4e8.png 1x","srcWebp":"/static/main-2f737f649f203198e56728b05b18fd0e-9a16c.webp","srcSetWebp":"/static/main-2f737f649f203198e56728b05b18fd0e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"FlickType Keyboard The first place belongs to FlickType Keyboard. The developer Kpaw, LLC says the following about the app.  FlickType is…","fields":{"slug":"/top-5-paid-ios-apps-in-productivity-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in May 2020","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in May 2020.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-38a539767b6f2c1394bd0c0c31daceb0-6d4e8.png","srcSet":"/static/main-38a539767b6f2c1394bd0c0c31daceb0-6d4e8.png 1x","srcWebp":"/static/main-38a539767b6f2c1394bd0c0c31daceb0-9a16c.webp","srcSetWebp":"/static/main-38a539767b6f2c1394bd0c0c31daceb0-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"TouchRetouch The winner of the battle is TouchRetouch. The developer ADVA Soft GmbH says the following about the app.  “…there’s no easier…","fields":{"slug":"/top-5-paid-ios-apps-in-photo-and-video-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in May 2020","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in May 2020.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6f358f7eaa255f740f355afd1c0352a5-6d4e8.png","srcSet":"/static/main-6f358f7eaa255f740f355afd1c0352a5-6d4e8.png 1x","srcWebp":"/static/main-6f358f7eaa255f740f355afd1c0352a5-9a16c.webp","srcSetWebp":"/static/main-6f358f7eaa255f740f355afd1c0352a5-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Badoo Premium The winner of the battle is Badoo Premium. The developer Badoo Software Ltd says the following about the app. _Badoo is the…","fields":{"slug":"/top-5-paid-ios-apps-in-social-networking-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Social Networking in May 2020","subTitle":"Top 5 Paid iOS Apps in Social Networking and Reviews from the AppStore in May 2020.","category":"top 5 paid ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0aa7a94c6a13aa80a7e9dd1e00a5391f-6d4e8.png","srcSet":"/static/main-0aa7a94c6a13aa80a7e9dd1e00a5391f-6d4e8.png 1x","srcWebp":"/static/main-0aa7a94c6a13aa80a7e9dd1e00a5391f-9a16c.webp","srcSetWebp":"/static/main-0aa7a94c6a13aa80a7e9dd1e00a5391f-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Camp & RV - Tents to RV Parks The first place is taken by Camp & RV - Tents to RV Parks. The developer Allstays LLC says the following about…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in May 2020","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in May 2020.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-295500728da7c7709a8713182befaf0b-6d4e8.png","srcSet":"/static/main-295500728da7c7709a8713182befaf0b-6d4e8.png 1x","srcWebp":"/static/main-295500728da7c7709a8713182befaf0b-9a16c.webp","srcSetWebp":"/static/main-295500728da7c7709a8713182befaf0b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Find My Bluetooth Device The winner of the battle is Find My Bluetooth Device. The developer Mehdi Amiri says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-may-2020/","prefix":"2020-05-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in May 2020","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in May 2020.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-00828ad2ebafc235a101aec10435f14e-6d4e8.png","srcSet":"/static/main-00828ad2ebafc235a101aec10435f14e-6d4e8.png 1x","srcWebp":"/static/main-00828ad2ebafc235a101aec10435f14e-9a16c.webp","srcSetWebp":"/static/main-00828ad2ebafc235a101aec10435f14e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ZOOM Cloud Meetings The winner of the battle is ZOOM Cloud Meetings. The developer Zoom says the following about the app. _Stay connected…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in April 2020","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in April 2020.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-f9d4d34b66b002d44fa7543edfb123ac-6d4e8.png","srcSet":"/static/main-f9d4d34b66b002d44fa7543edfb123ac-6d4e8.png 1x","srcWebp":"/static/main-f9d4d34b66b002d44fa7543edfb123ac-9a16c.webp","srcSetWebp":"/static/main-f9d4d34b66b002d44fa7543edfb123ac-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Classroom The first place belongs to Google Classroom. The developer Google LLC says the following about the app.  Classroom is a…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in April 2020","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in April 2020.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-10f1b986c651d6feece0060a726faf4d-6d4e8.png","srcSet":"/static/main-10f1b986c651d6feece0060a726faf4d-6d4e8.png 1x","srcWebp":"/static/main-10f1b986c651d6feece0060a726faf4d-9a16c.webp","srcSetWebp":"/static/main-10f1b986c651d6feece0060a726faf4d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps - Transit & Food The first place is taken by Google Maps - Transit & Food. The developer Google LLC says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in April 2020","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in April 2020.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-722eaa2f551862700a5d17af2ee47d55-6d4e8.png","srcSet":"/static/main-722eaa2f551862700a5d17af2ee47d55-6d4e8.png 1x","srcWebp":"/static/main-722eaa2f551862700a5d17af2ee47d55-9a16c.webp","srcSetWebp":"/static/main-722eaa2f551862700a5d17af2ee47d55-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Pinterest The first place is taken by Pinterest. The developer Pinterest says the following about the app.  Looking for inspiration? Whether…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in April 2020","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in April 2020.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a91fd69a4992ea513f2561b7ad9b6d11-6d4e8.png","srcSet":"/static/main-a91fd69a4992ea513f2561b7ad9b6d11-6d4e8.png 1x","srcWebp":"/static/main-a91fd69a4992ea513f2561b7ad9b6d11-9a16c.webp","srcSetWebp":"/static/main-a91fd69a4992ea513f2561b7ad9b6d11-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Instagram The winning spot belongs to Instagram. The developer Instagram, Inc. says the following about the app.  Bringing you closer to the…","fields":{"slug":"/top-5-free-ios-apps-in-photo-and-video-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in April 2020","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in April 2020.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-be0ed377a42bd1108ed17c3129e8a2d5-6d4e8.png","srcSet":"/static/main-be0ed377a42bd1108ed17c3129e8a2d5-6d4e8.png 1x","srcWebp":"/static/main-be0ed377a42bd1108ed17c3129e8a2d5-9a16c.webp","srcSetWebp":"/static/main-be0ed377a42bd1108ed17c3129e8a2d5-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The first place belongs to Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in April 2020","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in April 2020.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-4a7a77a440213095c4468022d6ac07d9-6d4e8.png","srcSet":"/static/main-4a7a77a440213095c4468022d6ac07d9-6d4e8.png 1x","srcWebp":"/static/main-4a7a77a440213095c4468022d6ac07d9-9a16c.webp","srcSetWebp":"/static/main-4a7a77a440213095c4468022d6ac07d9-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Houseparty The first place belongs to Houseparty. The developer Life On Air, Inc says the following about the app.  Houseparty is the face…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in April 2020","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in April 2020.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-3cd80c380499d4576e5c85541b7f7b12-6d4e8.png","srcSet":"/static/main-3cd80c380499d4576e5c85541b7f7b12-6d4e8.png 1x","srcWebp":"/static/main-3cd80c380499d4576e5c85541b7f7b12-9a16c.webp","srcSetWebp":"/static/main-3cd80c380499d4576e5c85541b7f7b12-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Earth The winning spot belongs to Google Earth. The developer Google LLC says the following about the app.  Explore the whole world…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in April 2020","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in April 2020.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0d49b4505ddc52d2596825ce43fca7cb-6d4e8.png","srcSet":"/static/main-0d49b4505ddc52d2596825ce43fca7cb-6d4e8.png 1x","srcWebp":"/static/main-0d49b4505ddc52d2596825ce43fca7cb-9a16c.webp","srcSetWebp":"/static/main-0d49b4505ddc52d2596825ce43fca7cb-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Chrome The first place is taken by Google Chrome. The developer Google LLC says the following about the app.  Get more done with the…","fields":{"slug":"/top-5-free-ios-apps-in-utilities-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in April 2020","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in April 2020.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5c3069caa6ac3709c79a0f976b6c9baa-6d4e8.png","srcSet":"/static/main-5c3069caa6ac3709c79a0f976b6c9baa-6d4e8.png 1x","srcWebp":"/static/main-5c3069caa6ac3709c79a0f976b6c9baa-9a16c.webp","srcSetWebp":"/static/main-5c3069caa6ac3709c79a0f976b6c9baa-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The first place belongs to LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in April 2020","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in April 2020.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-201fd8a3cecb4d91841e3f450d5db410-6d4e8.png","srcSet":"/static/main-201fd8a3cecb4d91841e3f450d5db410-6d4e8.png 1x","srcWebp":"/static/main-201fd8a3cecb4d91841e3f450d5db410-9a16c.webp","srcSetWebp":"/static/main-201fd8a3cecb4d91841e3f450d5db410-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Duolingo - Language Lessons The first place is taken by Duolingo - Language Lessons. The developer Duolingo says the following about the app…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in April 2020","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in April 2020.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a6cf62e7173355327417e84122ea8f54-6d4e8.png","srcSet":"/static/main-a6cf62e7173355327417e84122ea8f54-6d4e8.png 1x","srcWebp":"/static/main-a6cf62e7173355327417e84122ea8f54-9a16c.webp","srcSetWebp":"/static/main-a6cf62e7173355327417e84122ea8f54-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder The winning spot belongs to Tinder. The developer Tinder Inc. says the following about the app.  With 30 billion matches to date…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in April 2020","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in April 2020.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ed84833f90a8d3593b2777aa3555fc70-6d4e8.png","srcSet":"/static/main-ed84833f90a8d3593b2777aa3555fc70-6d4e8.png 1x","srcWebp":"/static/main-ed84833f90a8d3593b2777aa3555fc70-9a16c.webp","srcSetWebp":"/static/main-ed84833f90a8d3593b2777aa3555fc70-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The first place belongs to onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in April 2020","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in April 2020.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ff725d29bfb5e300a175c0378fdbebf8-6d4e8.png","srcSet":"/static/main-ff725d29bfb5e300a175c0378fdbebf8-6d4e8.png 1x","srcWebp":"/static/main-ff725d29bfb5e300a175c0378fdbebf8-9a16c.webp","srcSetWebp":"/static/main-ff725d29bfb5e300a175c0378fdbebf8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"BIGO LIVE - Live Stream The first place is taken by BIGO LIVE - Live Stream. The developer BIGO TECHNOLOGY PTE. LTD. says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in April 2020","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in April 2020.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-15e4f1f0292f5d87a4d7dd8e6e21884a-6d4e8.png","srcSet":"/static/main-15e4f1f0292f5d87a4d7dd8e6e21884a-6d4e8.png 1x","srcWebp":"/static/main-15e4f1f0292f5d87a4d7dd8e6e21884a-9a16c.webp","srcSetWebp":"/static/main-15e4f1f0292f5d87a4d7dd8e6e21884a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"My Disney Experience The first place belongs to My Disney Experience. The developer Disney says the following about the app. _The official…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Travel in April 2020","subTitle":"Top 5 Grossing iOS Apps in Travel and Reviews from the AppStore in April 2020.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-4f48142c52d7e77d3199e09f00b33f9f-6d4e8.png","srcSet":"/static/main-4f48142c52d7e77d3199e09f00b33f9f-6d4e8.png 1x","srcWebp":"/static/main-4f48142c52d7e77d3199e09f00b33f9f-9a16c.webp","srcSetWebp":"/static/main-4f48142c52d7e77d3199e09f00b33f9f-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The winner of the battle is RoboKiller: Block Spam Calls. The developer TelTech Systems says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in April 2020","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in April 2020.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-306ceeda8751d2e97fcf767d3b9ee465-6d4e8.png","srcSet":"/static/main-306ceeda8751d2e97fcf767d3b9ee465-6d4e8.png 1x","srcWebp":"/static/main-306ceeda8751d2e97fcf767d3b9ee465-9a16c.webp","srcSetWebp":"/static/main-306ceeda8751d2e97fcf767d3b9ee465-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Scanner Pro: PDF Scanner App The winning spot belongs to Scanner Pro: PDF Scanner App. The developer Readdle Inc. says the following about…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in April 2020","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in April 2020.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-2615a7183fc4a89ce5c79e49a4600cd8-6d4e8.png","srcSet":"/static/main-2615a7183fc4a89ce5c79e49a4600cd8-6d4e8.png 1x","srcWebp":"/static/main-2615a7183fc4a89ce5c79e49a4600cd8-9a16c.webp","srcSetWebp":"/static/main-2615a7183fc4a89ce5c79e49a4600cd8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"SkyView® The first place belongs to SkyView®. The developer Terminal Eleven LLC says the following about the app.  SkyView® brings…","fields":{"slug":"/top-5-paid-ios-apps-in-education-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in April 2020","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in April 2020.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9d69642feea43b42077b700ff958746f-6d4e8.png","srcSet":"/static/main-9d69642feea43b42077b700ff958746f-6d4e8.png 1x","srcWebp":"/static/main-9d69642feea43b42077b700ff958746f-9a16c.webp","srcSetWebp":"/static/main-9d69642feea43b42077b700ff958746f-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"MyBabysBeat - Fetal heartbeat The winner of the battle is MyBabysBeat - Fetal heartbeat. The developer MATIS O.M.G LTD says the following…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in April 2020","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in April 2020.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b2d8175ec586af7aa6531ccb3cf9fb0e-6d4e8.png","srcSet":"/static/main-b2d8175ec586af7aa6531ccb3cf9fb0e-6d4e8.png 1x","srcWebp":"/static/main-b2d8175ec586af7aa6531ccb3cf9fb0e-9a16c.webp","srcSetWebp":"/static/main-b2d8175ec586af7aa6531ccb3cf9fb0e-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"GPS Tracks The winning spot belongs to GPS Tracks. The developer David Morneault says the following about the app.  “One of the better GPS…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in April 2020","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in April 2020.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-33bd5edf6b8a949025e547170cff7c68-6d4e8.png","srcSet":"/static/main-33bd5edf6b8a949025e547170cff7c68-6d4e8.png 1x","srcWebp":"/static/main-33bd5edf6b8a949025e547170cff7c68-9a16c.webp","srcSetWebp":"/static/main-33bd5edf6b8a949025e547170cff7c68-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Forest - Stay focused The winner of the battle is Forest - Stay focused. The developer SEEKRTECH CO., LTD. says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-productivity-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in April 2020","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in April 2020.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-df19e274079cce248823434304aa0252-6d4e8.png","srcSet":"/static/main-df19e274079cce248823434304aa0252-6d4e8.png 1x","srcWebp":"/static/main-df19e274079cce248823434304aa0252-9a16c.webp","srcSetWebp":"/static/main-df19e274079cce248823434304aa0252-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"TouchRetouch The winning spot belongs to TouchRetouch. The developer ADVA Soft GmbH says the following about the app.  “…there’s no easier…","fields":{"slug":"/top-5-paid-ios-apps-in-photo-and-video-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in April 2020","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in April 2020.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-511e1ca9c48a8812157c3e090ce83b22-6d4e8.png","srcSet":"/static/main-511e1ca9c48a8812157c3e090ce83b22-6d4e8.png 1x","srcWebp":"/static/main-511e1ca9c48a8812157c3e090ce83b22-9a16c.webp","srcSetWebp":"/static/main-511e1ca9c48a8812157c3e090ce83b22-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LiveATC Air Radio The winner of the battle is LiveATC Air Radio. The developer LiveATC.net says the following about the app.  LiveATC Air…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in April 2020","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in April 2020.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c2d66447c7231ac89beba06a53b11c6a-6d4e8.png","srcSet":"/static/main-c2d66447c7231ac89beba06a53b11c6a-6d4e8.png 1x","srcWebp":"/static/main-c2d66447c7231ac89beba06a53b11c6a-9a16c.webp","srcSetWebp":"/static/main-c2d66447c7231ac89beba06a53b11c6a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Cora Color The winning spot belongs to Cora Color. The developer Refinery Apps, LLC says the following about the app. _  Welcome to Cora…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-april-2020/","prefix":"2020-04-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in April 2020","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in April 2020.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-94f66f2a1e8b126f8c4869d810f94afd-6d4e8.png","srcSet":"/static/main-94f66f2a1e8b126f8c4869d810f94afd-6d4e8.png 1x","srcWebp":"/static/main-94f66f2a1e8b126f8c4869d810f94afd-9a16c.webp","srcSetWebp":"/static/main-94f66f2a1e8b126f8c4869d810f94afd-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ZOOM Cloud Meetings The first place is taken by ZOOM Cloud Meetings. The developer Zoom says the following about the app. _Stay connected…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in March 2020","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in March 2020.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-61353fbbb6ebf4e336700c6407f698fc-6d4e8.png","srcSet":"/static/main-61353fbbb6ebf4e336700c6407f698fc-6d4e8.png 1x","srcWebp":"/static/main-61353fbbb6ebf4e336700c6407f698fc-9a16c.webp","srcSetWebp":"/static/main-61353fbbb6ebf4e336700c6407f698fc-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Photomath The winner of the battle is Photomath. The developer Photomath, Inc. says the following about the app.  Learn math, check homework…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in March 2020","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in March 2020.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-febe982585bc3cbacf0304d246495c7c-6d4e8.png","srcSet":"/static/main-febe982585bc3cbacf0304d246495c7c-6d4e8.png 1x","srcWebp":"/static/main-febe982585bc3cbacf0304d246495c7c-9a16c.webp","srcSetWebp":"/static/main-febe982585bc3cbacf0304d246495c7c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Pinterest The winning spot belongs to Pinterest. The developer Pinterest says the following about the app.  Looking for inspiration? Whether…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in March 2020","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in March 2020.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-269a8826e81044c39160acab6154fe4a-6d4e8.png","srcSet":"/static/main-269a8826e81044c39160acab6154fe4a-6d4e8.png 1x","srcWebp":"/static/main-269a8826e81044c39160acab6154fe4a-9a16c.webp","srcSetWebp":"/static/main-269a8826e81044c39160acab6154fe4a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps - Transit & Food The winner of the battle is Google Maps - Transit & Food. The developer Google LLC says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in March 2020","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in March 2020.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-f6c205a51d1163a7823f698f9c1242e4-6d4e8.png","srcSet":"/static/main-f6c205a51d1163a7823f698f9c1242e4-6d4e8.png 1x","srcWebp":"/static/main-f6c205a51d1163a7823f698f9c1242e4-9a16c.webp","srcSetWebp":"/static/main-f6c205a51d1163a7823f698f9c1242e4-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"PicsArt Photo Editor + Collage The winner of the battle is PicsArt Photo Editor + Collage. The developer PicsArt, Inc. says the following…","fields":{"slug":"/top-5-free-ios-apps-in-photo-and-video-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in March 2020","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in March 2020.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-f615de743555cbfc3a176114e9398ec6-6d4e8.png","srcSet":"/static/main-f615de743555cbfc3a176114e9398ec6-6d4e8.png 1x","srcWebp":"/static/main-f615de743555cbfc3a176114e9398ec6-9a16c.webp","srcSetWebp":"/static/main-f615de743555cbfc3a176114e9398ec6-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Messenger The winner of the battle is Messenger. The developer Facebook, Inc. says the following about the app.  * SEND A MESSAGE - Skip…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in March 2020","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in March 2020.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5965ba02ae70db39160c6e791235f3da-6d4e8.png","srcSet":"/static/main-5965ba02ae70db39160c6e791235f3da-6d4e8.png 1x","srcWebp":"/static/main-5965ba02ae70db39160c6e791235f3da-9a16c.webp","srcSetWebp":"/static/main-5965ba02ae70db39160c6e791235f3da-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The first place is taken by Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in March 2020","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in March 2020.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6251a09fb3cfbcab594a51f653e9d611-6d4e8.png","srcSet":"/static/main-6251a09fb3cfbcab594a51f653e9d611-6d4e8.png 1x","srcWebp":"/static/main-6251a09fb3cfbcab594a51f653e9d611-9a16c.webp","srcSetWebp":"/static/main-6251a09fb3cfbcab594a51f653e9d611-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Chrome The first place is taken by Google Chrome. The developer Google LLC says the following about the app.  Get more done with the…","fields":{"slug":"/top-5-free-ios-apps-in-utilities-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in March 2020","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in March 2020.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ea36ecbcfaae1ccaaa2cf04569ed1209-6d4e8.png","srcSet":"/static/main-ea36ecbcfaae1ccaaa2cf04569ed1209-6d4e8.png 1x","srcWebp":"/static/main-ea36ecbcfaae1ccaaa2cf04569ed1209-9a16c.webp","srcSetWebp":"/static/main-ea36ecbcfaae1ccaaa2cf04569ed1209-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber The winning spot belongs to Uber. The developer Uber Technologies, Inc. says the following about the app.  Uber is a ridesharing app…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in March 2020","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in March 2020.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c279081d1136b984f860a38c74fb20f8-6d4e8.png","srcSet":"/static/main-c279081d1136b984f860a38c74fb20f8-6d4e8.png 1x","srcWebp":"/static/main-c279081d1136b984f860a38c74fb20f8-9a16c.webp","srcSetWebp":"/static/main-c279081d1136b984f860a38c74fb20f8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The first place is taken by LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in March 2020","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in March 2020.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-07a64bd49b1063bbf9012bc473c668f4-6d4e8.png","srcSet":"/static/main-07a64bd49b1063bbf9012bc473c668f4-6d4e8.png 1x","srcWebp":"/static/main-07a64bd49b1063bbf9012bc473c668f4-9a16c.webp","srcSetWebp":"/static/main-07a64bd49b1063bbf9012bc473c668f4-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Duolingo The winner of the battle is Duolingo. The developer Duolingo says the following about the app.  Join over 300 million learners on…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in March 2020","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in March 2020.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-6d4e8.png","srcSet":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-6d4e8.png 1x","srcWebp":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-9a16c.webp","srcSetWebp":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder The winning spot belongs to Tinder. The developer Tinder Inc. says the following about the app.  With 30 billion matches to date…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in March 2020","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in March 2020.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0241c3a42f1dca6c6788185766c04175-6d4e8.png","srcSet":"/static/main-0241c3a42f1dca6c6788185766c04175-6d4e8.png 1x","srcWebp":"/static/main-0241c3a42f1dca6c6788185766c04175-9a16c.webp","srcSetWebp":"/static/main-0241c3a42f1dca6c6788185766c04175-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The first place belongs to onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in March 2020","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in March 2020.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ff14aaa54198e93d72b2d433305117c0-6d4e8.png","srcSet":"/static/main-ff14aaa54198e93d72b2d433305117c0-6d4e8.png 1x","srcWebp":"/static/main-ff14aaa54198e93d72b2d433305117c0-9a16c.webp","srcSetWebp":"/static/main-ff14aaa54198e93d72b2d433305117c0-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"My Disney Experience The first place belongs to My Disney Experience. The developer Disney says the following about the app. _The official…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Travel in March 2020","subTitle":"Top 5 Grossing iOS Apps in Travel and Reviews from the AppStore in March 2020.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a35eb9812b9d54108921d298aad91ee3-6d4e8.png","srcSet":"/static/main-a35eb9812b9d54108921d298aad91ee3-6d4e8.png 1x","srcWebp":"/static/main-a35eb9812b9d54108921d298aad91ee3-9a16c.webp","srcSetWebp":"/static/main-a35eb9812b9d54108921d298aad91ee3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"BIGO LIVE - Live Stream The first place belongs to BIGO LIVE - Live Stream. The developer BIGO TECHNOLOGY PTE. LTD. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in March 2020","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in March 2020.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-68db77d7bada277dab48a27ee76cfd27-6d4e8.png","srcSet":"/static/main-68db77d7bada277dab48a27ee76cfd27-6d4e8.png 1x","srcWebp":"/static/main-68db77d7bada277dab48a27ee76cfd27-9a16c.webp","srcSetWebp":"/static/main-68db77d7bada277dab48a27ee76cfd27-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The winning spot belongs to RoboKiller: Block Spam Calls. The developer TelTech Systems says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in March 2020","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in March 2020.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0b18f0d392ef3ed759e9e4c25b5d2edb-6d4e8.png","srcSet":"/static/main-0b18f0d392ef3ed759e9e4c25b5d2edb-6d4e8.png 1x","srcWebp":"/static/main-0b18f0d392ef3ed759e9e4c25b5d2edb-9a16c.webp","srcSetWebp":"/static/main-0b18f0d392ef3ed759e9e4c25b5d2edb-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The first place belongs to HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in March 2020","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in March 2020.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-3911d6b58fc0c644f5158e9271759ffc-6d4e8.png","srcSet":"/static/main-3911d6b58fc0c644f5158e9271759ffc-6d4e8.png 1x","srcWebp":"/static/main-3911d6b58fc0c644f5158e9271759ffc-9a16c.webp","srcSetWebp":"/static/main-3911d6b58fc0c644f5158e9271759ffc-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Toca Hair Salon 3 The first place belongs to Toca Hair Salon 3. The developer Toca Boca AB says the following about the app.  Welcome to…","fields":{"slug":"/top-5-paid-ios-apps-in-education-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in March 2020","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in March 2020.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-69e856f211685c9750e4eb4287a5bca0-6d4e8.png","srcSet":"/static/main-69e856f211685c9750e4eb4287a5bca0-6d4e8.png 1x","srcWebp":"/static/main-69e856f211685c9750e4eb4287a5bca0-9a16c.webp","srcSetWebp":"/static/main-69e856f211685c9750e4eb4287a5bca0-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Ski Tracks The winner of the battle is Ski Tracks. The developer Core Coders Ltd says the following about the app.  The world’s favourite…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in March 2020","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in March 2020.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-41685122a79cf93be4d1e001c11bfe3d-6d4e8.png","srcSet":"/static/main-41685122a79cf93be4d1e001c11bfe3d-6d4e8.png 1x","srcWebp":"/static/main-41685122a79cf93be4d1e001c11bfe3d-9a16c.webp","srcSetWebp":"/static/main-41685122a79cf93be4d1e001c11bfe3d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"TouchRetouch The first place is taken by TouchRetouch. The developer ADVA Soft GmbH says the following about the app.  “…there’s no easier…","fields":{"slug":"/top-5-paid-ios-apps-in-photo-and-video-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in March 2020","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in March 2020.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-511e1ca9c48a8812157c3e090ce83b22-6d4e8.png","srcSet":"/static/main-511e1ca9c48a8812157c3e090ce83b22-6d4e8.png 1x","srcWebp":"/static/main-511e1ca9c48a8812157c3e090ce83b22-9a16c.webp","srcSetWebp":"/static/main-511e1ca9c48a8812157c3e090ce83b22-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"INKHUNTER PRO Tattoos try on The winner of the battle is INKHUNTER PRO Tattoos try on. The developer Virtmotion says the following about the…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in March 2020","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in March 2020.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-25bac447ad55cf789a64e0400c4caeac-6d4e8.png","srcSet":"/static/main-25bac447ad55cf789a64e0400c4caeac-6d4e8.png 1x","srcWebp":"/static/main-25bac447ad55cf789a64e0400c4caeac-9a16c.webp","srcSetWebp":"/static/main-25bac447ad55cf789a64e0400c4caeac-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"FlickType Keyboard The winning spot belongs to FlickType Keyboard. The developer Kpaw, LLC says the following about the app.  FlickType is…","fields":{"slug":"/top-5-paid-ios-apps-in-productivity-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in March 2020","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in March 2020.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e25b77022ab1d51f6f80d1b3c5365241-6d4e8.png","srcSet":"/static/main-e25b77022ab1d51f6f80d1b3c5365241-6d4e8.png 1x","srcWebp":"/static/main-e25b77022ab1d51f6f80d1b3c5365241-9a16c.webp","srcSetWebp":"/static/main-e25b77022ab1d51f6f80d1b3c5365241-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"WatchChat 2: for WhatsApp The winner of the battle is WatchChat 2: for WhatsApp. The developer Alexander Nowak says the following about the…","fields":{"slug":"/top-5-paid-ios-apps-in-social-networking-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Social Networking in March 2020","subTitle":"Top 5 Paid iOS Apps in Social Networking and Reviews from the AppStore in March 2020.","category":"top 5 paid ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-cae4a13aaf54c9f1bbd55aa414b9c050-6d4e8.png","srcSet":"/static/main-cae4a13aaf54c9f1bbd55aa414b9c050-6d4e8.png 1x","srcWebp":"/static/main-cae4a13aaf54c9f1bbd55aa414b9c050-9a16c.webp","srcSetWebp":"/static/main-cae4a13aaf54c9f1bbd55aa414b9c050-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Puffin Browser Pro The first place is taken by Puffin Browser Pro. The developer CloudMosa, Inc. says the following about the app.  Puffin…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in March 2020","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in March 2020.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e25f6bb73589e78bb315985ba853fd2c-6d4e8.png","srcSet":"/static/main-e25f6bb73589e78bb315985ba853fd2c-6d4e8.png 1x","srcWebp":"/static/main-e25f6bb73589e78bb315985ba853fd2c-9a16c.webp","srcSetWebp":"/static/main-e25f6bb73589e78bb315985ba853fd2c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"MarineTraffic - Ship Tracking The winning spot belongs to MarineTraffic - Ship Tracking. The developer MarineTraffic.com says the following…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-march-2020/","prefix":"2020-03-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in March 2020","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in March 2020.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-1dea8d00f2929ad266eca59ac2268001-6d4e8.png","srcSet":"/static/main-1dea8d00f2929ad266eca59ac2268001-6d4e8.png 1x","srcWebp":"/static/main-1dea8d00f2929ad266eca59ac2268001-9a16c.webp","srcSetWebp":"/static/main-1dea8d00f2929ad266eca59ac2268001-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Indeed Job Search The winning spot belongs to Indeed Job Search. The developer Indeed Inc. says the following about the app.  Find jobs…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in February 2020","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in February 2020.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e9b2efcb2861e609408f239b30f05994-6d4e8.png","srcSet":"/static/main-e9b2efcb2861e609408f239b30f05994-6d4e8.png 1x","srcWebp":"/static/main-e9b2efcb2861e609408f239b30f05994-9a16c.webp","srcSetWebp":"/static/main-e9b2efcb2861e609408f239b30f05994-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Duolingo The first place is taken by Duolingo. The developer Duolingo says the following about the app.  Join over 300 million learners on…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in February 2020","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in February 2020.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-6d4e8.png","srcSet":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-6d4e8.png 1x","srcWebp":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-9a16c.webp","srcSetWebp":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Pinterest: Home, recipes, DIY The winning spot belongs to Pinterest: Home, recipes, DIY. The developer Pinterest says the following about…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in February 2020","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in February 2020.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-269a8826e81044c39160acab6154fe4a-6d4e8.png","srcSet":"/static/main-269a8826e81044c39160acab6154fe4a-6d4e8.png 1x","srcWebp":"/static/main-269a8826e81044c39160acab6154fe4a-9a16c.webp","srcSetWebp":"/static/main-269a8826e81044c39160acab6154fe4a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps - Transit & Food The winner of the battle is Google Maps - Transit & Food. The developer Google LLC says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in February 2020","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in February 2020.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-f6c205a51d1163a7823f698f9c1242e4-6d4e8.png","srcSet":"/static/main-f6c205a51d1163a7823f698f9c1242e4-6d4e8.png 1x","srcWebp":"/static/main-f6c205a51d1163a7823f698f9c1242e4-9a16c.webp","srcSetWebp":"/static/main-f6c205a51d1163a7823f698f9c1242e4-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winner of the battle is YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-free-ios-apps-in-photo-and-video-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in February 2020","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in February 2020.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-6d4e8.png","srcSet":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-6d4e8.png 1x","srcWebp":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-9a16c.webp","srcSetWebp":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The first place is taken by Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in February 2020","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in February 2020.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6251a09fb3cfbcab594a51f653e9d611-6d4e8.png","srcSet":"/static/main-6251a09fb3cfbcab594a51f653e9d611-6d4e8.png 1x","srcWebp":"/static/main-6251a09fb3cfbcab594a51f653e9d611-9a16c.webp","srcSetWebp":"/static/main-6251a09fb3cfbcab594a51f653e9d611-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Messenger The winning spot belongs to Messenger. The developer Facebook, Inc. says the following about the app.  * SEND A MESSAGE -Skip…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in February 2020","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in February 2020.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5965ba02ae70db39160c6e791235f3da-6d4e8.png","srcSet":"/static/main-5965ba02ae70db39160c6e791235f3da-6d4e8.png 1x","srcWebp":"/static/main-5965ba02ae70db39160c6e791235f3da-9a16c.webp","srcSetWebp":"/static/main-5965ba02ae70db39160c6e791235f3da-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber The first place belongs to Uber. The developer Uber Technologies, Inc. says the following about the app.  Uber is a ridesharing app for…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in February 2020","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in February 2020.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c279081d1136b984f860a38c74fb20f8-6d4e8.png","srcSet":"/static/main-c279081d1136b984f860a38c74fb20f8-6d4e8.png 1x","srcWebp":"/static/main-c279081d1136b984f860a38c74fb20f8-9a16c.webp","srcSetWebp":"/static/main-c279081d1136b984f860a38c74fb20f8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The winning spot belongs to LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in February 2020","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in February 2020.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-07a64bd49b1063bbf9012bc473c668f4-6d4e8.png","srcSet":"/static/main-07a64bd49b1063bbf9012bc473c668f4-6d4e8.png 1x","srcWebp":"/static/main-07a64bd49b1063bbf9012bc473c668f4-9a16c.webp","srcSetWebp":"/static/main-07a64bd49b1063bbf9012bc473c668f4-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google The winner of the battle is Google. The developer Google LLC says the following about the app.  The Google app keeps you in the know…","fields":{"slug":"/top-5-free-ios-apps-in-utilities-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in February 2020","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in February 2020.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-177ccf2b039085f62d3179478a4186ea-6d4e8.png","srcSet":"/static/main-177ccf2b039085f62d3179478a4186ea-6d4e8.png 1x","srcWebp":"/static/main-177ccf2b039085f62d3179478a4186ea-9a16c.webp","srcSetWebp":"/static/main-177ccf2b039085f62d3179478a4186ea-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder The winning spot belongs to Tinder. The developer Tinder Inc. says the following about the app.  With 30 billion matches to date…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in February 2020","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in February 2020.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0241c3a42f1dca6c6788185766c04175-6d4e8.png","srcSet":"/static/main-0241c3a42f1dca6c6788185766c04175-6d4e8.png 1x","srcWebp":"/static/main-0241c3a42f1dca6c6788185766c04175-9a16c.webp","srcSetWebp":"/static/main-0241c3a42f1dca6c6788185766c04175-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The first place belongs to onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in February 2020","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in February 2020.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ff14aaa54198e93d72b2d433305117c0-6d4e8.png","srcSet":"/static/main-ff14aaa54198e93d72b2d433305117c0-6d4e8.png 1x","srcWebp":"/static/main-ff14aaa54198e93d72b2d433305117c0-9a16c.webp","srcSetWebp":"/static/main-ff14aaa54198e93d72b2d433305117c0-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The first place is taken by YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Photo and Video in February 2020","subTitle":"Top 5 Grossing iOS Apps in Photo and Video and Reviews from the AppStore in February 2020.","category":"top 5 grossing ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-6d4e8.png","srcSet":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-6d4e8.png 1x","srcWebp":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-9a16c.webp","srcSetWebp":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Dropbox The first place belongs to Dropbox. The developer Dropbox says the following about the app.  Dropbox brings your cloud content and…","fields":{"slug":"/top-5-grossing-ios-apps-in-productivity-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Productivity in February 2020","subTitle":"Top 5 Grossing iOS Apps in Productivity and Reviews from the AppStore in February 2020.","category":"top 5 grossing ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c653aeffbed164b671bcf0fdf922d04b-6d4e8.png","srcSet":"/static/main-c653aeffbed164b671bcf0fdf922d04b-6d4e8.png 1x","srcWebp":"/static/main-c653aeffbed164b671bcf0fdf922d04b-9a16c.webp","srcSetWebp":"/static/main-c653aeffbed164b671bcf0fdf922d04b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"BIGO LIVE - Live Stream The first place belongs to BIGO LIVE - Live Stream. The developer BIGO TECHNOLOGY PTE. LTD. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in February 2020","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in February 2020.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-68db77d7bada277dab48a27ee76cfd27-6d4e8.png","srcSet":"/static/main-68db77d7bada277dab48a27ee76cfd27-6d4e8.png 1x","srcWebp":"/static/main-68db77d7bada277dab48a27ee76cfd27-9a16c.webp","srcSetWebp":"/static/main-68db77d7bada277dab48a27ee76cfd27-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"My Disney Experience The first place belongs to My Disney Experience. The developer Disney says the following about the app. _The official…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Travel in February 2020","subTitle":"Top 5 Grossing iOS Apps in Travel and Reviews from the AppStore in February 2020.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a35eb9812b9d54108921d298aad91ee3-6d4e8.png","srcSet":"/static/main-a35eb9812b9d54108921d298aad91ee3-6d4e8.png 1x","srcWebp":"/static/main-a35eb9812b9d54108921d298aad91ee3-9a16c.webp","srcSetWebp":"/static/main-a35eb9812b9d54108921d298aad91ee3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Duolingo The winner of the battle is Duolingo. The developer Duolingo says the following about the app.  Join over 300 million learners on…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in February 2020","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in February 2020.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-6d4e8.png","srcSet":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-6d4e8.png 1x","srcWebp":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-9a16c.webp","srcSetWebp":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The first place is taken by RoboKiller: Block Spam Calls. The developer TelTech Systems says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in February 2020","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in February 2020.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c900635c4bf28e42fec295e91d9a5ad8-6d4e8.png","srcSet":"/static/main-c900635c4bf28e42fec295e91d9a5ad8-6d4e8.png 1x","srcWebp":"/static/main-c900635c4bf28e42fec295e91d9a5ad8-9a16c.webp","srcSetWebp":"/static/main-c900635c4bf28e42fec295e91d9a5ad8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Stylebook The winning spot belongs to Stylebook. The developer left brain / right brain, LLC says the following about the app.  Get the most…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in February 2020","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in February 2020.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-53cb4c6cbb1faf28b31a86cbba4e5b07-6d4e8.png","srcSet":"/static/main-53cb4c6cbb1faf28b31a86cbba4e5b07-6d4e8.png 1x","srcWebp":"/static/main-53cb4c6cbb1faf28b31a86cbba4e5b07-9a16c.webp","srcSetWebp":"/static/main-53cb4c6cbb1faf28b31a86cbba4e5b07-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The first place is taken by HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in February 2020","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in February 2020.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-3911d6b58fc0c644f5158e9271759ffc-6d4e8.png","srcSet":"/static/main-3911d6b58fc0c644f5158e9271759ffc-6d4e8.png 1x","srcWebp":"/static/main-3911d6b58fc0c644f5158e9271759ffc-9a16c.webp","srcSetWebp":"/static/main-3911d6b58fc0c644f5158e9271759ffc-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Toca Hair Salon 3 The winning spot belongs to Toca Hair Salon 3. The developer Toca Boca AB says the following about the app.  Welcome to…","fields":{"slug":"/top-5-paid-ios-apps-in-education-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in February 2020","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in February 2020.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-69e856f211685c9750e4eb4287a5bca0-6d4e8.png","srcSet":"/static/main-69e856f211685c9750e4eb4287a5bca0-6d4e8.png 1x","srcWebp":"/static/main-69e856f211685c9750e4eb4287a5bca0-9a16c.webp","srcSetWebp":"/static/main-69e856f211685c9750e4eb4287a5bca0-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Ski Tracks The first place belongs to Ski Tracks. The developer Core Coders Ltd says the following about the app.  The world’s favourite…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in February 2020","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in February 2020.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-41685122a79cf93be4d1e001c11bfe3d-6d4e8.png","srcSet":"/static/main-41685122a79cf93be4d1e001c11bfe3d-6d4e8.png 1x","srcWebp":"/static/main-41685122a79cf93be4d1e001c11bfe3d-9a16c.webp","srcSetWebp":"/static/main-41685122a79cf93be4d1e001c11bfe3d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"TouchRetouch The first place belongs to TouchRetouch. The developer ADVA Soft GmbH says the following about the app.  “…there’s no easier…","fields":{"slug":"/top-5-paid-ios-apps-in-photo-and-video-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in February 2020","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in February 2020.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-511e1ca9c48a8812157c3e090ce83b22-6d4e8.png","srcSet":"/static/main-511e1ca9c48a8812157c3e090ce83b22-6d4e8.png 1x","srcWebp":"/static/main-511e1ca9c48a8812157c3e090ce83b22-9a16c.webp","srcSetWebp":"/static/main-511e1ca9c48a8812157c3e090ce83b22-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"WatchChat 2: for WhatsApp The first place belongs to WatchChat 2: for WhatsApp. The developer Alexander Nowak says the following about the…","fields":{"slug":"/top-5-paid-ios-apps-in-social-networking-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Social Networking in February 2020","subTitle":"Top 5 Paid iOS Apps in Social Networking and Reviews from the AppStore in February 2020.","category":"top 5 paid ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-cae4a13aaf54c9f1bbd55aa414b9c050-6d4e8.png","srcSet":"/static/main-cae4a13aaf54c9f1bbd55aa414b9c050-6d4e8.png 1x","srcWebp":"/static/main-cae4a13aaf54c9f1bbd55aa414b9c050-9a16c.webp","srcSetWebp":"/static/main-cae4a13aaf54c9f1bbd55aa414b9c050-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"FlickType Keyboard The first place belongs to FlickType Keyboard. The developer Kpaw, LLC says the following about the app.  FlickType is…","fields":{"slug":"/top-5-paid-ios-apps-in-productivity-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in February 2020","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in February 2020.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e25b77022ab1d51f6f80d1b3c5365241-6d4e8.png","srcSet":"/static/main-e25b77022ab1d51f6f80d1b3c5365241-6d4e8.png 1x","srcWebp":"/static/main-e25b77022ab1d51f6f80d1b3c5365241-9a16c.webp","srcSetWebp":"/static/main-e25b77022ab1d51f6f80d1b3c5365241-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Find My Headphones & Earbuds The winning spot belongs to Find My Headphones & Earbuds. The developer Bickster LLC says the following about…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in February 2020","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in February 2020.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0f0c68613f4b6d588a25a3978aa2120f-6d4e8.png","srcSet":"/static/main-0f0c68613f4b6d588a25a3978aa2120f-6d4e8.png 1x","srcWebp":"/static/main-0f0c68613f4b6d588a25a3978aa2120f-9a16c.webp","srcSetWebp":"/static/main-0f0c68613f4b6d588a25a3978aa2120f-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HappyCow Find Vegan Food The winning spot belongs to HappyCow Find Vegan Food. The developer HappyCow says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-february-2020/","prefix":"2020-02-15"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in February 2020","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in February 2020.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9bff673620924b5017f59117e3c209dc-6d4e8.png","srcSet":"/static/main-9bff673620924b5017f59117e3c209dc-6d4e8.png 1x","srcWebp":"/static/main-9bff673620924b5017f59117e3c209dc-9a16c.webp","srcSetWebp":"/static/main-9bff673620924b5017f59117e3c209dc-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Indeed Job Search The first place is taken by Indeed Job Search. The developer Indeed Inc. says the following about the app.  Find jobs…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in January 2020","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in January 2020.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e9b2efcb2861e609408f239b30f05994-6d4e8.png","srcSet":"/static/main-e9b2efcb2861e609408f239b30f05994-6d4e8.png 1x","srcWebp":"/static/main-e9b2efcb2861e609408f239b30f05994-9a16c.webp","srcSetWebp":"/static/main-e9b2efcb2861e609408f239b30f05994-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Photomath The first place is taken by Photomath. The developer Photomath, Inc. says the following about the app.  Learn math, check homework…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in January 2020","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in January 2020.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-febe982585bc3cbacf0304d246495c7c-6d4e8.png","srcSet":"/static/main-febe982585bc3cbacf0304d246495c7c-6d4e8.png 1x","srcWebp":"/static/main-febe982585bc3cbacf0304d246495c7c-9a16c.webp","srcSetWebp":"/static/main-febe982585bc3cbacf0304d246495c7c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder The first place is taken by Tinder. The developer Tinder Inc. says the following about the app.  With 30 billion matches to date…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in January 2020","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in January 2020.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0241c3a42f1dca6c6788185766c04175-6d4e8.png","srcSet":"/static/main-0241c3a42f1dca6c6788185766c04175-6d4e8.png 1x","srcWebp":"/static/main-0241c3a42f1dca6c6788185766c04175-9a16c.webp","srcSetWebp":"/static/main-0241c3a42f1dca6c6788185766c04175-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The first place belongs to Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in January 2020","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in January 2020.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6251a09fb3cfbcab594a51f653e9d611-6d4e8.png","srcSet":"/static/main-6251a09fb3cfbcab594a51f653e9d611-6d4e8.png 1x","srcWebp":"/static/main-6251a09fb3cfbcab594a51f653e9d611-9a16c.webp","srcSetWebp":"/static/main-6251a09fb3cfbcab594a51f653e9d611-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps - Transit & Food The first place is taken by Google Maps - Transit & Food. The developer Google LLC says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in January 2020","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in January 2020.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-1cec07ad26d96f144db88f0f3f3bee95-6d4e8.png","srcSet":"/static/main-1cec07ad26d96f144db88f0f3f3bee95-6d4e8.png 1x","srcWebp":"/static/main-1cec07ad26d96f144db88f0f3f3bee95-9a16c.webp","srcSetWebp":"/static/main-1cec07ad26d96f144db88f0f3f3bee95-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Messenger The winning spot belongs to Messenger. The developer Facebook, Inc. says the following about the app.  * SEND A MESSAGE -Skip…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in January 2020","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in January 2020.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5965ba02ae70db39160c6e791235f3da-6d4e8.png","srcSet":"/static/main-5965ba02ae70db39160c6e791235f3da-6d4e8.png 1x","srcWebp":"/static/main-5965ba02ae70db39160c6e791235f3da-9a16c.webp","srcSetWebp":"/static/main-5965ba02ae70db39160c6e791235f3da-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Chrome The first place belongs to Google Chrome. The developer Google LLC says the following about the app.  Get more done with the…","fields":{"slug":"/top-5-free-ios-apps-in-utilities-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in January 2020","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in January 2020.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ea36ecbcfaae1ccaaa2cf04569ed1209-6d4e8.png","srcSet":"/static/main-ea36ecbcfaae1ccaaa2cf04569ed1209-6d4e8.png 1x","srcWebp":"/static/main-ea36ecbcfaae1ccaaa2cf04569ed1209-9a16c.webp","srcSetWebp":"/static/main-ea36ecbcfaae1ccaaa2cf04569ed1209-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber The first place is taken by Uber. The developer Uber Technologies, Inc. says the following about the app.  Uber is a ridesharing app…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in January 2020","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in January 2020.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c279081d1136b984f860a38c74fb20f8-6d4e8.png","srcSet":"/static/main-c279081d1136b984f860a38c74fb20f8-6d4e8.png 1x","srcWebp":"/static/main-c279081d1136b984f860a38c74fb20f8-9a16c.webp","srcSetWebp":"/static/main-c279081d1136b984f860a38c74fb20f8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Scanner App: PDF Document Scan The winner of the battle is Scanner App: PDF Document Scan. The developer BPMobile says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in January 2020","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in January 2020.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c6d20f7e5298ed4d85ef0a9b9b49805b-6d4e8.png","srcSet":"/static/main-c6d20f7e5298ed4d85ef0a9b9b49805b-6d4e8.png 1x","srcWebp":"/static/main-c6d20f7e5298ed4d85ef0a9b9b49805b-9a16c.webp","srcSetWebp":"/static/main-c6d20f7e5298ed4d85ef0a9b9b49805b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder The first place is taken by Tinder. The developer Tinder Inc. says the following about the app.  With 30 billion matches to date…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in January 2020","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in January 2020.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0241c3a42f1dca6c6788185766c04175-6d4e8.png","srcSet":"/static/main-0241c3a42f1dca6c6788185766c04175-6d4e8.png 1x","srcWebp":"/static/main-0241c3a42f1dca6c6788185766c04175-9a16c.webp","srcSetWebp":"/static/main-0241c3a42f1dca6c6788185766c04175-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Duolingo The first place belongs to Duolingo. The developer Duolingo says the following about the app.  Join over 300 million learners on…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in January 2020","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in January 2020.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-6d4e8.png","srcSet":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-6d4e8.png 1x","srcWebp":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-9a16c.webp","srcSetWebp":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The first place is taken by onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in January 2020","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in January 2020.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ff14aaa54198e93d72b2d433305117c0-6d4e8.png","srcSet":"/static/main-ff14aaa54198e93d72b2d433305117c0-6d4e8.png 1x","srcWebp":"/static/main-ff14aaa54198e93d72b2d433305117c0-9a16c.webp","srcSetWebp":"/static/main-ff14aaa54198e93d72b2d433305117c0-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Dropbox The winning spot belongs to Dropbox. The developer Dropbox says the following about the app.  Dropbox brings your cloud content and…","fields":{"slug":"/top-5-grossing-ios-apps-in-productivity-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Productivity in January 2020","subTitle":"Top 5 Grossing iOS Apps in Productivity and Reviews from the AppStore in January 2020.","category":"top 5 grossing ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c653aeffbed164b671bcf0fdf922d04b-6d4e8.png","srcSet":"/static/main-c653aeffbed164b671bcf0fdf922d04b-6d4e8.png 1x","srcWebp":"/static/main-c653aeffbed164b671bcf0fdf922d04b-9a16c.webp","srcSetWebp":"/static/main-c653aeffbed164b671bcf0fdf922d04b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The first place is taken by LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in January 2020","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in January 2020.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-07a64bd49b1063bbf9012bc473c668f4-6d4e8.png","srcSet":"/static/main-07a64bd49b1063bbf9012bc473c668f4-6d4e8.png 1x","srcWebp":"/static/main-07a64bd49b1063bbf9012bc473c668f4-9a16c.webp","srcSetWebp":"/static/main-07a64bd49b1063bbf9012bc473c668f4-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winner of the battle is YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Photo and Video in January 2020","subTitle":"Top 5 Grossing iOS Apps in Photo and Video and Reviews from the AppStore in January 2020.","category":"top 5 grossing ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-6d4e8.png","srcSet":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-6d4e8.png 1x","srcWebp":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-9a16c.webp","srcSetWebp":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Instagram The first place is taken by Instagram. The developer Instagram, Inc. says the following about the app.  Bringing you closer to the…","fields":{"slug":"/top-5-free-ios-apps-in-photo-and-video-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in January 2020","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in January 2020.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-bd4fb457d72eac8a7d126f1b47bd90a5-6d4e8.png","srcSet":"/static/main-bd4fb457d72eac8a7d126f1b47bd90a5-6d4e8.png 1x","srcWebp":"/static/main-bd4fb457d72eac8a7d126f1b47bd90a5-9a16c.webp","srcSetWebp":"/static/main-bd4fb457d72eac8a7d126f1b47bd90a5-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The first place is taken by RoboKiller: Block Spam Calls. The developer TelTech Systems says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in January 2020","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in January 2020.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c900635c4bf28e42fec295e91d9a5ad8-6d4e8.png","srcSet":"/static/main-c900635c4bf28e42fec295e91d9a5ad8-6d4e8.png 1x","srcWebp":"/static/main-c900635c4bf28e42fec295e91d9a5ad8-9a16c.webp","srcSetWebp":"/static/main-c900635c4bf28e42fec295e91d9a5ad8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"My Disney Experience The winner of the battle is My Disney Experience. The developer Disney says the following about the app. _The official…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Travel in January 2020","subTitle":"Top 5 Grossing iOS Apps in Travel and Reviews from the AppStore in January 2020.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a35eb9812b9d54108921d298aad91ee3-6d4e8.png","srcSet":"/static/main-a35eb9812b9d54108921d298aad91ee3-6d4e8.png 1x","srcWebp":"/static/main-a35eb9812b9d54108921d298aad91ee3-9a16c.webp","srcSetWebp":"/static/main-a35eb9812b9d54108921d298aad91ee3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Toca Hair Salon 3 The winner of the battle is Toca Hair Salon 3. The developer Toca Boca AB says the following about the app.  Welcome to…","fields":{"slug":"/top-5-paid-ios-apps-in-education-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in January 2020","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in January 2020.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-69e856f211685c9750e4eb4287a5bca0-6d4e8.png","srcSet":"/static/main-69e856f211685c9750e4eb4287a5bca0-6d4e8.png 1x","srcWebp":"/static/main-69e856f211685c9750e4eb4287a5bca0-9a16c.webp","srcSetWebp":"/static/main-69e856f211685c9750e4eb4287a5bca0-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The winner of the battle is HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in January 2020","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in January 2020.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-3911d6b58fc0c644f5158e9271759ffc-6d4e8.png","srcSet":"/static/main-3911d6b58fc0c644f5158e9271759ffc-6d4e8.png 1x","srcWebp":"/static/main-3911d6b58fc0c644f5158e9271759ffc-9a16c.webp","srcSetWebp":"/static/main-3911d6b58fc0c644f5158e9271759ffc-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Ski Tracks The winning spot belongs to Ski Tracks. The developer Core Coders Ltd says the following about the app.  The world’s favourite…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in January 2020","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in January 2020.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-41685122a79cf93be4d1e001c11bfe3d-6d4e8.png","srcSet":"/static/main-41685122a79cf93be4d1e001c11bfe3d-6d4e8.png 1x","srcWebp":"/static/main-41685122a79cf93be4d1e001c11bfe3d-9a16c.webp","srcSetWebp":"/static/main-41685122a79cf93be4d1e001c11bfe3d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Stylebook The winning spot belongs to Stylebook. The developer left brain / right brain, LLC says the following about the app.  Get the most…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in January 2020","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in January 2020.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-53cb4c6cbb1faf28b31a86cbba4e5b07-6d4e8.png","srcSet":"/static/main-53cb4c6cbb1faf28b31a86cbba4e5b07-6d4e8.png 1x","srcWebp":"/static/main-53cb4c6cbb1faf28b31a86cbba4e5b07-9a16c.webp","srcSetWebp":"/static/main-53cb4c6cbb1faf28b31a86cbba4e5b07-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"TouchRetouch The first place is taken by TouchRetouch. The developer Adva-Soft says the following about the app.  “…there’s no easier way to…","fields":{"slug":"/top-5-paid-ios-apps-in-photo-and-video-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in January 2020","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in January 2020.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-511e1ca9c48a8812157c3e090ce83b22-6d4e8.png","srcSet":"/static/main-511e1ca9c48a8812157c3e090ce83b22-6d4e8.png 1x","srcWebp":"/static/main-511e1ca9c48a8812157c3e090ce83b22-9a16c.webp","srcSetWebp":"/static/main-511e1ca9c48a8812157c3e090ce83b22-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Forest - Stay focused The winning spot belongs to Forest - Stay focused. The developer SEEKRTECH CO., LTD. says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-productivity-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in January 2020","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in January 2020.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-7e85a61f096d5e782efdc09653c8b62b-6d4e8.png","srcSet":"/static/main-7e85a61f096d5e782efdc09653c8b62b-6d4e8.png 1x","srcWebp":"/static/main-7e85a61f096d5e782efdc09653c8b62b-9a16c.webp","srcSetWebp":"/static/main-7e85a61f096d5e782efdc09653c8b62b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"TeamSpeak 3 The winner of the battle is TeamSpeak 3. The developer TeamSpeak Systems Inc says the following about the app.  Voice Chat…","fields":{"slug":"/top-5-paid-ios-apps-in-social-networking-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Social Networking in January 2020","subTitle":"Top 5 Paid iOS Apps in Social Networking and Reviews from the AppStore in January 2020.","category":"top 5 paid ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5841033d15f6af91d2d223e5c3e5ceab-6d4e8.png","srcSet":"/static/main-5841033d15f6af91d2d223e5c3e5ceab-6d4e8.png 1x","srcWebp":"/static/main-5841033d15f6af91d2d223e5c3e5ceab-9a16c.webp","srcSetWebp":"/static/main-5841033d15f6af91d2d223e5c3e5ceab-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LiveATC Air Radio The winner of the battle is LiveATC Air Radio. The developer LiveATC.net says the following about the app.  LiveATC Air…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in January 2020","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in January 2020.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c2d66447c7231ac89beba06a53b11c6a-6d4e8.png","srcSet":"/static/main-c2d66447c7231ac89beba06a53b11c6a-6d4e8.png 1x","srcWebp":"/static/main-c2d66447c7231ac89beba06a53b11c6a-9a16c.webp","srcSetWebp":"/static/main-c2d66447c7231ac89beba06a53b11c6a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Cora Color The winning spot belongs to Cora Color. The developer Refinery Apps, LLC says the following about the app. _  Welcome to Cora…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-january-2020/","prefix":"2020-01-16"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in January 2020","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in January 2020.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-94f66f2a1e8b126f8c4869d810f94afd-6d4e8.png","srcSet":"/static/main-94f66f2a1e8b126f8c4869d810f94afd-6d4e8.png 1x","srcWebp":"/static/main-94f66f2a1e8b126f8c4869d810f94afd-9a16c.webp","srcSetWebp":"/static/main-94f66f2a1e8b126f8c4869d810f94afd-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Photomath The first place belongs to Photomath. The developer Photomath, Inc. says the following about the app.  Learn math, check homework…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Education in December 2019","subTitle":"Top 5 Free iOS Apps in Education and Reviews from the AppStore in December 2019.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-febe982585bc3cbacf0304d246495c7c-6d4e8.png","srcSet":"/static/main-febe982585bc3cbacf0304d246495c7c-6d4e8.png 1x","srcWebp":"/static/main-febe982585bc3cbacf0304d246495c7c-9a16c.webp","srcSetWebp":"/static/main-febe982585bc3cbacf0304d246495c7c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ADP Mobile Solutions The winner of the battle is ADP Mobile Solutions. The developer ADP, Inc says the following about the app.  ADP Mobile…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Business in December 2019","subTitle":"Top 5 Free iOS Apps in Business and Reviews from the AppStore in December 2019.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6bd9eb2043a9bdc4fd7717e78f46a492-6d4e8.png","srcSet":"/static/main-6bd9eb2043a9bdc4fd7717e78f46a492-6d4e8.png 1x","srcWebp":"/static/main-6bd9eb2043a9bdc4fd7717e78f46a492-9a16c.webp","srcSetWebp":"/static/main-6bd9eb2043a9bdc4fd7717e78f46a492-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Home The winning spot belongs to Google Home. The developer Google LLC says the following about the app.  Set up, manage, and control…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Lifestyle in December 2019","subTitle":"Top 5 Free iOS Apps in Lifestyle and Reviews from the AppStore in December 2019.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ac39de16c4acff1543da1e1f4b2c4ae6-6d4e8.png","srcSet":"/static/main-ac39de16c4acff1543da1e1f4b2c4ae6-6d4e8.png 1x","srcWebp":"/static/main-ac39de16c4acff1543da1e1f4b2c4ae6-9a16c.webp","srcSetWebp":"/static/main-ac39de16c4acff1543da1e1f4b2c4ae6-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winner of the battle is YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-free-ios-apps-in-photo-and-video-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in December 2019","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in December 2019.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-6d4e8.png","srcSet":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-6d4e8.png 1x","srcWebp":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-9a16c.webp","srcSetWebp":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The first place is taken by Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Productivity in December 2019","subTitle":"Top 5 Free iOS Apps in Productivity and Reviews from the AppStore in December 2019.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6251a09fb3cfbcab594a51f653e9d611-6d4e8.png","srcSet":"/static/main-6251a09fb3cfbcab594a51f653e9d611-6d4e8.png 1x","srcWebp":"/static/main-6251a09fb3cfbcab594a51f653e9d611-9a16c.webp","srcSetWebp":"/static/main-6251a09fb3cfbcab594a51f653e9d611-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps - Transit & Food The winning spot belongs to Google Maps - Transit & Food. The developer Google LLC says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Navigation in December 2019","subTitle":"Top 5 Free iOS Apps in Navigation and Reviews from the AppStore in December 2019.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-1cec07ad26d96f144db88f0f3f3bee95-6d4e8.png","srcSet":"/static/main-1cec07ad26d96f144db88f0f3f3bee95-6d4e8.png 1x","srcWebp":"/static/main-1cec07ad26d96f144db88f0f3f3bee95-9a16c.webp","srcSetWebp":"/static/main-1cec07ad26d96f144db88f0f3f3bee95-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Messenger The first place belongs to Messenger. The developer Facebook, Inc. says the following about the app.  * SEND A MESSAGE -Skip…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in December 2019","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in December 2019.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5965ba02ae70db39160c6e791235f3da-6d4e8.png","srcSet":"/static/main-5965ba02ae70db39160c6e791235f3da-6d4e8.png 1x","srcWebp":"/static/main-5965ba02ae70db39160c6e791235f3da-9a16c.webp","srcSetWebp":"/static/main-5965ba02ae70db39160c6e791235f3da-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber The first place is taken by Uber. The developer Uber Technologies, Inc. says the following about the app.  Uber is a ridesharing app…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Travel in December 2019","subTitle":"Top 5 Free iOS Apps in Travel and Reviews from the AppStore in December 2019.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c279081d1136b984f860a38c74fb20f8-6d4e8.png","srcSet":"/static/main-c279081d1136b984f860a38c74fb20f8-6d4e8.png 1x","srcWebp":"/static/main-c279081d1136b984f860a38c74fb20f8-9a16c.webp","srcSetWebp":"/static/main-c279081d1136b984f860a38c74fb20f8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Chrome The first place is taken by Google Chrome. The developer Google LLC says the following about the app.  Get more done with the…","fields":{"slug":"/top-5-free-ios-apps-in-utilities-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in Utilities in December 2019","subTitle":"Top 5 Free iOS Apps in Utilities and Reviews from the AppStore in December 2019.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ea36ecbcfaae1ccaaa2cf04569ed1209-6d4e8.png","srcSet":"/static/main-ea36ecbcfaae1ccaaa2cf04569ed1209-6d4e8.png 1x","srcWebp":"/static/main-ea36ecbcfaae1ccaaa2cf04569ed1209-9a16c.webp","srcSetWebp":"/static/main-ea36ecbcfaae1ccaaa2cf04569ed1209-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Scanner App: PDF Document Scan The first place belongs to Scanner App: PDF Document Scan. The developer BPMobile says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Business in December 2019","subTitle":"Top 5 Grossing iOS Apps in Business and Reviews from the AppStore in December 2019.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c6d20f7e5298ed4d85ef0a9b9b49805b-6d4e8.png","srcSet":"/static/main-c6d20f7e5298ed4d85ef0a9b9b49805b-6d4e8.png 1x","srcWebp":"/static/main-c6d20f7e5298ed4d85ef0a9b9b49805b-9a16c.webp","srcSetWebp":"/static/main-c6d20f7e5298ed4d85ef0a9b9b49805b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder The winning spot belongs to Tinder. The developer Tinder Inc. says the following about the app.  With 30 billion matches to date…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Lifestyle in December 2019","subTitle":"Top 5 Grossing iOS Apps in Lifestyle and Reviews from the AppStore in December 2019.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0241c3a42f1dca6c6788185766c04175-6d4e8.png","srcSet":"/static/main-0241c3a42f1dca6c6788185766c04175-6d4e8.png 1x","srcWebp":"/static/main-0241c3a42f1dca6c6788185766c04175-9a16c.webp","srcSetWebp":"/static/main-0241c3a42f1dca6c6788185766c04175-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Duolingo The winning spot belongs to Duolingo. The developer Duolingo says the following about the app.  Join over 300 million learners on…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Education in December 2019","subTitle":"Top 5 Grossing iOS Apps in Education and Reviews from the AppStore in December 2019.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-6d4e8.png","srcSet":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-6d4e8.png 1x","srcWebp":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-9a16c.webp","srcSetWebp":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The first place belongs to onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Navigation in December 2019","subTitle":"Top 5 Grossing iOS Apps in Navigation and Reviews from the AppStore in December 2019.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ff14aaa54198e93d72b2d433305117c0-6d4e8.png","srcSet":"/static/main-ff14aaa54198e93d72b2d433305117c0-6d4e8.png 1x","srcWebp":"/static/main-ff14aaa54198e93d72b2d433305117c0-9a16c.webp","srcSetWebp":"/static/main-ff14aaa54198e93d72b2d433305117c0-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The first place belongs to LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in December 2019","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in December 2019.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-07a64bd49b1063bbf9012bc473c668f4-6d4e8.png","srcSet":"/static/main-07a64bd49b1063bbf9012bc473c668f4-6d4e8.png 1x","srcWebp":"/static/main-07a64bd49b1063bbf9012bc473c668f4-9a16c.webp","srcSetWebp":"/static/main-07a64bd49b1063bbf9012bc473c668f4-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The first place is taken by YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Photo and Video in December 2019","subTitle":"Top 5 Grossing iOS Apps in Photo and Video and Reviews from the AppStore in December 2019.","category":"top 5 grossing ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-6d4e8.png","srcSet":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-6d4e8.png 1x","srcWebp":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-9a16c.webp","srcSetWebp":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Dropbox The winner of the battle is Dropbox. The developer Dropbox says the following about the app.  Dropbox brings your cloud content and…","fields":{"slug":"/top-5-grossing-ios-apps-in-productivity-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Productivity in December 2019","subTitle":"Top 5 Grossing iOS Apps in Productivity and Reviews from the AppStore in December 2019.","category":"top 5 grossing ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c653aeffbed164b671bcf0fdf922d04b-6d4e8.png","srcSet":"/static/main-c653aeffbed164b671bcf0fdf922d04b-6d4e8.png 1x","srcWebp":"/static/main-c653aeffbed164b671bcf0fdf922d04b-9a16c.webp","srcSetWebp":"/static/main-c653aeffbed164b671bcf0fdf922d04b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The winner of the battle is RoboKiller: Block Spam Calls. The developer TelTech Systems says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Utilities in December 2019","subTitle":"Top 5 Grossing iOS Apps in Utilities and Reviews from the AppStore in December 2019.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c900635c4bf28e42fec295e91d9a5ad8-6d4e8.png","srcSet":"/static/main-c900635c4bf28e42fec295e91d9a5ad8-6d4e8.png 1x","srcWebp":"/static/main-c900635c4bf28e42fec295e91d9a5ad8-9a16c.webp","srcSetWebp":"/static/main-c900635c4bf28e42fec295e91d9a5ad8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The first place is taken by HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Business in December 2019","subTitle":"Top 5 Paid iOS Apps in Business and Reviews from the AppStore in December 2019.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-3911d6b58fc0c644f5158e9271759ffc-6d4e8.png","srcSet":"/static/main-3911d6b58fc0c644f5158e9271759ffc-6d4e8.png 1x","srcWebp":"/static/main-3911d6b58fc0c644f5158e9271759ffc-9a16c.webp","srcSetWebp":"/static/main-3911d6b58fc0c644f5158e9271759ffc-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"My Disney Experience The first place is taken by My Disney Experience. The developer Disney says the following about the app.  The official…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Travel in December 2019","subTitle":"Top 5 Grossing iOS Apps in Travel and Reviews from the AppStore in December 2019.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a35eb9812b9d54108921d298aad91ee3-6d4e8.png","srcSet":"/static/main-a35eb9812b9d54108921d298aad91ee3-6d4e8.png 1x","srcWebp":"/static/main-a35eb9812b9d54108921d298aad91ee3-9a16c.webp","srcSetWebp":"/static/main-a35eb9812b9d54108921d298aad91ee3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Iconical The winning spot belongs to Iconical. The developer Dappological Ltd. says the following about the app.  Create your own icons on…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Lifestyle in December 2019","subTitle":"Top 5 Paid iOS Apps in Lifestyle and Reviews from the AppStore in December 2019.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b4c08709bff2478ba74855c8711a7ab0-6d4e8.png","srcSet":"/static/main-b4c08709bff2478ba74855c8711a7ab0-6d4e8.png 1x","srcWebp":"/static/main-b4c08709bff2478ba74855c8711a7ab0-9a16c.webp","srcSetWebp":"/static/main-b4c08709bff2478ba74855c8711a7ab0-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Toca Hair Salon 3 The first place belongs to Toca Hair Salon 3. The developer Toca Boca AB says the following about the app.  Welcome to…","fields":{"slug":"/top-5-paid-ios-apps-in-education-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Education in December 2019","subTitle":"Top 5 Paid iOS Apps in Education and Reviews from the AppStore in December 2019.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-69e856f211685c9750e4eb4287a5bca0-6d4e8.png","srcSet":"/static/main-69e856f211685c9750e4eb4287a5bca0-6d4e8.png 1x","srcWebp":"/static/main-69e856f211685c9750e4eb4287a5bca0-9a16c.webp","srcSetWebp":"/static/main-69e856f211685c9750e4eb4287a5bca0-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Ski Tracks The winning spot belongs to Ski Tracks. The developer Core Coders Ltd says the following about the app.  The world’s favourite…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Navigation in December 2019","subTitle":"Top 5 Paid iOS Apps in Navigation and Reviews from the AppStore in December 2019.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-41685122a79cf93be4d1e001c11bfe3d-6d4e8.png","srcSet":"/static/main-41685122a79cf93be4d1e001c11bfe3d-6d4e8.png 1x","srcWebp":"/static/main-41685122a79cf93be4d1e001c11bfe3d-9a16c.webp","srcSetWebp":"/static/main-41685122a79cf93be4d1e001c11bfe3d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facetune The first place belongs to Facetune. The developer Lightricks Ltd. says the following about the app.  Facetune 2 is now available…","fields":{"slug":"/top-5-paid-ios-apps-in-photo-and-video-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in December 2019","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in December 2019.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ec1f0029a8b18dcec0ea41ba49938bb8-6d4e8.png","srcSet":"/static/main-ec1f0029a8b18dcec0ea41ba49938bb8-6d4e8.png 1x","srcWebp":"/static/main-ec1f0029a8b18dcec0ea41ba49938bb8-9a16c.webp","srcSetWebp":"/static/main-ec1f0029a8b18dcec0ea41ba49938bb8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Forest - Stay focused The first place is taken by Forest - Stay focused. The developer SEEKRTECH CO., LTD. says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-productivity-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Productivity in December 2019","subTitle":"Top 5 Paid iOS Apps in Productivity and Reviews from the AppStore in December 2019.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b228a2baa46fe98f4c5c2d389f2272d8-6d4e8.png","srcSet":"/static/main-b228a2baa46fe98f4c5c2d389f2272d8-6d4e8.png 1x","srcWebp":"/static/main-b228a2baa46fe98f4c5c2d389f2272d8-9a16c.webp","srcSetWebp":"/static/main-b228a2baa46fe98f4c5c2d389f2272d8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HappyCow Find Vegan Food The first place belongs to HappyCow Find Vegan Food. The developer HappyCow says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Travel in December 2019","subTitle":"Top 5 Paid iOS Apps in Travel and Reviews from the AppStore in December 2019.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9bff673620924b5017f59117e3c209dc-6d4e8.png","srcSet":"/static/main-9bff673620924b5017f59117e3c209dc-6d4e8.png 1x","srcWebp":"/static/main-9bff673620924b5017f59117e3c209dc-9a16c.webp","srcSetWebp":"/static/main-9bff673620924b5017f59117e3c209dc-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"TeamSpeak 3 The first place belongs to TeamSpeak 3. The developer TeamSpeak Systems Inc says the following about the app.  Voice Chat…","fields":{"slug":"/top-5-paid-ios-apps-in-social-networking-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Social Networking in December 2019","subTitle":"Top 5 Paid iOS Apps in Social Networking and Reviews from the AppStore in December 2019.","category":"top 5 paid ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5841033d15f6af91d2d223e5c3e5ceab-6d4e8.png","srcSet":"/static/main-5841033d15f6af91d2d223e5c3e5ceab-6d4e8.png 1x","srcWebp":"/static/main-5841033d15f6af91d2d223e5c3e5ceab-9a16c.webp","srcSetWebp":"/static/main-5841033d15f6af91d2d223e5c3e5ceab-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Puffin Browser Pro The winner of the battle is Puffin Browser Pro. The developer CloudMosa, Inc. says the following about the app.  Puffin…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-december-2019/","prefix":"2019-12-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Utilities in December 2019","subTitle":"Top 5 Paid iOS Apps in Utilities and Reviews from the AppStore in December 2019.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e25f6bb73589e78bb315985ba853fd2c-6d4e8.png","srcSet":"/static/main-e25f6bb73589e78bb315985ba853fd2c-6d4e8.png 1x","srcWebp":"/static/main-e25f6bb73589e78bb315985ba853fd2c-9a16c.webp","srcSetWebp":"/static/main-e25f6bb73589e78bb315985ba853fd2c-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The first place belongs to YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-free-ios-apps-in-photo-and-video-in-november-2019/","prefix":"2019-11-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Photo and Video in November 2019","subTitle":"Top 5 Free iOS Apps in Photo and Video and Reviews from the AppStore in November 2019.","category":"top 5 free ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-6d4e8.png","srcSet":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-6d4e8.png 1x","srcWebp":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-9a16c.webp","srcSetWebp":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winning spot belongs to YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-photo-and-video-in-november-2019/","prefix":"2019-11-10"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Photo and Video in November 2019","subTitle":"Top 5 Grossing iOS Apps in Photo and Video and Reviews from the AppStore in November 2019.","category":"top 5 grossing ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-6d4e8.png","srcSet":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-6d4e8.png 1x","srcWebp":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-9a16c.webp","srcSetWebp":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facebook The winning spot belongs to Facebook. The developer Facebook, Inc. says the following about the app.  Connect with friends, family…","fields":{"slug":"/top-5-free-ios-apps-in-social-networking-in-november-2019/","prefix":"2019-11-10"},"frontmatter":{"title":"Top 5 Free iOS Apps in Social Networking in November 2019","subTitle":"Top 5 Free iOS Apps in Social Networking and Reviews from the AppStore in November 2019.","category":"top 5 free ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-468aa682dc535bec22fddfb6726fccd3-6d4e8.png","srcSet":"/static/main-468aa682dc535bec22fddfb6726fccd3-6d4e8.png 1x","srcWebp":"/static/main-468aa682dc535bec22fddfb6726fccd3-9a16c.webp","srcSetWebp":"/static/main-468aa682dc535bec22fddfb6726fccd3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Facetune The winning spot belongs to Facetune. The developer Lightricks Ltd. says the following about the app.  Facetune 2 is now available…","fields":{"slug":"/top-5-paid-ios-apps-in-photo-and-video-in-november-2019/","prefix":"2019-11-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Photo and Video in November 2019","subTitle":"Top 5 Paid iOS Apps in Photo and Video and Reviews from the AppStore in November 2019.","category":"top 5 paid ios apps in photo and video","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ec1f0029a8b18dcec0ea41ba49938bb8-6d4e8.png","srcSet":"/static/main-ec1f0029a8b18dcec0ea41ba49938bb8-6d4e8.png 1x","srcWebp":"/static/main-ec1f0029a8b18dcec0ea41ba49938bb8-9a16c.webp","srcSetWebp":"/static/main-ec1f0029a8b18dcec0ea41ba49938bb8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"WatchChat 2: for WhatsApp The first place is taken by WatchChat 2: for WhatsApp. The developer Alexander Nowak says the following about the…","fields":{"slug":"/top-5-paid-ios-apps-in-social-networking-in-november-2019/","prefix":"2019-11-10"},"frontmatter":{"title":"Top 5 Paid iOS Apps in Social Networking in November 2019","subTitle":"Top 5 Paid iOS Apps in Social Networking and Reviews from the AppStore in November 2019.","category":"top 5 paid ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-cae4a13aaf54c9f1bbd55aa414b9c050-6d4e8.png","srcSet":"/static/main-cae4a13aaf54c9f1bbd55aa414b9c050-6d4e8.png 1x","srcWebp":"/static/main-cae4a13aaf54c9f1bbd55aa414b9c050-9a16c.webp","srcSetWebp":"/static/main-cae4a13aaf54c9f1bbd55aa414b9c050-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"LinkedIn: Network & Job Finder The first place belongs to LinkedIn: Network & Job Finder. The developer LinkedIn Corporation says the…","fields":{"slug":"/top-5-grossing-ios-apps-in-social-networking-in-november-2019/","prefix":"2019-11-10"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in Social Networking in November 2019","subTitle":"Top 5 Grossing iOS Apps in Social Networking and Reviews from the AppStore in November 2019.","category":"top 5 grossing ios apps in social networking","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-07a64bd49b1063bbf9012bc473c668f4-6d4e8.png","srcSet":"/static/main-07a64bd49b1063bbf9012bc473c668f4-6d4e8.png 1x","srcWebp":"/static/main-07a64bd49b1063bbf9012bc473c668f4-9a16c.webp","srcSetWebp":"/static/main-07a64bd49b1063bbf9012bc473c668f4-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Indeed Job Search The winner of the battle is Indeed Job Search. The developer Indeed Inc. says the following about the app.  Find jobs…","fields":{"slug":"/top-5-free-ios-apps-in-business-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Free iOS Apps In Business in November 2019","subTitle":"Top 5 Free iOS Apps In Business and Reviews from the AppStore in November 2019.","category":"top 5 free ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-e9b2efcb2861e609408f239b30f05994-6d4e8.png","srcSet":"/static/main-e9b2efcb2861e609408f239b30f05994-6d4e8.png 1x","srcWebp":"/static/main-e9b2efcb2861e609408f239b30f05994-9a16c.webp","srcSetWebp":"/static/main-e9b2efcb2861e609408f239b30f05994-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Duolingo The winner of the battle is Duolingo. The developer Duolingo says the following about the app.  Join over 300 million learners on…","fields":{"slug":"/top-5-free-ios-apps-in-education-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Free iOS Apps In Education in November 2019","subTitle":"Top 5 Free iOS Apps In Education and Reviews from the AppStore in November 2019.","category":"top 5 free ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-6d4e8.png","srcSet":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-6d4e8.png 1x","srcWebp":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-9a16c.webp","srcSetWebp":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Home The winner of the battle is Google Home. The developer Google LLC says the following about the app.  Set up, manage, and control…","fields":{"slug":"/top-5-free-ios-apps-in-lifestyle-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Free iOS Apps In Lifestyle in November 2019","subTitle":"Top 5 Free iOS Apps In Lifestyle and Reviews from the AppStore in November 2019.","category":"top 5 free ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ac39de16c4acff1543da1e1f4b2c4ae6-6d4e8.png","srcSet":"/static/main-ac39de16c4acff1543da1e1f4b2c4ae6-6d4e8.png 1x","srcWebp":"/static/main-ac39de16c4acff1543da1e1f4b2c4ae6-9a16c.webp","srcSetWebp":"/static/main-ac39de16c4acff1543da1e1f4b2c4ae6-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Maps - Transit & Food The winner of the battle is Google Maps - Transit & Food. The developer Google LLC says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-navigation-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Free iOS Apps In Navigation in November 2019","subTitle":"Top 5 Free iOS Apps In Navigation and Reviews from the AppStore in November 2019.","category":"top 5 free ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-1cec07ad26d96f144db88f0f3f3bee95-6d4e8.png","srcSet":"/static/main-1cec07ad26d96f144db88f0f3f3bee95-6d4e8.png 1x","srcWebp":"/static/main-1cec07ad26d96f144db88f0f3f3bee95-9a16c.webp","srcSetWebp":"/static/main-1cec07ad26d96f144db88f0f3f3bee95-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Rescue Cut - Rope Puzzle The winning spot belongs to Rescue Cut - Rope Puzzle. The developer MarkApp Co. Ltd says the following about the…","fields":{"slug":"/top-5-free-ios-apps-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Free iOS Apps in November 2019","subTitle":"Top 5 Free iOS Apps and Reviews from the AppStore in November 2019.","category":"top 5 free ios apps","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-6ac11605e1f881773a404cf5e0a9b45a-6d4e8.png","srcSet":"/static/main-6ac11605e1f881773a404cf5e0a9b45a-6d4e8.png 1x","srcWebp":"/static/main-6ac11605e1f881773a404cf5e0a9b45a-9a16c.webp","srcSetWebp":"/static/main-6ac11605e1f881773a404cf5e0a9b45a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Gmail - Email by Google The first place belongs to Gmail - Email by Google. The developer Google LLC says the following about the app.  The…","fields":{"slug":"/top-5-free-ios-apps-in-productivity-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Free iOS Apps In Productivity in November 2019","subTitle":"Top 5 Free iOS Apps In Productivity and Reviews from the AppStore in November 2019.","category":"top 5 free ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-12dc4b477ad6946cff2629c6d871c745-6d4e8.png","srcSet":"/static/main-12dc4b477ad6946cff2629c6d871c745-6d4e8.png 1x","srcWebp":"/static/main-12dc4b477ad6946cff2629c6d871c745-9a16c.webp","srcSetWebp":"/static/main-12dc4b477ad6946cff2629c6d871c745-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber The first place is taken by Uber. The developer Uber Technologies, Inc. says the following about the app.  Uber is a ridesharing app…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Free iOS Apps In Travel in November 2019","subTitle":"Top 5 Free iOS Apps In Travel and Reviews from the AppStore in November 2019.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c279081d1136b984f860a38c74fb20f8-6d4e8.png","srcSet":"/static/main-c279081d1136b984f860a38c74fb20f8-6d4e8.png 1x","srcWebp":"/static/main-c279081d1136b984f860a38c74fb20f8-9a16c.webp","srcSetWebp":"/static/main-c279081d1136b984f860a38c74fb20f8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Google Chrome The first place belongs to Google Chrome. The developer Google LLC says the following about the app.  Get more done with the…","fields":{"slug":"/top-5-free-ios-apps-in-utilities-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Free iOS Apps In Utilities in November 2019","subTitle":"Top 5 Free iOS Apps In Utilities and Reviews from the AppStore in November 2019.","category":"top 5 free ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ea36ecbcfaae1ccaaa2cf04569ed1209-6d4e8.png","srcSet":"/static/main-ea36ecbcfaae1ccaaa2cf04569ed1209-6d4e8.png 1x","srcWebp":"/static/main-ea36ecbcfaae1ccaaa2cf04569ed1209-9a16c.webp","srcSetWebp":"/static/main-ea36ecbcfaae1ccaaa2cf04569ed1209-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Duolingo The first place belongs to Duolingo. The developer Duolingo says the following about the app.  Join over 300 million learners on…","fields":{"slug":"/top-5-grossing-ios-apps-in-education-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Grossing iOS Apps In Education in November 2019","subTitle":"Top 5 Grossing iOS Apps In Education and Reviews from the AppStore in November 2019.","category":"top 5 grossing ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-6d4e8.png","srcSet":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-6d4e8.png 1x","srcWebp":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-9a16c.webp","srcSetWebp":"/static/main-b885bb759cefc9110d5ed5c45a51eb33-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Scanner App: PDF Document Scan The winning spot belongs to Scanner App: PDF Document Scan. The developer BPMobile says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-business-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Grossing iOS Apps In Business in November 2019","subTitle":"Top 5 Grossing iOS Apps In Business and Reviews from the AppStore in November 2019.","category":"top 5 grossing ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c6d20f7e5298ed4d85ef0a9b9b49805b-6d4e8.png","srcSet":"/static/main-c6d20f7e5298ed4d85ef0a9b9b49805b-6d4e8.png 1x","srcWebp":"/static/main-c6d20f7e5298ed4d85ef0a9b9b49805b-9a16c.webp","srcSetWebp":"/static/main-c6d20f7e5298ed4d85ef0a9b9b49805b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Tinder The first place is taken by Tinder. The developer Tinder Inc. says the following about the app.  With 30 billion matches to date…","fields":{"slug":"/top-5-grossing-ios-apps-in-lifestyle-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Grossing iOS Apps In Lifestyle in November 2019","subTitle":"Top 5 Grossing iOS Apps In Lifestyle and Reviews from the AppStore in November 2019.","category":"top 5 grossing ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0241c3a42f1dca6c6788185766c04175-6d4e8.png","srcSet":"/static/main-0241c3a42f1dca6c6788185766c04175-6d4e8.png 1x","srcWebp":"/static/main-0241c3a42f1dca6c6788185766c04175-9a16c.webp","srcSetWebp":"/static/main-0241c3a42f1dca6c6788185766c04175-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"onX Hunt: #1 GPS Hunting Map The winning spot belongs to onX Hunt: #1 GPS Hunting Map. The developer onXmaps, Inc. says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-navigation-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Grossing iOS Apps In Navigation in November 2019","subTitle":"Top 5 Grossing iOS Apps In Navigation and Reviews from the AppStore in November 2019.","category":"top 5 grossing ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-ff14aaa54198e93d72b2d433305117c0-6d4e8.png","srcSet":"/static/main-ff14aaa54198e93d72b2d433305117c0-6d4e8.png 1x","srcWebp":"/static/main-ff14aaa54198e93d72b2d433305117c0-9a16c.webp","srcSetWebp":"/static/main-ff14aaa54198e93d72b2d433305117c0-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"ESPN: Live Sports & Scores The winner of the battle is ESPN: Live Sports & Scores. The developer ESPN says the following about the app…","fields":{"slug":"/top-5-grossing-ios-apps-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in November 2019","subTitle":"Top 5 Grossing iOS Apps and Reviews from the AppStore in November 2019.","category":"top 5 grossing ios apps","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-74c5e44c7960802ec2358760bf57da2f-6d4e8.png","srcSet":"/static/main-74c5e44c7960802ec2358760bf57da2f-6d4e8.png 1x","srcWebp":"/static/main-74c5e44c7960802ec2358760bf57da2f-9a16c.webp","srcSetWebp":"/static/main-74c5e44c7960802ec2358760bf57da2f-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Dropbox The winner of the battle is Dropbox. The developer Dropbox says the following about the app.  Dropbox brings your cloud content and…","fields":{"slug":"/top-5-grossing-ios-apps-in-productivity-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Grossing iOS Apps In Productivity in November 2019","subTitle":"Top 5 Grossing iOS Apps In Productivity and Reviews from the AppStore in November 2019.","category":"top 5 grossing ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c653aeffbed164b671bcf0fdf922d04b-6d4e8.png","srcSet":"/static/main-c653aeffbed164b671bcf0fdf922d04b-6d4e8.png 1x","srcWebp":"/static/main-c653aeffbed164b671bcf0fdf922d04b-9a16c.webp","srcSetWebp":"/static/main-c653aeffbed164b671bcf0fdf922d04b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"My Disney Experience The first place belongs to My Disney Experience. The developer Disney says the following about the app.  The official…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Grossing iOS Apps In Travel in November 2019","subTitle":"Top 5 Grossing iOS Apps In Travel and Reviews from the AppStore in November 2019.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a35eb9812b9d54108921d298aad91ee3-6d4e8.png","srcSet":"/static/main-a35eb9812b9d54108921d298aad91ee3-6d4e8.png 1x","srcWebp":"/static/main-a35eb9812b9d54108921d298aad91ee3-9a16c.webp","srcSetWebp":"/static/main-a35eb9812b9d54108921d298aad91ee3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"RoboKiller: Block Spam Calls The winner of the battle is RoboKiller: Block Spam Calls. The developer TelTech Systems says the following…","fields":{"slug":"/top-5-grossing-ios-apps-in-utilities-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Grossing iOS Apps In Utilities in November 2019","subTitle":"Top 5 Grossing iOS Apps In Utilities and Reviews from the AppStore in November 2019.","category":"top 5 grossing ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-c900635c4bf28e42fec295e91d9a5ad8-6d4e8.png","srcSet":"/static/main-c900635c4bf28e42fec295e91d9a5ad8-6d4e8.png 1x","srcWebp":"/static/main-c900635c4bf28e42fec295e91d9a5ad8-9a16c.webp","srcSetWebp":"/static/main-c900635c4bf28e42fec295e91d9a5ad8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Shock My Friends: Tap Roulette The winning spot belongs to Shock My Friends: Tap Roulette. The developer Abdelsatar Mahmoud says the…","fields":{"slug":"/top-5-paid-ios-apps-in-lifestyle-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Paid iOS Apps In Lifestyle in November 2019","subTitle":"Top 5 Paid iOS Apps In Lifestyle and Reviews from the AppStore in November 2019.","category":"top 5 paid ios apps in lifestyle","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-21a3228631e359906c2a431550cc691a-6d4e8.png","srcSet":"/static/main-21a3228631e359906c2a431550cc691a-6d4e8.png 1x","srcWebp":"/static/main-21a3228631e359906c2a431550cc691a-9a16c.webp","srcSetWebp":"/static/main-21a3228631e359906c2a431550cc691a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HotSchedules The first place belongs to HotSchedules. The developer HotSchedules says the following about the app.  HotSchedules is the…","fields":{"slug":"/top-5-paid-ios-apps-in-business-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Paid iOS Apps In Business in November 2019","subTitle":"Top 5 Paid iOS Apps In Business and Reviews from the AppStore in November 2019.","category":"top 5 paid ios apps in business","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-3911d6b58fc0c644f5158e9271759ffc-6d4e8.png","srcSet":"/static/main-3911d6b58fc0c644f5158e9271759ffc-6d4e8.png 1x","srcWebp":"/static/main-3911d6b58fc0c644f5158e9271759ffc-9a16c.webp","srcSetWebp":"/static/main-3911d6b58fc0c644f5158e9271759ffc-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Toca Hair Salon 3 The first place is taken by Toca Hair Salon 3. The developer Toca Boca AB says the following about the app.  Welcome to…","fields":{"slug":"/top-5-paid-ios-apps-in-education-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Paid iOS Apps In Education in November 2019","subTitle":"Top 5 Paid iOS Apps In Education and Reviews from the AppStore in November 2019.","category":"top 5 paid ios apps in education","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-69e856f211685c9750e4eb4287a5bca0-6d4e8.png","srcSet":"/static/main-69e856f211685c9750e4eb4287a5bca0-6d4e8.png 1x","srcWebp":"/static/main-69e856f211685c9750e4eb4287a5bca0-9a16c.webp","srcSetWebp":"/static/main-69e856f211685c9750e4eb4287a5bca0-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Land Nav Assistant The first place belongs to Land Nav Assistant. The developer Gammon Applications says the following about the app.  Land…","fields":{"slug":"/top-5-paid-ios-apps-in-navigation-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Paid iOS Apps In Navigation in November 2019","subTitle":"Top 5 Paid iOS Apps In Navigation and Reviews from the AppStore in November 2019.","category":"top 5 paid ios apps in navigation","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-8b56ee719d556e7ac1ee3ab0c7ee07ac-6d4e8.png","srcSet":"/static/main-8b56ee719d556e7ac1ee3ab0c7ee07ac-6d4e8.png 1x","srcWebp":"/static/main-8b56ee719d556e7ac1ee3ab0c7ee07ac-9a16c.webp","srcSetWebp":"/static/main-8b56ee719d556e7ac1ee3ab0c7ee07ac-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Minecraft The winning spot belongs to Minecraft. The developer Mojang says the following about the app.  Explore infinite worlds and build…","fields":{"slug":"/top-5-paid-ios-apps-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Paid iOS Apps in November 2019","subTitle":"Top 5 Paid iOS Apps and Reviews from the AppStore in November 2019.","category":"top 5 paid ios apps","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-5fc743c0a04f4375fe0668b73f772fa8-6d4e8.png","srcSet":"/static/main-5fc743c0a04f4375fe0668b73f772fa8-6d4e8.png 1x","srcWebp":"/static/main-5fc743c0a04f4375fe0668b73f772fa8-9a16c.webp","srcSetWebp":"/static/main-5fc743c0a04f4375fe0668b73f772fa8-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Forest - Stay focused The winning spot belongs to Forest - Stay focused. The developer SEEKRTECH CO., LTD. says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-productivity-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Paid iOS Apps In Productivity in November 2019","subTitle":"Top 5 Paid iOS Apps In Productivity and Reviews from the AppStore in November 2019.","category":"top 5 paid ios apps in productivity","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-7e85a61f096d5e782efdc09653c8b62b-6d4e8.png","srcSet":"/static/main-7e85a61f096d5e782efdc09653c8b62b-6d4e8.png 1x","srcWebp":"/static/main-7e85a61f096d5e782efdc09653c8b62b-9a16c.webp","srcSetWebp":"/static/main-7e85a61f096d5e782efdc09653c8b62b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HappyCow Find Vegan Food The first place belongs to HappyCow Find Vegan Food. The developer HappyCow says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Paid iOS Apps In Travel in November 2019","subTitle":"Top 5 Paid iOS Apps In Travel and Reviews from the AppStore in November 2019.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9bff673620924b5017f59117e3c209dc-6d4e8.png","srcSet":"/static/main-9bff673620924b5017f59117e3c209dc-6d4e8.png 1x","srcWebp":"/static/main-9bff673620924b5017f59117e3c209dc-9a16c.webp","srcSetWebp":"/static/main-9bff673620924b5017f59117e3c209dc-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Find My Headphones & Earbuds The first place belongs to Find My Headphones & Earbuds. The developer Bickster LLC says the following about…","fields":{"slug":"/top-5-paid-ios-apps-in-utilities-in-november-2019/","prefix":"2019-11-03"},"frontmatter":{"title":"Top 5 Paid iOS Apps In Utilities in November 2019","subTitle":"Top 5 Paid iOS Apps In Utilities and Reviews from the AppStore in November 2019.","category":"top 5 paid ios apps in utilities","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-0cf937acbc3467e2012e56771022f97b-6d4e8.png","srcSet":"/static/main-0cf937acbc3467e2012e56771022f97b-6d4e8.png 1x","srcWebp":"/static/main-0cf937acbc3467e2012e56771022f97b-9a16c.webp","srcSetWebp":"/static/main-0cf937acbc3467e2012e56771022f97b-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Uber The first place is taken by Uber. The developer Uber Technologies, Inc. says the following about the app.  Uber is a ridesharing app…","fields":{"slug":"/top-5-free-ios-apps-in-travel-in-october-2019/","prefix":"2019-10-13"},"frontmatter":{"title":"Top 5 Free iOS Apps In Travel in October 2019","subTitle":"Top 5 Free iOS Apps In Travel and Reviews from the AppStore in October 2019.","category":"top 5 free ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-8fe924c8cf33318da845b31e5e8225f0-6d4e8.png","srcSet":"/static/main-8fe924c8cf33318da845b31e5e8225f0-6d4e8.png 1x","srcWebp":"/static/main-8fe924c8cf33318da845b31e5e8225f0-9a16c.webp","srcSetWebp":"/static/main-8fe924c8cf33318da845b31e5e8225f0-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winner of the battle is YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-october-2019/","prefix":"2019-10-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in October 2019","subTitle":"Top 5 Grossing iOS Apps and Reviews from the AppStore in October 2019.","category":"top 5 grossing ios apps","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-6d4e8.png","srcSet":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-6d4e8.png 1x","srcWebp":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-9a16c.webp","srcSetWebp":"/static/main-9db77a3ec3aa75848af90fa2ed8a7e7a-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"My Disney Experience The winning spot belongs to My Disney Experience. The developer Disney says the following about the app.  The official…","fields":{"slug":"/top-5-grossing-ios-apps-in-travel-in-october-2019/","prefix":"2019-10-13"},"frontmatter":{"title":"Top 5 Grossing iOS Apps In Travel in October 2019","subTitle":"Top 5 Grossing iOS Apps In Travel and Reviews from the AppStore in October 2019.","category":"top 5 grossing ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a35eb9812b9d54108921d298aad91ee3-6d4e8.png","srcSet":"/static/main-a35eb9812b9d54108921d298aad91ee3-6d4e8.png 1x","srcWebp":"/static/main-a35eb9812b9d54108921d298aad91ee3-9a16c.webp","srcSetWebp":"/static/main-a35eb9812b9d54108921d298aad91ee3-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Call of Duty®: Mobile The first place belongs to Call of Duty®: Mobile. The developer Activision Publishing, Inc. says the following about…","fields":{"slug":"/top-5-free-ios-apps-in-october-2019/","prefix":"2019-10-13"},"frontmatter":{"title":"Top 5 Free iOS Apps in October 2019","subTitle":"Top 5 Free iOS Apps and Reviews from the AppStore in October 2019.","category":"top 5 free ios apps","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-83a84e4aa4a99457d6a8b82017465197-6d4e8.png","srcSet":"/static/main-83a84e4aa4a99457d6a8b82017465197-6d4e8.png 1x","srcWebp":"/static/main-83a84e4aa4a99457d6a8b82017465197-9a16c.webp","srcSetWebp":"/static/main-83a84e4aa4a99457d6a8b82017465197-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Minecraft The winner of the battle is Minecraft. The developer Mojang says the following about the app.  The Village & Pillage Update is…","fields":{"slug":"/top-5-paid-ios-apps-in-october-2019/","prefix":"2019-10-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps in October 2019","subTitle":"Top 5 Paid iOS Apps and Reviews from the AppStore in October 2019.","category":"top 5 paid ios apps","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-fe3420d6b0110fd9afd6cfa315bd88e9-6d4e8.png","srcSet":"/static/main-fe3420d6b0110fd9afd6cfa315bd88e9-6d4e8.png 1x","srcWebp":"/static/main-fe3420d6b0110fd9afd6cfa315bd88e9-9a16c.webp","srcSetWebp":"/static/main-fe3420d6b0110fd9afd6cfa315bd88e9-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"HappyCow Find Vegan Food The first place belongs to HappyCow Find Vegan Food. The developer HappyCow says the following about the app…","fields":{"slug":"/top-5-paid-ios-apps-in-travel-in-october-2019/","prefix":"2019-10-13"},"frontmatter":{"title":"Top 5 Paid iOS Apps In Travel in October 2019","subTitle":"Top 5 Paid iOS Apps In Travel and Reviews from the AppStore in October 2019.","category":"top 5 paid ios apps in travel","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-9bff673620924b5017f59117e3c209dc-6d4e8.png","srcSet":"/static/main-9bff673620924b5017f59117e3c209dc-6d4e8.png 1x","srcWebp":"/static/main-9bff673620924b5017f59117e3c209dc-9a16c.webp","srcSetWebp":"/static/main-9bff673620924b5017f59117e3c209dc-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"YouTube: Watch, Listen, Stream The winner of the battle is YouTube: Watch, Listen, Stream. The developer Google LLC says the following about…","fields":{"slug":"/top-5-grossing-ios-apps-in-september-2019/","prefix":"2019-09-27"},"frontmatter":{"title":"Top 5 Grossing iOS Apps in September 2019","subTitle":"Top 5 Grossing iOS Apps and Reviews from the AppStore in September 2019.","category":"top 5 grossing ios apps","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-94826b14902ea071aa92957d397bddf5-6d4e8.png","srcSet":"/static/main-94826b14902ea071aa92957d397bddf5-6d4e8.png 1x","srcWebp":"/static/main-94826b14902ea071aa92957d397bddf5-9a16c.webp","srcSetWebp":"/static/main-94826b14902ea071aa92957d397bddf5-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Mario Kart Tour The winning spot belongs to Mario Kart Tour. The developer Nintendo Co., Ltd. says the following about the app.  ■ Mario…","fields":{"slug":"/top-5-free-ios-apps-in-september-2019/","prefix":"2019-09-27"},"frontmatter":{"title":"Top 5 Free iOS Apps in September 2019","subTitle":"Top 5 Free iOS Apps and Reviews from the AppStore in September 2019.","category":"top 5 free ios apps","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-a78ae669ddf03623ff2b95241be8354d-6d4e8.png","srcSet":"/static/main-a78ae669ddf03623ff2b95241be8354d-6d4e8.png 1x","srcWebp":"/static/main-a78ae669ddf03623ff2b95241be8354d-9a16c.webp","srcSetWebp":"/static/main-a78ae669ddf03623ff2b95241be8354d-9a16c.webp 1x"}}]}}}},{"node":{"excerpt":"Minecraft The first place belongs to Minecraft. The developer Mojang says the following about the app.  The Village & Pillage Update is here…","fields":{"slug":"/top-5-paid-ios-apps-in-september-2019/","prefix":"2019-09-27"},"frontmatter":{"title":"Top 5 Paid iOS Apps in September 2019","subTitle":"Top 5 Paid iOS Apps and Reviews from the AppStore in September 2019.","category":"top 5 paid ios apps","cover":{"children":[{"__typename":"ImageSharp","resolutions":{"width":90,"height":90,"src":"/static/main-fe3420d6b0110fd9afd6cfa315bd88e9-6d4e8.png","srcSet":"/static/main-fe3420d6b0110fd9afd6cfa315bd88e9-6d4e8.png 1x","srcWebp":"/static/main-fe3420d6b0110fd9afd6cfa315bd88e9-9a16c.webp","srcSetWebp":"/static/main-fe3420d6b0110fd9afd6cfa315bd88e9-9a16c.webp 1x"}}]}}}}]},"pages":{"edges":[{"node":{"fields":{"slug":"/about-appogeddon/","prefix":"1"},"frontmatter":{"title":"About Appogeddon","menuTitle":"About Appogeddon"}}}]},"parts":{"edges":[{"node":{"html":"<p><strong>Appogeddon</strong> Post.</p>","frontmatter":{"title":"author"}}},{"node":{"html":"<p>iPhone &#x26; iPad Apps Available on the AppStore Today.</p>","frontmatter":{"title":"info"}}},{"node":{"html":"<ul>\n<li>Copyright © Appogeddon 2019</li>\n</ul>","frontmatter":{"title":"footnote"}}}]}},"layoutContext":{}}

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(629);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(255);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      flexShrink: 0,
	      width: 40,
	      height: 40,
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(20),
	      borderRadius: '50%',
	      overflow: 'hidden',
	      userSelect: 'none'
	    },
	
	    /* Styles applied to the root element if there are children and not `src` or `srcSet` */
	
	    /* Styles applied to the root element if `color="default"`. */
	    colorDefault: {
	      color: theme.palette.background.default,
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	
	    /* Styles applied to the img element if either `src` or `srcSet` is defined. */
	    img: {
	      width: '100%',
	      height: '100%',
	      textAlign: 'center',
	      // Handle non-square image. The property isn't supported by IE11.
	      objectFit: 'cover'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function Avatar(props) {
	  var alt = props.alt,
	      childrenProp = props.children,
	      childrenClassNameProp = props.childrenClassName,
	      classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      imgProps = props.imgProps,
	      sizes = props.sizes,
	      src = props.src,
	      srcSet = props.srcSet,
	      other = (0, _objectWithoutProperties2.default)(props, ["alt", "children", "childrenClassName", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet"]);
	  var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.colorDefault, childrenProp && !src && !srcSet), classNameProp);
	  var children = null;
	
	  if (src || srcSet) {
	    children = _react.default.createElement("img", (0, _extends2.default)({
	      alt: alt,
	      src: src,
	      srcSet: srcSet,
	      sizes: sizes,
	      className: classes.img
	    }, imgProps));
	  } else if (childrenClassNameProp && _react.default.isValidElement(childrenProp)) {
	    var childrenClassName = (0, _classnames.default)(childrenClassNameProp, childrenProp.props.className);
	    children = _react.default.cloneElement(childrenProp, {
	      className: childrenClassName
	    });
	  } else {
	    children = childrenProp;
	  }
	
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className
	  }, other), children);
	}
	
	Avatar.propTypes =  false ? {
	  /**
	   * Used in combination with `src` or `srcSet` to
	   * provide an alt attribute for the rendered `img` element.
	   */
	  alt: _propTypes.default.string,
	
	  /**
	   * Used to render icon or text elements inside the Avatar.
	   * `src` and `alt` props will not be used and no `img` will
	   * be rendered by default.
	   *
	   * This can be an element, or just a string.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   * The className of the child element.
	   * Used by Chip and ListItemIcon to style the Avatar icon.
	   */
	  childrenClassName: _propTypes.default.string,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * Attributes applied to the `img` element if the component
	   * is used to display an image.
	   */
	  imgProps: _propTypes.default.object,
	
	  /**
	   * The `sizes` attribute for the `img` element.
	   */
	  sizes: _propTypes.default.string,
	
	  /**
	   * The `src` attribute for the `img` element.
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * The `srcSet` attribute for the `img` element.
	   */
	  srcSet: _propTypes.default.string
	} : {};
	Avatar.defaultProps = {
	  component: 'div'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAvatar'
	})(Avatar);
	
	exports.default = _default;

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.default;
	  }
	});
	
	var _Avatar = _interopRequireDefault(__webpack_require__(199));

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(7));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(8));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(11));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(10));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(28));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _keycode = _interopRequireDefault(__webpack_require__(57));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(113));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _focusVisible = __webpack_require__(205);
	
	var _TouchRipple = _interopRequireDefault(__webpack_require__(203));
	
	var _createRippleHandler = _interopRequireDefault(__webpack_require__(204));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'inline-flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    position: 'relative',
	    // Remove grey highlight
	    WebkitTapHighlightColor: 'transparent',
	    backgroundColor: 'transparent',
	    // Reset default value
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 'none',
	    border: 0,
	    margin: 0,
	    // Remove the margin in Safari
	    borderRadius: 0,
	    padding: 0,
	    // Remove the padding in Firefox
	    cursor: 'pointer',
	    userSelect: 'none',
	    verticalAlign: 'middle',
	    '-moz-appearance': 'none',
	    // Reset
	    '-webkit-appearance': 'none',
	    // Reset
	    textDecoration: 'none',
	    // So we take precedent over the style of a native <a /> element.
	    color: 'inherit',
	    '&::-moz-focus-inner': {
	      borderStyle: 'none' // Remove Firefox dotted outline.
	
	    },
	    '&$disabled': {
	      pointerEvents: 'none',
	      // Disable link interactions
	      cursor: 'default'
	    }
	  },
	
	  /* Styles applied to the root element if `disabled={true}`. */
	  disabled: {},
	
	  /* Styles applied to the root element if keyboard focused. */
	  focusVisible: {}
	};
	/* istanbul ignore if */
	
	exports.styles = styles;
	
	if (false) {
	  throw new Error('Material-UI: react@16.3.0 or greater is required.');
	}
	/**
	 * `ButtonBase` contains as few styles as possible.
	 * It aims to be a simple building block for creating a button.
	 * It contains a load of style reset and some focus/ripple logic.
	 */
	
	
	var ButtonBase =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ButtonBase, _React$Component);
	
	  function ButtonBase() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, ButtonBase);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ButtonBase)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.ripple = null;
	    _this.keyDown = false;
	    _this.button = null;
	    _this.focusVisibleTimeout = null;
	    _this.focusVisibleCheckTime = 50;
	    _this.focusVisibleMaxCheckTimes = 5;
	    _this.handleMouseDown = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseDown', 'start', function () {
	      clearTimeout(_this.focusVisibleTimeout);
	
	      if (_this.state.focusVisible) {
	        _this.setState({
	          focusVisible: false
	        });
	      }
	    });
	    _this.handleMouseUp = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseUp', 'stop');
	    _this.handleMouseLeave = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseLeave', 'stop', function (event) {
	      if (_this.state.focusVisible) {
	        event.preventDefault();
	      }
	    });
	    _this.handleTouchStart = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchStart', 'start');
	    _this.handleTouchEnd = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchEnd', 'stop');
	    _this.handleTouchMove = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchMove', 'stop');
	    _this.handleBlur = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'Blur', 'stop', function () {
	      clearTimeout(_this.focusVisibleTimeout);
	
	      if (_this.state.focusVisible) {
	        _this.setState({
	          focusVisible: false
	        });
	      }
	    });
	    _this.state = {};
	
	    _this.onRippleRef = function (node) {
	      _this.ripple = node;
	    };
	
	    _this.onFocusVisibleHandler = function (event) {
	      _this.keyDown = false;
	
	      _this.setState({
	        focusVisible: true
	      });
	
	      if (_this.props.onFocusVisible) {
	        _this.props.onFocusVisible(event);
	      }
	    };
	
	    _this.handleKeyDown = function (event) {
	      var _this$props = _this.props,
	          component = _this$props.component,
	          focusRipple = _this$props.focusRipple,
	          onKeyDown = _this$props.onKeyDown,
	          onClick = _this$props.onClick;
	      var key = (0, _keycode.default)(event); // Check if key is already down to avoid repeats being counted as multiple activations
	
	      if (focusRipple && !_this.keyDown && _this.state.focusVisible && _this.ripple && key === 'space') {
	        _this.keyDown = true;
	        event.persist();
	
	        _this.ripple.stop(event, function () {
	          _this.ripple.start(event);
	        });
	      }
	
	      if (onKeyDown) {
	        onKeyDown(event);
	      } // Keyboard accessibility for non interactive elements
	
	
	      if (event.target === event.currentTarget && component && component !== 'button' && (key === 'space' || key === 'enter') && !(_this.button.tagName === 'A' && _this.button.href)) {
	        event.preventDefault();
	
	        if (onClick) {
	          onClick(event);
	        }
	      }
	    };
	
	    _this.handleKeyUp = function (event) {
	      if (_this.props.focusRipple && (0, _keycode.default)(event) === 'space' && _this.ripple && _this.state.focusVisible) {
	        _this.keyDown = false;
	        event.persist();
	
	        _this.ripple.stop(event, function () {
	          _this.ripple.pulsate(event);
	        });
	      }
	
	      if (_this.props.onKeyUp) {
	        _this.props.onKeyUp(event);
	      }
	    };
	
	    _this.handleFocus = function (event) {
	      if (_this.props.disabled) {
	        return;
	      } // Fix for https://github.com/facebook/react/issues/7769
	
	
	      if (!_this.button) {
	        _this.button = event.currentTarget;
	      }
	
	      event.persist();
	      (0, _focusVisible.detectFocusVisible)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), _this.button, function () {
	        _this.onFocusVisibleHandler(event);
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(ButtonBase, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.button = _reactDom.default.findDOMNode(this);
	      (0, _focusVisible.listenForFocusKeys)((0, _ownerWindow.default)(this.button));
	
	      if (this.props.action) {
	        this.props.action({
	          focusVisible: function focusVisible() {
	            _this2.setState({
	              focusVisible: true
	            });
	
	            _this2.button.focus();
	          }
	        });
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.focusRipple && !this.props.disableRipple && !prevState.focusVisible && this.state.focusVisible) {
	        this.ripple.pulsate();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.button = null;
	      clearTimeout(this.focusVisibleTimeout);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props2 = this.props,
	          action = _this$props2.action,
	          buttonRef = _this$props2.buttonRef,
	          centerRipple = _this$props2.centerRipple,
	          children = _this$props2.children,
	          classes = _this$props2.classes,
	          classNameProp = _this$props2.className,
	          component = _this$props2.component,
	          disabled = _this$props2.disabled,
	          disableRipple = _this$props2.disableRipple,
	          disableTouchRipple = _this$props2.disableTouchRipple,
	          focusRipple = _this$props2.focusRipple,
	          focusVisibleClassName = _this$props2.focusVisibleClassName,
	          onBlur = _this$props2.onBlur,
	          onFocus = _this$props2.onFocus,
	          onFocusVisible = _this$props2.onFocusVisible,
	          onKeyDown = _this$props2.onKeyDown,
	          onKeyUp = _this$props2.onKeyUp,
	          onMouseDown = _this$props2.onMouseDown,
	          onMouseLeave = _this$props2.onMouseLeave,
	          onMouseUp = _this$props2.onMouseUp,
	          onTouchEnd = _this$props2.onTouchEnd,
	          onTouchMove = _this$props2.onTouchMove,
	          onTouchStart = _this$props2.onTouchStart,
	          tabIndex = _this$props2.tabIndex,
	          TouchRippleProps = _this$props2.TouchRippleProps,
	          type = _this$props2.type,
	          other = (0, _objectWithoutProperties2.default)(_this$props2, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "type"]);
	      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.focusVisible, this.state.focusVisible), (0, _defineProperty2.default)(_classNames, focusVisibleClassName, this.state.focusVisible), _classNames), classNameProp);
	      var buttonProps = {};
	      var ComponentProp = component;
	
	      if (ComponentProp === 'button' && other.href) {
	        ComponentProp = 'a';
	      }
	
	      if (ComponentProp === 'button') {
	        buttonProps.type = type || 'button';
	        buttonProps.disabled = disabled;
	      } else {
	        buttonProps.role = 'button';
	      }
	
	      return _react.default.createElement(ComponentProp, (0, _extends2.default)({
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        onKeyUp: this.handleKeyUp,
	        onMouseDown: this.handleMouseDown,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseUp: this.handleMouseUp,
	        onTouchEnd: this.handleTouchEnd,
	        onTouchMove: this.handleTouchMove,
	        onTouchStart: this.handleTouchStart,
	        tabIndex: disabled ? '-1' : tabIndex,
	        className: className,
	        ref: buttonRef
	      }, buttonProps, other), children, !disableRipple && !disabled ? _react.default.createElement(_TouchRipple.default, (0, _extends2.default)({
	        innerRef: this.onRippleRef,
	        center: centerRipple
	      }, TouchRippleProps)) : null);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      if (typeof prevState.focusVisible === 'undefined') {
	        return {
	          focusVisible: false,
	          lastDisabled: nextProps.disabled
	        };
	      } // The blur won't fire when the disabled state is set on a focused input.
	      // We need to book keep the focused state manually.
	
	
	      if (!prevState.prevState && nextProps.disabled && prevState.focusVisible) {
	        return {
	          focusVisible: false,
	          lastDisabled: nextProps.disabled
	        };
	      }
	
	      return {
	        lastDisabled: nextProps.disabled
	      };
	    }
	  }]);
	  return ButtonBase;
	}(_react.default.Component);
	
	ButtonBase.propTypes =  false ? {
	  /**
	   * Callback fired when the component mounts.
	   * This is useful when you want to trigger an action programmatically.
	   * It currently only supports `focusVisible()` action.
	   *
	   * @param {object} actions This object contains all possible actions
	   * that can be triggered programmatically.
	   */
	  action: _propTypes.default.func,
	
	  /**
	   * Use that property to pass a ref callback to the native button component.
	   */
	  buttonRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * If `true`, the ripples will be centered.
	   * They won't start at the cursor interaction position.
	   */
	  centerRipple: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * If `true`, the base button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the touch ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the base button will have a keyboard focus ripple.
	   * `disableRipple` must also be `false`.
	   */
	  focusRipple: _propTypes.default.bool,
	
	  /**
	   * This property can help a person know which element has the keyboard focus.
	   * The class name will be applied when the element gain the focus through a keyboard interaction.
	   * It's a polyfill for the [CSS :focus-visible feature](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
	   * The rational for using this feature [is explain here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is focused with a keyboard.
	   * We trigger a `onFocus` callback too.
	   */
	  onFocusVisible: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchEnd: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchMove: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchStart: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Properties applied to the `TouchRipple` element.
	   */
	  TouchRippleProps: _propTypes.default.object,
	
	  /**
	   * Used to control the button's purpose.
	   * This property passes the value to the `type` attribute of the native button component.
	   * Valid property values include `button`, `submit`, and `reset`.
	   */
	  type: _propTypes.default.string
	} : {};
	ButtonBase.defaultProps = {
	  centerRipple: false,
	  component: 'button',
	  disableRipple: false,
	  disableTouchRipple: false,
	  focusRipple: false,
	  tabIndex: '0',
	  type: 'button'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButtonBase'
	})(ButtonBase);
	
	exports.default = _default;

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(7));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(8));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(11));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _Transition = _interopRequireDefault(__webpack_require__(106));
	
	/**
	 * @ignore - internal component.
	 */
	var Ripple =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Ripple, _React$Component);
	
	  function Ripple() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Ripple);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Ripple)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      visible: false,
	      leaving: false
	    };
	
	    _this.handleEnter = function () {
	      _this.setState({
	        visible: true
	      });
	    };
	
	    _this.handleExit = function () {
	      _this.setState({
	        leaving: true
	      });
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(Ripple, [{
	    key: "render",
	    value: function render() {
	      var _classNames, _classNames2;
	
	      var _this$props = this.props,
	          classes = _this$props.classes,
	          classNameProp = _this$props.className,
	          pulsate = _this$props.pulsate,
	          rippleX = _this$props.rippleX,
	          rippleY = _this$props.rippleY,
	          rippleSize = _this$props.rippleSize,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "pulsate", "rippleX", "rippleY", "rippleSize"]);
	      var _this$state = this.state,
	          visible = _this$state.visible,
	          leaving = _this$state.leaving;
	      var rippleClassName = (0, _classnames.default)(classes.ripple, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.rippleVisible, visible), (0, _defineProperty2.default)(_classNames, classes.ripplePulsate, pulsate), _classNames), classNameProp);
	      var rippleStyles = {
	        width: rippleSize,
	        height: rippleSize,
	        top: -(rippleSize / 2) + rippleY,
	        left: -(rippleSize / 2) + rippleX
	      };
	      var childClassName = (0, _classnames.default)(classes.child, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.childLeaving, leaving), (0, _defineProperty2.default)(_classNames2, classes.childPulsate, pulsate), _classNames2));
	      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
	        onEnter: this.handleEnter,
	        onExit: this.handleExit
	      }, other), _react.default.createElement("span", {
	        className: rippleClassName,
	        style: rippleStyles
	      }, _react.default.createElement("span", {
	        className: childClassName
	      })));
	    }
	  }]);
	  return Ripple;
	}(_react.default.Component);
	
	Ripple.propTypes =  false ? {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
	   */
	  pulsate: _propTypes.default.bool,
	
	  /**
	   * Diameter of the ripple.
	   */
	  rippleSize: _propTypes.default.number,
	
	  /**
	   * Horizontal position of the ripple center.
	   */
	  rippleX: _propTypes.default.number,
	
	  /**
	   * Vertical position of the ripple center.
	   */
	  rippleY: _propTypes.default.number
	} : {};
	Ripple.defaultProps = {
	  pulsate: false
	};
	var _default = Ripple;
	exports.default = _default;

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = exports.DELAY_RIPPLE = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(86));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(7));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(8));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(11));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(10));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(22));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(28));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(301));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _Ripple = _interopRequireDefault(__webpack_require__(202));
	
	var DURATION = 550;
	var DELAY_RIPPLE = 80;
	exports.DELAY_RIPPLE = DELAY_RIPPLE;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      position: 'absolute',
	      overflow: 'hidden',
	      borderRadius: 'inherit',
	      width: '100%',
	      height: '100%',
	      left: 0,
	      top: 0,
	      pointerEvents: 'none',
	      zIndex: 0
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripple` class. */
	    ripple: {
	      width: 50,
	      height: 50,
	      left: 0,
	      top: 0,
	      opacity: 0,
	      position: 'absolute'
	    },
	
	    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
	    rippleVisible: {
	      opacity: 0.3,
	      transform: 'scale(1)',
	      animation: "mui-ripple-enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
	    ripplePulsate: {
	      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
	    },
	
	    /* Styles applied to the internal `Ripple` components `child` class. */
	    child: {
	      opacity: 1,
	      display: 'block',
	      width: '100%',
	      height: '100%',
	      borderRadius: '50%',
	      backgroundColor: 'currentColor'
	    },
	
	    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
	    childLeaving: {
	      opacity: 0,
	      animation: "mui-ripple-exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
	    childPulsate: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      animation: "mui-ripple-pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
	    },
	    '@keyframes mui-ripple-enter': {
	      '0%': {
	        transform: 'scale(0)',
	        opacity: 0.1
	      },
	      '100%': {
	        transform: 'scale(1)',
	        opacity: 0.3
	      }
	    },
	    '@keyframes mui-ripple-exit': {
	      '0%': {
	        opacity: 1
	      },
	      '100%': {
	        opacity: 0
	      }
	    },
	    '@keyframes mui-ripple-pulsate': {
	      '0%': {
	        transform: 'scale(1)'
	      },
	      '50%': {
	        transform: 'scale(0.92)'
	      },
	      '100%': {
	        transform: 'scale(1)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	var TouchRipple =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  (0, _inherits2.default)(TouchRipple, _React$PureComponent);
	
	  function TouchRipple() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, TouchRipple);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TouchRipple)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.ignoringMouseDown = false;
	    _this.startTimer = null;
	    _this.startTimerCommit = null;
	    _this.state = {
	      // eslint-disable-next-line react/no-unused-state
	      nextKey: 0,
	      ripples: []
	    };
	
	    _this.pulsate = function () {
	      _this.start({}, {
	        pulsate: true
	      });
	    };
	
	    _this.start = function () {
	      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var cb = arguments.length > 2 ? arguments[2] : undefined;
	      var _options$pulsate = options.pulsate,
	          pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
	          _options$center = options.center,
	          center = _options$center === void 0 ? _this.props.center || options.pulsate : _options$center,
	          _options$fakeElement = options.fakeElement,
	          fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
	
	      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
	        _this.ignoringMouseDown = false;
	        return;
	      }
	
	      if (event.type === 'touchstart') {
	        _this.ignoringMouseDown = true;
	      }
	
	      var element = fakeElement ? null : _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	      var rect = element ? element.getBoundingClientRect() : {
	        width: 0,
	        height: 0,
	        left: 0,
	        top: 0
	      }; // Get the size of the ripple
	
	      var rippleX;
	      var rippleY;
	      var rippleSize;
	
	      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
	        rippleX = Math.round(rect.width / 2);
	        rippleY = Math.round(rect.height / 2);
	      } else {
	        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
	        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
	        rippleX = Math.round(clientX - rect.left);
	        rippleY = Math.round(clientY - rect.top);
	      }
	
	      if (center) {
	        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
	
	        if (rippleSize % 2 === 0) {
	          rippleSize += 1;
	        }
	      } else {
	        var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
	        var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
	        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
	      } // Touche devices
	
	
	      if (event.touches) {
	        // Prepare the ripple effect.
	        _this.startTimerCommit = function () {
	          _this.startCommit({
	            pulsate: pulsate,
	            rippleX: rippleX,
	            rippleY: rippleY,
	            rippleSize: rippleSize,
	            cb: cb
	          });
	        }; // Deplay the execution of the ripple effect.
	
	
	        _this.startTimer = setTimeout(function () {
	          if (_this.startTimerCommit) {
	            _this.startTimerCommit();
	
	            _this.startTimerCommit = null;
	          }
	        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
	      } else {
	        _this.startCommit({
	          pulsate: pulsate,
	          rippleX: rippleX,
	          rippleY: rippleY,
	          rippleSize: rippleSize,
	          cb: cb
	        });
	      }
	    };
	
	    _this.startCommit = function (params) {
	      var pulsate = params.pulsate,
	          rippleX = params.rippleX,
	          rippleY = params.rippleY,
	          rippleSize = params.rippleSize,
	          cb = params.cb;
	
	      _this.setState(function (state) {
	        return {
	          nextKey: state.nextKey + 1,
	          ripples: (0, _toConsumableArray2.default)(state.ripples).concat([_react.default.createElement(_Ripple.default, {
	            key: state.nextKey,
	            classes: _this.props.classes,
	            timeout: {
	              exit: DURATION,
	              enter: DURATION
	            },
	            pulsate: pulsate,
	            rippleX: rippleX,
	            rippleY: rippleY,
	            rippleSize: rippleSize
	          })])
	        };
	      }, cb);
	    };
	
	    _this.stop = function (event, cb) {
	      clearTimeout(_this.startTimer);
	      var ripples = _this.state.ripples; // The touch interaction occurs too quickly.
	      // We still want to show ripple effect.
	
	      if (event.type === 'touchend' && _this.startTimerCommit) {
	        event.persist();
	
	        _this.startTimerCommit();
	
	        _this.startTimerCommit = null;
	        _this.startTimer = setTimeout(function () {
	          _this.stop(event, cb);
	        }, 0);
	        return;
	      }
	
	      _this.startTimerCommit = null;
	
	      if (ripples && ripples.length) {
	        _this.setState({
	          ripples: ripples.slice(1)
	        }, cb);
	      }
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(TouchRipple, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.startTimer);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          center = _this$props.center,
	          classes = _this$props.classes,
	          className = _this$props.className,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["center", "classes", "className"]);
	      return _react.default.createElement(_TransitionGroup.default, (0, _extends2.default)({
	        component: "span",
	        enter: true,
	        exit: true,
	        className: (0, _classnames.default)(classes.root, className)
	      }, other), this.state.ripples);
	    }
	  }]);
	  return TouchRipple;
	}(_react.default.PureComponent);
	
	TouchRipple.propTypes =  false ? {
	  /**
	   * If `true`, the ripple starts at the center of the component
	   * rather than at the point of interaction.
	   */
	  center: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : {};
	TouchRipple.defaultProps = {
	  center: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiTouchRipple'
	})(TouchRipple);
	
	exports.default = _default;

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function createRippleHandler(instance, eventName, action, cb) {
	  return function handleEvent(event) {
	    if (cb) {
	      cb.call(instance, event);
	    }
	
	    var ignore = false; // Ignore events that have been `event.preventDefault()` marked.
	
	    if (event.defaultPrevented) {
	      ignore = true;
	    }
	
	    if (instance.props.disableTouchRipple && eventName !== 'Blur') {
	      ignore = true;
	    }
	
	    if (!ignore && instance.ripple) {
	      instance.ripple[action](event);
	    }
	
	    if (typeof instance.props["on".concat(eventName)] === 'function') {
	      instance.props["on".concat(eventName)](event);
	    }
	
	    return true;
	  };
	}
	
	var _default = createRippleHandler;
	exports.default = _default;

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.detectFocusVisible = detectFocusVisible;
	exports.listenForFocusKeys = listenForFocusKeys;
	
	var _keycode = _interopRequireDefault(__webpack_require__(57));
	
	var _warning = _interopRequireDefault(__webpack_require__(15));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(37));
	
	var internal = {
	  focusKeyPressed: false,
	  keyUpEventTimeout: -1
	};
	
	function detectFocusVisible(instance, element, callback) {
	  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	   false ? (0, _warning.default)(instance.focusVisibleCheckTime, 'Material-UI: missing instance.focusVisibleCheckTime.') : void 0;
	   false ? (0, _warning.default)(instance.focusVisibleMaxCheckTimes, 'Material-UI: missing instance.focusVisibleMaxCheckTimes.') : void 0;
	  instance.focusVisibleTimeout = setTimeout(function () {
	    var doc = (0, _ownerDocument.default)(element);
	
	    if (internal.focusKeyPressed && (doc.activeElement === element || element.contains(doc.activeElement))) {
	      callback();
	    } else if (attempt < instance.focusVisibleMaxCheckTimes) {
	      detectFocusVisible(instance, element, callback, attempt + 1);
	    }
	  }, instance.focusVisibleCheckTime);
	}
	
	var FOCUS_KEYS = ['tab', 'enter', 'space', 'esc', 'up', 'down', 'left', 'right'];
	
	function isFocusKey(event) {
	  return FOCUS_KEYS.indexOf((0, _keycode.default)(event)) > -1;
	}
	
	var handleKeyUpEvent = function handleKeyUpEvent(event) {
	  if (isFocusKey(event)) {
	    internal.focusKeyPressed = true; // Let's consider that the user is using a keyboard during a window frame of 1s.
	
	    clearTimeout(internal.keyUpEventTimeout);
	    internal.keyUpEventTimeout = setTimeout(function () {
	      internal.focusKeyPressed = false;
	    }, 1e3);
	  }
	};
	
	function listenForFocusKeys(win) {
	  // The event listener will only be added once per window.
	  // Duplicate event listeners will be ignored by addEventListener.
	  // Also, this logic is client side only, we don't need a teardown.
	  win.addEventListener('keyup', handleKeyUpEvent);
	}

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonBase.default;
	  }
	});
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(201));

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _helpers = __webpack_require__(61);
	
	var SIZE = 44;
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  return (clampedValue - min) / (max - min);
	}
	
	function easeOut(t) {
	  t = getRelativeValue(t, 0, 1); // https://gist.github.com/gre/1650294
	
	  t = (t -= 1) * t * t + 1;
	  return t;
	}
	
	function easeIn(t) {
	  return t * t;
	}
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-block',
	      lineHeight: 1 // Keep the progress centered
	
	    },
	
	    /* Styles applied to the root element if `variant="static"`. */
	    static: {
	      transition: theme.transitions.create('transform')
	    },
	
	    /* Styles applied to the root element if `variant="indeterminate"`. */
	    indeterminate: {
	      animation: 'mui-progress-circular-rotate 1.4s linear infinite'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the `svg` element. */
	    svg: {},
	
	    /* Styles applied to the `circle` svg path. */
	    circle: {
	      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
	      // strokeLinecap: 'butt',
	
	    },
	
	    /* Styles applied to the `circle` svg path if `variant="static"`. */
	    circleStatic: {
	      transition: theme.transitions.create('stroke-dashoffset')
	    },
	
	    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
	    circleIndeterminate: {
	      animation: 'mui-progress-circular-dash 1.4s ease-in-out infinite',
	      // Some default value that looks fine waiting for the animation to kicks in.
	      strokeDasharray: '80px, 200px',
	      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
	
	    },
	    '@keyframes mui-progress-circular-rotate': {
	      '100%': {
	        transform: 'rotate(360deg)'
	      }
	    },
	    '@keyframes mui-progress-circular-dash': {
	      '0%': {
	        strokeDasharray: '1px, 200px',
	        strokeDashoffset: '0px'
	      },
	      '50%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-15px'
	      },
	      '100%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-120px'
	      }
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	
	function CircularProgress(props) {
	  var _classNames, _classNames2;
	
	  var classes = props.classes,
	      className = props.className,
	      color = props.color,
	      size = props.size,
	      style = props.style,
	      thickness = props.thickness,
	      value = props.value,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "size", "style", "thickness", "value", "variant"]);
	  var circleStyle = {};
	  var rootStyle = {};
	  var rootProps = {};
	
	  if (variant === 'determinate' || variant === 'static') {
	    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
	    circleStyle.strokeDasharray = circumference.toFixed(3);
	    rootProps['aria-valuenow'] = Math.round(value);
	
	    if (variant === 'static') {
	      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
	      rootStyle.transform = 'rotate(-90deg)';
	    } else {
	      circleStyle.strokeDashoffset = "".concat((easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
	      rootStyle.transform = "rotate(".concat((easeOut(value / 70) * 270).toFixed(3), "deg)");
	    }
	  }
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes.indeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames, classes.static, variant === 'static'), _classNames), className),
	    style: (0, _extends2.default)({
	      width: size,
	      height: size
	    }, rootStyle, style),
	    role: "progressbar"
	  }, rootProps, other), _react.default.createElement("svg", {
	    className: classes.svg,
	    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
	  }, _react.default.createElement("circle", {
	    className: (0, _classnames.default)(classes.circle, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.circleIndeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames2, classes.circleStatic, variant === 'static'), _classNames2)),
	    style: circleStyle,
	    cx: SIZE,
	    cy: SIZE,
	    r: (SIZE - thickness) / 2,
	    fill: "none",
	    strokeWidth: thickness
	  })));
	}
	
	CircularProgress.propTypes =  false ? {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary', 'inherit']),
	
	  /**
	   * The size of the circle.
	   */
	  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The thickness of the circle.
	   */
	  thickness: _propTypes.default.number,
	
	  /**
	   * The value of the progress indicator for the determinate and static variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The variant to use.
	   * Use indeterminate when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'static'])
	} : {};
	CircularProgress.defaultProps = {
	  color: 'primary',
	  size: 40,
	  thickness: 3.6,
	  value: 0,
	  variant: 'indeterminate'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCircularProgress',
	  flip: false
	})(CircularProgress);
	
	exports.default = _default;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CircularProgress.default;
	  }
	});
	
	var _CircularProgress = _interopRequireDefault(__webpack_require__(489));

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(7));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(8));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(11));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(28));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactEventListener = _interopRequireDefault(__webpack_require__(149));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(37));
	
	// @inheritedComponent EventListener
	
	/**
	 * Listen for click events that occur somewhere in the document, outside of the element itself.
	 * For instance, if you need to hide a menu when people click anywhere else on your page.
	 */
	var ClickAwayListener =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ClickAwayListener, _React$Component);
	
	  function ClickAwayListener() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, ClickAwayListener);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ClickAwayListener)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.node = null;
	    _this.mounted = null;
	
	    _this.handleClickAway = function (event) {
	      // Ignore events that have been `event.preventDefault()` marked.
	      if (event.defaultPrevented) {
	        return;
	      } // IE11 support, which trigger the handleClickAway even after the unbind
	
	
	      if (!_this.mounted) {
	        return;
	      } // The child might render null.
	
	
	      if (!_this.node) {
	        return;
	      }
	
	      var doc = (0, _ownerDocument.default)(_this.node);
	
	      if (doc.documentElement && doc.documentElement.contains(event.target) && !_this.node.contains(event.target)) {
	        _this.props.onClickAway(event);
	      }
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(ClickAwayListener, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Finds the first child when a component returns a fragment.
	      // https://github.com/facebook/react/blob/036ae3c6e2f056adffc31dfb78d1b6f0c63272f0/packages/react-dom/src/__tests__/ReactDOMFiber-test.js#L105
	      this.node = _reactDom.default.findDOMNode(this);
	      this.mounted = true;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          mouseEvent = _this$props.mouseEvent,
	          touchEvent = _this$props.touchEvent,
	          onClickAway = _this$props.onClickAway,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "mouseEvent", "touchEvent", "onClickAway"]);
	      var listenerProps = {};
	
	      if (mouseEvent !== false) {
	        listenerProps[mouseEvent] = this.handleClickAway;
	      }
	
	      if (touchEvent !== false) {
	        listenerProps[touchEvent] = this.handleClickAway;
	      }
	
	      return _react.default.createElement(_reactEventListener.default, (0, _extends2.default)({
	        target: "document"
	      }, listenerProps, other), children);
	    }
	  }]);
	  return ClickAwayListener;
	}(_react.default.Component);
	
	ClickAwayListener.propTypes =  false ? {
	  /**
	   * The wrapped element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * The mouse event to listen to. You can disable the listener by providing `false`.
	   */
	  mouseEvent: _propTypes.default.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),
	
	  /**
	   * Callback fired when a "click away" event is detected.
	   */
	  onClickAway: _propTypes.default.func.isRequired,
	
	  /**
	   * The touch event to listen to. You can disable the listener by providing `false`.
	   */
	  touchEvent: _propTypes.default.oneOf(['onTouchStart', 'onTouchEnd', false])
	} : {};
	ClickAwayListener.defaultProps = {
	  mouseEvent: 'onMouseUp',
	  touchEvent: 'onTouchEnd'
	};
	var _default = ClickAwayListener;
	exports.default = _default;

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ClickAwayListener.default;
	  }
	});
	
	var _ClickAwayListener = _interopRequireDefault(__webpack_require__(491));

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(7));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(8));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(11));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _styles = __webpack_require__(110);
	
	var _exactProp = _interopRequireDefault(__webpack_require__(112));
	
	/* eslint-disable react/no-unused-prop-types */
	var styles = function styles(theme) {
	  return {
	    '@global': {
	      html: {
	        WebkitFontSmoothing: 'antialiased',
	        // Antialiasing.
	        MozOsxFontSmoothing: 'grayscale',
	        // Antialiasing.
	        // Change from `box-sizing: content-box` so that `width`
	        // is not affected by `padding` or `border`.
	        boxSizing: 'border-box'
	      },
	      '*, *::before, *::after': {
	        boxSizing: 'inherit'
	      },
	      body: {
	        margin: 0,
	        // Remove the margin in all browsers.
	        backgroundColor: theme.palette.background.default,
	        '@media print': {
	          // Save printer ink.
	          backgroundColor: theme.palette.common.white
	        }
	      }
	    }
	  };
	};
	/**
	 * Kickstart an elegant, consistent, and simple baseline to build upon.
	 */
	
	
	var CssBaseline =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(CssBaseline, _React$Component);
	
	  function CssBaseline() {
	    (0, _classCallCheck2.default)(this, CssBaseline);
	    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CssBaseline).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(CssBaseline, [{
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return CssBaseline;
	}(_react.default.Component);
	
	CssBaseline.propTypes =  false ? {
	  /**
	   * You can wrap a node.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  classes: _propTypes.default.object.isRequired
	} : {};
	CssBaseline.propTypes =  false ? (0, _exactProp.default)(CssBaseline.propTypes) : {};
	CssBaseline.defaultProps = {
	  children: null
	};
	
	var _default = (0, _styles.withStyles)(styles, {
	  name: 'MuiCssBaseline'
	})(CssBaseline);
	
	exports.default = _default;

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CssBaseline.default;
	  }
	});
	
	var _CssBaseline = _interopRequireDefault(__webpack_require__(492));

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(7));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(8));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(11));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Transition = _interopRequireDefault(__webpack_require__(106));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(111));
	
	var _utils = __webpack_require__(152);
	
	// @inheritedComponent Transition
	function getScale(value) {
	  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
	}
	
	var styles = {
	  entering: {
	    opacity: 1,
	    transform: getScale(1)
	  },
	  entered: {
	    opacity: 1,
	    // Use translateZ to scrolling issue on Chrome.
	    transform: "".concat(getScale(1), " translateZ(0)")
	  }
	};
	/**
	 * The Grow transition is used by the [Tooltip](/demos/tooltips) and
	 * [Popover](/utils/popover) components.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Grow =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Grow, _React$Component);
	
	  function Grow() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Grow);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Grow)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.autoTimeout = null;
	    _this.timer = null;
	
	    _this.handleEnter = function (node) {
	      var _this$props = _this.props,
	          theme = _this$props.theme,
	          timeout = _this$props.timeout;
	      (0, _utils.reflow)(node); // So the animation always start from the start.
	
	      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'enter'
	      }),
	          transitionDuration = _getTransitionProps.duration,
	          delay = _getTransitionProps.delay;
	
	      var duration = 0;
	
	      if (timeout === 'auto') {
	        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	        _this.autoTimeout = duration;
	      } else {
	        duration = transitionDuration;
	      }
	
	      node.style.transition = [theme.transitions.create('opacity', {
	        duration: duration,
	        delay: delay
	      }), theme.transitions.create('transform', {
	        duration: duration * 0.666,
	        delay: delay
	      })].join(',');
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    };
	
	    _this.handleExit = function (node) {
	      var _this$props2 = _this.props,
	          theme = _this$props2.theme,
	          timeout = _this$props2.timeout;
	      var duration = 0;
	
	      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'exit'
	      }),
	          transitionDuration = _getTransitionProps2.duration,
	          delay = _getTransitionProps2.delay;
	
	      if (timeout === 'auto') {
	        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	        _this.autoTimeout = duration;
	      } else {
	        duration = transitionDuration;
	      }
	
	      node.style.transition = [theme.transitions.create('opacity', {
	        duration: duration,
	        delay: delay
	      }), theme.transitions.create('transform', {
	        duration: duration * 0.666,
	        delay: delay || duration * 0.333
	      })].join(',');
	      node.style.opacity = '0';
	      node.style.transform = getScale(0.75);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.addEndListener = function (_, next) {
	      if (_this.props.timeout === 'auto') {
	        _this.timer = setTimeout(next, _this.autoTimeout || 0);
	      }
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(Grow, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timer);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props3 = this.props,
	          children = _this$props3.children,
	          onEnter = _this$props3.onEnter,
	          onExit = _this$props3.onExit,
	          styleProp = _this$props3.style,
	          theme = _this$props3.theme,
	          timeout = _this$props3.timeout,
	          other = (0, _objectWithoutProperties2.default)(_this$props3, ["children", "onEnter", "onExit", "style", "theme", "timeout"]);
	      var style = (0, _extends2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
	      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
	        appear: true,
	        onEnter: this.handleEnter,
	        onExit: this.handleExit,
	        addEndListener: this.addEndListener,
	        timeout: timeout === 'auto' ? null : timeout
	      }, other), function (state, childProps) {
	        return _react.default.cloneElement(children, (0, _extends2.default)({
	          style: (0, _extends2.default)({
	            opacity: 0,
	            transform: getScale(0.75)
	          }, styles[state], style)
	        }, childProps));
	      });
	    }
	  }]);
	  return Grow;
	}(_react.default.Component);
	
	Grow.propTypes =  false ? {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  }), _propTypes.default.oneOf(['auto'])])
	} : {};
	Grow.defaultProps = {
	  timeout: 'auto'
	};
	Grow.muiSupportAuto = true;
	
	var _default = (0, _withTheme.default)()(Grow);
	
	exports.default = _default;

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Grow.default;
	  }
	});
	
	var _Grow = _interopRequireDefault(__webpack_require__(207));

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _colorManipulator = __webpack_require__(217);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(148));
	
	var _helpers = __webpack_require__(61);
	
	// @inheritedComponent ButtonBase
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      textAlign: 'center',
	      flex: '0 0 auto',
	      fontSize: theme.typography.pxToRem(24),
	      width: 48,
	      height: 48,
	      padding: 0,
	      borderRadius: '50%',
	      color: theme.palette.action.active,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        },
	        '&$disabled': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the children container element. */
	    label: {
	      width: '100%',
	      display: 'flex',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    }
	  };
	};
	/**
	 * Refer to the [Icons](/style/icons) section of the documentation
	 * regarding the available icon options.
	 */
	
	
	exports.styles = styles;
	
	function IconButton(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      color = props.color,
	      disabled = props.disabled,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled"]);
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), className),
	    centerRipple: true,
	    focusRipple: true,
	    disabled: disabled
	  }, other), _react.default.createElement("span", {
	    className: classes.label
	  }, children));
	}
	
	IconButton.propTypes =  false ? {
	  /**
	   * The icon element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple will be disabled.
	   */
	  disableRipple: _propTypes.default.bool
	} : {};
	IconButton.defaultProps = {
	  color: 'default',
	  disabled: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIconButton'
	})(IconButton);
	
	exports.default = _default;

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	
	var _IconButton = _interopRequireDefault(__webpack_require__(502));

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(7));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(8));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(11));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    listStyle: 'none',
	    margin: 0,
	    padding: 0,
	    position: 'relative'
	  },
	
	  /* Styles applied to the root element if `disablePadding={false}`. */
	  padding: {
	    paddingTop: 8,
	    paddingBottom: 8
	  },
	
	  /* Styles applied to the root element if `dense={true}` & `disablePadding={false}`. */
	  dense: {
	    paddingTop: 4,
	    paddingBottom: 4
	  },
	
	  /* Styles applied to the root element if a `subheader` is provided. */
	  subheader: {
	    paddingTop: 0
	  }
	};
	exports.styles = styles;
	
	var List =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(List, _React$Component);
	
	  function List() {
	    (0, _classCallCheck2.default)(this, List);
	    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(List).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(List, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        dense: this.props.dense
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props = this.props,
	          children = _this$props.children,
	          classes = _this$props.classes,
	          classNameProp = _this$props.className,
	          Component = _this$props.component,
	          dense = _this$props.dense,
	          disablePadding = _this$props.disablePadding,
	          subheader = _this$props.subheader,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);
	      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.dense, dense && !disablePadding), (0, _defineProperty2.default)(_classNames, classes.padding, !disablePadding), (0, _defineProperty2.default)(_classNames, classes.subheader, subheader), _classNames), classNameProp);
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        className: className
	      }, other), subheader, children);
	    }
	  }]);
	  return List;
	}(_react.default.Component);
	
	List.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
	   * the list and list items. The property is available to descendant components as the
	   * `dense` context.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * If `true`, vertical padding will be removed from the list.
	   */
	  disablePadding: _propTypes.default.bool,
	
	  /**
	   * The content of the subheader, normally `ListSubheader`.
	   */
	  subheader: _propTypes.default.node
	} : {};
	List.defaultProps = {
	  component: 'ul',
	  dense: false,
	  disablePadding: false
	};
	List.childContextTypes = {
	  dense: _propTypes.default.bool
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiList'
	})(List);
	
	exports.default = _default;

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _List.default;
	  }
	});
	
	var _List = _interopRequireDefault(__webpack_require__(210));

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(7));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(8));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(11));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(148));
	
	var _reactHelpers = __webpack_require__(218);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
	    root: {
	      display: 'flex',
	      justifyContent: 'flex-start',
	      alignItems: 'center',
	      position: 'relative',
	      textDecoration: 'none',
	      width: '100%',
	      boxSizing: 'border-box',
	      textAlign: 'left',
	      paddingTop: 12,
	      paddingBottom: 12
	    },
	
	    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
	    container: {
	      position: 'relative'
	    },
	    // TODO: Sanity check this - why is focusVisibleClassName prop apparently applied to a div?
	
	    /* Styles applied to the `component`'s `focusVisibleClassName` property if `button={true}`. */
	    focusVisible: {
	      backgroundColor: theme.palette.action.hover
	    },
	
	    /* Legacy styles applied to the root element. Use `root` instead. */
	    default: {},
	
	    /* Styles applied to the `component` element if `dense={true}` or `children` includes `Avatar`. */
	    dense: {
	      paddingTop: 8,
	      paddingBottom: 8
	    },
	
	    /* Styles applied to the inner `component` element if `disabled={true}`. */
	    disabled: {
	      opacity: 0.5
	    },
	
	    /* Styles applied to the inner `component` element if `divider={true}`. */
	    divider: {
	      borderBottom: "1px solid ".concat(theme.palette.divider),
	      backgroundClip: 'padding-box'
	    },
	
	    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
	    gutters: theme.mixins.gutters(),
	
	    /* Styles applied to the inner `component` element if `button={true}`. */
	    button: {
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: theme.palette.action.hover,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
	    secondaryAction: {
	      // Add some space to avoid collision as `ListItemSecondaryAction`
	      // is absolutely positionned.
	      paddingRight: 32
	    }
	  };
	};
	
	exports.styles = styles;
	
	var ListItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ListItem, _React$Component);
	
	  function ListItem() {
	    (0, _classCallCheck2.default)(this, ListItem);
	    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ListItem).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(ListItem, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        dense: this.props.dense || this.context.dense || false
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props = this.props,
	          button = _this$props.button,
	          childrenProp = _this$props.children,
	          classes = _this$props.classes,
	          classNameProp = _this$props.className,
	          componentProp = _this$props.component,
	          ContainerComponent = _this$props.ContainerComponent,
	          _this$props$Container = _this$props.ContainerProps;
	      _this$props$Container = _this$props$Container === void 0 ? {} : _this$props$Container;
	      var ContainerClassName = _this$props$Container.className,
	          ContainerProps = (0, _objectWithoutProperties2.default)(_this$props$Container, ["className"]),
	          dense = _this$props.dense,
	          disabled = _this$props.disabled,
	          disableGutters = _this$props.disableGutters,
	          divider = _this$props.divider,
	          focusVisibleClassName = _this$props.focusVisibleClassName,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName"]);
	      var isDense = dense || this.context.dense || false;
	
	      var children = _react.default.Children.toArray(childrenProp);
	
	      var hasAvatar = children.some(function (value) {
	        return (0, _reactHelpers.isMuiElement)(value, ['ListItemAvatar']);
	      });
	      var hasSecondaryAction = children.length && (0, _reactHelpers.isMuiElement)(children[children.length - 1], ['ListItemSecondaryAction']);
	      var className = (0, _classnames.default)(classes.root, classes.default, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.dense, isDense || hasAvatar), (0, _defineProperty2.default)(_classNames, classes.gutters, !disableGutters), (0, _defineProperty2.default)(_classNames, classes.divider, divider), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.button, button), (0, _defineProperty2.default)(_classNames, classes.secondaryAction, hasSecondaryAction), _classNames), classNameProp);
	      var componentProps = (0, _extends2.default)({
	        className: className,
	        disabled: disabled
	      }, other);
	      var Component = componentProp || 'li';
	
	      if (button) {
	        componentProps.component = componentProp || 'div';
	        componentProps.focusVisibleClassName = (0, _classnames.default)(classes.focusVisible, focusVisibleClassName);
	        Component = _ButtonBase.default;
	      }
	
	      if (hasSecondaryAction) {
	        // Use div by default.
	        Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.
	
	        if (ContainerComponent === 'li') {
	          if (Component === 'li') {
	            Component = 'div';
	          } else if (componentProps.component === 'li') {
	            componentProps.component = 'div';
	          }
	        }
	
	        return _react.default.createElement(ContainerComponent, (0, _extends2.default)({
	          className: (0, _classnames.default)(classes.container, ContainerClassName)
	        }, ContainerProps), _react.default.createElement(Component, componentProps, children), children.pop());
	      }
	
	      return _react.default.createElement(Component, componentProps, children);
	    }
	  }]);
	  return ListItem;
	}(_react.default.Component);
	
	ListItem.propTypes =  false ? {
	  /**
	   * If `true`, the list item will be a button (using `ButtonBase`).
	   */
	  button: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * The container component used when a `ListItemSecondaryAction` is rendered.
	   */
	  ContainerComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * Properties applied to the container element when the component
	   * is used to display a `ListItemSecondaryAction`.
	   */
	  ContainerProps: _propTypes.default.object,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * If `true`, the list item will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * If `true`, a 1px light border is added to the bottom of the list item.
	   */
	  divider: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string
	} : {};
	ListItem.defaultProps = {
	  button: false,
	  ContainerComponent: 'li',
	  dense: false,
	  disabled: false,
	  disableGutters: false,
	  divider: false
	};
	ListItem.contextTypes = {
	  dense: _propTypes.default.bool
	};
	ListItem.childContextTypes = {
	  dense: _propTypes.default.bool
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItem'
	})(ListItem);
	
	exports.default = _default;

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItem.default;
	  }
	});
	
	var _ListItem = _interopRequireDefault(__webpack_require__(506));

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _ListItem = _interopRequireDefault(__webpack_require__(507));
	
	// @inheritedComponent ListItem
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.subheading, {
	      height: 24,
	      boxSizing: 'content-box',
	      width: 'auto',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      paddingLeft: 16,
	      paddingRight: 16,
	      '&$selected': {
	        backgroundColor: theme.palette.action.selected
	      }
	    }),
	
	    /* Styles applied to the root element if `selected={true}`. */
	    selected: {}
	  };
	};
	
	exports.styles = styles;
	
	function MenuItem(props) {
	  var classes = props.classes,
	      className = props.className,
	      component = props.component,
	      selected = props.selected,
	      role = props.role,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "selected", "role"]);
	  return _react.default.createElement(_ListItem.default, (0, _extends2.default)({
	    button: true,
	    role: role,
	    tabIndex: -1,
	    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.selected, selected), className),
	    component: component
	  }, other));
	}
	
	MenuItem.propTypes =  false ? {
	  /**
	   * Menu item contents.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * Use to apply selected styling.
	   */
	  selected: _propTypes.default.bool
	} : {};
	MenuItem.defaultProps = {
	  component: 'li',
	  role: 'menuitem',
	  selected: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMenuItem'
	})(MenuItem);
	
	exports.default = _default;

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem.default;
	  }
	});
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(509));

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(7));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(8));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(11));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(9));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(28));
	
	var _keycode = _interopRequireDefault(__webpack_require__(57));
	
	var _warning = _interopRequireDefault(__webpack_require__(15));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(37));
	
	var _List = _interopRequireDefault(__webpack_require__(211));
	
	// @inheritedComponent List
	var MenuList =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(MenuList, _React$Component);
	
	  function MenuList() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, MenuList);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MenuList)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.listRef = null;
	    _this.selectedItemRef = null;
	    _this.blurTimer = null;
	    _this.state = {
	      currentTabIndex: null
	    };
	
	    _this.handleBlur = function (event) {
	      _this.blurTimer = setTimeout(function () {
	        if (_this.listRef) {
	          var list = _this.listRef;
	          var currentFocus = (0, _ownerDocument.default)(list).activeElement;
	
	          if (!list.contains(currentFocus)) {
	            _this.resetTabIndex();
	          }
	        }
	      }, 30);
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    };
	
	    _this.handleKeyDown = function (event) {
	      var list = _this.listRef;
	      var key = (0, _keycode.default)(event);
	      var currentFocus = (0, _ownerDocument.default)(list).activeElement;
	
	      if ((key === 'up' || key === 'down') && (!currentFocus || currentFocus && !list.contains(currentFocus))) {
	        if (_this.selectedItemRef) {
	          _this.selectedItemRef.focus();
	        } else {
	          list.firstChild.focus();
	        }
	      } else if (key === 'down') {
	        event.preventDefault();
	
	        if (currentFocus.nextElementSibling) {
	          currentFocus.nextElementSibling.focus();
	        }
	      } else if (key === 'up') {
	        event.preventDefault();
	
	        if (currentFocus.previousElementSibling) {
	          currentFocus.previousElementSibling.focus();
	        }
	      }
	
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(event, key);
	      }
	    };
	
	    _this.handleItemFocus = function (event) {
	      var list = _this.listRef;
	
	      if (list) {
	        for (var i = 0; i < list.children.length; i += 1) {
	          if (list.children[i] === event.currentTarget) {
	            _this.setTabIndex(i);
	
	            break;
	          }
	        }
	      }
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(MenuList, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.resetTabIndex();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.blurTimer);
	    }
	  }, {
	    key: "setTabIndex",
	    value: function setTabIndex(index) {
	      this.setState({
	        currentTabIndex: index
	      });
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      var currentTabIndex = this.state.currentTabIndex;
	      var list = this.listRef;
	
	      if (!list || !list.children || !list.firstChild) {
	        return;
	      }
	
	      if (currentTabIndex && currentTabIndex >= 0) {
	        list.children[currentTabIndex].focus();
	      } else {
	        list.firstChild.focus();
	      }
	    }
	  }, {
	    key: "resetTabIndex",
	    value: function resetTabIndex() {
	      var list = this.listRef;
	      var currentFocus = (0, _ownerDocument.default)(list).activeElement;
	      var items = [];
	
	      for (var i = 0; i < list.children.length; i += 1) {
	        items.push(list.children[i]);
	      }
	
	      var currentFocusIndex = items.indexOf(currentFocus);
	
	      if (currentFocusIndex !== -1) {
	        return this.setTabIndex(currentFocusIndex);
	      }
	
	      if (this.selectedItemRef) {
	        return this.setTabIndex(items.indexOf(this.selectedItemRef));
	      }
	
	      return this.setTabIndex(0);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          children = _this$props.children,
	          className = _this$props.className,
	          onBlur = _this$props.onBlur,
	          onKeyDown = _this$props.onKeyDown,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "onBlur", "onKeyDown"]);
	      return _react.default.createElement(_List.default, (0, _extends2.default)({
	        role: "menu",
	        ref: function ref(_ref) {
	          _this2.listRef = _reactDom.default.findDOMNode(_ref);
	        },
	        className: className,
	        onKeyDown: this.handleKeyDown,
	        onBlur: this.handleBlur
	      }, other), _react.default.Children.map(children, function (child, index) {
	        if (!_react.default.isValidElement(child)) {
	          return null;
	        }
	
	         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the MenuList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
	        return _react.default.cloneElement(child, {
	          tabIndex: index === _this2.state.currentTabIndex ? 0 : -1,
	          ref: child.props.selected ? function (ref) {
	            _this2.selectedItemRef = _reactDom.default.findDOMNode(ref);
	          } : undefined,
	          onFocus: _this2.handleItemFocus
	        });
	      }));
	    }
	  }]);
	  return MenuList;
	}(_react.default.Component);
	
	MenuList.propTypes =  false ? {
	  /**
	   * MenuList contents, normally `MenuItem`s.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func
	} : {};
	var _default = MenuList;
	exports.default = _default;

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MenuList.default;
	  }
	});
	
	var _MenuList = _interopRequireDefault(__webpack_require__(213));

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _warning = _interopRequireDefault(__webpack_require__(15));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var styles = function styles(theme) {
	  var elevations = {};
	  theme.shadows.forEach(function (shadow, index) {
	    elevations["elevation".concat(index)] = {
	      boxShadow: shadow
	    };
	  });
	  return (0, _extends2.default)({
	    /* Styles applied to the root element. */
	    root: {
	      backgroundColor: theme.palette.background.paper
	    },
	
	    /* Styles applied to the root element if `square={false}`. */
	    rounded: {
	      borderRadius: theme.shape.borderRadius
	    }
	  }, elevations);
	};
	
	exports.styles = styles;
	
	function Paper(props) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      square = props.square,
	      elevation = props.elevation,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
	   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
	  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className
	  }, other));
	}
	
	Paper.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * Shadow depth, corresponds to `dp` in the spec.
	   * It's accepting values between 0 and 24 inclusive.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * If `true`, rounded corners are disabled.
	   */
	  square: _propTypes.default.bool
	} : {};
	Paper.defaultProps = {
	  component: 'div',
	  elevation: 2,
	  square: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiPaper'
	})(Paper);
	
	exports.default = _default;

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Paper.default;
	  }
	});
	
	var _Paper = _interopRequireDefault(__webpack_require__(214));

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _helpers = __webpack_require__(61);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      userSelect: 'none',
	      width: '1em',
	      height: '1em',
	      display: 'inline-block',
	      fill: 'currentColor',
	      flexShrink: 0,
	      fontSize: 24,
	      transition: theme.transitions.create('fill', {
	        duration: theme.transitions.duration.shorter
	      })
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="saction"`. */
	    colorAction: {
	      color: theme.palette.action.active
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `color="disabled"`. */
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	
	    /* Styles applied to the root element if `fontSize="inherit"`. */
	    fontSizeInherit: {
	      fontSize: 'inherit'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function SvgIcon(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      Component = props.component,
	      fontSize = props.fontSize,
	      nativeColor = props.nativeColor,
	      titleAccess = props.titleAccess,
	      viewBox = props.viewBox,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize", "nativeColor", "titleAccess", "viewBox"]);
	  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.fontSizeInherit, fontSize === 'inherit'), (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), _classNames), classNameProp);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className,
	    focusable: "false",
	    viewBox: viewBox,
	    color: nativeColor,
	    "aria-hidden": titleAccess ? 'false' : 'true'
	  }, other), children, titleAccess ? _react.default.createElement("title", null, titleAccess) : null);
	}
	
	SvgIcon.propTypes =  false ? {
	  /**
	   * Node passed into the SVG element.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   * You can use the `nativeColor` property to apply a color attribute to the SVG element.
	   */
	  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
	   */
	  fontSize: _propTypes.default.oneOf(['inherit', 'default']),
	
	  /**
	   * Applies a color attribute to the SVG element.
	   */
	  nativeColor: _propTypes.default.string,
	
	  /**
	   * Provides a human-readable title for the element that contains it.
	   * https://www.w3.org/TR/SVG-access/#Equivalent
	   */
	  titleAccess: _propTypes.default.string,
	
	  /**
	   * Allows you to redefine what the coordinates without units mean inside an SVG element.
	   * For example, if the SVG element is 500 (width) by 200 (height),
	   * and you pass viewBox="0 0 50 20",
	   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
	   * to bottom right (50,20) and each unit will be worth 10px.
	   */
	  viewBox: _propTypes.default.string
	} : {};
	SvgIcon.defaultProps = {
	  color: 'inherit',
	  component: 'svg',
	  fontSize: 'default',
	  viewBox: '0 0 24 24'
	};
	SvgIcon.muiName = 'SvgIcon';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSvgIcon'
	})(SvgIcon);
	
	exports.default = _default;

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SvgIcon.default;
	  }
	});
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(215));

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _classCallCheck = _interopDefault(__webpack_require__(7));
	var _createClass = _interopDefault(__webpack_require__(8));
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(11));
	var _getPrototypeOf = _interopDefault(__webpack_require__(9));
	var _inherits = _interopDefault(__webpack_require__(10));
	var _typeof = _interopDefault(__webpack_require__(87));
	var _objectWithoutProperties = _interopDefault(__webpack_require__(13));
	var _extends = _interopDefault(__webpack_require__(6));
	var React = _interopDefault(__webpack_require__(2));
	var PropTypes = _interopDefault(__webpack_require__(4));
	var warning = _interopDefault(__webpack_require__(15));
	
	function defineProperty(object, property, attr) {
	  return Object.defineProperty(object, property, attr);
	} // Passive options
	// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
	
	
	var passiveOption = function () {
	  var cache = null;
	  return function () {
	    if (cache !== null) {
	      return cache;
	    }
	
	    var supportsPassiveOption = false;
	
	    try {
	      window.addEventListener('test', null, defineProperty({}, 'passive', {
	        get: function get() {
	          supportsPassiveOption = true;
	        }
	      }));
	    } catch (err) {//
	    }
	
	    cache = supportsPassiveOption;
	    return supportsPassiveOption;
	  }();
	}();
	
	var defaultEventOptions = {
	  capture: false,
	  passive: false
	};
	
	function mergeDefaultEventOptions(options) {
	  return _extends({}, defaultEventOptions, options);
	}
	
	function getEventListenerArgs(eventName, callback, options) {
	  var args = [eventName, callback];
	  args.push(passiveOption ? options : options.capture);
	  return args;
	}
	
	function on(target, eventName, callback, options) {
	  // eslint-disable-next-line prefer-spread
	  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	}
	
	function off(target, eventName, callback, options) {
	  // eslint-disable-next-line prefer-spread
	  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	}
	
	function forEachListener(props, iteratee) {
	  var children = props.children,
	      target = props.target,
	      eventProps = _objectWithoutProperties(props, ["children", "target"]);
	
	  Object.keys(eventProps).forEach(function (name) {
	    if (name.substring(0, 2) !== 'on') {
	      return;
	    }
	
	    var prop = eventProps[name];
	
	    var type = _typeof(prop);
	
	    var isObject = type === 'object';
	    var isFunction = type === 'function';
	
	    if (!isObject && !isFunction) {
	      return;
	    }
	
	    var capture = name.substr(-7).toLowerCase() === 'capture';
	    var eventName = name.substring(2).toLowerCase();
	    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;
	
	    if (isObject) {
	      iteratee(eventName, prop.handler, prop.options);
	    } else {
	      iteratee(eventName, prop, mergeDefaultEventOptions({
	        capture: capture
	      }));
	    }
	  });
	}
	
	function withOptions(handler, options) {
	   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
	  return {
	    handler: handler,
	    options: mergeDefaultEventOptions(options)
	  };
	}
	
	var EventListener =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(EventListener, _React$PureComponent);
	
	  function EventListener() {
	    _classCallCheck(this, EventListener);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(EventListener).apply(this, arguments));
	  }
	
	  _createClass(EventListener, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.applyListeners(on);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      this.applyListeners(off, prevProps);
	      this.applyListeners(on);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.applyListeners(off);
	    }
	  }, {
	    key: "applyListeners",
	    value: function applyListeners(onOrOff) {
	      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
	      var target = props.target;
	
	      if (target) {
	        var element = target;
	
	        if (typeof target === 'string') {
	          element = window[target];
	        }
	
	        forEachListener(props, onOrOff.bind(null, element));
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	
	  return EventListener;
	}(React.PureComponent);
	
	EventListener.propTypes =  false ? {
	  /**
	   * You can provide a single child too.
	   */
	  children: PropTypes.node,
	
	  /**
	   * The DOM target to listen to.
	   */
	  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
	} : {};
	
	exports.withOptions = withOptions;
	exports.default = EventListener;


/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(17);
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(5));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(7));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(8));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(11));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _warning = _interopRequireDefault(__webpack_require__(15));
	
	var _brcast = _interopRequireDefault(__webpack_require__(335));
	
	var _themeListener = _interopRequireWildcard(__webpack_require__(151));
	
	var _exactProp = _interopRequireDefault(__webpack_require__(112));
	
	/**
	 * This component takes a `theme` property.
	 * It makes the `theme` available down the React tree thanks to React context.
	 * This component should preferably be used at **the root of your component tree**.
	 */
	var MuiThemeProvider =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(MuiThemeProvider, _React$Component);
	
	  // We are not using the React state in order to avoid unnecessary rerender.
	  function MuiThemeProvider(props, context) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, MuiThemeProvider);
	    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MuiThemeProvider).call(this)); // Get the outer theme from the context, can be null
	
	    _this.broadcast = (0, _brcast.default)();
	    _this.unsubscribeId = null;
	    _this.outerTheme = null;
	    _this.outerTheme = _themeListener.default.initial(context); // Propagate the theme so it can be accessed by the children
	
	    _this.broadcast.setState(_this.mergeOuterLocalTheme(props.theme));
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(MuiThemeProvider, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      var _ref;
	
	      var _this$props = this.props,
	          sheetsManager = _this$props.sheetsManager,
	          disableStylesGeneration = _this$props.disableStylesGeneration;
	      var muiThemeProviderOptions = this.context.muiThemeProviderOptions || {};
	
	      if (sheetsManager !== undefined) {
	        muiThemeProviderOptions.sheetsManager = sheetsManager;
	      }
	
	      if (disableStylesGeneration !== undefined) {
	        muiThemeProviderOptions.disableStylesGeneration = disableStylesGeneration;
	      }
	
	      return _ref = {}, (0, _defineProperty2.default)(_ref, _themeListener.CHANNEL, this.broadcast), (0, _defineProperty2.default)(_ref, "muiThemeProviderOptions", muiThemeProviderOptions), _ref;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // Subscribe on the outer theme, if present
	      this.unsubscribeId = _themeListener.default.subscribe(this.context, function (outerTheme) {
	        _this2.outerTheme = outerTheme; // Forward the parent theme update to the children
	
	        _this2.broadcast.setState(_this2.mergeOuterLocalTheme(_this2.props.theme));
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      // Propagate a local theme update
	      if (this.props.theme !== prevProps.theme) {
	        this.broadcast.setState(this.mergeOuterLocalTheme(this.props.theme));
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.unsubscribeId !== null) {
	        _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
	      }
	    } // Simple merge between the outer theme and the local theme
	
	  }, {
	    key: "mergeOuterLocalTheme",
	    value: function mergeOuterLocalTheme(localTheme) {
	      // To support composition of theme.
	      if (typeof localTheme === 'function') {
	         false ? (0, _warning.default)(this.outerTheme, ['Material-UI: you are providing a theme function property ' + 'to the MuiThemeProvider component:', '<MuiThemeProvider theme={outerTheme => outerTheme} />', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n')) : void 0;
	        return localTheme(this.outerTheme);
	      }
	
	      if (!this.outerTheme) {
	        return localTheme;
	      }
	
	      return (0, _extends2.default)({}, this.outerTheme, localTheme);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      // TODO move the sheetsManager property to a different component.
	      // warning(
	      //   typeof window !== 'undefined' || this.props.sheetsManager,
	      //   [
	      //     'Material-UI: you need to provide a sheetsManager to the MuiThemeProvider ' +
	      //       'when rendering on the server.',
	      //     'If you do not, you might experience a memory leak',
	      //   ].join('\n'),
	      // );
	      return this.props.children;
	    }
	  }]);
	  return MuiThemeProvider;
	}(_react.default.Component);
	
	MuiThemeProvider.propTypes =  false ? {
	  /**
	   * You can wrap a node.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * You can disable the generation of the styles with this option.
	   * It can be useful when traversing the React tree outside of the HTML
	   * rendering step on the server.
	   * Let's say you are using react-apollo to extract all
	   * the queries made by the interface server side.
	   * You can significantly speed up the traversal with this property.
	   */
	  disableStylesGeneration: _propTypes.default.bool,
	
	  /**
	   * The sheetsManager is used to deduplicate style sheet injection in the page.
	   * It's deduplicating using the (theme, styles) couple.
	   * On the server, you should provide a new instance for each request.
	   */
	  sheetsManager: _propTypes.default.object,
	
	  /**
	   * A theme object.
	   */
	  theme: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]).isRequired
	} : {};
	MuiThemeProvider.propTypes =  false ? (0, _exactProp.default)(MuiThemeProvider.propTypes) : {};
	MuiThemeProvider.childContextTypes = (0, _extends2.default)({}, _themeListener.default.contextTypes, {
	  muiThemeProviderOptions: _propTypes.default.object
	});
	MuiThemeProvider.contextTypes = (0, _extends2.default)({}, _themeListener.default.contextTypes, {
	  muiThemeProviderOptions: _propTypes.default.object
	});
	var _default = MuiThemeProvider;
	exports.default = _default;

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createStyles;
	
	function createStyles(styles) {
	  return styles;
	}

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "createGenerateClassName", {
	  enumerable: true,
	  get: function get() {
	    return _createGenerateClassName.default;
	  }
	});
	Object.defineProperty(exports, "createMuiTheme", {
	  enumerable: true,
	  get: function get() {
	    return _createMuiTheme.default;
	  }
	});
	Object.defineProperty(exports, "jssPreset", {
	  enumerable: true,
	  get: function get() {
	    return _jssPreset.default;
	  }
	});
	Object.defineProperty(exports, "MuiThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _MuiThemeProvider.default;
	  }
	});
	Object.defineProperty(exports, "createStyles", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	Object.defineProperty(exports, "withStyles", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	Object.defineProperty(exports, "withTheme", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(315));
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(150));
	
	var _jssPreset = _interopRequireDefault(__webpack_require__(316));
	
	var _MuiThemeProvider = _interopRequireDefault(__webpack_require__(530));
	
	var _createStyles = _interopRequireDefault(__webpack_require__(534));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(111));

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(6));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(7));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(8));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(11));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(9));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(128));
	
	var _wrapDisplayName = _interopRequireDefault(__webpack_require__(85));
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(150));
	
	var _themeListener = _interopRequireDefault(__webpack_require__(151));
	
	var defaultTheme;
	
	function getDefaultTheme() {
	  if (defaultTheme) {
	    return defaultTheme;
	  }
	
	  defaultTheme = (0, _createMuiTheme.default)();
	  return defaultTheme;
	} // Provide the theme object as a property to the input component.
	
	
	var withTheme = function withTheme() {
	  return function (Component) {
	    var WithTheme =
	    /*#__PURE__*/
	    function (_React$Component) {
	      (0, _inherits2.default)(WithTheme, _React$Component);
	
	      function WithTheme(props, context) {
	        var _this;
	
	        (0, _classCallCheck2.default)(this, WithTheme);
	        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithTheme).call(this));
	        _this.unsubscribeId = null;
	        _this.state = {};
	        _this.state = {
	          // We use || as the function call is lazy evaluated.
	          theme: _themeListener.default.initial(context) || getDefaultTheme()
	        };
	        return _this;
	      }
	
	      (0, _createClass2.default)(WithTheme, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	          var _this2 = this;
	
	          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
	            _this2.setState({
	              theme: theme
	            });
	          });
	        }
	      }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	          if (this.unsubscribeId !== null) {
	            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
	          }
	        }
	      }, {
	        key: "render",
	        value: function render() {
	          var _this$props = this.props,
	              innerRef = _this$props.innerRef,
	              other = (0, _objectWithoutProperties2.default)(_this$props, ["innerRef"]);
	          return _react.default.createElement(Component, (0, _extends2.default)({
	            theme: this.state.theme,
	            ref: innerRef
	          }, other));
	        }
	      }]);
	      return WithTheme;
	    }(_react.default.Component);
	
	    WithTheme.propTypes =  false ? {
	      /**
	       * Use that property to pass a ref callback to the decorated component.
	       */
	      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
	    } : {};
	    WithTheme.contextTypes = _themeListener.default.contextTypes;
	
	    if (false) {
	      WithTheme.displayName = (0, _wrapDisplayName.default)(Component, 'WithTheme');
	    }
	
	    (0, _hoistNonReactStatics.default)(WithTheme, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithTheme.Naked = Component;
	    }
	
	    return WithTheme;
	  };
	};
	
	var _default = withTheme;
	exports.default = _default;

/***/ }),

/***/ 152:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionProps = getTransitionProps;
	exports.reflow = void 0;
	
	var reflow = function reflow(node) {
	  return node.scrollTop;
	};
	
	exports.reflow = reflow;
	
	function getTransitionProps(props, options) {
	  var timeout = props.timeout,
	      _props$style = props.style,
	      style = _props$style === void 0 ? {} : _props$style;
	  return {
	    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode],
	    delay: style.transitionDelay
	  };
	}

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.specialProperty = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(5));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(6));
	
	// This module is based on https://github.com/airbnb/prop-types-exact repository.
	// However, in order to reduce the number of dependencies and to remove some extra safe checks
	// the module was forked.
	// Only exported for test purposes.
	var specialProperty = "exact-prop: \u200B";
	exports.specialProperty = specialProperty;
	
	function exactProp(propTypes) {
	  /* istanbul ignore if */
	  if (true) {
	    return propTypes;
	  }
	
	  return (0, _extends3.default)({}, propTypes, (0, _defineProperty2.default)({}, specialProperty, function (props) {
	    var unsupportedProps = Object.keys(props).filter(function (prop) {
	      return !propTypes.hasOwnProperty(prop);
	    });
	
	    if (unsupportedProps.length > 0) {
	      return new Error("The following properties are not supported: ".concat(unsupportedProps.map(function (prop) {
	        return "`".concat(prop, "`");
	      }).join(', '), ". Please remove them."));
	    }
	
	    return null;
	  }));
	}
	
	var _default = exactProp;
	exports.default = _default;

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.capitalize = capitalize;
	exports.contains = contains;
	exports.findIndex = findIndex;
	exports.find = find;
	exports.createChainedFunction = createChainedFunction;
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(87));
	
	var _warning = _interopRequireDefault(__webpack_require__(15));
	
	function capitalize(string) {
	  if (false) {
	    throw new Error('Material-UI: capitalize(string) expects a string argument.');
	  }
	
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	function contains(obj, pred) {
	  return Object.keys(pred).every(function (key) {
	    return obj.hasOwnProperty(key) && obj[key] === pred[key];
	  });
	}
	
	function findIndex(arr, pred) {
	  var predType = (0, _typeof2.default)(pred);
	
	  for (var i = 0; i < arr.length; i += 1) {
	    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
	      return i;
	    }
	
	    if (predType === 'object' && contains(arr[i], pred)) {
	      return i;
	    }
	
	    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
	      return arr.indexOf(pred);
	    }
	  }
	
	  return -1;
	}
	
	function find(arr, pred) {
	  var index = findIndex(arr, pred);
	  return index > -1 ? arr[index] : undefined;
	}
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	
	
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.reduce(function (acc, func) {
	    if (func == null) {
	      return acc;
	    }
	
	     false ? (0, _warning.default)(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      func.apply(this, args);
	    };
	  }, function () {});
	}

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	var _default = ownerDocument;
	exports.default = _default;

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(37));
	
	function ownerWindow(node) {
	  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
	  var doc = (0, _ownerDocument.default)(node);
	  return doc.defaultView || doc.parentView || fallback;
	}
	
	var _default = ownerWindow;
	exports.default = _default;

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cloneElementWithClassName = cloneElementWithClassName;
	exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
	exports.isMuiElement = isMuiElement;
	exports.isMuiComponent = isMuiComponent;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(12));
	
	/* eslint-disable import/prefer-default-export */
	function cloneElementWithClassName(child, className) {
	  return _react.default.cloneElement(child, {
	    className: (0, _classnames.default)(child.props.className, className)
	  });
	}
	
	function cloneChildrenWithClassName(children, className) {
	  return _react.default.Children.map(children, function (child) {
	    return _react.default.isValidElement(child) && cloneElementWithClassName(child, className);
	  });
	}
	
	function isMuiElement(element, muiNames) {
	  return _react.default.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
	}
	
	function isMuiComponent(element, muiNames) {
	  return muiNames.indexOf(element.muiName) !== -1;
	}

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(38);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
	})), 'ArrowUpward');
	
	exports.default = _default;

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(38);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
	})), 'Close');
	
	exports.default = _default;

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(38);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
	})), 'Email');
	
	exports.default = _default;

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(38);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
	})), 'ExpandLess');
	
	exports.default = _default;

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(38);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
	})), 'FilterList');
	
	exports.default = _default;

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(38);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"
	})), 'FormatSize');
	
	exports.default = _default;

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(38);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
	})), 'Fullscreen');
	
	exports.default = _default;

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(38);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
	})), 'FullscreenExit');
	
	exports.default = _default;

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(38);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
	})), 'Home');
	
	exports.default = _default;

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(38);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	})), 'MoreVert');
	
	exports.default = _default;

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(38);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
	})), 'Search');
	
	exports.default = _default;

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(38);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _pure = _interopRequireDefault(__webpack_require__(305));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(216));
	
	function createSvgIcon(path, displayName) {
	  var Icon = function Icon(props) {
	    return _react.default.createElement(_SvgIcon.default, props, path);
	  };
	
	  Icon.displayName = displayName;
	  Icon = (0, _pure.default)(Icon);
	  Icon.muiName = 'SvgIcon';
	  return Icon;
	}
	
	;
	var _default = createSvgIcon;
	exports.default = _default;

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var cssKeywords = __webpack_require__(338);
	
	// NOTE: conversions should only return primitive values (i.e. arrays, or
	//       values that give correct `typeof` results).
	//       do not use box values types (i.e. Number(), String(), etc.)
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
		if (cssKeywords.hasOwnProperty(key)) {
			reverseKeywords[cssKeywords[key]] = key;
		}
	}
	
	var convert = module.exports = {
		rgb: {channels: 3, labels: 'rgb'},
		hsl: {channels: 3, labels: 'hsl'},
		hsv: {channels: 3, labels: 'hsv'},
		hwb: {channels: 3, labels: 'hwb'},
		cmyk: {channels: 4, labels: 'cmyk'},
		xyz: {channels: 3, labels: 'xyz'},
		lab: {channels: 3, labels: 'lab'},
		lch: {channels: 3, labels: 'lch'},
		hex: {channels: 1, labels: ['hex']},
		keyword: {channels: 1, labels: ['keyword']},
		ansi16: {channels: 1, labels: ['ansi16']},
		ansi256: {channels: 1, labels: ['ansi256']},
		hcg: {channels: 3, labels: ['h', 'c', 'g']},
		apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
		gray: {channels: 1, labels: ['gray']}
	};
	
	// hide .channels and .labels properties
	for (var model in convert) {
		if (convert.hasOwnProperty(model)) {
			if (!('channels' in convert[model])) {
				throw new Error('missing channels property: ' + model);
			}
	
			if (!('labels' in convert[model])) {
				throw new Error('missing channel labels property: ' + model);
			}
	
			if (convert[model].labels.length !== convert[model].channels) {
				throw new Error('channel and label counts mismatch: ' + model);
			}
	
			var channels = convert[model].channels;
			var labels = convert[model].labels;
			delete convert[model].channels;
			delete convert[model].labels;
			Object.defineProperty(convert[model], 'channels', {value: channels});
			Object.defineProperty(convert[model], 'labels', {value: labels});
		}
	}
	
	convert.rgb.hsl = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var l;
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		l = (min + max) / 2;
	
		if (max === min) {
			s = 0;
		} else if (l <= 0.5) {
			s = delta / (max + min);
		} else {
			s = delta / (2 - max - min);
		}
	
		return [h, s * 100, l * 100];
	};
	
	convert.rgb.hsv = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var v;
	
		if (max === 0) {
			s = 0;
		} else {
			s = (delta / max * 1000) / 10;
		}
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		v = ((max / 255) * 1000) / 10;
	
		return [h, s, v];
	};
	
	convert.rgb.hwb = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var h = convert.rgb.hsl(rgb)[0];
		var w = 1 / 255 * Math.min(r, Math.min(g, b));
	
		b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
	
		return [h, w * 100, b * 100];
	};
	
	convert.rgb.cmyk = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var c;
		var m;
		var y;
		var k;
	
		k = Math.min(1 - r, 1 - g, 1 - b);
		c = (1 - r - k) / (1 - k) || 0;
		m = (1 - g - k) / (1 - k) || 0;
		y = (1 - b - k) / (1 - k) || 0;
	
		return [c * 100, m * 100, y * 100, k * 100];
	};
	
	/**
	 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	 * */
	function comparativeDistance(x, y) {
		return (
			Math.pow(x[0] - y[0], 2) +
			Math.pow(x[1] - y[1], 2) +
			Math.pow(x[2] - y[2], 2)
		);
	}
	
	convert.rgb.keyword = function (rgb) {
		var reversed = reverseKeywords[rgb];
		if (reversed) {
			return reversed;
		}
	
		var currentClosestDistance = Infinity;
		var currentClosestKeyword;
	
		for (var keyword in cssKeywords) {
			if (cssKeywords.hasOwnProperty(keyword)) {
				var value = cssKeywords[keyword];
	
				// Compute comparative distance
				var distance = comparativeDistance(rgb, value);
	
				// Check if its less, if so set as closest
				if (distance < currentClosestDistance) {
					currentClosestDistance = distance;
					currentClosestKeyword = keyword;
				}
			}
		}
	
		return currentClosestKeyword;
	};
	
	convert.keyword.rgb = function (keyword) {
		return cssKeywords[keyword];
	};
	
	convert.rgb.xyz = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
	
		// assume sRGB
		r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
		g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
		b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
		var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
		var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
		var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
		return [x * 100, y * 100, z * 100];
	};
	
	convert.rgb.lab = function (rgb) {
		var xyz = convert.rgb.xyz(rgb);
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.hsl.rgb = function (hsl) {
		var h = hsl[0] / 360;
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var t1;
		var t2;
		var t3;
		var rgb;
		var val;
	
		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}
	
		if (l < 0.5) {
			t2 = l * (1 + s);
		} else {
			t2 = l + s - l * s;
		}
	
		t1 = 2 * l - t2;
	
		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * -(i - 1);
			if (t3 < 0) {
				t3++;
			}
			if (t3 > 1) {
				t3--;
			}
	
			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			} else if (2 * t3 < 1) {
				val = t2;
			} else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			} else {
				val = t1;
			}
	
			rgb[i] = val * 255;
		}
	
		return rgb;
	};
	
	convert.hsl.hsv = function (hsl) {
		var h = hsl[0];
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var smin = s;
		var lmin = Math.max(l, 0.01);
		var sv;
		var v;
	
		l *= 2;
		s *= (l <= 1) ? l : 2 - l;
		smin *= lmin <= 1 ? lmin : 2 - lmin;
		v = (l + s) / 2;
		sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);
	
		return [h, sv * 100, v * 100];
	};
	
	convert.hsv.rgb = function (hsv) {
		var h = hsv[0] / 60;
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var hi = Math.floor(h) % 6;
	
		var f = h - Math.floor(h);
		var p = 255 * v * (1 - s);
		var q = 255 * v * (1 - (s * f));
		var t = 255 * v * (1 - (s * (1 - f)));
		v *= 255;
	
		switch (hi) {
			case 0:
				return [v, t, p];
			case 1:
				return [q, v, p];
			case 2:
				return [p, v, t];
			case 3:
				return [p, q, v];
			case 4:
				return [t, p, v];
			case 5:
				return [v, p, q];
		}
	};
	
	convert.hsv.hsl = function (hsv) {
		var h = hsv[0];
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var vmin = Math.max(v, 0.01);
		var lmin;
		var sl;
		var l;
	
		l = (2 - s) * v;
		lmin = (2 - s) * vmin;
		sl = s * vmin;
		sl /= (lmin <= 1) ? lmin : 2 - lmin;
		sl = sl || 0;
		l /= 2;
	
		return [h, sl * 100, l * 100];
	};
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	convert.hwb.rgb = function (hwb) {
		var h = hwb[0] / 360;
		var wh = hwb[1] / 100;
		var bl = hwb[2] / 100;
		var ratio = wh + bl;
		var i;
		var v;
		var f;
		var n;
	
		// wh + bl cant be > 1
		if (ratio > 1) {
			wh /= ratio;
			bl /= ratio;
		}
	
		i = Math.floor(6 * h);
		v = 1 - bl;
		f = 6 * h - i;
	
		if ((i & 0x01) !== 0) {
			f = 1 - f;
		}
	
		n = wh + f * (v - wh); // linear interpolation
	
		var r;
		var g;
		var b;
		switch (i) {
			default:
			case 6:
			case 0: r = v; g = n; b = wh; break;
			case 1: r = n; g = v; b = wh; break;
			case 2: r = wh; g = v; b = n; break;
			case 3: r = wh; g = n; b = v; break;
			case 4: r = n; g = wh; b = v; break;
			case 5: r = v; g = wh; b = n; break;
		}
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.cmyk.rgb = function (cmyk) {
		var c = cmyk[0] / 100;
		var m = cmyk[1] / 100;
		var y = cmyk[2] / 100;
		var k = cmyk[3] / 100;
		var r;
		var g;
		var b;
	
		r = 1 - Math.min(1, c * (1 - k) + k);
		g = 1 - Math.min(1, m * (1 - k) + k);
		b = 1 - Math.min(1, y * (1 - k) + k);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.rgb = function (xyz) {
		var x = xyz[0] / 100;
		var y = xyz[1] / 100;
		var z = xyz[2] / 100;
		var r;
		var g;
		var b;
	
		r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
		g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
		b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
		// assume sRGB
		r = r > 0.0031308
			? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
			: r * 12.92;
	
		g = g > 0.0031308
			? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
			: g * 12.92;
	
		b = b > 0.0031308
			? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
			: b * 12.92;
	
		r = Math.min(Math.max(0, r), 1);
		g = Math.min(Math.max(0, g), 1);
		b = Math.min(Math.max(0, b), 1);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.lab = function (xyz) {
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.lab.xyz = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var x;
		var y;
		var z;
	
		y = (l + 16) / 116;
		x = a / 500 + y;
		z = y - b / 200;
	
		var y2 = Math.pow(y, 3);
		var x2 = Math.pow(x, 3);
		var z2 = Math.pow(z, 3);
		y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
		x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
		z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
	
		x *= 95.047;
		y *= 100;
		z *= 108.883;
	
		return [x, y, z];
	};
	
	convert.lab.lch = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var hr;
		var h;
		var c;
	
		hr = Math.atan2(b, a);
		h = hr * 360 / 2 / Math.PI;
	
		if (h < 0) {
			h += 360;
		}
	
		c = Math.sqrt(a * a + b * b);
	
		return [l, c, h];
	};
	
	convert.lch.lab = function (lch) {
		var l = lch[0];
		var c = lch[1];
		var h = lch[2];
		var a;
		var b;
		var hr;
	
		hr = h / 360 * 2 * Math.PI;
		a = c * Math.cos(hr);
		b = c * Math.sin(hr);
	
		return [l, a, b];
	};
	
	convert.rgb.ansi16 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
	
		value = Math.round(value / 50);
	
		if (value === 0) {
			return 30;
		}
	
		var ansi = 30
			+ ((Math.round(b / 255) << 2)
			| (Math.round(g / 255) << 1)
			| Math.round(r / 255));
	
		if (value === 2) {
			ansi += 60;
		}
	
		return ansi;
	};
	
	convert.hsv.ansi16 = function (args) {
		// optimization here; we already know the value and don't need to get
		// it converted for us.
		return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
	};
	
	convert.rgb.ansi256 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
	
		// we use the extended greyscale palette here, with the exception of
		// black and white. normal palette only has 4 greyscale shades.
		if (r === g && g === b) {
			if (r < 8) {
				return 16;
			}
	
			if (r > 248) {
				return 231;
			}
	
			return Math.round(((r - 8) / 247) * 24) + 232;
		}
	
		var ansi = 16
			+ (36 * Math.round(r / 255 * 5))
			+ (6 * Math.round(g / 255 * 5))
			+ Math.round(b / 255 * 5);
	
		return ansi;
	};
	
	convert.ansi16.rgb = function (args) {
		var color = args % 10;
	
		// handle greyscale
		if (color === 0 || color === 7) {
			if (args > 50) {
				color += 3.5;
			}
	
			color = color / 10.5 * 255;
	
			return [color, color, color];
		}
	
		var mult = (~~(args > 50) + 1) * 0.5;
		var r = ((color & 1) * mult) * 255;
		var g = (((color >> 1) & 1) * mult) * 255;
		var b = (((color >> 2) & 1) * mult) * 255;
	
		return [r, g, b];
	};
	
	convert.ansi256.rgb = function (args) {
		// handle greyscale
		if (args >= 232) {
			var c = (args - 232) * 10 + 8;
			return [c, c, c];
		}
	
		args -= 16;
	
		var rem;
		var r = Math.floor(args / 36) / 5 * 255;
		var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
		var b = (rem % 6) / 5 * 255;
	
		return [r, g, b];
	};
	
	convert.rgb.hex = function (args) {
		var integer = ((Math.round(args[0]) & 0xFF) << 16)
			+ ((Math.round(args[1]) & 0xFF) << 8)
			+ (Math.round(args[2]) & 0xFF);
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.hex.rgb = function (args) {
		var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
		if (!match) {
			return [0, 0, 0];
		}
	
		var colorString = match[0];
	
		if (match[0].length === 3) {
			colorString = colorString.split('').map(function (char) {
				return char + char;
			}).join('');
		}
	
		var integer = parseInt(colorString, 16);
		var r = (integer >> 16) & 0xFF;
		var g = (integer >> 8) & 0xFF;
		var b = integer & 0xFF;
	
		return [r, g, b];
	};
	
	convert.rgb.hcg = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var max = Math.max(Math.max(r, g), b);
		var min = Math.min(Math.min(r, g), b);
		var chroma = (max - min);
		var grayscale;
		var hue;
	
		if (chroma < 1) {
			grayscale = min / (1 - chroma);
		} else {
			grayscale = 0;
		}
	
		if (chroma <= 0) {
			hue = 0;
		} else
		if (max === r) {
			hue = ((g - b) / chroma) % 6;
		} else
		if (max === g) {
			hue = 2 + (b - r) / chroma;
		} else {
			hue = 4 + (r - g) / chroma + 4;
		}
	
		hue /= 6;
		hue %= 1;
	
		return [hue * 360, chroma * 100, grayscale * 100];
	};
	
	convert.hsl.hcg = function (hsl) {
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var c = 1;
		var f = 0;
	
		if (l < 0.5) {
			c = 2.0 * s * l;
		} else {
			c = 2.0 * s * (1.0 - l);
		}
	
		if (c < 1.0) {
			f = (l - 0.5 * c) / (1.0 - c);
		}
	
		return [hsl[0], c * 100, f * 100];
	};
	
	convert.hsv.hcg = function (hsv) {
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
	
		var c = s * v;
		var f = 0;
	
		if (c < 1.0) {
			f = (v - c) / (1 - c);
		}
	
		return [hsv[0], c * 100, f * 100];
	};
	
	convert.hcg.rgb = function (hcg) {
		var h = hcg[0] / 360;
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		if (c === 0.0) {
			return [g * 255, g * 255, g * 255];
		}
	
		var pure = [0, 0, 0];
		var hi = (h % 1) * 6;
		var v = hi % 1;
		var w = 1 - v;
		var mg = 0;
	
		switch (Math.floor(hi)) {
			case 0:
				pure[0] = 1; pure[1] = v; pure[2] = 0; break;
			case 1:
				pure[0] = w; pure[1] = 1; pure[2] = 0; break;
			case 2:
				pure[0] = 0; pure[1] = 1; pure[2] = v; break;
			case 3:
				pure[0] = 0; pure[1] = w; pure[2] = 1; break;
			case 4:
				pure[0] = v; pure[1] = 0; pure[2] = 1; break;
			default:
				pure[0] = 1; pure[1] = 0; pure[2] = w;
		}
	
		mg = (1.0 - c) * g;
	
		return [
			(c * pure[0] + mg) * 255,
			(c * pure[1] + mg) * 255,
			(c * pure[2] + mg) * 255
		];
	};
	
	convert.hcg.hsv = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var v = c + g * (1.0 - c);
		var f = 0;
	
		if (v > 0.0) {
			f = c / v;
		}
	
		return [hcg[0], f * 100, v * 100];
	};
	
	convert.hcg.hsl = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var l = g * (1.0 - c) + 0.5 * c;
		var s = 0;
	
		if (l > 0.0 && l < 0.5) {
			s = c / (2 * l);
		} else
		if (l >= 0.5 && l < 1.0) {
			s = c / (2 * (1 - l));
		}
	
		return [hcg[0], s * 100, l * 100];
	};
	
	convert.hcg.hwb = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
		var v = c + g * (1.0 - c);
		return [hcg[0], (v - c) * 100, (1 - v) * 100];
	};
	
	convert.hwb.hcg = function (hwb) {
		var w = hwb[1] / 100;
		var b = hwb[2] / 100;
		var v = 1 - b;
		var c = v - w;
		var g = 0;
	
		if (c < 1) {
			g = (v - c) / (1 - c);
		}
	
		return [hwb[0], c * 100, g * 100];
	};
	
	convert.apple.rgb = function (apple) {
		return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
	};
	
	convert.rgb.apple = function (rgb) {
		return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
	};
	
	convert.gray.rgb = function (args) {
		return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
	};
	
	convert.gray.hsl = convert.gray.hsv = function (args) {
		return [0, 0, args[0]];
	};
	
	convert.gray.hwb = function (gray) {
		return [0, 100, gray[0]];
	};
	
	convert.gray.cmyk = function (gray) {
		return [0, 0, 0, gray[0]];
	};
	
	convert.gray.lab = function (gray) {
		return [gray[0], 0, 0];
	};
	
	convert.gray.hex = function (gray) {
		var val = Math.round(gray[0] / 100 * 255) & 0xFF;
		var integer = (val << 16) + (val << 8) + val;
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.rgb.gray = function (rgb) {
		var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
		return [val / 255 * 100];
	};


/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(337);
	var route = __webpack_require__(646);
	
	var convert = {};
	
	var models = Object.keys(conversions);
	
	function wrapRaw(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			return fn(args);
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	function wrapRounded(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			var result = fn(args);
	
			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if (typeof result === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}
	
			return result;
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	models.forEach(function (fromModel) {
		convert[fromModel] = {};
	
		Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
		Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});
	
		var routes = route(fromModel);
		var routeModels = Object.keys(routes);
	
		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];
	
			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});
	
	module.exports = convert;


/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(337);
	
	/*
		this function routes a model to all other models.
	
		all functions that are routed have a property `.conversion` attached
		to the returned synthetic function. This property is an array
		of strings, each with the steps in between the 'from' and 'to'
		color models (inclusive).
	
		conversions that are not possible simply are not included.
	*/
	
	function buildGraph() {
		var graph = {};
		// https://jsperf.com/object-keys-vs-for-in-with-closure/3
		var models = Object.keys(conversions);
	
		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}
	
		return graph;
	}
	
	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop
	
		graph[fromModel].distance = 0;
	
		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions[current]);
	
			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];
	
				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}
	
		return graph;
	}
	
	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}
	
	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions[graph[toModel].parent][toModel];
	
		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}
	
		fn.conversion = path;
		return fn;
	}
	
	module.exports = function (fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};
	
		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];
	
			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}
	
			conversion[toModel] = wrapConversion(toModel, graph);
		}
	
		return conversion;
	};
	


/***/ }),

/***/ 338:
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};


/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var colorString = __webpack_require__(648);
	var convert = __webpack_require__(645);
	
	var _slice = [].slice;
	
	var skippedModels = [
		// to be honest, I don't really feel like keyword belongs in color convert, but eh.
		'keyword',
	
		// gray conflicts with some method names, and has its own method defined.
		'gray',
	
		// shouldn't really be in color-convert either...
		'hex'
	];
	
	var hashedModelKeys = {};
	Object.keys(convert).forEach(function (model) {
		hashedModelKeys[_slice.call(convert[model].labels).sort().join('')] = model;
	});
	
	var limiters = {};
	
	function Color(obj, model) {
		if (!(this instanceof Color)) {
			return new Color(obj, model);
		}
	
		if (model && model in skippedModels) {
			model = null;
		}
	
		if (model && !(model in convert)) {
			throw new Error('Unknown model: ' + model);
		}
	
		var i;
		var channels;
	
		if (!obj) {
			this.model = 'rgb';
			this.color = [0, 0, 0];
			this.valpha = 1;
		} else if (obj instanceof Color) {
			this.model = obj.model;
			this.color = obj.color.slice();
			this.valpha = obj.valpha;
		} else if (typeof obj === 'string') {
			var result = colorString.get(obj);
			if (result === null) {
				throw new Error('Unable to parse color from string: ' + obj);
			}
	
			this.model = result.model;
			channels = convert[this.model].channels;
			this.color = result.value.slice(0, channels);
			this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
		} else if (obj.length) {
			this.model = model || 'rgb';
			channels = convert[this.model].channels;
			var newArr = _slice.call(obj, 0, channels);
			this.color = zeroArray(newArr, channels);
			this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
		} else if (typeof obj === 'number') {
			// this is always RGB - can be converted later on.
			obj &= 0xFFFFFF;
			this.model = 'rgb';
			this.color = [
				(obj >> 16) & 0xFF,
				(obj >> 8) & 0xFF,
				obj & 0xFF
			];
			this.valpha = 1;
		} else {
			this.valpha = 1;
	
			var keys = Object.keys(obj);
			if ('alpha' in obj) {
				keys.splice(keys.indexOf('alpha'), 1);
				this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
			}
	
			var hashedKeys = keys.sort().join('');
			if (!(hashedKeys in hashedModelKeys)) {
				throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
			}
	
			this.model = hashedModelKeys[hashedKeys];
	
			var labels = convert[this.model].labels;
			var color = [];
			for (i = 0; i < labels.length; i++) {
				color.push(obj[labels[i]]);
			}
	
			this.color = zeroArray(color);
		}
	
		// perform limitations (clamping, etc.)
		if (limiters[this.model]) {
			channels = convert[this.model].channels;
			for (i = 0; i < channels; i++) {
				var limit = limiters[this.model][i];
				if (limit) {
					this.color[i] = limit(this.color[i]);
				}
			}
		}
	
		this.valpha = Math.max(0, Math.min(1, this.valpha));
	
		if (Object.freeze) {
			Object.freeze(this);
		}
	}
	
	Color.prototype = {
		toString: function () {
			return this.string();
		},
	
		toJSON: function () {
			return this[this.model]();
		},
	
		string: function (places) {
			var self = this.model in colorString.to ? this : this.rgb();
			self = self.round(typeof places === 'number' ? places : 1);
			var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
			return colorString.to[self.model](args);
		},
	
		percentString: function (places) {
			var self = this.rgb().round(typeof places === 'number' ? places : 1);
			var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
			return colorString.to.rgb.percent(args);
		},
	
		array: function () {
			return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
		},
	
		object: function () {
			var result = {};
			var channels = convert[this.model].channels;
			var labels = convert[this.model].labels;
	
			for (var i = 0; i < channels; i++) {
				result[labels[i]] = this.color[i];
			}
	
			if (this.valpha !== 1) {
				result.alpha = this.valpha;
			}
	
			return result;
		},
	
		unitArray: function () {
			var rgb = this.rgb().color;
			rgb[0] /= 255;
			rgb[1] /= 255;
			rgb[2] /= 255;
	
			if (this.valpha !== 1) {
				rgb.push(this.valpha);
			}
	
			return rgb;
		},
	
		unitObject: function () {
			var rgb = this.rgb().object();
			rgb.r /= 255;
			rgb.g /= 255;
			rgb.b /= 255;
	
			if (this.valpha !== 1) {
				rgb.alpha = this.valpha;
			}
	
			return rgb;
		},
	
		round: function (places) {
			places = Math.max(places || 0, 0);
			return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
		},
	
		alpha: function (val) {
			if (arguments.length) {
				return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
			}
	
			return this.valpha;
		},
	
		// rgb
		red: getset('rgb', 0, maxfn(255)),
		green: getset('rgb', 1, maxfn(255)),
		blue: getset('rgb', 2, maxfn(255)),
	
		hue: getset(['hsl', 'hsv', 'hsl', 'hwb', 'hcg'], 0, function (val) { return ((val % 360) + 360) % 360; }), // eslint-disable-line brace-style
	
		saturationl: getset('hsl', 1, maxfn(100)),
		lightness: getset('hsl', 2, maxfn(100)),
	
		saturationv: getset('hsv', 1, maxfn(100)),
		value: getset('hsv', 2, maxfn(100)),
	
		chroma: getset('hcg', 1, maxfn(100)),
		gray: getset('hcg', 2, maxfn(100)),
	
		white: getset('hwb', 1, maxfn(100)),
		wblack: getset('hwb', 2, maxfn(100)),
	
		cyan: getset('cmyk', 0, maxfn(100)),
		magenta: getset('cmyk', 1, maxfn(100)),
		yellow: getset('cmyk', 2, maxfn(100)),
		black: getset('cmyk', 3, maxfn(100)),
	
		x: getset('xyz', 0, maxfn(100)),
		y: getset('xyz', 1, maxfn(100)),
		z: getset('xyz', 2, maxfn(100)),
	
		l: getset('lab', 0, maxfn(100)),
		a: getset('lab', 1),
		b: getset('lab', 2),
	
		keyword: function (val) {
			if (arguments.length) {
				return new Color(val);
			}
	
			return convert[this.model].keyword(this.color);
		},
	
		hex: function (val) {
			if (arguments.length) {
				return new Color(val);
			}
	
			return colorString.to.hex(this.rgb().round().color);
		},
	
		rgbNumber: function () {
			var rgb = this.rgb().color;
			return ((rgb[0] & 0xFF) << 16) | ((rgb[1] & 0xFF) << 8) | (rgb[2] & 0xFF);
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.rgb().color;
	
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
	
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
	
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
	
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		isDark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.rgb().color;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		isLight: function () {
			return !this.isDark();
		},
	
		negate: function () {
			var rgb = this.rgb();
			for (var i = 0; i < 3; i++) {
				rgb.color[i] = 255 - rgb.color[i];
			}
			return rgb;
		},
	
		lighten: function (ratio) {
			var hsl = this.hsl();
			hsl.color[2] += hsl.color[2] * ratio;
			return hsl;
		},
	
		darken: function (ratio) {
			var hsl = this.hsl();
			hsl.color[2] -= hsl.color[2] * ratio;
			return hsl;
		},
	
		saturate: function (ratio) {
			var hsl = this.hsl();
			hsl.color[1] += hsl.color[1] * ratio;
			return hsl;
		},
	
		desaturate: function (ratio) {
			var hsl = this.hsl();
			hsl.color[1] -= hsl.color[1] * ratio;
			return hsl;
		},
	
		whiten: function (ratio) {
			var hwb = this.hwb();
			hwb.color[1] += hwb.color[1] * ratio;
			return hwb;
		},
	
		blacken: function (ratio) {
			var hwb = this.hwb();
			hwb.color[2] += hwb.color[2] * ratio;
			return hwb;
		},
	
		grayscale: function () {
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var rgb = this.rgb().color;
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			return Color.rgb(val, val, val);
		},
	
		fade: function (ratio) {
			return this.alpha(this.valpha - (this.valpha * ratio));
		},
	
		opaquer: function (ratio) {
			return this.alpha(this.valpha + (this.valpha * ratio));
		},
	
		rotate: function (degrees) {
			var hsl = this.hsl();
			var hue = hsl.color[0];
			hue = (hue + degrees) % 360;
			hue = hue < 0 ? 360 + hue : hue;
			hsl.color[0] = hue;
			return hsl;
		},
	
		mix: function (mixinColor, weight) {
			// ported from sass implementation in C
			// https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
			var color1 = mixinColor.rgb();
			var color2 = this.rgb();
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return Color.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue(),
					color1.alpha() * p + color2.alpha() * (1 - p));
		}
	};
	
	// model conversion methods and static constructors
	Object.keys(convert).forEach(function (model) {
		if (skippedModels.indexOf(model) !== -1) {
			return;
		}
	
		var channels = convert[model].channels;
	
		// conversion methods
		Color.prototype[model] = function () {
			if (this.model === model) {
				return new Color(this);
			}
	
			if (arguments.length) {
				return new Color(arguments, model);
			}
	
			var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
			return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
		};
	
		// 'static' construction methods
		Color[model] = function (color) {
			if (typeof color === 'number') {
				color = zeroArray(_slice.call(arguments), channels);
			}
			return new Color(color, model);
		};
	});
	
	function roundTo(num, places) {
		return Number(num.toFixed(places));
	}
	
	function roundToPlace(places) {
		return function (num) {
			return roundTo(num, places);
		};
	}
	
	function getset(model, channel, modifier) {
		model = Array.isArray(model) ? model : [model];
	
		model.forEach(function (m) {
			(limiters[m] || (limiters[m] = []))[channel] = modifier;
		});
	
		model = model[0];
	
		return function (val) {
			var result;
	
			if (arguments.length) {
				if (modifier) {
					val = modifier(val);
				}
	
				result = this[model]();
				result.color[channel] = val;
				return result;
			}
	
			result = this[model]().color[channel];
			if (modifier) {
				result = modifier(result);
			}
	
			return result;
		};
	}
	
	function maxfn(max) {
		return function (v) {
			return Math.max(0, Math.min(max, v));
		};
	}
	
	function assertArray(val) {
		return Array.isArray(val) ? val : [val];
	}
	
	function zeroArray(arr, length) {
		for (var i = 0; i < length; i++) {
			if (typeof arr[i] !== 'number') {
				arr[i] = 0;
			}
		}
	
		return arr;
	}
	
	module.exports = Color;


/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(338);
	var swizzle = __webpack_require__(2254);
	
	var reverseNames = {};
	
	// create a list of reverse color names
	for (var name in colorNames) {
		if (colorNames.hasOwnProperty(name)) {
			reverseNames[colorNames[name]] = name;
		}
	}
	
	var cs = module.exports = {
		to: {}
	};
	
	cs.get = function (string) {
		var prefix = string.substring(0, 3).toLowerCase();
		var val;
		var model;
		switch (prefix) {
			case 'hsl':
				val = cs.get.hsl(string);
				model = 'hsl';
				break;
			case 'hwb':
				val = cs.get.hwb(string);
				model = 'hwb';
				break;
			default:
				val = cs.get.rgb(string);
				model = 'rgb';
				break;
		}
	
		if (!val) {
			return null;
		}
	
		return {model: model, value: val};
	};
	
	cs.get.rgb = function (string) {
		if (!string) {
			return null;
		}
	
		var abbr = /^#([a-f0-9]{3,4})$/i;
		var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
		var rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var keyword = /(\D+)/;
	
		var rgb = [0, 0, 0, 1];
		var match;
		var i;
		var hexAlpha;
	
		if (match = string.match(hex)) {
			hexAlpha = match[2];
			match = match[1];
	
			for (i = 0; i < 3; i++) {
				// https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
				var i2 = i * 2;
				rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
			}
	
			if (hexAlpha) {
				rgb[3] = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
			}
		} else if (match = string.match(abbr)) {
			match = match[1];
			hexAlpha = match[3];
	
			for (i = 0; i < 3; i++) {
				rgb[i] = parseInt(match[i] + match[i], 16);
			}
	
			if (hexAlpha) {
				rgb[3] = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
			}
		} else if (match = string.match(rgba)) {
			for (i = 0; i < 3; i++) {
				rgb[i] = parseInt(match[i + 1], 0);
			}
	
			if (match[4]) {
				rgb[3] = parseFloat(match[4]);
			}
		} else if (match = string.match(per)) {
			for (i = 0; i < 3; i++) {
				rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
			}
	
			if (match[4]) {
				rgb[3] = parseFloat(match[4]);
			}
		} else if (match = string.match(keyword)) {
			if (match[1] === 'transparent') {
				return [0, 0, 0, 0];
			}
	
			rgb = colorNames[match[1]];
	
			if (!rgb) {
				return null;
			}
	
			rgb[3] = 1;
	
			return rgb;
		} else {
			return null;
		}
	
		for (i = 0; i < 3; i++) {
			rgb[i] = clamp(rgb[i], 0, 255);
		}
		rgb[3] = clamp(rgb[3], 0, 1);
	
		return rgb;
	};
	
	cs.get.hsl = function (string) {
		if (!string) {
			return null;
		}
	
		var hsl = /^hsla?\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var match = string.match(hsl);
	
		if (match) {
			var alpha = parseFloat(match[4]);
			var h = ((parseFloat(match[1]) % 360) + 360) % 360;
			var s = clamp(parseFloat(match[2]), 0, 100);
			var l = clamp(parseFloat(match[3]), 0, 100);
			var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
	
			return [h, s, l, a];
		}
	
		return null;
	};
	
	cs.get.hwb = function (string) {
		if (!string) {
			return null;
		}
	
		var hwb = /^hwb\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var match = string.match(hwb);
	
		if (match) {
			var alpha = parseFloat(match[4]);
			var h = ((parseFloat(match[1]) % 360) + 360) % 360;
			var w = clamp(parseFloat(match[2]), 0, 100);
			var b = clamp(parseFloat(match[3]), 0, 100);
			var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
			return [h, w, b, a];
		}
	
		return null;
	};
	
	cs.to.hex = function () {
		var rgba = swizzle(arguments);
	
		return (
			'#' +
			hexDouble(rgba[0]) +
			hexDouble(rgba[1]) +
			hexDouble(rgba[2]) +
			(rgba[3] < 1
				? (hexDouble(Math.round(rgba[3] * 255)))
				: '')
		);
	};
	
	cs.to.rgb = function () {
		var rgba = swizzle(arguments);
	
		return rgba.length < 4 || rgba[3] === 1
			? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')'
			: 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
	};
	
	cs.to.rgb.percent = function () {
		var rgba = swizzle(arguments);
	
		var r = Math.round(rgba[0] / 255 * 100);
		var g = Math.round(rgba[1] / 255 * 100);
		var b = Math.round(rgba[2] / 255 * 100);
	
		return rgba.length < 4 || rgba[3] === 1
			? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)'
			: 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
	};
	
	cs.to.hsl = function () {
		var hsla = swizzle(arguments);
		return hsla.length < 4 || hsla[3] === 1
			? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)'
			: 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
	};
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	cs.to.hwb = function () {
		var hwba = swizzle(arguments);
	
		var a = '';
		if (hwba.length >= 4 && hwba[3] !== 1) {
			a = ', ' + hwba[3];
		}
	
		return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
	};
	
	cs.to.keyword = function (rgb) {
		return reverseNames[rgb.slice(0, 3)];
	};
	
	// helpers
	function clamp(num, min, max) {
		return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
		var str = num.toString(16).toUpperCase();
		return (str.length < 2) ? '0' + str : str;
	}


/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	exports = module.exports = function(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ }),

/***/ 2015:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.15.0
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	
	var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	var timeoutDuration = 0;
	for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	    timeoutDuration = 1;
	    break;
	  }
	}
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.right - result.left;
	  var height = sizes.height || element.clientHeight || result.bottom - result.top;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop, 10);
	    var marginLeft = parseFloat(styles.marginLeft, 10);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicity asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var react = __webpack_require__(2);
	var PropTypes = _interopDefault(__webpack_require__(4));
	var PopperJS = _interopDefault(__webpack_require__(2015));
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var Manager = function (_Component) {
	  inherits(Manager, _Component);
	
	  function Manager() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Manager);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
	      _this._targetNode = node;
	    }, _this._getTargetNode = function () {
	      return _this._targetNode;
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  createClass(Manager, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popperManager: {
	          setTargetNode: this._setTargetNode,
	          getTargetNode: this._getTargetNode
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tag = _props.tag,
	          children = _props.children,
	          restProps = objectWithoutProperties(_props, ['tag', 'children']);
	
	      if (tag !== false) {
	        return react.createElement(tag, restProps, children);
	      } else {
	        return children;
	      }
	    }
	  }]);
	  return Manager;
	}(react.Component);
	
	Manager.childContextTypes = {
	  popperManager: PropTypes.object.isRequired
	};
	Manager.propTypes = {
	  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	Manager.defaultProps = {
	  tag: 'div'
	};
	
	var Target = function Target(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'div' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	  var popperManager = context.popperManager;
	
	  var targetRef = function targetRef(node) {
	    popperManager.setTargetNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	
	  if (typeof children === 'function') {
	    var targetProps = { ref: targetRef };
	    return children({ targetProps: targetProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps);
	
	  if (typeof component === 'string') {
	    componentProps.ref = targetRef;
	  } else {
	    componentProps.innerRef = targetRef;
	  }
	
	  return react.createElement(component, componentProps, children);
	};
	
	Target.contextTypes = {
	  popperManager: PropTypes.object.isRequired
	};
	
	Target.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	
	var placements = PopperJS.placements;
	
	var Popper = function (_Component) {
	  inherits(Popper, _Component);
	
	  function Popper() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Popper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
	      _this._arrowNode = node;
	    }, _this._getTargetNode = function () {
	      if (_this.props.target) {
	        return _this.props.target;
	      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
	        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
	      }
	      return _this.context.popperManager.getTargetNode();
	    }, _this._getOffsets = function (data) {
	      return Object.keys(data.offsets).map(function (key) {
	        return data.offsets[key];
	      });
	    }, _this._isDataDirty = function (data) {
	      if (_this.state.data) {
	        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
	      } else {
	        return true;
	      }
	    }, _this._updateStateModifier = {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        if (_this._isDataDirty(data)) {
	          _this.setState({ data: data });
	        }
	        return data;
	      }
	    }, _this._getPopperStyle = function () {
	      var data = _this.state.data;
	
	
	      if (!_this._popper || !data) {
	        return {
	          position: 'absolute',
	          pointerEvents: 'none',
	          opacity: 0
	        };
	      }
	
	      return _extends({
	        position: data.offsets.popper.position
	      }, data.styles);
	    }, _this._getPopperPlacement = function () {
	      return _this.state.data ? _this.state.data.placement : undefined;
	    }, _this._getPopperHide = function () {
	      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
	    }, _this._getArrowStyle = function () {
	      if (!_this.state.data || !_this.state.data.offsets.arrow) {
	        return {};
	      } else {
	        var _this$state$data$offs = _this.state.data.offsets.arrow,
	            top = _this$state$data$offs.top,
	            left = _this$state$data$offs.left;
	
	        return { top: top, left: left };
	      }
	    }, _this._handlePopperRef = function (node) {
	      _this._popperNode = node;
	      if (node) {
	        _this._createPopper();
	      } else {
	        _this._destroyPopper();
	      }
	      if (_this.props.innerRef) {
	        _this.props.innerRef(node);
	      }
	    }, _this._scheduleUpdate = function () {
	      _this._popper && _this._popper.scheduleUpdate();
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  createClass(Popper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popper: {
	          setArrowNode: this._setArrowNode,
	          getArrowStyle: this._getArrowStyle
	        }
	      };
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(lastProps) {
	      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
	        this._destroyPopper();
	        this._createPopper();
	      }
	      if (lastProps.children !== this.props.children) {
	        this._scheduleUpdate();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._destroyPopper();
	    }
	  }, {
	    key: '_createPopper',
	    value: function _createPopper() {
	      var _this2 = this;
	
	      var _props = this.props,
	          placement = _props.placement,
	          eventsEnabled = _props.eventsEnabled,
	          positionFixed = _props.positionFixed;
	
	      var modifiers = _extends({}, this.props.modifiers, {
	        applyStyle: { enabled: false },
	        updateState: this._updateStateModifier
	      });
	      if (this._arrowNode) {
	        modifiers.arrow = _extends({}, this.props.modifiers.arrow || {}, {
	          element: this._arrowNode
	        });
	      }
	      this._popper = new PopperJS(this._getTargetNode(), this._popperNode, {
	        placement: placement,
	        positionFixed: positionFixed,
	        eventsEnabled: eventsEnabled,
	        modifiers: modifiers
	      });
	
	      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
	      setTimeout(function () {
	        return _this2._scheduleUpdate();
	      });
	    }
	  }, {
	    key: '_destroyPopper',
	    value: function _destroyPopper() {
	      if (this._popper) {
	        this._popper.destroy();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          component = _props2.component,
	          innerRef = _props2.innerRef,
	          placement = _props2.placement,
	          eventsEnabled = _props2.eventsEnabled,
	          positionFixed = _props2.positionFixed,
	          modifiers = _props2.modifiers,
	          children = _props2.children,
	          restProps = objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'positionFixed', 'modifiers', 'children']);
	
	      var popperStyle = this._getPopperStyle();
	      var popperPlacement = this._getPopperPlacement();
	      var popperHide = this._getPopperHide();
	
	      if (typeof children === 'function') {
	        var popperProps = {
	          ref: this._handlePopperRef,
	          style: popperStyle,
	          'data-placement': popperPlacement,
	          'data-x-out-of-boundaries': popperHide
	        };
	        return children({
	          popperProps: popperProps,
	          restProps: restProps,
	          scheduleUpdate: this._scheduleUpdate
	        });
	      }
	
	      var componentProps = _extends({}, restProps, {
	        style: _extends({}, restProps.style, popperStyle),
	        'data-placement': popperPlacement,
	        'data-x-out-of-boundaries': popperHide
	      });
	
	      if (typeof component === 'string') {
	        componentProps.ref = this._handlePopperRef;
	      } else {
	        componentProps.innerRef = this._handlePopperRef;
	      }
	
	      return react.createElement(component, componentProps, children);
	    }
	  }]);
	  return Popper;
	}(react.Component);
	
	Popper.contextTypes = {
	  popperManager: PropTypes.object
	};
	Popper.childContextTypes = {
	  popper: PropTypes.object.isRequired
	};
	Popper.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  placement: PropTypes.oneOf(placements),
	  eventsEnabled: PropTypes.bool,
	  positionFixed: PropTypes.bool,
	  modifiers: PropTypes.object,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  target: PropTypes.oneOfType([
	  // the following check is needed for SSR
	  PropTypes.instanceOf(typeof Element !== 'undefined' ? Element : Object), PropTypes.shape({
	    getBoundingClientRect: PropTypes.func.isRequired,
	    clientWidth: PropTypes.number.isRequired,
	    clientHeight: PropTypes.number.isRequired
	  })])
	};
	Popper.defaultProps = {
	  component: 'div',
	  placement: 'bottom',
	  eventsEnabled: true,
	  positionFixed: false,
	  modifiers: {}
	};
	
	var Arrow = function Arrow(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'span' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	  var popper = context.popper;
	
	  var arrowRef = function arrowRef(node) {
	    popper.setArrowNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	  var arrowStyle = popper.getArrowStyle();
	
	  if (typeof children === 'function') {
	    var arrowProps = {
	      ref: arrowRef,
	      style: arrowStyle
	    };
	    return children({ arrowProps: arrowProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps, {
	    style: _extends({}, arrowStyle, restProps.style)
	  });
	
	  if (typeof component === 'string') {
	    componentProps.ref = arrowRef;
	  } else {
	    componentProps.innerRef = arrowRef;
	  }
	
	  return react.createElement(component, componentProps, children);
	};
	
	Arrow.contextTypes = {
	  popper: PropTypes.object.isRequired
	};
	
	Arrow.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	
	exports.Manager = Manager;
	exports.Target = Target;
	exports.Popper = Popper;
	exports.placements = placements;
	exports.Arrow = Arrow;
	//# sourceMappingURL=react-popper.js.map


/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _propTypes = __webpack_require__(4);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(28);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _PropTypes = __webpack_require__(303);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
	var EXITED = exports.EXITED = 'exited';
	var ENTERING = exports.ENTERING = 'entering';
	var ENTERED = exports.ENTERED = 'entered';
	var EXITING = exports.EXITING = 'exiting';
	
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm A fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `ENTERING`
	 *  - `ENTERED`
	 *  - `EXITING`
	 *  - `EXITED`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state= { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var parentGroup = context.transitionGroup;
	    // In the context of a TransitionGroup all enters are really appears
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.getChildContext = function getChildContext() {
	    return { transitionGroup: null }; // allows for nested Transitions
	  };
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus(true);
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _ref = this.pendingState || this.state,
	        status = _ref.status;
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	
	    var exit = void 0,
	        enter = void 0,
	        appear = void 0;
	
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	    return { exit: exit, enter: enter, appear: appear };
	  };
	
	  Transition.prototype.updateStatus = function updateStatus() {
	    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var nextStatus = this.nextStatus;
	
	    if (nextStatus !== null) {
	      this.nextStatus = null;
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({ status: UNMOUNTED });
	    }
	  };
	
	  Transition.prototype.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	
	    var timeouts = this.getTimeouts();
	
	    // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	    if (!mounting && !enter) {
	      this.safeSetState({ status: ENTERED }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	
	    this.safeSetState({ status: ENTERING }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      // FIXME: appear timeout?
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({ status: ENTERED }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	
	    var timeouts = this.getTimeouts();
	
	    // no exit animation skip right to EXITED
	    if (!exit) {
	      this.safeSetState({ status: EXITED }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	    this.props.onExit(node);
	
	    this.safeSetState({ status: EXITING }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({ status: EXITED }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
	    var _this4 = this;
	
	    // We need to track pending updates for instances where a cWRP fires quickly
	    // after cDM and before the state flushes, which would double trigger a
	    // transition
	    this.pendingState = nextState;
	
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, function () {
	      _this4.pendingState = null;
	      callback();
	    });
	  };
	
	  Transition.prototype.setNextCallback = function setNextCallback(callback) {
	    var _this5 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this5.nextCallback = null;
	
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        childProps = _objectWithoutProperties(_props, ['children']);
	    // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	
	
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEventListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	    return pt.apply(undefined, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func
	} : {};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	exports.default = Transition;

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChildMapping = __webpack_require__(302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var propTypes = {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   */
	  component: _propTypes2.default.any,
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A convenience prop that enables or disabled appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes2.default.bool,
	  /**
	   * A convenience prop that enables or disabled enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes2.default.bool,
	  /**
	    * A convenience prop that enables or disabled exit animations
	    * for all children. Note that specifying this will override any defaults set
	    * on individual children Transitions.
	    */
	  exit: _propTypes2.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes2.default.func
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	/**
	 * The `<TransitionGroup>` component manages a set of `<Transition>` components
	 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
	 * state machine for managing the mounting and unmounting of components over
	 * time.
	 *
	 * Consider the example below using the `Fade` CSS transition from before.
	 * As items are removed or added to the TodoList the `in` prop is toggled
	 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
	 * component in a `<TransitionGroup>`, not just css.
	 *
	 * ```jsx
	 * import TransitionGroup from 'react-transition-group/TransitionGroup';
	 *
	 * class TodoList extends React.Component {
	 *   constructor(props) {
	 *     super(props)
	 *     this.state = {items: ['hello', 'world', 'click', 'me']}
	 *   }
	 *   handleAdd() {
	 *     const newItems = this.state.items.concat([
	 *       prompt('Enter some text')
	 *     ]);
	 *     this.setState({ items: newItems });
	 *   }
	 *   handleRemove(i) {
	 *     let newItems = this.state.items.slice();
	 *     newItems.splice(i, 1);
	 *     this.setState({items: newItems});
	 *   }
	 *   render() {
	 *     return (
	 *       <div>
	 *         <button onClick={() => this.handleAdd()}>Add Item</button>
	 *         <TransitionGroup>
	 *           {this.state.items.map((item, i) => (
	 *             <FadeTransition key={item}>
	 *               <div>
	 *                 {item}{' '}
	 *                 <button onClick={() => this.handleRemove(i)}>
	 *                   remove
	 *                 </button>
	 *               </div>
	 *             </FadeTransition>
	 *           ))}
	 *         </TransitionGroup>
	 *       </div>
	 *     );
	 *   }
	 * }
	 * ```
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual `<Transition>`
	 * components. This means you can mix and match animations across different
	 * list items.
	 */
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    // Initial children should all be entering, dependent on appear
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleExited = function (key, node, originalHandler) {
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (key in currentChildMapping) return;
	
	      if (originalHandler) originalHandler(node);
	
	      _this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[key];
	        return { children: children };
	      });
	    };
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
	        var onExited = function onExited(node) {
	          _this.handleExited(child.key, node, child.props.onExited);
	        };
	
	        return (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          appear: _this.getProp(child, 'appear'),
	          enter: _this.getProp(child, 'enter'),
	          exit: _this.getProp(child, 'exit')
	        });
	      })
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: { isMounting: !this.appeared }
	    };
	  };
	  // use child config unless explictly set by the Group
	
	
	  TransitionGroup.prototype.getProp = function getProp(child, prop) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;
	
	    return props[prop] != null ? props[prop] : child.props[prop];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var prevChildMapping = this.state.children;
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	
	    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);
	
	    Object.keys(children).forEach(function (key) {
	      var child = children[key];
	
	      if (!(0, _react.isValidElement)(child)) return;
	
	      var onExited = function onExited(node) {
	        _this2.handleExited(child.key, node, child.props.onExited);
	      };
	
	      var hasPrev = key in prevChildMapping;
	      var hasNext = key in nextChildMapping;
	
	      var prevChild = prevChildMapping[key];
	      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;
	
	      // item is new (entering)
	      if (hasNext && (!hasPrev || isLeaving)) {
	        // console.log('entering', key)
	        children[key] = (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          exit: _this2.getProp(child, 'exit', nextProps),
	          enter: _this2.getProp(child, 'enter', nextProps)
	        });
	      }
	      // item is old (exiting)
	      else if (!hasNext && hasPrev && !isLeaving) {
	          // console.log('leaving', key)
	          children[key] = (0, _react.cloneElement)(child, { in: false });
	        }
	        // item hasn't changed transition states
	        // copy over the last transition props;
	        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	            // console.log('unchanged', key)
	            children[key] = (0, _react.cloneElement)(child, {
	              onExited: onExited,
	              in: prevChild.props.in,
	              exit: _this2.getProp(child, 'exit', nextProps),
	              enter: _this2.getProp(child, 'enter', nextProps)
	            });
	          }
	    });
	
	    this.setState({ children: children });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        childFactory = _props.childFactory,
	        props = _objectWithoutProperties(_props, ['component', 'childFactory']);
	
	    var children = this.state.children;
	
	
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    return _react2.default.createElement(
	      Component,
	      props,
	      values(children).map(childFactory)
	    );
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes2.default.object.isRequired
	};
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = Object.create(null);
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	  enter: _propTypes2.default.number,
	  exit: _propTypes2.default.number
	}).isRequired]);
	
	var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  exitActive: _propTypes2.default.string
	})]);

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(308);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(307);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _setDisplayName = __webpack_require__(146);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(85);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = function pure(BaseComponent) {
	  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
	    return !(0, _shallowEqual2.default)(props, nextProps);
	  });
	
	  if (false) {
	    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
	  }
	
	  return hoc(BaseComponent);
	};
	
	exports.default = pure;

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setStatic = __webpack_require__(306);
	
	var _setStatic2 = _interopRequireDefault(_setStatic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setDisplayName = function setDisplayName(displayName) {
	  return (0, _setStatic2.default)('displayName', displayName);
	};
	
	exports.default = setDisplayName;

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	exports.default = setStatic;

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(376);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _setDisplayName = __webpack_require__(146);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(85);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _react.createFactory)(BaseComponent);
	
	    var ShouldUpdate = function (_Component) {
	      _inherits(ShouldUpdate, _Component);
	
	      function ShouldUpdate() {
	        _classCallCheck(this, ShouldUpdate);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      ShouldUpdate.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return ShouldUpdate;
	    }(_react.Component);
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
	    }
	    return ShouldUpdate;
	  };
	};
	
	exports.default = shouldUpdate;

/***/ }),

/***/ 2248:
/***/ (function(module, exports) {

	/*!
	* screenfull
	* v3.3.3 - 2018-09-04
	* (c) Sindre Sorhus; MIT License
	*/
	(function () {
		'use strict';
	
		var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
		var isCommonjs = typeof module !== 'undefined' && module.exports;
		var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;
	
		var fn = (function () {
			var val;
	
			var fnMap = [
				[
					'requestFullscreen',
					'exitFullscreen',
					'fullscreenElement',
					'fullscreenEnabled',
					'fullscreenchange',
					'fullscreenerror'
				],
				// New WebKit
				[
					'webkitRequestFullscreen',
					'webkitExitFullscreen',
					'webkitFullscreenElement',
					'webkitFullscreenEnabled',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				// Old WebKit (Safari 5.1)
				[
					'webkitRequestFullScreen',
					'webkitCancelFullScreen',
					'webkitCurrentFullScreenElement',
					'webkitCancelFullScreen',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				[
					'mozRequestFullScreen',
					'mozCancelFullScreen',
					'mozFullScreenElement',
					'mozFullScreenEnabled',
					'mozfullscreenchange',
					'mozfullscreenerror'
				],
				[
					'msRequestFullscreen',
					'msExitFullscreen',
					'msFullscreenElement',
					'msFullscreenEnabled',
					'MSFullscreenChange',
					'MSFullscreenError'
				]
			];
	
			var i = 0;
			var l = fnMap.length;
			var ret = {};
	
			for (; i < l; i++) {
				val = fnMap[i];
				if (val && val[1] in document) {
					for (i = 0; i < val.length; i++) {
						ret[fnMap[0][i]] = val[i];
					}
					return ret;
				}
			}
	
			return false;
		})();
	
		var eventNameMap = {
			change: fn.fullscreenchange,
			error: fn.fullscreenerror
		};
	
		var screenfull = {
			request: function (elem) {
				var request = fn.requestFullscreen;
	
				elem = elem || document.documentElement;
	
				// Work around Safari 5.1 bug: reports support for
				// keyboard in fullscreen even though it doesn't.
				// Browser sniffing, since the alternative with
				// setTimeout is even worse.
				if (/ Version\/5\.1(?:\.\d+)? Safari\//.test(navigator.userAgent)) {
					elem[request]();
				} else {
					elem[request](keyboardAllowed ? Element.ALLOW_KEYBOARD_INPUT : {});
				}
			},
			exit: function () {
				document[fn.exitFullscreen]();
			},
			toggle: function (elem) {
				if (this.isFullscreen) {
					this.exit();
				} else {
					this.request(elem);
				}
			},
			onchange: function (callback) {
				this.on('change', callback);
			},
			onerror: function (callback) {
				this.on('error', callback);
			},
			on: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.addEventListener(eventName, callback, false);
				}
			},
			off: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.removeEventListener(eventName, callback, false);
				}
			},
			raw: fn
		};
	
		if (!fn) {
			if (isCommonjs) {
				module.exports = false;
			} else {
				window.screenfull = false;
			}
	
			return;
		}
	
		Object.defineProperties(screenfull, {
			isFullscreen: {
				get: function () {
					return Boolean(document[fn.fullscreenElement]);
				}
			},
			element: {
				enumerable: true,
				get: function () {
					return document[fn.fullscreenElement];
				}
			},
			enabled: {
				enumerable: true,
				get: function () {
					// Coerce to boolean in case of old WebKit
					return Boolean(document[fn.fullscreenEnabled]);
				}
			}
		});
	
		if (isCommonjs) {
			module.exports = screenfull;
		} else {
			window.screenfull = screenfull;
		}
	})();


/***/ }),

/***/ 2254:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isArrayish = __webpack_require__(2255);
	
	var concat = Array.prototype.concat;
	var slice = Array.prototype.slice;
	
	var swizzle = module.exports = function swizzle(args) {
		var results = [];
	
		for (var i = 0, len = args.length; i < len; i++) {
			var arg = args[i];
	
			if (isArrayish(arg)) {
				// http://jsperf.com/javascript-array-concat-vs-push/98
				results = concat.call(results, slice.call(arg));
			} else {
				results.push(arg);
			}
		}
	
		return results;
	};
	
	swizzle.wrap = function (fn) {
		return function () {
			return fn(swizzle(arguments));
		};
	};


/***/ }),

/***/ 2255:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isArrayish(obj) {
		if (!obj || typeof obj === 'string') {
			return false;
		}
	
		return obj instanceof Array || Array.isArray(obj) ||
			(obj.length >= 0 && (obj.splice instanceof Function ||
				(Object.getOwnPropertyDescriptor(obj, (obj.length - 1)) && obj.constructor.name !== 'String')));
	};


/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _IconButton = __webpack_require__(88);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactRedux = __webpack_require__(47);
	
	var _screenfull = __webpack_require__(2248);
	
	var _screenfull2 = _interopRequireDefault(_screenfull);
	
	var _Home = __webpack_require__(551);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Search = __webpack_require__(553);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Email = __webpack_require__(544);
	
	var _Email2 = _interopRequireDefault(_Email);
	
	var _ArrowUpward = __webpack_require__(542);
	
	var _ArrowUpward2 = _interopRequireDefault(_ArrowUpward);
	
	var _Fullscreen = __webpack_require__(549);
	
	var _Fullscreen2 = _interopRequireDefault(_Fullscreen);
	
	var _FullscreenExit = __webpack_require__(550);
	
	var _FullscreenExit2 = _interopRequireDefault(_FullscreenExit);
	
	var _store = __webpack_require__(45);
	
	var _shared = __webpack_require__(74);
	
	var _FontSetter = __webpack_require__(588);
	
	var _FontSetter2 = _interopRequireDefault(_FontSetter);
	
	var _CategoryFilter = __webpack_require__(587);
	
	var _CategoryFilter2 = _interopRequireDefault(_CategoryFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _actionsBar, _group;
	
	  return {
	    actionsBar: (_actionsBar = {
	      position: "absolute",
	      background: theme.bars.colors.background,
	      left: 0,
	      //top: `calc(100vh - ${theme.bars.sizes.actionsBar}px)`,
	      bottom: 0,
	      display: "flex",
	      flexDirection: "row",
	      padding: "0 " + theme.base.sizes.linesMargin,
	      justifyContent: "space-between",
	      height: theme.bars.sizes.actionsBar + "px",
	      width: "100%",
	      "&::before": {
	        content: "\"\"",
	        position: "absolute",
	        left: theme.base.sizes.linesMargin,
	        right: theme.base.sizes.linesMargin,
	        height: 0,
	        top: 0,
	        borderTop: "1px solid " + theme.base.colors.lines
	      }
	    }, _actionsBar["@media (min-width: " + theme.mediaQueryTresholds.M + "px)"] = {
	      padding: "0 calc(" + theme.base.sizes.linesMargin + " * 1.5)"
	    }, _actionsBar["@media (min-width: " + theme.mediaQueryTresholds.L + "px)"] = {
	      flexDirection: "column",
	      top: 0,
	      right: 0,
	      left: "auto",
	      height: "100%",
	      padding: theme.base.sizes.linesMargin + " 0",
	      width: theme.bars.sizes.actionsBar + "px",
	      "&::before": {
	        top: theme.base.sizes.linesMargin,
	        bottom: theme.base.sizes.linesMargin,
	        left: 0,
	        right: "auto",
	        width: 0,
	        height: "auto",
	        borderLeft: "1px solid " + theme.base.colors.lines
	      }
	    }, _actionsBar),
	    group: (_group = {
	      display: "flex",
	      flexDirection: "row",
	      alignItems: "center"
	    }, _group["@media (min-width: " + theme.mediaQueryTresholds.L + "px)"] = {
	      flexDirection: "column"
	    }, _group),
	    button: {
	      color: theme.bars.colors.icon
	    }
	  };
	};
	
	var ActionsBar = function (_React$Component) {
	  _inherits(ActionsBar, _React$Component);
	
	  function ActionsBar() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActionsBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      fullscreen: false
	    }, _this.homeOnClick = _shared.featureNavigator.bind(_this), _this.searchOnClick = _shared.moveNavigatorAside.bind(_this), _this.fullscreenOnClick = function () {
	      if (_screenfull2.default.enabled) {
	        _screenfull2.default.toggle();
	      }
	    }, _this.arrowUpOnClick = function () {
	      _this.props.setScrollToTop(true);
	    }, _this.fontSetterOnClick = function (val) {
	      _this.props.setFontSizeIncrease(val);
	
	      if (typeof localStorage !== "undefined") {
	        localStorage.setItem("font-size-increase", val);
	      }
	    }, _this.categoryFilterOnClick = function (val) {
	      _this.props.setCategoryFilter(val);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ActionsBar.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    if (_screenfull2.default.enabled) {
	      _screenfull2.default.on("change", function () {
	        _this2.setState({
	          fullscreen: _screenfull2.default.isFullscreen
	        });
	      });
	    }
	  };
	
	  ActionsBar.prototype.render = function render() {
	    var _props = this.props,
	        classes = _props.classes,
	        navigatorPosition = _props.navigatorPosition,
	        navigatorShape = _props.navigatorShape,
	        isWideScreen = _props.isWideScreen,
	        categories = _props.categories;
	
	
	    return _react2.default.createElement(
	      "div",
	      { className: classes.actionsBar },
	      _react2.default.createElement(
	        "div",
	        { className: classes.group },
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            "aria-label": "Back to list",
	            onClick: this.homeOnClick,
	            title: "Back to the list",
	            className: classes.button
	          },
	          _react2.default.createElement(_Home2.default, null)
	        ),
	        (isWideScreen && navigatorShape === "open" || navigatorPosition !== "is-aside") && _react2.default.createElement(_CategoryFilter2.default, { categories: categories, filterCategory: this.categoryFilterOnClick }),
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            "aria-label": "Contact",
	            onClick: this.searchOnClick,
	            component: _gatsbyLink2.default,
	            "data-shape": "closed",
	            to: "/contact/",
	            title: "Contact",
	            className: classes.button
	          },
	          _react2.default.createElement(_Email2.default, { className: classes.button })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: classes.group },
	        navigatorPosition === "is-aside" && _react2.default.createElement(_FontSetter2.default, { increaseFont: this.fontSetterOnClick }),
	        _screenfull2.default.enabled && _react2.default.createElement(
	          _IconButton2.default,
	          {
	            "aria-label": "Fullscreen",
	            onClick: this.fullscreenOnClick,
	            title: "Fullscreen mode",
	            className: classes.button
	          },
	          this.state.fullscreen ? _react2.default.createElement(_FullscreenExit2.default, null) : _react2.default.createElement(_Fullscreen2.default, null)
	        ),
	        _react2.default.createElement(
	          _IconButton2.default,
	          { "aria-label": "Back to top", onClick: this.arrowUpOnClick, title: "Scroll to top" },
	          _react2.default.createElement(_ArrowUpward2.default, { className: classes.button })
	        )
	      )
	    );
	  };
	
	  return ActionsBar;
	}(_react2.default.Component);
	
	ActionsBar.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  navigatorPosition: _propTypes2.default.string.isRequired,
	  navigatorShape: _propTypes2.default.string.isRequired,
	  isWideScreen: _propTypes2.default.bool.isRequired,
	  setScrollToTop: _propTypes2.default.func.isRequired,
	  setFontSizeIncrease: _propTypes2.default.func.isRequired,
	  categories: _propTypes2.default.array.isRequired,
	  setCategoryFilter: _propTypes2.default.func.isRequired,
	  categoryFilter: _propTypes2.default.string.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    navigatorPosition: state.navigatorPosition,
	    navigatorShape: state.navigatorShape,
	    isWideScreen: state.isWideScreen,
	    categoryFilter: state.categoryFilter
	  };
	};
	
	var mapDispatchToProps = {
	  setNavigatorPosition: _store.setNavigatorPosition,
	  setNavigatorShape: _store.setNavigatorShape,
	  setScrollToTop: _store.setScrollToTop,
	  setFontSizeIncrease: _store.setFontSizeIncrease,
	  setCategoryFilter: _store.setCategoryFilter
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactJss2.default)(styles)(ActionsBar));
	module.exports = exports["default"];

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _MenuItem = __webpack_require__(212);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _MenuList = __webpack_require__(108);
	
	var _MenuList2 = _interopRequireDefault(_MenuList);
	
	var _IconButton = __webpack_require__(88);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _reactPopper = __webpack_require__(296);
	
	var _ClickAwayListener = __webpack_require__(206);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _Grow = __webpack_require__(107);
	
	var _Grow2 = _interopRequireDefault(_Grow);
	
	var _Paper = __webpack_require__(109);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FilterList = __webpack_require__(547);
	
	var _FilterList2 = _interopRequireDefault(_FilterList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _fontSizeSetter;
	
	  return {
	    fontSizeSetter: (_fontSizeSetter = {}, _fontSizeSetter["@media (min-width: " + theme.mediaQueryTresholds.M + "px)"] = {}, _fontSizeSetter),
	    open: {
	      color: theme.bars.colors.icon
	    },
	    popperClose: {
	      pointerEvents: "none"
	    },
	    popper: {
	      zIndex: 1
	    }
	  };
	};
	
	var CategoryFilter = function (_React$Component) {
	  _inherits(CategoryFilter, _React$Component);
	
	  function CategoryFilter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CategoryFilter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.handleClick = function () {
	      _this.setState({ open: !_this.state.open });
	    }, _this.handleClose = function () {
	      if (!_this.state.open) {
	        return;
	      }
	
	      _this.timeout = setTimeout(function () {
	        _this.setState({ open: false });
	      });
	    }, _this.handleFiltering = function (e) {
	      var category = e.target.innerText.trim();
	      _this.props.filterCategory(category);
	      _this.handleClose();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CategoryFilter.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	  };
	
	  CategoryFilter.prototype.render = function render() {
	    var _classNames,
	        _this2 = this;
	
	    var _props = this.props,
	        classes = _props.classes,
	        categories = _props.categories;
	    var open = this.state.open;
	
	
	    return _react2.default.createElement(
	      "nav",
	      { className: classes.fontSizeSetter },
	      _react2.default.createElement(
	        _reactPopper.Manager,
	        null,
	        _react2.default.createElement(
	          _reactPopper.Target,
	          null,
	          _react2.default.createElement(
	            _IconButton2.default,
	            {
	              "aria-label": "Filter by category",
	              "aria-haspopup": "true",
	              onClick: this.handleClick,
	              title: "Filter the list by category",
	              className: classes.open
	            },
	            _react2.default.createElement(_FilterList2.default, null)
	          )
	        ),
	        _react2.default.createElement(
	          _reactPopper.Popper,
	          {
	            placement: "bottom-end",
	            eventsEnabled: open,
	            className: (0, _classnames2.default)((_classNames = {}, _classNames[classes.popperClose] = !open, _classNames)) + " " + classes.popper
	          },
	          _react2.default.createElement(
	            _ClickAwayListener2.default,
	            { onClickAway: this.handleClose },
	            _react2.default.createElement(
	              _Grow2.default,
	              { "in": open, id: "cat-menu-list", style: { transformOrigin: "0 0 0" } },
	              _react2.default.createElement(
	                _Paper2.default,
	                null,
	                _react2.default.createElement(
	                  _MenuList2.default,
	                  { role: "menu" },
	                  _react2.default.createElement(
	                    _MenuItem2.default,
	                    { key: "all", onClick: this.handleFiltering },
	                    "all posts"
	                  ),
	                  categories.map(function (category) {
	                    return _react2.default.createElement(
	                      _MenuItem2.default,
	                      { key: category, onClick: _this2.handleFiltering },
	                      category
	                    );
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return CategoryFilter;
	}(_react2.default.Component);
	
	CategoryFilter.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  categories: _propTypes2.default.array.isRequired,
	  filterCategory: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(CategoryFilter);
	module.exports = exports["default"];

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPopper = __webpack_require__(296);
	
	var _ClickAwayListener = __webpack_require__(206);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _Grow = __webpack_require__(107);
	
	var _Grow2 = _interopRequireDefault(_Grow);
	
	var _Paper = __webpack_require__(109);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _MenuItem = __webpack_require__(212);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _MenuList = __webpack_require__(108);
	
	var _MenuList2 = _interopRequireDefault(_MenuList);
	
	var _IconButton = __webpack_require__(88);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _FormatSize = __webpack_require__(548);
	
	var _FormatSize2 = _interopRequireDefault(_FormatSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import { MenuItem, MenuList } from "@material-ui/core/Menu";
	
	
	var styles = function styles(theme) {
	  var _fontSizeSetter;
	
	  return {
	    fontSizeSetter: (_fontSizeSetter = {}, _fontSizeSetter["@media (min-width: " + theme.mediaQueryTresholds.M + "px)"] = {}, _fontSizeSetter),
	    open: {
	      color: theme.bars.colors.icon
	    },
	    popperClose: {
	      pointerEvents: "none"
	    }
	  };
	};
	
	var FontSetter = function (_React$Component) {
	  _inherits(FontSetter, _React$Component);
	
	  function FontSetter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FontSetter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      anchorEl: null,
	      open: false
	    }, _this.handleClick = function () {
	      _this.setState({ open: !_this.state.open });
	    }, _this.handleClose = function () {
	      if (!_this.state.open) {
	        return;
	      }
	
	      _this.timeout = setTimeout(function () {
	        _this.setState({ open: false });
	      });
	    }, _this.handleSetting = function (e) {
	      var val = e.target.innerText.replace("%", "");
	      var factor = +val / 100;
	      _this.props.increaseFont(factor);
	      _this.handleClose();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  FontSetter.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	  };
	
	  FontSetter.prototype.render = function render() {
	    var _classNames;
	
	    var classes = this.props.classes;
	    var _state = this.state,
	        anchorEl = _state.anchorEl,
	        open = _state.open;
	
	
	    return _react2.default.createElement(
	      "nav",
	      { className: classes.fontSizeSetter },
	      _react2.default.createElement(
	        _reactPopper.Manager,
	        null,
	        _react2.default.createElement(
	          _reactPopper.Target,
	          null,
	          _react2.default.createElement(
	            _IconButton2.default,
	            {
	              "aria-label": "Increase font size",
	              "aria-owns": anchorEl ? "long-menu" : null,
	              "aria-haspopup": "true",
	              onClick: this.handleClick,
	              title: "Change font size",
	              className: classes.open
	            },
	            _react2.default.createElement(_FormatSize2.default, null)
	          )
	        ),
	        _react2.default.createElement(
	          _reactPopper.Popper,
	          {
	            placement: "bottom-end",
	            eventsEnabled: open,
	            className: (0, _classnames2.default)((_classNames = {}, _classNames[classes.popperClose] = !open, _classNames))
	          },
	          _react2.default.createElement(
	            _ClickAwayListener2.default,
	            { onClickAway: this.handleClose },
	            _react2.default.createElement(
	              _Grow2.default,
	              { "in": open, id: "font-menu-list", style: { transformOrigin: "0 0 0" } },
	              _react2.default.createElement(
	                _Paper2.default,
	                null,
	                _react2.default.createElement(
	                  _MenuList2.default,
	                  { role: "menu" },
	                  _react2.default.createElement(
	                    _MenuItem2.default,
	                    { onClick: this.handleSetting },
	                    "150%"
	                  ),
	                  _react2.default.createElement(
	                    _MenuItem2.default,
	                    { onClick: this.handleSetting },
	                    "125%"
	                  ),
	                  _react2.default.createElement(
	                    _MenuItem2.default,
	                    { onClick: this.handleSetting },
	                    "100%"
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return FontSetter;
	}(_react2.default.Component);
	
	FontSetter.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  increaseFont: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(FontSetter);
	module.exports = exports["default"];

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _ActionsBar = __webpack_require__(586);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ActionsBar).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Avatar = __webpack_require__(200);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactRedux = __webpack_require__(47);
	
	var _store = __webpack_require__(45);
	
	var _shared = __webpack_require__(74);
	
	var _config = __webpack_require__(62);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _avatar = __webpack_require__(197);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _TopMenu = __webpack_require__(595);
	
	var _TopMenu2 = _interopRequireDefault(_TopMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _infoBar;
	
	  return {
	    infoBar: (_infoBar = {
	      position: "absolute",
	      background: theme.bars.colors.background,
	      top: 0,
	      left: 0,
	      width: "100%",
	      height: theme.bars.sizes.infoBar + "px",
	      "&::before": {
	        content: "\"\"",
	        position: "absolute",
	        left: theme.base.sizes.linesMargin,
	        right: theme.base.sizes.linesMargin,
	        height: 0,
	        bottom: 0,
	        borderTop: "1px solid " + theme.base.colors.lines
	      }
	    }, _infoBar["@media (min-width: " + theme.mediaQueryTresholds.L + "px)"] = {
	      display: "none"
	    }, _infoBar),
	    title: {
	      float: "left",
	      margin: "10px 0 0 15px",
	      color: theme.bars.colors.text,
	      "& small": {
	        display: "block",
	        fontSize: ".65em",
	        margin: "2px 0 0 0"
	      }
	    },
	    avatarLink: {
	      display: "block",
	      float: "left",
	      margin: "13px 0 0 30px"
	    },
	    avatar: {
	      width: "36px",
	      borderRadius: "65% 75%",
	      border: "1px solid #ddd",
	      height: "36px"
	    }
	  };
	};
	
	var InfoBar = function (_React$Component) {
	  _inherits(InfoBar, _React$Component);
	
	  function InfoBar() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, InfoBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.homeLinkOnClick = _shared.featureNavigator.bind(_this), _this.pageLinkOnClick = _shared.moveNavigatorAside.bind(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  InfoBar.prototype.render = function render() {
	    var _props = this.props,
	        classes = _props.classes,
	        pages = _props.pages;
	
	
	    return _react2.default.createElement(
	      "aside",
	      { className: classes.infoBar },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/", className: classes.avatarLink, onClick: this.homeLinkOnClick },
	        _react2.default.createElement(_Avatar2.default, { alt: _config2.default.infoTitle, src: _avatar2.default, className: classes.avatar })
	      ),
	      _react2.default.createElement(
	        "h3",
	        { className: classes.title },
	        _config2.default.infoTitle,
	        _react2.default.createElement(
	          "small",
	          null,
	          _config2.default.infoTitleNote
	        )
	      ),
	      _react2.default.createElement(_TopMenu2.default, {
	        pages: pages,
	        homeLinkOnClick: this.homeLinkOnClick,
	        pageLinkOnClick: this.pageLinkOnClick
	      })
	    );
	  };
	
	  return InfoBar;
	}(_react2.default.Component);
	
	InfoBar.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  pages: _propTypes2.default.array.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    navigatorPosition: state.navigatorPosition,
	    navigatorShape: state.navigatorShape
	  };
	};
	
	var mapDispatchToProps = {
	  setNavigatorPosition: _store.setNavigatorPosition
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactJss2.default)(styles)(InfoBar));
	module.exports = exports["default"];

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ClickAwayListener = __webpack_require__(206);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _Grow = __webpack_require__(107);
	
	var _Grow2 = _interopRequireDefault(_Grow);
	
	var _IconButton = __webpack_require__(88);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _MenuItem = __webpack_require__(212);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _MenuList = __webpack_require__(108);
	
	var _MenuList2 = _interopRequireDefault(_MenuList);
	
	var _Paper = __webpack_require__(109);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _MoreVert = __webpack_require__(552);
	
	var _MoreVert2 = _interopRequireDefault(_MoreVert);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _reactPopper = __webpack_require__(296);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _topMenu;
	
	  return {
	    topMenu: (_topMenu = {
	      float: "right",
	      margin: "5px 10px 0 0"
	    }, _topMenu['@media (min-width: ' + theme.mediaQueryTresholds.M + 'px)'] = {}, _topMenu),
	    open: {
	      color: theme.bars.colors.icon
	    },
	    popperClose: {
	      pointerEvents: "none"
	    }
	  };
	};
	
	var TopMenu = function (_React$Component) {
	  _inherits(TopMenu, _React$Component);
	
	  function TopMenu() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TopMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      anchorEl: null,
	      open: false
	    }, _this.handleClick = function () {
	      _this.setState({ open: !_this.state.open });
	    }, _this.handleClose = function () {
	      if (!_this.state.open) {
	        return;
	      }
	
	      _this.timeout = setTimeout(function () {
	        _this.setState({ open: false });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TopMenu.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	  };
	
	  TopMenu.prototype.render = function render() {
	    var _classNames,
	        _this2 = this;
	
	    var _props = this.props,
	        classes = _props.classes,
	        pages = _props.pages;
	    var _state = this.state,
	        anchorEl = _state.anchorEl,
	        open = _state.open;
	
	
	    return _react2.default.createElement(
	      'nav',
	      { className: classes.topMenu },
	      _react2.default.createElement(
	        _reactPopper.Manager,
	        null,
	        _react2.default.createElement(
	          _reactPopper.Target,
	          null,
	          _react2.default.createElement(
	            _IconButton2.default,
	            {
	              'aria-label': 'More',
	              'aria-owns': anchorEl ? "long-menu" : null,
	              'aria-haspopup': 'true',
	              onClick: this.handleClick,
	              className: classes.open
	            },
	            _react2.default.createElement(_MoreVert2.default, null)
	          )
	        ),
	        _react2.default.createElement(
	          _reactPopper.Popper,
	          {
	            placement: 'bottom-end',
	            eventsEnabled: open,
	            className: (0, _classnames2.default)((_classNames = {}, _classNames[classes.popperClose] = !open, _classNames))
	          },
	          _react2.default.createElement(
	            _ClickAwayListener2.default,
	            { onClickAway: this.handleClose },
	            _react2.default.createElement(
	              _Grow2.default,
	              { 'in': open, id: 'menu-list', style: { transformOrigin: "0 0 0" } },
	              _react2.default.createElement(
	                _Paper2.default,
	                null,
	                _react2.default.createElement(
	                  _MenuList2.default,
	                  { role: 'menu' },
	                  _react2.default.createElement(
	                    _MenuItem2.default,
	                    {
	                      onClick: function onClick(e) {
	                        _this2.props.homeLinkOnClick(e);
	                        _this2.handleClose();
	                      }
	                    },
	                    'Home'
	                  ),
	                  pages.map(function (page, i) {
	                    var _page$node = page.node,
	                        fields = _page$node.fields,
	                        frontmatter = _page$node.frontmatter;
	
	
	                    return _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { key: fields.slug, to: fields.slug, style: { display: "block" } },
	                      _react2.default.createElement(
	                        _MenuItem2.default,
	                        {
	                          onClick: function onClick(e) {
	                            _this2.props.pageLinkOnClick(e);
	                            _this2.handleClose();
	                          }
	                        },
	                        frontmatter.menuTitle ? frontmatter.menuTitle : frontmatter.title
	                      )
	                    );
	                  }),
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/contact/', style: { display: "block" } },
	                    _react2.default.createElement(
	                      _MenuItem2.default,
	                      {
	                        onClick: function onClick(e) {
	                          _this2.props.pageLinkOnClick(e);
	                          _this2.handleClose();
	                        }
	                      },
	                      'Contact'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return TopMenu;
	}(_react2.default.Component);
	
	TopMenu.propTypes = {
	  pages: _propTypes2.default.array.isRequired,
	  classes: _propTypes2.default.object.isRequired,
	  pageLinkOnClick: _propTypes2.default.func.isRequired,
	  homeLinkOnClick: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(TopMenu);
	module.exports = exports['default'];

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _InfoBar = __webpack_require__(594);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InfoBar).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    wrapper: {
	      padding: "1px",
	      position: "absolute",
	      top: 0,
	      left: 0,
	      bottom: 0,
	      right: 0,
	      overflow: "hidden",
	      "@media print": {
	        position: "relative",
	        overflow: "visible"
	      }
	    }
	  };
	};
	
	var LayoutWrapper = function LayoutWrapper(props) {
	  var classes = props.classes,
	      children = props.children;
	
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes.wrapper },
	    children
	  );
	};
	
	LayoutWrapper.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	
	exports.default = (0, _reactJss2.default)(styles)(LayoutWrapper);
	module.exports = exports["default"];

/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _LayoutWrapper = __webpack_require__(604);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LayoutWrapper).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _reactLazyload = __webpack_require__(144);
	
	var _ListHeader = __webpack_require__(608);
	
	var _ListHeader2 = _interopRequireDefault(_ListHeader);
	
	var _SpringScrollbars = __webpack_require__(330);
	
	var _SpringScrollbars2 = _interopRequireDefault(_SpringScrollbars);
	
	var _ListItem = __webpack_require__(609);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _inner;
	
	  return {
	    posts: {
	      position: "absolute",
	      left: 0,
	      top: 0,
	      bottom: 0,
	      width: "100%"
	    },
	    inner: (_inner = {
	      padding: "calc(" + theme.bars.sizes.infoBar + "px + 1.3rem) 1.3rem calc(" + theme.bars.sizes.actionsBar + "px + 1.3rem) 1.3rem"
	    }, _inner["@media (min-width: " + theme.mediaQueryTresholds.M + "px)"] = {
	      padding: "calc(" + theme.bars.sizes.infoBar + "px + 2rem) 2rem calc(" + theme.bars.sizes.actionsBar + "px + 2rem) 2rem"
	    }, _inner["@media (min-width: " + theme.mediaQueryTresholds.L + "px)"] = {
	      padding: "2rem  calc(1rem + 17px) calc(2rem + 17px) 2rem",
	      left: theme.info.sizes.width + "px",
	      ".moving-featured &, .is-aside &": {
	        padding: "1rem .5rem 1rem .5rem"
	      }
	    }, _inner),
	    list: {
	      listStyle: "none",
	      margin: 0,
	      padding: 0,
	      ".is-aside.closed &, .moving-featured.closed &": {
	        display: "none"
	      }
	    }
	  };
	};
	
	var List = function (_React$Component) {
	  _inherits(List, _React$Component);
	
	  function List() {
	    _classCallCheck(this, List);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  List.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (prevProps.categoryFilter !== this.props.categoryFilter) {
	      setTimeout(_reactLazyload.forceCheck, 300);
	    }
	  };
	
	  List.prototype.render = function render() {
	    var _props = this.props,
	        classes = _props.classes,
	        posts = _props.posts,
	        linkOnClick = _props.linkOnClick,
	        expandOnClick = _props.expandOnClick,
	        categoryFilter = _props.categoryFilter,
	        navigatorShape = _props.navigatorShape,
	        removeFilter = _props.removeFilter;
	
	
	    return _react2.default.createElement(
	      "div",
	      { className: classes.posts },
	      _react2.default.createElement(
	        _SpringScrollbars2.default,
	        { forceCheckOnScroll: true, isNavigator: true },
	        _react2.default.createElement(
	          "div",
	          { className: classes.inner },
	          _react2.default.createElement(_ListHeader2.default, {
	            expandOnClick: expandOnClick,
	            categoryFilter: categoryFilter,
	            navigatorShape: navigatorShape,
	            removeFilter: removeFilter
	          }),
	          _react2.default.createElement(
	            "ul",
	            { className: classes.list },
	            posts && posts.map(function (post, i) {
	              return _react2.default.createElement(_ListItem2.default, {
	                key: i,
	                post: post,
	                linkOnClick: linkOnClick,
	                categoryFilter: categoryFilter
	              });
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return List;
	}(_react2.default.Component);
	
	List.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  posts: _propTypes2.default.array.isRequired,
	  linkOnClick: _propTypes2.default.func.isRequired,
	  expandOnClick: _propTypes2.default.func.isRequired,
	  navigatorPosition: _propTypes2.default.string.isRequired,
	  navigatorShape: _propTypes2.default.string.isRequired,
	  categoryFilter: _propTypes2.default.string.isRequired,
	  removeFilter: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(List);
	module.exports = exports["default"];

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _IconButton = __webpack_require__(88);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _Close = __webpack_require__(543);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	var _ExpandLess = __webpack_require__(545);
	
	var _ExpandLess2 = _interopRequireDefault(_ExpandLess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _filter;
	
	  return {
	    closed: {
	      display: "none",
	      ".is-aside.closed &, .moving-featured.closed &": {
	        display: "flex",
	        flexDirection: "row",
	        justifyContent: "space-between",
	        alignItems: "center",
	        position: "absolute",
	        top: 0,
	        left: 0,
	        width: "100%",
	        margin: 0,
	        height: theme.navigator.sizes.closedHeight + "px",
	        padding: "0 30px 0 40px"
	      },
	      "& h3": {
	        fontSize: "1.1em",
	        color: theme.navigator.colors.postsHeader,
	        fontWeight: 600,
	        margin: "-.2em 0 0 0",
	        textTransform: "uppercase",
	        "& small": {
	          fontSize: ".6em",
	          display: "block",
	          margin: "0 0 .1em",
	          fontWeight: 300,
	          letterSpacing: ".2em"
	        }
	      }
	    },
	    expand: {
	      color: theme.navigator.colors.postsHeader
	    },
	    filter: (_filter = {
	      margin: "0 calc(-.5rem + " + theme.base.sizes.linesMargin + ") 1em calc(-.5rem + " + theme.base.sizes.linesMargin + ")",
	      position: "relative",
	      fontSize: "1.2em",
	      lineHeight: 1,
	      color: theme.base.colors.accent,
	      borderBottom: "1px solid " + theme.base.colors.lines,
	      padding: "0 1em 1em",
	      fontWeight: 300,
	      "& strong": {
	        fontWeight: 600,
	        display: "block"
	      },
	      "& small": {
	        display: "block",
	        margin: "0 0 .3em 0"
	      }
	    }, _filter["@media (min-width: " + theme.mediaQueryTresholds.L + "px)"] = {
	      margin: "0 0 1em 0",
	      padding: "0 1em 1.5em",
	      ".is-aside &": {
	        padding: "0 0 1em .5em",
	        margin: "0 calc(-.5rem + " + theme.base.sizes.linesMargin + ") 1em calc(-.5rem + " + theme.base.sizes.linesMargin + ")"
	      }
	    }, _filter),
	    clear: {
	      position: "absolute",
	      top: 0,
	      right: 0
	    }
	  };
	};
	
	var ListHeader = function ListHeader(props) {
	  var classes = props.classes,
	      expandOnClick = props.expandOnClick,
	      categoryFilter = props.categoryFilter,
	      navigatorShape = props.navigatorShape,
	      removeFilter = props.removeFilter;
	
	
	  return _react2.default.createElement(
	    "header",
	    null,
	    navigatorShape === "closed" && _react2.default.createElement(
	      "div",
	      { className: classes.closed },
	      _react2.default.createElement(
	        "h3",
	        null,
	        "List of posts"
	      ),
	      _react2.default.createElement(
	        _IconButton2.default,
	        {
	          "aria-label": "Expand the list",
	          className: classes.expand,
	          onClick: expandOnClick,
	          title: "Expand the list"
	        },
	        _react2.default.createElement(_ExpandLess2.default, null)
	      )
	    ),
	    navigatorShape === "open" && categoryFilter !== "all posts" && _react2.default.createElement(
	      "div",
	      { className: classes.filter },
	      _react2.default.createElement(
	        "small",
	        null,
	        "Active category filter:"
	      ),
	      " ",
	      _react2.default.createElement(
	        "strong",
	        null,
	        categoryFilter
	      ),
	      _react2.default.createElement(
	        _IconButton2.default,
	        {
	          "aria-label": "Remove filtering",
	          className: classes.clear,
	          onClick: removeFilter,
	          title: "Clear filtering"
	        },
	        _react2.default.createElement(_Close2.default, null)
	      )
	    )
	  );
	};
	
	ListHeader.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  expandOnClick: _propTypes2.default.func.isRequired,
	  categoryFilter: _propTypes2.default.string.isRequired,
	  navigatorShape: _propTypes2.default.string.isRequired,
	  removeFilter: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(ListHeader);
	module.exports = exports["default"];

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _reactLazyload = __webpack_require__(144);
	
	var _reactLazyload2 = _interopRequireDefault(_reactLazyload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _listItem, _listItemPointer, _h, _h2, _listItemText;
	
	  return {
	    listItem: (_listItem = {
	      margin: "0 0 .7em 0",
	      transition: "height 1s"
	    }, _listItem["@media (min-width: " + theme.mediaQueryTresholds.M + "px)"] = {
	      margin: "0 0 1.5rem 0"
	    }, _listItem["@media (min-width: " + theme.mediaQueryTresholds.L + "px)"] = {
	      ".moving-featured &, .is-aside &": {
	        margin: "0 0 0 0"
	      }
	    }, _listItem),
	    listLink: {
	      display: "flex",
	      alignContent: "center",
	      alignItems: "center",
	      justifyContent: "flex-start",
	      flexDirection: "row",
	      padding: ".7em 1em .7em 1em",
	      color: theme.navigator.colors.postsListItemLink,
	      "@media (hover: hover)": {
	        "&:hover": {
	          color: theme.navigator.colors.postsListItemLinkHover,
	          "& .pointer": {
	            borderRadius: "65% 75%"
	          }
	        }
	      }
	    },
	    listItemPointer: (_listItemPointer = {
	      position: "relative",
	      flexShrink: 0,
	      overflow: "hidden",
	      borderRadius: "75% 65%",
	      width: "60px",
	      height: "60px",
	      margin: "0",
	      transition: "all .5s",
	      "& img": {
	        width: "100%",
	        height: "100%"
	      }
	    }, _listItemPointer["@media (min-width: " + theme.mediaQueryTresholds.M + "px)"] = {
	      marginRight: ".5em",
	      width: "80px",
	      height: "80px"
	    }, _listItemPointer["@media (min-width: " + theme.mediaQueryTresholds.L + "px)"] = {
	      marginRight: ".8em",
	      width: "90px",
	      height: "90px",
	      transition: "all .3s",
	      transitionTimingFunction: "ease",
	      ".moving-featured &, .is-aside &": {
	        width: "30px",
	        height: "30px"
	      }
	    }, _listItemPointer),
	    listItemText: (_listItemText = {
	      margin: "0 0 0 1.5em",
	      flexGrow: 1,
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      "& h1": (_h = {
	        lineHeight: 1.15,
	        fontWeight: 600,
	        letterSpacing: "-0.03em",
	        margin: 0,
	        fontSize: theme.navigator.sizes.postsListItemH1Font + "em"
	      }, _h["@media (min-width: " + theme.mediaQueryTresholds.M + "px)"] = {
	        fontSize: theme.navigator.sizes.postsListItemH1Font * theme.navigator.sizes.fontIncraseForM + "em"
	      }, _h["@media (min-width: " + theme.mediaQueryTresholds.L + "px)"] = {
	        fontSize: theme.navigator.sizes.postsListItemH1Font * theme.navigator.sizes.fontIncraseForL + "em",
	        ".moving-featured &, .is-aside &": {
	          fontSize: "1em",
	          fontWeight: 400
	        }
	      }, _h),
	      "& h2": (_h2 = {
	        lineHeight: 1.2,
	        display: "block",
	        fontSize: theme.navigator.sizes.postsListItemH2Font + "em",
	        margin: ".3em 0 0 0"
	      }, _h2["@media (min-width: " + theme.mediaQueryTresholds.M + "px)"] = {
	        fontSize: theme.navigator.sizes.postsListItemH2Font * theme.navigator.sizes.fontIncraseForM + "em"
	      }, _h2["@media (min-width: " + theme.mediaQueryTresholds.L + "px)"] = {
	        fontSize: theme.navigator.sizes.postsListItemH2Font * theme.navigator.sizes.fontIncraseForL + "em",
	        ".moving-featured &, .is-aside &": {
	          display: "none"
	        }
	      }, _h2)
	    }, _listItemText["@media (min-width: " + theme.mediaQueryTresholds.L + "px)"] = {
	      ".moving-featured &, .is-aside &": {
	        margin: "0 0 0 .5em"
	      }
	    }, _listItemText)
	  };
	};
	
	var ListItem = function (_React$Component) {
	  _inherits(ListItem, _React$Component);
	
	  function ListItem() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      hidden: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ListItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (prevProps.categoryFilter !== this.props.categoryFilter) {
	      var category = this.props.post.node.frontmatter.category;
	      var categoryFilter = this.props.categoryFilter;
	
	      if (categoryFilter === "all posts") {
	        this.setState({ hidden: false });
	      } else if (category !== categoryFilter) {
	        this.setState({ hidden: true });
	      } else if (category === categoryFilter) {
	        this.setState({ hidden: false });
	      }
	    }
	  };
	
	  ListItem.prototype.render = function render() {
	    var _props = this.props,
	        classes = _props.classes,
	        post = _props.post,
	        linkOnClick = _props.linkOnClick;
	
	
	    return _react2.default.createElement(
	      "li",
	      {
	        className: classes.listItem + " " + post.node.frontmatter.category,
	        style: { display: "" + (this.state.hidden ? "none" : "block") },
	        key: post.node.fields.slug
	      },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          activeClassName: "active",
	          className: classes.listLink,
	          to: post.node.fields.slug,
	          onClick: linkOnClick
	        },
	        post.node.frontmatter.cover && post.node.frontmatter.cover.children[0] && _react2.default.createElement(
	          "div",
	          { className: classes.listItemPointer + " pointer" },
	          _react2.default.createElement(
	            _reactLazyload2.default,
	            { height: 60, overflow: true, throttle: 300, once: true, offset: 100 },
	            _react2.default.createElement(
	              "picture",
	              null,
	              _react2.default.createElement("source", {
	                type: "image/webp",
	                srcSet: post.node.frontmatter.cover.children[0].resolutions.srcSetWebp
	              }),
	              _react2.default.createElement("source", { srcSet: post.node.frontmatter.cover.children[0].resolutions.srcSet }),
	              _react2.default.createElement("img", { src: post.node.frontmatter.cover.children[0].resolutions.src, alt: "" })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: classes.listItemText },
	          _react2.default.createElement(
	            "h1",
	            null,
	            post.node.frontmatter.title
	          ),
	          post.node.frontmatter.subTitle && _react2.default.createElement(
	            "h2",
	            null,
	            post.node.frontmatter.subTitle
	          )
	        )
	      )
	    );
	  };
	
	  return ListItem;
	}(_react2.default.Component);
	
	ListItem.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  post: _propTypes2.default.object.isRequired,
	  linkOnClick: _propTypes2.default.func.isRequired,
	  categoryFilter: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(ListItem);
	module.exports = exports["default"];

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(47);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _reactLazyload = __webpack_require__(144);
	
	var _store = __webpack_require__(45);
	
	var _shared = __webpack_require__(74);
	
	var _List = __webpack_require__(607);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _navigator;
	
	  return {
	    navigator: (_navigator = {
	      transform: "translate3d(0, 0, 0)",
	      willChange: "left, top, bottom, width",
	      background: theme.navigator.colors.background,
	      position: "absolute",
	      top: 0,
	      left: 0,
	      height: "100vh",
	      transitionTimingFunction: "ease",
	      transition: "left .9s",
	      width: "100%"
	    }, _navigator["@media (max-width: " + (theme.mediaQueryTresholds.L - 1) + "px)"] = {
	      "&.is-aside": {
	        left: "-100%"
	      },
	      "&.is-featured": {
	        left: 0
	      }
	    }, _navigator["@media (min-width: " + theme.mediaQueryTresholds.L + "px)"] = {
	      "&.is-featured": {
	        transition: "left .9s",
	        width: "calc(100vw - " + theme.info.sizes.width + "px - " + theme.bars.sizes.actionsBar + "px)",
	        left: theme.info.sizes.width + "px",
	        top: 0
	      },
	      "&.is-aside": {
	        transition: "none, bottom 0.5s",
	        left: 0,
	        width: theme.info.sizes.width - 1 + "px",
	        zIndex: 1,
	        top: "auto",
	        "&.closed": {
	          bottom: "calc(-100% + 100px + " + theme.navigator.sizes.closedHeight + "px)",
	          height: "calc(100% - 100px)"
	        },
	        "&.open": {
	          bottom: 0,
	          height: "calc(100% - 100px)"
	        },
	        "&::after": {
	          content: "\"\"",
	          position: "absolute",
	          top: 0,
	          left: theme.base.sizes.linesMargin,
	          right: theme.base.sizes.linesMargin,
	          height: 0,
	          borderTop: "1px solid " + theme.base.colors.lines
	        }
	      },
	      "&.moving-aside": {
	        transition: "left 0.9s",
	        left: "calc(-100vw + " + (2 * theme.info.sizes.width + 60) + "px)",
	        width: "calc(100vw - " + theme.info.sizes.width + "px - 60px)",
	        top: 0
	      },
	      "&.resizing-aside": {
	        transition: "none",
	        width: theme.info.sizes.width - 1 + "px",
	        top: "auto",
	        left: 0,
	        "&.closed": {
	          bottom: "calc(-100% + 100px)",
	          height: "calc(100% - 100px)"
	        },
	        "&.open": {
	          bottom: "calc(-100% + 100px)",
	          height: "calc(100% - 100px)"
	        }
	      },
	      "&.moving-featured": {
	        transition: "bottom .3s",
	
	        bottom: "-100%",
	        top: "auto",
	        left: 0,
	        zIndex: 1,
	        width: theme.info.sizes.width - 1 + "px"
	      },
	      "&.resizing-featured": {
	        transition: "none",
	        top: 0,
	        bottom: "auto",
	        left: "calc(-100vw + " + (2 * theme.info.sizes.width + 60) + "px)",
	        width: "calc(100vw - " + theme.info.sizes.width + "px - 60px)"
	      }
	    }, _navigator)
	  };
	};
	
	var Navigator = function (_React$Component) {
	  _inherits(Navigator, _React$Component);
	
	  function Navigator() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Navigator);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.linkOnClick = _shared.moveNavigatorAside.bind(_this), _this.expandOnClick = function (e) {
	      _this.props.setNavigatorShape("open");
	      setTimeout(_reactLazyload.forceCheck, 600);
	    }, _this.removefilterOnClick = function (e) {
	      _this.props.setCategoryFilter("all posts");
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Navigator.prototype.render = function render() {
	    var _props = this.props,
	        classes = _props.classes,
	        posts = _props.posts,
	        navigatorPosition = _props.navigatorPosition,
	        navigatorShape = _props.navigatorShape,
	        categoryFilter = _props.categoryFilter;
	
	
	    return _react2.default.createElement(
	      "nav",
	      {
	        className: classes.navigator + " " + (navigatorPosition ? navigatorPosition : "") + " " + (navigatorShape ? navigatorShape : "") + " "
	      },
	      this.props.posts.length && _react2.default.createElement(_List2.default, {
	        posts: posts,
	        navigatorPosition: navigatorPosition,
	        navigatorShape: navigatorShape,
	        linkOnClick: this.linkOnClick,
	        expandOnClick: this.expandOnClick,
	        categoryFilter: categoryFilter,
	        removeFilter: this.removefilterOnClick
	      })
	    );
	  };
	
	  return Navigator;
	}(_react2.default.Component);
	
	Navigator.propTypes = {
	  posts: _propTypes2.default.array.isRequired,
	  classes: _propTypes2.default.object.isRequired,
	  navigatorPosition: _propTypes2.default.string.isRequired,
	  navigatorShape: _propTypes2.default.string.isRequired,
	  setNavigatorPosition: _propTypes2.default.func.isRequired,
	  setNavigatorShape: _propTypes2.default.func.isRequired,
	  isWideScreen: _propTypes2.default.bool.isRequired,
	  categoryFilter: _propTypes2.default.string.isRequired,
	  setCategoryFilter: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    navigatorPosition: state.navigatorPosition,
	    navigatorShape: state.navigatorShape,
	    isWideScreen: state.isWideScreen,
	    categoryFilter: state.categoryFilter
	  };
	};
	
	var mapDispatchToProps = {
	  setNavigatorPosition: _store.setNavigatorPosition,
	  setNavigatorShape: _store.setNavigatorShape,
	  setCategoryFilter: _store.setCategoryFilter
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactJss2.default)(styles)(Navigator));
	module.exports = exports["default"];

/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Navigator = __webpack_require__(610);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Navigator).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = asyncComponent;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function asyncComponent(getComponent, loadingComponent) {
	  var AsyncComponent = function (_React$Component) {
	    _inherits(AsyncComponent, _React$Component);
	
	    function AsyncComponent() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, AsyncComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { Component: null }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    AsyncComponent.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      if (!this.state.Component) {
	        getComponent().then(function (Component) {
	          _this2.setState({ Component: Component });
	        });
	      }
	    };
	
	    AsyncComponent.prototype.render = function render() {
	      var Component = this.state.Component;
	
	      if (Component) {
	        return _react2.default.createElement(Component, this.props);
	      }
	      return loadingComponent ? loadingComponent : _react2.default.createElement(
	        "div",
	        null,
	        "Loading..."
	      );
	    };
	
	    return AsyncComponent;
	  }(_react2.default.Component);
	
	  return AsyncComponent;
	}
	module.exports = exports["default"];

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _AsyncComponent = __webpack_require__(224);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AsyncComponent).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _CircularProgress = __webpack_require__(490);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    loading: {
	      display: "flex",
	      background: function background(props) {
	        return props.overrides && props.overrides.background ? props.overrides.background : theme.base.colors.background;
	      },
	      position: "absolute",
	      left: function left(props) {
	        return props.overrides && props.overrides.left ? props.overrides.left : 0;
	      },
	      right: function right(props) {
	        return props.overrides && props.overrides.right ? props.overrides.right : 0;
	      },
	      top: "0",
	      width: function width(props) {
	        return props.overrides && props.overrides.width ? props.overrides.width : "100%";
	      },
	      height: function height(props) {
	        return props.overrides && props.overrides.height ? props.overrides.height : "100%";
	      },
	      flexDirection: "column",
	      justifyContent: "center",
	      alignItems: "center",
	      "&::after": {
	        content: function content(props) {
	          return props.afterLeft || props.afterRight ? "\"\"" : "";
	        },
	        position: "absolute",
	        right: function right(props) {
	          return props.afterRight ? 0 : "";
	        },
	        left: function left(props) {
	          return props.afterLeft ? 0 : "";
	        },
	        top: theme.base.sizes.linesMargin,
	        bottom: theme.base.sizes.linesMargin,
	        width: 0,
	        borderRight: "1px solid " + theme.base.colors.lines
	      }
	    },
	    progress: {}
	  };
	};
	
	var Loading = function Loading(props) {
	  var classes = props.classes,
	      progressSize = props.progressSize;
	
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes.loading },
	    _react2.default.createElement(_CircularProgress2.default, { className: classes.progress, size: progressSize ? progressSize : 30 })
	  );
	};
	
	Loading.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  progressSize: _propTypes2.default.number,
	  overrides: _propTypes2.default.object
	};
	
	exports.default = (0, _reactJss2.default)(styles)(Loading);
	module.exports = exports["default"];

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Loading = __webpack_require__(626);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Loading).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {"use strict";
	
	exports.__esModule = true;
	exports.default = getPageContext;
	
	var _jss = __webpack_require__(170);
	
	var _styles = __webpack_require__(110);
	
	var _theme = __webpack_require__(158);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPageContext() {
	  return {
	    theme: _theme2.default,
	    // This is needed in order to deduplicate the injection of CSS in the page.
	    sheetsManager: new Map(),
	    // This is needed in order to inject the critical CSS.
	    sheetsRegistry: new _jss.SheetsRegistry(),
	    // The standard class name generator.
	    generateClassName: (0, _styles.createGenerateClassName)()
	  };
	} /* eslint-disable no-underscore-dangle */
	
	function getPageContext() {
	  // Make sure to create a new context for every server-side request so that data
	  // isn't shared between connections (which would be bad).
	  if (!process.browser) {
	    return createPageContext();
	  }
	
	  // Reuse context on the client-side.
	  if (!global.__INIT_MATERIAL_UI__) {
	    global.__INIT_MATERIAL_UI__ = createPageContext();
	  }
	
	  return global.__INIT_MATERIAL_UI__;
	}
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71), (function() { return this; }())))

/***/ }),

/***/ 197:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.guery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJss = __webpack_require__(16);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _styles = __webpack_require__(110);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(47);
	
	var _withRoot = __webpack_require__(637);
	
	var _withRoot2 = _interopRequireDefault(_withRoot);
	
	var _theme = __webpack_require__(158);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _globals = __webpack_require__(633);
	
	var _globals2 = _interopRequireDefault(_globals);
	
	var _store = __webpack_require__(45);
	
	var _AsyncComponent = __webpack_require__(225);
	
	var _AsyncComponent2 = _interopRequireDefault(_AsyncComponent);
	
	var _Loading = __webpack_require__(627);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _Navigator = __webpack_require__(611);
	
	var _Navigator2 = _interopRequireDefault(_Navigator);
	
	var _ActionsBar = __webpack_require__(589);
	
	var _ActionsBar2 = _interopRequireDefault(_ActionsBar);
	
	var _InfoBar = __webpack_require__(596);
	
	var _InfoBar2 = _interopRequireDefault(_InfoBar);
	
	var _LayoutWrapper = __webpack_require__(605);
	
	var _LayoutWrapper2 = _interopRequireDefault(_LayoutWrapper);
	
	var _helpers = __webpack_require__(636);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InfoBox = (0, _AsyncComponent2.default)(function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(1, function (require) {
	      resolve(__webpack_require__(603));
	    });
	  }).then(function (module) {
	    return module;
	  }).catch(function (error) {});
	}, _react2.default.createElement(_Loading2.default, {
	  overrides: { width: _theme2.default.info.sizes.width + "px", height: "100vh", right: "auto" },
	  afterRight: true
	}));
	
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Layout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.timeouts = {}, _this.categories = [], _this.getCategories = function () {
	      _this.categories = _this.props.data.posts.edges.reduce(function (list, edge, i) {
	        var category = edge.node.frontmatter.category;
	        if (category && !~list.indexOf(category)) {
	          return list.concat(edge.node.frontmatter.category);
	        } else {
	          return list;
	        }
	      }, []);
	    }, _this.resizeThrottler = function () {
	      return (0, _helpers.timeoutThrottlerHandler)(_this.timeouts, "resize", 500, _this.resizeHandler);
	    }, _this.resizeHandler = function () {
	      _this.props.setIsWideScreen((0, _helpers.isWideScreen)());
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Layout.prototype.componentDidMount = function componentDidMount() {
	    this.props.setIsWideScreen((0, _helpers.isWideScreen)());
	    if (typeof window !== "undefined") {
	      window.addEventListener("resize", this.resizeThrottler, false);
	    }
	  };
	
	  Layout.prototype.componentWillMount = function componentWillMount() {
	    if (typeof localStorage !== "undefined") {
	      var inLocal = +localStorage.getItem("font-size-increase");
	
	      var inStore = this.props.fontSizeIncrease;
	
	      if (inLocal && inLocal !== inStore && inLocal >= 1 && inLocal <= 1.5) {
	        this.props.setFontSizeIncrease(inLocal);
	      }
	    }
	
	    this.getCategories();
	  };
	
	  Layout.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        data = _props.data;
	
	    // TODO: dynamic management of tabindexes for keybord navigation
	
	    return _react2.default.createElement(
	      _LayoutWrapper2.default,
	      null,
	      children(),
	      _react2.default.createElement(_Navigator2.default, { posts: data.posts.edges }),
	      _react2.default.createElement(_ActionsBar2.default, { categories: this.categories }),
	      _react2.default.createElement(_InfoBar2.default, { pages: data.pages.edges, parts: data.parts.edges }),
	      this.props.isWideScreen && _react2.default.createElement(InfoBox, { pages: data.pages.edges, parts: data.parts.edges })
	    );
	  };
	
	  return Layout;
	}(_react2.default.Component);
	
	Layout.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.func.isRequired,
	  setIsWideScreen: _propTypes2.default.func.isRequired,
	  isWideScreen: _propTypes2.default.bool.isRequired,
	  fontSizeIncrease: _propTypes2.default.number.isRequired,
	  setFontSizeIncrease: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    pages: state.pages,
	    isWideScreen: state.isWideScreen,
	    fontSizeIncrease: state.fontSizeIncrease
	  };
	};
	
	var mapDispatchToProps = {
	  setIsWideScreen: _store.setIsWideScreen,
	  setFontSizeIncrease: _store.setFontSizeIncrease
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _withRoot2.default)((0, _reactJss2.default)(_globals2.default)(Layout)));
	
	//eslint-disable-next-line no-undef
	
	var guery = exports.guery = "** extracted graphql fragment **";

/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _theme = __webpack_require__(158);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  /*
	      BEGINNING OF NORMALIZE STYLE
	    */
	
	  "@global": {
	    /**
	     * Add the correct display in IE9
	     */
	    "article, aside, footer, header, nav, section, figcaption, figure, main": {
	      display: "block"
	    },
	
	    /**
	     * Correct the font size and margin on `h1` elements within `section` and
	     * `article` contexts in Chrome, Firefox, and Safari.
	     */
	    h1: {
	      fontSize: "2em",
	      margin: [["0.67em", 0]]
	    },
	
	    /**
	     * 1. Add the correct box sizing in Firefox.
	     * 2. Show the overflow in Edge and IE.
	     */
	    hr: {
	      boxSizing: "content-box" /* 1 */
	      , height: 0 /* 1 */
	      , overflow: "visible" /* 2 */
	    },
	
	    /**
	     * 1. Correct the inheritance and scaling of font size in all browsers.
	     * 2. Correct the odd `em` font sizing in all browsers.
	     */
	    pre: {
	      fontFamily: "monospace, monospace" /* 1 */
	      , fontSize: "1em" /* 2 */
	    },
	
	    /**
	     * 1. Remove the gray background on active links in IE 10.
	     * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.
	     * 3. Remove the outline on focused links when they are also
	     *    active or hovered in all browsers (opinionated).
	     */
	    // a: {
	    //   background: "transparent" /* 1 */,
	    //   textDecorationSkip: "objects" /* 2 */
	    // },
	    "a:active, a:hover": {
	      outlineWidth: 0 /* 3 */
	    },
	
	    /**
	     * 1. Remove the bottom border in Firefox 39-.
	     * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
	     */
	    "abbr[title]": {
	      borderBottom: "none" /* 1 */
	      , textDecoration: "underline" /* 2 */
	    },
	
	    /**
	     * Add the correct font weight in Chrome, Edge, and Safari.
	     */
	    "b, strong": {
	      fontWeight: "bolder"
	    },
	
	    /**
	     * 1. Correct the inheritance and scaling of font size in all browsers.
	     * 2. Correct the odd `em` font sizing in all browsers.
	     */
	    "code, kbp, samp": {
	      fontFamily: "monospace, monospace" /* 1 */
	      , fontSize: "1em" /* 2 */
	    },
	
	    /**
	     * Add the correct font style in Android 4.3-.
	     */
	    dfn: {
	      fontStyle: "italic"
	    },
	
	    /**
	     * Add the correct background and color in IE 9-.
	     */
	    mark: {
	      backgroundColor: "#ff0",
	      color: "#000"
	    },
	
	    /**
	     * Add the correct font size in all browsers.
	     */
	    small: {
	      fontSize: "80%"
	    },
	
	    /**
	     * Prevent `sub` and `sup` elements from affecting the line height in
	     * all browsers.
	     */
	    "sub, sup": {
	      fontSize: "75%",
	      lineHeight: 0,
	      position: "relative",
	      verticalAlign: "baseline"
	    },
	    sup: {
	      top: "-0.5em"
	    },
	    sub: {
	      bottom: "-0.25em"
	    },
	
	    /**
	     * Add the correct display in IE 9-.
	     */
	    "audio, video": {
	      display: "inline-block"
	    },
	
	    /**
	     * Add the correct display in iOS 4-7.
	     */
	    "audio:not([controls])": {
	      display: "none",
	      height: 0
	    },
	
	    /**
	     * 1. Remove the border on images inside links in IE 10-.
	     * 2. Remove extra space in all browsers
	     */
	    img: {
	      borderStyle: "none" /* 1 */
	      , verticalAlign: "middle" /* 2 */
	    },
	
	    /**
	     * Hide the overflow in IE.
	     */
	    "svg:not(:root)": {
	      overflow: "hidden"
	    },
	
	    /**
	     * 1. Change the font styles in all browsers (opinionated).
	     * 2. Remove the margin in Firefox and Safari.
	     */
	    "button, input, optgroup, select, textarea": {
	      fontFamily: "sans-serif" /* 1 */
	      , fontSize: "100%" /* 1 */
	      , lineHeight: "1.15" /* 1 */
	      , margin: 0 /* 2 */
	    },
	
	    /**
	     * Show the overflow in IE & Edge.
	     */
	    "button, input": {
	      overflow: "visible"
	    },
	
	    /**
	     * Remove the inheritance of text transform in Edge, Firefox, and IE.
	     */
	    "button, select": {
	      textTransform: "none"
	    },
	
	    /**
	     * Correct the inability to style clickable types in iOS and Safari.
	     */
	    "button, [type=reset], [type=submit]": {
	      "-webkit-appearance": "button"
	    },
	
	    /**
	     * Remove the inner border and padding in Firefox.
	     */
	    "button::-moz-focus-inner, [type=button]::-moz-focus-inner, [type=reset]::-moz-focus-inner, [type=submit]::-moz-focus-inner": {
	      borderStyle: "none",
	      padding: 0
	    },
	
	    /**
	     * Restore the focus styles unset by the previous rule.
	     */
	    "button:-moz-focusring, [type=button]:-moz-focusring, [type=reset]:-moz-focusring, [type=submit]:-moz-focusring": {
	      outline: "1px dotted ButtonText"
	    },
	
	    /**
	     * Change the border, margin, and padding in all browsers (opinionated).
	     */
	    fieldset: {
	      border: "1px solid #c0c0c0",
	      margin: [[0, "2px"]],
	      padding: [["0.35em", "0.625em", "0.75em"]]
	    },
	
	    /**
	     * 1. Correct the text wrapping in Edge and IE.
	     * 2. Correct the color inheritance from `fieldset` elements in IE.
	     * 3. Remove the padding so developers are not caught out when they zero out
	     *    `fieldset` elements in all browsers.
	     */
	    legend: {
	      boxSizing: "border-box" /* 1 */
	      , color: "inherit" /* 2 */
	      , display: "table" /* 1 */
	      , maxWidth: "100%" /* 1 */
	      , padding: 0 /* 3 */
	      , whiteSpace: "normal" /* 1 */
	    },
	
	    /**
	     * 1. Add the correct display in IE 9-.
	     * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.
	     */
	    progress: {
	      display: "inline-block" /* 1 */
	      , verticalAlign: "baseline" /* 2 */
	    },
	
	    /**
	     * Remove the default vertical scrollbar in IE.
	     */
	    textarea: {
	      overflow: "auto"
	    },
	
	    /**
	     * 1. Add the correct box sizing in IE 10-.
	     * 2. Remove the padding in IE 10-.
	     */
	    "[type=checkbox], [type=radio]": {
	      boxSizing: "border-box" /* 1 */
	      , padding: 0 /* 2 */
	    },
	
	    /**
	     * Correct the cursor style of increment and decrement buttons in Chrome.
	     */
	    "[type=number]::-webkit-inner-spin-button, [type=number]::-webkit-outer-spin-button": {
	      height: "auto"
	    },
	
	    /**
	     * 1. Correct the odd appearance in Chrome and Safari.
	     * 2. Correct the outline style in Safari.
	     */
	    "[type=search]": {
	      appearance: "textfield" /* 1 */
	      , outlineOffset: "-2px" /* 2 */
	    },
	
	    /**
	     * Remove the inner padding and cancel buttons in Chrome and Safari on OS X.
	     */
	    "[type=search]::-webkit-search-cancel-button, [type=search]::-webkit-search-decoration": {
	      appearance: "none"
	    },
	
	    /**
	     * 1. Correct the inability to style clickable types in iOS and Safari.
	     * 2. Change font properties to `inherit` in Safari.
	     */
	    "::-webkit-file-upload-button": {
	      appearance: "button" /* 1 */
	      , font: "inherit" /* 2 */
	    },
	
	    /*
	     * Add the correct display in Edge, IE, and Firefox.
	     */
	    "details, menu": {
	      display: "block"
	    },
	
	    /*
	     * Add the correct display in all browsers.
	     */
	    summary: {
	      display: "list-item"
	    },
	
	    /**
	     * Add the correct display in IE 9-.
	     */
	    canvas: {
	      display: "inline-block"
	    },
	
	    /**
	     * Add the correct display in IE.
	     */
	    template: {
	      display: "none"
	    },
	
	    /**
	     * Add the correct display in IE 10-.
	     */
	    "[hidden]": {
	      display: "none"
	    },
	
	    /*
	      END OF NORMALIZE STYLE
	    */
	
	    /*
	      BEGiNNIG OF CUTSOM GLOBAL STYLE
	     */
	
	    html: {
	      boxSizing: "border-box",
	      "-webkit-text-size-adjust": "100%",
	      "-moz-text-size-adjust": "none",
	      "-ms-text-size-adjust": "100%",
	      fontFamily: _theme2.default.base.fonts.unstyledFamily,
	      lineHeight: "1.15",
	      textSizeAdjust: "100%"
	    },
	    "html.wf-active": {
	      fontFamily: _theme2.default.base.fonts.styledFamily
	    },
	    "*, *:before, *:after": {
	      boxSizing: "inherit"
	    },
	    noscript: {
	      background: "#d00",
	      color: "#fff",
	      position: "absolute",
	      top: "50%",
	      left: "50%",
	      zIndex: 1000,
	      transform: "translate(-50%, -50%)",
	      padding: "1.5rem 2.5rem",
	      fontWeight: 400,
	      borderRadius: "2px",
	      boxShadow: "0 0 10px 52px rgba(255,255,255,.8)"
	    },
	    body: {
	      margin: 0,
	      background: _theme2.default.base.colors.background,
	      //overflow: "hidden",
	      "-webkit-tap-highlight-color": "rgba(0,0,0,.05)"
	    },
	    wrapper: {},
	    main: {
	      position: "relative"
	    },
	    "h1, h2, h3": {
	      fontWeight: 300
	    },
	    a: {
	      background: "transparent",
	      textDecorationSkip: "objects",
	      fontWeight: "bold",
	      textDecoration: "none",
	      transition: "0.3s"
	    },
	    "input:-webkit-autofill": {
	      "-webkit-box-shadow": "0 0 0 50px white inset"
	    },
	    ":not(pre) > code[class*='language-']": {
	      background: "#eee",
	      color: "#666",
	      textShadow: "none",
	      padding: "1px 5px",
	      borderRadius: "2px"
	    }
	  }
	};
	module.exports = exports["default"];

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _styles = __webpack_require__(110);
	
	var _color = __webpack_require__(647);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _colors = __webpack_require__(331);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var theme = (0, _styles.createMuiTheme)({
	  base: {
	    colors: {
	      background: _colors2.default.background,
	      text: _colors2.default.dark,
	      link: _colors2.default.accent,
	      linkHover: (0, _color2.default)(_colors2.default.accent).lighten(0.1).string(),
	      accent: _colors2.default.accent,
	      lines: _colors2.default.superLightGray
	    },
	    sizes: {
	      linesMargin: "20px"
	    },
	    fonts: {
	      unstyledFamily: "Arial",
	      styledFamily: "Open Sans",
	      styledFonts: "300,400,600"
	    }
	  },
	  info: {
	    colors: {
	      text: _colors2.default.gray,
	      background: _colors2.default.background,
	      socialIcons: _colors2.default.lightGray,
	      socialIconsHover: _colors2.default.accent,
	      menuLink: _colors2.default.gray,
	      menuLinkHover: _colors2.default.accent
	    },
	    sizes: {
	      width: 320,
	      headerHeight: 170
	    },
	    fonts: {
	      boxTitleSize: 1.3,
	      boxTitleSizeM: 1.5,
	      boxTitleSizeL: 1.7
	    }
	  },
	  navigator: {
	    colors: {
	      background: _colors2.default.background,
	      postsListItemLink: _colors2.default.gray,
	      postsListItemLinkHover: _colors2.default.accent,
	      postsHeader: _colors2.default.gray
	    },
	    sizes: {
	      closedHeight: 80,
	      postsListItemH1Font: 1.3,
	      postsListItemH2Font: 1.1,
	      fontIncraseForM: 1.15,
	      fontIncraseForL: 1.3
	    }
	  },
	  main: {
	    colors: {
	      background: _colors2.default.background,
	      title: _colors2.default.gray,
	      subTitle: _colors2.default.gray,
	      meta: _colors2.default.gray,
	      content: _colors2.default.dark,
	      footer: _colors2.default.gray,
	      contentHeading: _colors2.default.gray,
	      blockquoteFrame: _colors2.default.lightGray,
	      link: _colors2.default.accent,
	      linkHover: _colors2.default.dark,
	      fbCommentsColorscheme: "light"
	    },
	    sizes: {
	      articleMaxWidth: "50em"
	    },
	    fonts: {
	      title: {
	        size: 1.9,
	        sizeM: 2.5,
	        sizeL: 2.7,
	        weight: 600,
	        lineHeight: 1.1
	      },
	      subTitle: {
	        size: 1.5,
	        sizeM: 1.8,
	        sizeL: 1.95,
	        weight: 300,
	        lineHeight: 1.1
	      },
	      meta: {
	        size: 0.9,
	        weight: 600
	      },
	      content: {
	        size: 1.0,
	        sizeM: 1.15,
	        sizeL: 1.1,
	        lineHeight: 1.6
	      },
	      contentHeading: {
	        h2Size: 1.5,
	        h3Size: 1.3,
	        weight: 600,
	        lineHeight: 1.3
	      },
	      footer: {
	        size: 1,
	        lineHeight: 1.4
	      }
	    }
	  },
	  footer: {
	    colors: {
	      text: (0, _color2.default)(_colors2.default.gray).lighten(0.5).string(),
	      link: _colors2.default.accent,
	      linkHover: (0, _color2.default)(_colors2.default.accent).lighten(0.2).string()
	    },
	    fonts: {
	      footnote: {
	        size: 0.8,
	        lineHeight: 1.4
	      }
	    }
	  },
	  bars: {
	    colors: {
	      background: _colors2.default.background,
	      icon: _colors2.default.gray,
	      text: _colors2.default.gray
	    },
	    sizes: {
	      actionsBar: 60,
	      infoBar: 60
	    }
	  },
	  mediaQueryTresholds: {
	    M: 600,
	    L: 1024
	  },
	  palette: {
	    primary: {
	      main: _colors2.default.accent
	    },
	    action: {
	      hover: "rgba(0, 0, 0, 0.01)"
	    }
	  },
	  typography: {
	    fontFamily: "Arial, sans-serif",
	    fontSize: 16
	  }
	});
	
	exports.default = theme;
	module.exports = exports["default"];

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.isWideScreen = isWideScreen;
	exports.timeoutThrottlerHandler = timeoutThrottlerHandler;
	
	var _theme = __webpack_require__(158);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isWideScreen() {
	  if (typeof window !== "undefined") {
	    var windowWidth = window.innerWidth;
	    var mediaQueryL = _theme2.default.mediaQueryTresholds.L;
	
	    return windowWidth >= mediaQueryL;
	  }
	}
	
	function timeoutThrottlerHandler(timeouts, name, delay, handler) {
	  if (!timeouts[name]) {
	    timeouts[name] = setTimeout(function () {
	      timeouts[name] = null;
	      handler();
	    }, delay);
	  }
	}

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(110);
	
	var _CssBaseline = __webpack_require__(493);
	
	var _CssBaseline2 = _interopRequireDefault(_CssBaseline);
	
	var _getPageContext = __webpack_require__(628);
	
	var _getPageContext2 = _interopRequireDefault(_getPageContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withRoot(Component) {
	  var WithRoot = function (_React$Component) {
	    _inherits(WithRoot, _React$Component);
	
	    function WithRoot(props) {
	      _classCallCheck(this, WithRoot);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	      _this.pageContext = null;
	
	
	      _this.pageContext = _this.props.pageContext || (0, _getPageContext2.default)();
	      return _this;
	    }
	
	    WithRoot.prototype.componentDidMount = function componentDidMount() {
	      // Remove the server-side injected CSS.
	      var jssStyles = document.querySelector("#server-side-jss");
	      if (jssStyles && jssStyles.parentNode) {
	        jssStyles.parentNode.removeChild(jssStyles);
	      }
	    };
	
	    WithRoot.prototype.render = function render() {
	      // MuiThemeProvider makes the theme available down the React tree thanks to React context.
	      return _react2.default.createElement(
	        _styles.MuiThemeProvider,
	        {
	          theme: this.pageContext.theme,
	          sheetsManager: this.pageContext.sheetsManager
	        },
	        _react2.default.createElement(_CssBaseline2.default, null),
	        _react2.default.createElement(Component, this.props)
	      );
	    };
	
	    return WithRoot;
	  }(_react2.default.Component);
	
	  WithRoot.propTypes = {
	    pageContext: _propTypes2.default.object
	  };
	
	  return WithRoot;
	}
	
	exports.default = withRoot;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-c0d3cd22734798d5ec51.js